/*eslint-disable block-scoped-var, id-length, no-control-regex, no-magic-numbers, no-prototype-builtins, no-redeclare, no-shadow, no-var, sort-vars*/
import * as $protobuf from "protobufjs/minimal";

// Common aliases
const $Reader = $protobuf.Reader, $Writer = $protobuf.Writer, $util = $protobuf.util;

// Exported root namespace
const $root = $protobuf.roots["default"] || ($protobuf.roots["default"] = {});

export const chat = $root.chat = (() => {

    /**
     * Namespace chat.
     * @exports chat
     * @namespace
     */
    const chat = {};

    /**
     * ControlType enum.
     * @name chat.ControlType
     * @enum {number}
     * @property {number} UNKNOWN=0 UNKNOWN value
     * @property {number} SEND_MESSAGE=6 SEND_MESSAGE value
     * @property {number} NOTICE=7 NOTICE value
     * @property {number} PULL_MESSAGE_ID_LIST=8 PULL_MESSAGE_ID_LIST value
     * @property {number} PULL_MESSAGE_INFO_LIST=9 PULL_MESSAGE_INFO_LIST value
     * @property {number} GET_MEDIA_CALL_TOKEN=10 GET_MEDIA_CALL_TOKEN value
     * @property {number} MEDIA_CALL_OPERATE=11 MEDIA_CALL_OPERATE value
     * @property {number} SYNC_MEDIA_CALL_INFO=12 SYNC_MEDIA_CALL_INFO value
     * @property {number} MESSAGE_ARRIVAL_REPLY=13 MESSAGE_ARRIVAL_REPLY value
     * @property {number} READ_BURN_MESSAGE_REPLY=14 READ_BURN_MESSAGE_REPLY value
     * @property {number} MEDIA_CALL_V2=15 MEDIA_CALL_V2 value
     * @property {number} PULL_GROUP_MSG_READ_REPLY=16 PULL_GROUP_MSG_READ_REPLY value
     */
    chat.ControlType = (function() {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "UNKNOWN"] = 0;
        values[valuesById[6] = "SEND_MESSAGE"] = 6;
        values[valuesById[7] = "NOTICE"] = 7;
        values[valuesById[8] = "PULL_MESSAGE_ID_LIST"] = 8;
        values[valuesById[9] = "PULL_MESSAGE_INFO_LIST"] = 9;
        values[valuesById[10] = "GET_MEDIA_CALL_TOKEN"] = 10;
        values[valuesById[11] = "MEDIA_CALL_OPERATE"] = 11;
        values[valuesById[12] = "SYNC_MEDIA_CALL_INFO"] = 12;
        values[valuesById[13] = "MESSAGE_ARRIVAL_REPLY"] = 13;
        values[valuesById[14] = "READ_BURN_MESSAGE_REPLY"] = 14;
        values[valuesById[15] = "MEDIA_CALL_V2"] = 15;
        values[valuesById[16] = "PULL_GROUP_MSG_READ_REPLY"] = 16;
        return values;
    })();

    chat.SendMessageRequest = (function() {

        /**
         * Properties of a SendMessageRequest.
         * @memberof chat
         * @interface ISendMessageRequest
         * @property {string|null} [chatId] SendMessageRequest chatId
         * @property {string|null} [messageId] SendMessageRequest messageId
         * @property {string|null} [cliMsgId] SendMessageRequest cliMsgId
         * @property {number|null} [msgAction] SendMessageRequest msgAction
         * @property {number|Long|null} [expireDuration] SendMessageRequest expireDuration
         * @property {string|null} [linkMsgId] SendMessageRequest linkMsgId
         * @property {string|null} [payload] SendMessageRequest payload
         * @property {number|null} [payloadType] SendMessageRequest payloadType
         * @property {string|null} [receiverId] SendMessageRequest receiverId
         * @property {string|null} [receiverOrgId] SendMessageRequest receiverOrgId
         * @property {number|null} [encryptIndex] SendMessageRequest encryptIndex
         * @property {Array.<string>|null} [expectReadList] SendMessageRequest expectReadList
         * @property {Array.<string>|null} [atList] SendMessageRequest atList
         * @property {Array.<string>|null} [delList] SendMessageRequest delList
         */

        /**
         * Constructs a new SendMessageRequest.
         * @memberof chat
         * @classdesc Represents a SendMessageRequest.
         * @implements ISendMessageRequest
         * @constructor
         * @param {chat.ISendMessageRequest=} [properties] Properties to set
         */
        function SendMessageRequest(properties) {
            this.expectReadList = [];
            this.atList = [];
            this.delList = [];
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * SendMessageRequest chatId.
         * @member {string} chatId
         * @memberof chat.SendMessageRequest
         * @instance
         */
        SendMessageRequest.prototype.chatId = "";

        /**
         * SendMessageRequest messageId.
         * @member {string} messageId
         * @memberof chat.SendMessageRequest
         * @instance
         */
        SendMessageRequest.prototype.messageId = "";

        /**
         * SendMessageRequest cliMsgId.
         * @member {string} cliMsgId
         * @memberof chat.SendMessageRequest
         * @instance
         */
        SendMessageRequest.prototype.cliMsgId = "";

        /**
         * SendMessageRequest msgAction.
         * @member {number} msgAction
         * @memberof chat.SendMessageRequest
         * @instance
         */
        SendMessageRequest.prototype.msgAction = 0;

        /**
         * SendMessageRequest expireDuration.
         * @member {number|Long} expireDuration
         * @memberof chat.SendMessageRequest
         * @instance
         */
        SendMessageRequest.prototype.expireDuration = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * SendMessageRequest linkMsgId.
         * @member {string} linkMsgId
         * @memberof chat.SendMessageRequest
         * @instance
         */
        SendMessageRequest.prototype.linkMsgId = "";

        /**
         * SendMessageRequest payload.
         * @member {string} payload
         * @memberof chat.SendMessageRequest
         * @instance
         */
        SendMessageRequest.prototype.payload = "";

        /**
         * SendMessageRequest payloadType.
         * @member {number} payloadType
         * @memberof chat.SendMessageRequest
         * @instance
         */
        SendMessageRequest.prototype.payloadType = 0;

        /**
         * SendMessageRequest receiverId.
         * @member {string} receiverId
         * @memberof chat.SendMessageRequest
         * @instance
         */
        SendMessageRequest.prototype.receiverId = "";

        /**
         * SendMessageRequest receiverOrgId.
         * @member {string} receiverOrgId
         * @memberof chat.SendMessageRequest
         * @instance
         */
        SendMessageRequest.prototype.receiverOrgId = "";

        /**
         * SendMessageRequest encryptIndex.
         * @member {number} encryptIndex
         * @memberof chat.SendMessageRequest
         * @instance
         */
        SendMessageRequest.prototype.encryptIndex = 0;

        /**
         * SendMessageRequest expectReadList.
         * @member {Array.<string>} expectReadList
         * @memberof chat.SendMessageRequest
         * @instance
         */
        SendMessageRequest.prototype.expectReadList = $util.emptyArray;

        /**
         * SendMessageRequest atList.
         * @member {Array.<string>} atList
         * @memberof chat.SendMessageRequest
         * @instance
         */
        SendMessageRequest.prototype.atList = $util.emptyArray;

        /**
         * SendMessageRequest delList.
         * @member {Array.<string>} delList
         * @memberof chat.SendMessageRequest
         * @instance
         */
        SendMessageRequest.prototype.delList = $util.emptyArray;

        /**
         * Creates a new SendMessageRequest instance using the specified properties.
         * @function create
         * @memberof chat.SendMessageRequest
         * @static
         * @param {chat.ISendMessageRequest=} [properties] Properties to set
         * @returns {chat.SendMessageRequest} SendMessageRequest instance
         */
        SendMessageRequest.create = function create(properties) {
            return new SendMessageRequest(properties);
        };

        /**
         * Encodes the specified SendMessageRequest message. Does not implicitly {@link chat.SendMessageRequest.verify|verify} messages.
         * @function encode
         * @memberof chat.SendMessageRequest
         * @static
         * @param {chat.ISendMessageRequest} message SendMessageRequest message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        SendMessageRequest.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.chatId != null && Object.hasOwnProperty.call(message, "chatId"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.chatId);
            if (message.messageId != null && Object.hasOwnProperty.call(message, "messageId"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.messageId);
            if (message.cliMsgId != null && Object.hasOwnProperty.call(message, "cliMsgId"))
                writer.uint32(/* id 3, wireType 2 =*/26).string(message.cliMsgId);
            if (message.msgAction != null && Object.hasOwnProperty.call(message, "msgAction"))
                writer.uint32(/* id 4, wireType 0 =*/32).int32(message.msgAction);
            if (message.expireDuration != null && Object.hasOwnProperty.call(message, "expireDuration"))
                writer.uint32(/* id 5, wireType 0 =*/40).int64(message.expireDuration);
            if (message.linkMsgId != null && Object.hasOwnProperty.call(message, "linkMsgId"))
                writer.uint32(/* id 6, wireType 2 =*/50).string(message.linkMsgId);
            if (message.payload != null && Object.hasOwnProperty.call(message, "payload"))
                writer.uint32(/* id 7, wireType 2 =*/58).string(message.payload);
            if (message.payloadType != null && Object.hasOwnProperty.call(message, "payloadType"))
                writer.uint32(/* id 8, wireType 0 =*/64).int32(message.payloadType);
            if (message.receiverId != null && Object.hasOwnProperty.call(message, "receiverId"))
                writer.uint32(/* id 9, wireType 2 =*/74).string(message.receiverId);
            if (message.receiverOrgId != null && Object.hasOwnProperty.call(message, "receiverOrgId"))
                writer.uint32(/* id 10, wireType 2 =*/82).string(message.receiverOrgId);
            if (message.encryptIndex != null && Object.hasOwnProperty.call(message, "encryptIndex"))
                writer.uint32(/* id 11, wireType 0 =*/88).int32(message.encryptIndex);
            if (message.expectReadList != null && message.expectReadList.length)
                for (let i = 0; i < message.expectReadList.length; ++i)
                    writer.uint32(/* id 12, wireType 2 =*/98).string(message.expectReadList[i]);
            if (message.atList != null && message.atList.length)
                for (let i = 0; i < message.atList.length; ++i)
                    writer.uint32(/* id 13, wireType 2 =*/106).string(message.atList[i]);
            if (message.delList != null && message.delList.length)
                for (let i = 0; i < message.delList.length; ++i)
                    writer.uint32(/* id 14, wireType 2 =*/114).string(message.delList[i]);
            return writer;
        };

        /**
         * Encodes the specified SendMessageRequest message, length delimited. Does not implicitly {@link chat.SendMessageRequest.verify|verify} messages.
         * @function encodeDelimited
         * @memberof chat.SendMessageRequest
         * @static
         * @param {chat.ISendMessageRequest} message SendMessageRequest message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        SendMessageRequest.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a SendMessageRequest message from the specified reader or buffer.
         * @function decode
         * @memberof chat.SendMessageRequest
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {chat.SendMessageRequest} SendMessageRequest
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        SendMessageRequest.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.chat.SendMessageRequest();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1: {
                        message.chatId = reader.string();
                        break;
                    }
                case 2: {
                        message.messageId = reader.string();
                        break;
                    }
                case 3: {
                        message.cliMsgId = reader.string();
                        break;
                    }
                case 4: {
                        message.msgAction = reader.int32();
                        break;
                    }
                case 5: {
                        message.expireDuration = reader.int64();
                        break;
                    }
                case 6: {
                        message.linkMsgId = reader.string();
                        break;
                    }
                case 7: {
                        message.payload = reader.string();
                        break;
                    }
                case 8: {
                        message.payloadType = reader.int32();
                        break;
                    }
                case 9: {
                        message.receiverId = reader.string();
                        break;
                    }
                case 10: {
                        message.receiverOrgId = reader.string();
                        break;
                    }
                case 11: {
                        message.encryptIndex = reader.int32();
                        break;
                    }
                case 12: {
                        if (!(message.expectReadList && message.expectReadList.length))
                            message.expectReadList = [];
                        message.expectReadList.push(reader.string());
                        break;
                    }
                case 13: {
                        if (!(message.atList && message.atList.length))
                            message.atList = [];
                        message.atList.push(reader.string());
                        break;
                    }
                case 14: {
                        if (!(message.delList && message.delList.length))
                            message.delList = [];
                        message.delList.push(reader.string());
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a SendMessageRequest message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof chat.SendMessageRequest
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {chat.SendMessageRequest} SendMessageRequest
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        SendMessageRequest.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a SendMessageRequest message.
         * @function verify
         * @memberof chat.SendMessageRequest
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        SendMessageRequest.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.chatId != null && message.hasOwnProperty("chatId"))
                if (!$util.isString(message.chatId))
                    return "chatId: string expected";
            if (message.messageId != null && message.hasOwnProperty("messageId"))
                if (!$util.isString(message.messageId))
                    return "messageId: string expected";
            if (message.cliMsgId != null && message.hasOwnProperty("cliMsgId"))
                if (!$util.isString(message.cliMsgId))
                    return "cliMsgId: string expected";
            if (message.msgAction != null && message.hasOwnProperty("msgAction"))
                if (!$util.isInteger(message.msgAction))
                    return "msgAction: integer expected";
            if (message.expireDuration != null && message.hasOwnProperty("expireDuration"))
                if (!$util.isInteger(message.expireDuration) && !(message.expireDuration && $util.isInteger(message.expireDuration.low) && $util.isInteger(message.expireDuration.high)))
                    return "expireDuration: integer|Long expected";
            if (message.linkMsgId != null && message.hasOwnProperty("linkMsgId"))
                if (!$util.isString(message.linkMsgId))
                    return "linkMsgId: string expected";
            if (message.payload != null && message.hasOwnProperty("payload"))
                if (!$util.isString(message.payload))
                    return "payload: string expected";
            if (message.payloadType != null && message.hasOwnProperty("payloadType"))
                if (!$util.isInteger(message.payloadType))
                    return "payloadType: integer expected";
            if (message.receiverId != null && message.hasOwnProperty("receiverId"))
                if (!$util.isString(message.receiverId))
                    return "receiverId: string expected";
            if (message.receiverOrgId != null && message.hasOwnProperty("receiverOrgId"))
                if (!$util.isString(message.receiverOrgId))
                    return "receiverOrgId: string expected";
            if (message.encryptIndex != null && message.hasOwnProperty("encryptIndex"))
                if (!$util.isInteger(message.encryptIndex))
                    return "encryptIndex: integer expected";
            if (message.expectReadList != null && message.hasOwnProperty("expectReadList")) {
                if (!Array.isArray(message.expectReadList))
                    return "expectReadList: array expected";
                for (let i = 0; i < message.expectReadList.length; ++i)
                    if (!$util.isString(message.expectReadList[i]))
                        return "expectReadList: string[] expected";
            }
            if (message.atList != null && message.hasOwnProperty("atList")) {
                if (!Array.isArray(message.atList))
                    return "atList: array expected";
                for (let i = 0; i < message.atList.length; ++i)
                    if (!$util.isString(message.atList[i]))
                        return "atList: string[] expected";
            }
            if (message.delList != null && message.hasOwnProperty("delList")) {
                if (!Array.isArray(message.delList))
                    return "delList: array expected";
                for (let i = 0; i < message.delList.length; ++i)
                    if (!$util.isString(message.delList[i]))
                        return "delList: string[] expected";
            }
            return null;
        };

        /**
         * Creates a SendMessageRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof chat.SendMessageRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {chat.SendMessageRequest} SendMessageRequest
         */
        SendMessageRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.chat.SendMessageRequest)
                return object;
            let message = new $root.chat.SendMessageRequest();
            if (object.chatId != null)
                message.chatId = String(object.chatId);
            if (object.messageId != null)
                message.messageId = String(object.messageId);
            if (object.cliMsgId != null)
                message.cliMsgId = String(object.cliMsgId);
            if (object.msgAction != null)
                message.msgAction = object.msgAction | 0;
            if (object.expireDuration != null)
                if ($util.Long)
                    (message.expireDuration = $util.Long.fromValue(object.expireDuration)).unsigned = false;
                else if (typeof object.expireDuration === "string")
                    message.expireDuration = parseInt(object.expireDuration, 10);
                else if (typeof object.expireDuration === "number")
                    message.expireDuration = object.expireDuration;
                else if (typeof object.expireDuration === "object")
                    message.expireDuration = new $util.LongBits(object.expireDuration.low >>> 0, object.expireDuration.high >>> 0).toNumber();
            if (object.linkMsgId != null)
                message.linkMsgId = String(object.linkMsgId);
            if (object.payload != null)
                message.payload = String(object.payload);
            if (object.payloadType != null)
                message.payloadType = object.payloadType | 0;
            if (object.receiverId != null)
                message.receiverId = String(object.receiverId);
            if (object.receiverOrgId != null)
                message.receiverOrgId = String(object.receiverOrgId);
            if (object.encryptIndex != null)
                message.encryptIndex = object.encryptIndex | 0;
            if (object.expectReadList) {
                if (!Array.isArray(object.expectReadList))
                    throw TypeError(".chat.SendMessageRequest.expectReadList: array expected");
                message.expectReadList = [];
                for (let i = 0; i < object.expectReadList.length; ++i)
                    message.expectReadList[i] = String(object.expectReadList[i]);
            }
            if (object.atList) {
                if (!Array.isArray(object.atList))
                    throw TypeError(".chat.SendMessageRequest.atList: array expected");
                message.atList = [];
                for (let i = 0; i < object.atList.length; ++i)
                    message.atList[i] = String(object.atList[i]);
            }
            if (object.delList) {
                if (!Array.isArray(object.delList))
                    throw TypeError(".chat.SendMessageRequest.delList: array expected");
                message.delList = [];
                for (let i = 0; i < object.delList.length; ++i)
                    message.delList[i] = String(object.delList[i]);
            }
            return message;
        };

        /**
         * Creates a plain object from a SendMessageRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof chat.SendMessageRequest
         * @static
         * @param {chat.SendMessageRequest} message SendMessageRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        SendMessageRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.arrays || options.defaults) {
                object.expectReadList = [];
                object.atList = [];
                object.delList = [];
            }
            if (options.defaults) {
                object.chatId = "";
                object.messageId = "";
                object.cliMsgId = "";
                object.msgAction = 0;
                if ($util.Long) {
                    let long = new $util.Long(0, 0, false);
                    object.expireDuration = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.expireDuration = options.longs === String ? "0" : 0;
                object.linkMsgId = "";
                object.payload = "";
                object.payloadType = 0;
                object.receiverId = "";
                object.receiverOrgId = "";
                object.encryptIndex = 0;
            }
            if (message.chatId != null && message.hasOwnProperty("chatId"))
                object.chatId = message.chatId;
            if (message.messageId != null && message.hasOwnProperty("messageId"))
                object.messageId = message.messageId;
            if (message.cliMsgId != null && message.hasOwnProperty("cliMsgId"))
                object.cliMsgId = message.cliMsgId;
            if (message.msgAction != null && message.hasOwnProperty("msgAction"))
                object.msgAction = message.msgAction;
            if (message.expireDuration != null && message.hasOwnProperty("expireDuration"))
                if (typeof message.expireDuration === "number")
                    object.expireDuration = options.longs === String ? String(message.expireDuration) : message.expireDuration;
                else
                    object.expireDuration = options.longs === String ? $util.Long.prototype.toString.call(message.expireDuration) : options.longs === Number ? new $util.LongBits(message.expireDuration.low >>> 0, message.expireDuration.high >>> 0).toNumber() : message.expireDuration;
            if (message.linkMsgId != null && message.hasOwnProperty("linkMsgId"))
                object.linkMsgId = message.linkMsgId;
            if (message.payload != null && message.hasOwnProperty("payload"))
                object.payload = message.payload;
            if (message.payloadType != null && message.hasOwnProperty("payloadType"))
                object.payloadType = message.payloadType;
            if (message.receiverId != null && message.hasOwnProperty("receiverId"))
                object.receiverId = message.receiverId;
            if (message.receiverOrgId != null && message.hasOwnProperty("receiverOrgId"))
                object.receiverOrgId = message.receiverOrgId;
            if (message.encryptIndex != null && message.hasOwnProperty("encryptIndex"))
                object.encryptIndex = message.encryptIndex;
            if (message.expectReadList && message.expectReadList.length) {
                object.expectReadList = [];
                for (let j = 0; j < message.expectReadList.length; ++j)
                    object.expectReadList[j] = message.expectReadList[j];
            }
            if (message.atList && message.atList.length) {
                object.atList = [];
                for (let j = 0; j < message.atList.length; ++j)
                    object.atList[j] = message.atList[j];
            }
            if (message.delList && message.delList.length) {
                object.delList = [];
                for (let j = 0; j < message.delList.length; ++j)
                    object.delList[j] = message.delList[j];
            }
            return object;
        };

        /**
         * Converts this SendMessageRequest to JSON.
         * @function toJSON
         * @memberof chat.SendMessageRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        SendMessageRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for SendMessageRequest
         * @function getTypeUrl
         * @memberof chat.SendMessageRequest
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        SendMessageRequest.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/chat.SendMessageRequest";
        };

        return SendMessageRequest;
    })();

    chat.SendMessageResponse = (function() {

        /**
         * Properties of a SendMessageResponse.
         * @memberof chat
         * @interface ISendMessageResponse
         * @property {number|null} [statusCode] SendMessageResponse statusCode
         * @property {string|null} [messageId] SendMessageResponse messageId
         * @property {number|Long|null} [messageSeq] SendMessageResponse messageSeq
         * @property {string|null} [cliMsgId] SendMessageResponse cliMsgId
         * @property {string|null} [chatId] SendMessageResponse chatId
         * @property {number|Long|null} [createdAt] SendMessageResponse createdAt
         * @property {number|Long|null} [recvSeq] SendMessageResponse recvSeq
         */

        /**
         * Constructs a new SendMessageResponse.
         * @memberof chat
         * @classdesc Represents a SendMessageResponse.
         * @implements ISendMessageResponse
         * @constructor
         * @param {chat.ISendMessageResponse=} [properties] Properties to set
         */
        function SendMessageResponse(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * SendMessageResponse statusCode.
         * @member {number} statusCode
         * @memberof chat.SendMessageResponse
         * @instance
         */
        SendMessageResponse.prototype.statusCode = 0;

        /**
         * SendMessageResponse messageId.
         * @member {string} messageId
         * @memberof chat.SendMessageResponse
         * @instance
         */
        SendMessageResponse.prototype.messageId = "";

        /**
         * SendMessageResponse messageSeq.
         * @member {number|Long} messageSeq
         * @memberof chat.SendMessageResponse
         * @instance
         */
        SendMessageResponse.prototype.messageSeq = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * SendMessageResponse cliMsgId.
         * @member {string} cliMsgId
         * @memberof chat.SendMessageResponse
         * @instance
         */
        SendMessageResponse.prototype.cliMsgId = "";

        /**
         * SendMessageResponse chatId.
         * @member {string} chatId
         * @memberof chat.SendMessageResponse
         * @instance
         */
        SendMessageResponse.prototype.chatId = "";

        /**
         * SendMessageResponse createdAt.
         * @member {number|Long} createdAt
         * @memberof chat.SendMessageResponse
         * @instance
         */
        SendMessageResponse.prototype.createdAt = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * SendMessageResponse recvSeq.
         * @member {number|Long} recvSeq
         * @memberof chat.SendMessageResponse
         * @instance
         */
        SendMessageResponse.prototype.recvSeq = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * Creates a new SendMessageResponse instance using the specified properties.
         * @function create
         * @memberof chat.SendMessageResponse
         * @static
         * @param {chat.ISendMessageResponse=} [properties] Properties to set
         * @returns {chat.SendMessageResponse} SendMessageResponse instance
         */
        SendMessageResponse.create = function create(properties) {
            return new SendMessageResponse(properties);
        };

        /**
         * Encodes the specified SendMessageResponse message. Does not implicitly {@link chat.SendMessageResponse.verify|verify} messages.
         * @function encode
         * @memberof chat.SendMessageResponse
         * @static
         * @param {chat.ISendMessageResponse} message SendMessageResponse message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        SendMessageResponse.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.statusCode != null && Object.hasOwnProperty.call(message, "statusCode"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.statusCode);
            if (message.messageId != null && Object.hasOwnProperty.call(message, "messageId"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.messageId);
            if (message.messageSeq != null && Object.hasOwnProperty.call(message, "messageSeq"))
                writer.uint32(/* id 3, wireType 0 =*/24).int64(message.messageSeq);
            if (message.cliMsgId != null && Object.hasOwnProperty.call(message, "cliMsgId"))
                writer.uint32(/* id 4, wireType 2 =*/34).string(message.cliMsgId);
            if (message.chatId != null && Object.hasOwnProperty.call(message, "chatId"))
                writer.uint32(/* id 5, wireType 2 =*/42).string(message.chatId);
            if (message.createdAt != null && Object.hasOwnProperty.call(message, "createdAt"))
                writer.uint32(/* id 6, wireType 0 =*/48).int64(message.createdAt);
            if (message.recvSeq != null && Object.hasOwnProperty.call(message, "recvSeq"))
                writer.uint32(/* id 7, wireType 0 =*/56).int64(message.recvSeq);
            return writer;
        };

        /**
         * Encodes the specified SendMessageResponse message, length delimited. Does not implicitly {@link chat.SendMessageResponse.verify|verify} messages.
         * @function encodeDelimited
         * @memberof chat.SendMessageResponse
         * @static
         * @param {chat.ISendMessageResponse} message SendMessageResponse message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        SendMessageResponse.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a SendMessageResponse message from the specified reader or buffer.
         * @function decode
         * @memberof chat.SendMessageResponse
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {chat.SendMessageResponse} SendMessageResponse
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        SendMessageResponse.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.chat.SendMessageResponse();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1: {
                        message.statusCode = reader.int32();
                        break;
                    }
                case 2: {
                        message.messageId = reader.string();
                        break;
                    }
                case 3: {
                        message.messageSeq = reader.int64();
                        break;
                    }
                case 4: {
                        message.cliMsgId = reader.string();
                        break;
                    }
                case 5: {
                        message.chatId = reader.string();
                        break;
                    }
                case 6: {
                        message.createdAt = reader.int64();
                        break;
                    }
                case 7: {
                        message.recvSeq = reader.int64();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a SendMessageResponse message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof chat.SendMessageResponse
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {chat.SendMessageResponse} SendMessageResponse
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        SendMessageResponse.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a SendMessageResponse message.
         * @function verify
         * @memberof chat.SendMessageResponse
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        SendMessageResponse.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.statusCode != null && message.hasOwnProperty("statusCode"))
                if (!$util.isInteger(message.statusCode))
                    return "statusCode: integer expected";
            if (message.messageId != null && message.hasOwnProperty("messageId"))
                if (!$util.isString(message.messageId))
                    return "messageId: string expected";
            if (message.messageSeq != null && message.hasOwnProperty("messageSeq"))
                if (!$util.isInteger(message.messageSeq) && !(message.messageSeq && $util.isInteger(message.messageSeq.low) && $util.isInteger(message.messageSeq.high)))
                    return "messageSeq: integer|Long expected";
            if (message.cliMsgId != null && message.hasOwnProperty("cliMsgId"))
                if (!$util.isString(message.cliMsgId))
                    return "cliMsgId: string expected";
            if (message.chatId != null && message.hasOwnProperty("chatId"))
                if (!$util.isString(message.chatId))
                    return "chatId: string expected";
            if (message.createdAt != null && message.hasOwnProperty("createdAt"))
                if (!$util.isInteger(message.createdAt) && !(message.createdAt && $util.isInteger(message.createdAt.low) && $util.isInteger(message.createdAt.high)))
                    return "createdAt: integer|Long expected";
            if (message.recvSeq != null && message.hasOwnProperty("recvSeq"))
                if (!$util.isInteger(message.recvSeq) && !(message.recvSeq && $util.isInteger(message.recvSeq.low) && $util.isInteger(message.recvSeq.high)))
                    return "recvSeq: integer|Long expected";
            return null;
        };

        /**
         * Creates a SendMessageResponse message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof chat.SendMessageResponse
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {chat.SendMessageResponse} SendMessageResponse
         */
        SendMessageResponse.fromObject = function fromObject(object) {
            if (object instanceof $root.chat.SendMessageResponse)
                return object;
            let message = new $root.chat.SendMessageResponse();
            if (object.statusCode != null)
                message.statusCode = object.statusCode | 0;
            if (object.messageId != null)
                message.messageId = String(object.messageId);
            if (object.messageSeq != null)
                if ($util.Long)
                    (message.messageSeq = $util.Long.fromValue(object.messageSeq)).unsigned = false;
                else if (typeof object.messageSeq === "string")
                    message.messageSeq = parseInt(object.messageSeq, 10);
                else if (typeof object.messageSeq === "number")
                    message.messageSeq = object.messageSeq;
                else if (typeof object.messageSeq === "object")
                    message.messageSeq = new $util.LongBits(object.messageSeq.low >>> 0, object.messageSeq.high >>> 0).toNumber();
            if (object.cliMsgId != null)
                message.cliMsgId = String(object.cliMsgId);
            if (object.chatId != null)
                message.chatId = String(object.chatId);
            if (object.createdAt != null)
                if ($util.Long)
                    (message.createdAt = $util.Long.fromValue(object.createdAt)).unsigned = false;
                else if (typeof object.createdAt === "string")
                    message.createdAt = parseInt(object.createdAt, 10);
                else if (typeof object.createdAt === "number")
                    message.createdAt = object.createdAt;
                else if (typeof object.createdAt === "object")
                    message.createdAt = new $util.LongBits(object.createdAt.low >>> 0, object.createdAt.high >>> 0).toNumber();
            if (object.recvSeq != null)
                if ($util.Long)
                    (message.recvSeq = $util.Long.fromValue(object.recvSeq)).unsigned = false;
                else if (typeof object.recvSeq === "string")
                    message.recvSeq = parseInt(object.recvSeq, 10);
                else if (typeof object.recvSeq === "number")
                    message.recvSeq = object.recvSeq;
                else if (typeof object.recvSeq === "object")
                    message.recvSeq = new $util.LongBits(object.recvSeq.low >>> 0, object.recvSeq.high >>> 0).toNumber();
            return message;
        };

        /**
         * Creates a plain object from a SendMessageResponse message. Also converts values to other types if specified.
         * @function toObject
         * @memberof chat.SendMessageResponse
         * @static
         * @param {chat.SendMessageResponse} message SendMessageResponse
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        SendMessageResponse.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.statusCode = 0;
                object.messageId = "";
                if ($util.Long) {
                    let long = new $util.Long(0, 0, false);
                    object.messageSeq = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.messageSeq = options.longs === String ? "0" : 0;
                object.cliMsgId = "";
                object.chatId = "";
                if ($util.Long) {
                    let long = new $util.Long(0, 0, false);
                    object.createdAt = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.createdAt = options.longs === String ? "0" : 0;
                if ($util.Long) {
                    let long = new $util.Long(0, 0, false);
                    object.recvSeq = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.recvSeq = options.longs === String ? "0" : 0;
            }
            if (message.statusCode != null && message.hasOwnProperty("statusCode"))
                object.statusCode = message.statusCode;
            if (message.messageId != null && message.hasOwnProperty("messageId"))
                object.messageId = message.messageId;
            if (message.messageSeq != null && message.hasOwnProperty("messageSeq"))
                if (typeof message.messageSeq === "number")
                    object.messageSeq = options.longs === String ? String(message.messageSeq) : message.messageSeq;
                else
                    object.messageSeq = options.longs === String ? $util.Long.prototype.toString.call(message.messageSeq) : options.longs === Number ? new $util.LongBits(message.messageSeq.low >>> 0, message.messageSeq.high >>> 0).toNumber() : message.messageSeq;
            if (message.cliMsgId != null && message.hasOwnProperty("cliMsgId"))
                object.cliMsgId = message.cliMsgId;
            if (message.chatId != null && message.hasOwnProperty("chatId"))
                object.chatId = message.chatId;
            if (message.createdAt != null && message.hasOwnProperty("createdAt"))
                if (typeof message.createdAt === "number")
                    object.createdAt = options.longs === String ? String(message.createdAt) : message.createdAt;
                else
                    object.createdAt = options.longs === String ? $util.Long.prototype.toString.call(message.createdAt) : options.longs === Number ? new $util.LongBits(message.createdAt.low >>> 0, message.createdAt.high >>> 0).toNumber() : message.createdAt;
            if (message.recvSeq != null && message.hasOwnProperty("recvSeq"))
                if (typeof message.recvSeq === "number")
                    object.recvSeq = options.longs === String ? String(message.recvSeq) : message.recvSeq;
                else
                    object.recvSeq = options.longs === String ? $util.Long.prototype.toString.call(message.recvSeq) : options.longs === Number ? new $util.LongBits(message.recvSeq.low >>> 0, message.recvSeq.high >>> 0).toNumber() : message.recvSeq;
            return object;
        };

        /**
         * Converts this SendMessageResponse to JSON.
         * @function toJSON
         * @memberof chat.SendMessageResponse
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        SendMessageResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for SendMessageResponse
         * @function getTypeUrl
         * @memberof chat.SendMessageResponse
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        SendMessageResponse.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/chat.SendMessageResponse";
        };

        return SendMessageResponse;
    })();

    chat.Notice = (function() {

        /**
         * Properties of a Notice.
         * @memberof chat
         * @interface INotice
         * @property {number|null} [code] Notice code
         * @property {number|Long|null} [sequence] Notice sequence
         * @property {number|null} [msgType] Notice msgType
         */

        /**
         * Constructs a new Notice.
         * @memberof chat
         * @classdesc Represents a Notice.
         * @implements INotice
         * @constructor
         * @param {chat.INotice=} [properties] Properties to set
         */
        function Notice(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Notice code.
         * @member {number} code
         * @memberof chat.Notice
         * @instance
         */
        Notice.prototype.code = 0;

        /**
         * Notice sequence.
         * @member {number|Long} sequence
         * @memberof chat.Notice
         * @instance
         */
        Notice.prototype.sequence = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * Notice msgType.
         * @member {number} msgType
         * @memberof chat.Notice
         * @instance
         */
        Notice.prototype.msgType = 0;

        /**
         * Creates a new Notice instance using the specified properties.
         * @function create
         * @memberof chat.Notice
         * @static
         * @param {chat.INotice=} [properties] Properties to set
         * @returns {chat.Notice} Notice instance
         */
        Notice.create = function create(properties) {
            return new Notice(properties);
        };

        /**
         * Encodes the specified Notice message. Does not implicitly {@link chat.Notice.verify|verify} messages.
         * @function encode
         * @memberof chat.Notice
         * @static
         * @param {chat.INotice} message Notice message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Notice.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.code != null && Object.hasOwnProperty.call(message, "code"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.code);
            if (message.sequence != null && Object.hasOwnProperty.call(message, "sequence"))
                writer.uint32(/* id 2, wireType 0 =*/16).int64(message.sequence);
            if (message.msgType != null && Object.hasOwnProperty.call(message, "msgType"))
                writer.uint32(/* id 3, wireType 0 =*/24).int32(message.msgType);
            return writer;
        };

        /**
         * Encodes the specified Notice message, length delimited. Does not implicitly {@link chat.Notice.verify|verify} messages.
         * @function encodeDelimited
         * @memberof chat.Notice
         * @static
         * @param {chat.INotice} message Notice message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Notice.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a Notice message from the specified reader or buffer.
         * @function decode
         * @memberof chat.Notice
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {chat.Notice} Notice
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Notice.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.chat.Notice();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1: {
                        message.code = reader.int32();
                        break;
                    }
                case 2: {
                        message.sequence = reader.int64();
                        break;
                    }
                case 3: {
                        message.msgType = reader.int32();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a Notice message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof chat.Notice
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {chat.Notice} Notice
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Notice.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a Notice message.
         * @function verify
         * @memberof chat.Notice
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        Notice.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.code != null && message.hasOwnProperty("code"))
                if (!$util.isInteger(message.code))
                    return "code: integer expected";
            if (message.sequence != null && message.hasOwnProperty("sequence"))
                if (!$util.isInteger(message.sequence) && !(message.sequence && $util.isInteger(message.sequence.low) && $util.isInteger(message.sequence.high)))
                    return "sequence: integer|Long expected";
            if (message.msgType != null && message.hasOwnProperty("msgType"))
                if (!$util.isInteger(message.msgType))
                    return "msgType: integer expected";
            return null;
        };

        /**
         * Creates a Notice message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof chat.Notice
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {chat.Notice} Notice
         */
        Notice.fromObject = function fromObject(object) {
            if (object instanceof $root.chat.Notice)
                return object;
            let message = new $root.chat.Notice();
            if (object.code != null)
                message.code = object.code | 0;
            if (object.sequence != null)
                if ($util.Long)
                    (message.sequence = $util.Long.fromValue(object.sequence)).unsigned = false;
                else if (typeof object.sequence === "string")
                    message.sequence = parseInt(object.sequence, 10);
                else if (typeof object.sequence === "number")
                    message.sequence = object.sequence;
                else if (typeof object.sequence === "object")
                    message.sequence = new $util.LongBits(object.sequence.low >>> 0, object.sequence.high >>> 0).toNumber();
            if (object.msgType != null)
                message.msgType = object.msgType | 0;
            return message;
        };

        /**
         * Creates a plain object from a Notice message. Also converts values to other types if specified.
         * @function toObject
         * @memberof chat.Notice
         * @static
         * @param {chat.Notice} message Notice
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        Notice.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.code = 0;
                if ($util.Long) {
                    let long = new $util.Long(0, 0, false);
                    object.sequence = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.sequence = options.longs === String ? "0" : 0;
                object.msgType = 0;
            }
            if (message.code != null && message.hasOwnProperty("code"))
                object.code = message.code;
            if (message.sequence != null && message.hasOwnProperty("sequence"))
                if (typeof message.sequence === "number")
                    object.sequence = options.longs === String ? String(message.sequence) : message.sequence;
                else
                    object.sequence = options.longs === String ? $util.Long.prototype.toString.call(message.sequence) : options.longs === Number ? new $util.LongBits(message.sequence.low >>> 0, message.sequence.high >>> 0).toNumber() : message.sequence;
            if (message.msgType != null && message.hasOwnProperty("msgType"))
                object.msgType = message.msgType;
            return object;
        };

        /**
         * Converts this Notice to JSON.
         * @function toJSON
         * @memberof chat.Notice
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        Notice.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for Notice
         * @function getTypeUrl
         * @memberof chat.Notice
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        Notice.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/chat.Notice";
        };

        return Notice;
    })();

    chat.PullMessageIdListRequest = (function() {

        /**
         * Properties of a PullMessageIdListRequest.
         * @memberof chat
         * @interface IPullMessageIdListRequest
         * @property {number|Long|null} [sequence] PullMessageIdListRequest sequence
         * @property {number|null} [msgType] PullMessageIdListRequest msgType
         */

        /**
         * Constructs a new PullMessageIdListRequest.
         * @memberof chat
         * @classdesc Represents a PullMessageIdListRequest.
         * @implements IPullMessageIdListRequest
         * @constructor
         * @param {chat.IPullMessageIdListRequest=} [properties] Properties to set
         */
        function PullMessageIdListRequest(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * PullMessageIdListRequest sequence.
         * @member {number|Long} sequence
         * @memberof chat.PullMessageIdListRequest
         * @instance
         */
        PullMessageIdListRequest.prototype.sequence = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * PullMessageIdListRequest msgType.
         * @member {number} msgType
         * @memberof chat.PullMessageIdListRequest
         * @instance
         */
        PullMessageIdListRequest.prototype.msgType = 0;

        /**
         * Creates a new PullMessageIdListRequest instance using the specified properties.
         * @function create
         * @memberof chat.PullMessageIdListRequest
         * @static
         * @param {chat.IPullMessageIdListRequest=} [properties] Properties to set
         * @returns {chat.PullMessageIdListRequest} PullMessageIdListRequest instance
         */
        PullMessageIdListRequest.create = function create(properties) {
            return new PullMessageIdListRequest(properties);
        };

        /**
         * Encodes the specified PullMessageIdListRequest message. Does not implicitly {@link chat.PullMessageIdListRequest.verify|verify} messages.
         * @function encode
         * @memberof chat.PullMessageIdListRequest
         * @static
         * @param {chat.IPullMessageIdListRequest} message PullMessageIdListRequest message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        PullMessageIdListRequest.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.sequence != null && Object.hasOwnProperty.call(message, "sequence"))
                writer.uint32(/* id 1, wireType 0 =*/8).int64(message.sequence);
            if (message.msgType != null && Object.hasOwnProperty.call(message, "msgType"))
                writer.uint32(/* id 2, wireType 0 =*/16).int32(message.msgType);
            return writer;
        };

        /**
         * Encodes the specified PullMessageIdListRequest message, length delimited. Does not implicitly {@link chat.PullMessageIdListRequest.verify|verify} messages.
         * @function encodeDelimited
         * @memberof chat.PullMessageIdListRequest
         * @static
         * @param {chat.IPullMessageIdListRequest} message PullMessageIdListRequest message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        PullMessageIdListRequest.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a PullMessageIdListRequest message from the specified reader or buffer.
         * @function decode
         * @memberof chat.PullMessageIdListRequest
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {chat.PullMessageIdListRequest} PullMessageIdListRequest
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        PullMessageIdListRequest.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.chat.PullMessageIdListRequest();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1: {
                        message.sequence = reader.int64();
                        break;
                    }
                case 2: {
                        message.msgType = reader.int32();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a PullMessageIdListRequest message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof chat.PullMessageIdListRequest
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {chat.PullMessageIdListRequest} PullMessageIdListRequest
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        PullMessageIdListRequest.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a PullMessageIdListRequest message.
         * @function verify
         * @memberof chat.PullMessageIdListRequest
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        PullMessageIdListRequest.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.sequence != null && message.hasOwnProperty("sequence"))
                if (!$util.isInteger(message.sequence) && !(message.sequence && $util.isInteger(message.sequence.low) && $util.isInteger(message.sequence.high)))
                    return "sequence: integer|Long expected";
            if (message.msgType != null && message.hasOwnProperty("msgType"))
                if (!$util.isInteger(message.msgType))
                    return "msgType: integer expected";
            return null;
        };

        /**
         * Creates a PullMessageIdListRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof chat.PullMessageIdListRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {chat.PullMessageIdListRequest} PullMessageIdListRequest
         */
        PullMessageIdListRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.chat.PullMessageIdListRequest)
                return object;
            let message = new $root.chat.PullMessageIdListRequest();
            if (object.sequence != null)
                if ($util.Long)
                    (message.sequence = $util.Long.fromValue(object.sequence)).unsigned = false;
                else if (typeof object.sequence === "string")
                    message.sequence = parseInt(object.sequence, 10);
                else if (typeof object.sequence === "number")
                    message.sequence = object.sequence;
                else if (typeof object.sequence === "object")
                    message.sequence = new $util.LongBits(object.sequence.low >>> 0, object.sequence.high >>> 0).toNumber();
            if (object.msgType != null)
                message.msgType = object.msgType | 0;
            return message;
        };

        /**
         * Creates a plain object from a PullMessageIdListRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof chat.PullMessageIdListRequest
         * @static
         * @param {chat.PullMessageIdListRequest} message PullMessageIdListRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        PullMessageIdListRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                if ($util.Long) {
                    let long = new $util.Long(0, 0, false);
                    object.sequence = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.sequence = options.longs === String ? "0" : 0;
                object.msgType = 0;
            }
            if (message.sequence != null && message.hasOwnProperty("sequence"))
                if (typeof message.sequence === "number")
                    object.sequence = options.longs === String ? String(message.sequence) : message.sequence;
                else
                    object.sequence = options.longs === String ? $util.Long.prototype.toString.call(message.sequence) : options.longs === Number ? new $util.LongBits(message.sequence.low >>> 0, message.sequence.high >>> 0).toNumber() : message.sequence;
            if (message.msgType != null && message.hasOwnProperty("msgType"))
                object.msgType = message.msgType;
            return object;
        };

        /**
         * Converts this PullMessageIdListRequest to JSON.
         * @function toJSON
         * @memberof chat.PullMessageIdListRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        PullMessageIdListRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for PullMessageIdListRequest
         * @function getTypeUrl
         * @memberof chat.PullMessageIdListRequest
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        PullMessageIdListRequest.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/chat.PullMessageIdListRequest";
        };

        return PullMessageIdListRequest;
    })();

    chat.PullMessageSequence = (function() {

        /**
         * Properties of a PullMessageSequence.
         * @memberof chat
         * @interface IPullMessageSequence
         * @property {string|null} [chatId] PullMessageSequence chatId
         * @property {string|null} [messageId] PullMessageSequence messageId
         * @property {number|Long|null} [createdAt] PullMessageSequence createdAt
         * @property {string|null} [senderId] PullMessageSequence senderId
         * @property {Array.<string>|null} [atList] PullMessageSequence atList
         * @property {Array.<string>|null} [delList] PullMessageSequence delList
         */

        /**
         * Constructs a new PullMessageSequence.
         * @memberof chat
         * @classdesc Represents a PullMessageSequence.
         * @implements IPullMessageSequence
         * @constructor
         * @param {chat.IPullMessageSequence=} [properties] Properties to set
         */
        function PullMessageSequence(properties) {
            this.atList = [];
            this.delList = [];
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * PullMessageSequence chatId.
         * @member {string} chatId
         * @memberof chat.PullMessageSequence
         * @instance
         */
        PullMessageSequence.prototype.chatId = "";

        /**
         * PullMessageSequence messageId.
         * @member {string} messageId
         * @memberof chat.PullMessageSequence
         * @instance
         */
        PullMessageSequence.prototype.messageId = "";

        /**
         * PullMessageSequence createdAt.
         * @member {number|Long} createdAt
         * @memberof chat.PullMessageSequence
         * @instance
         */
        PullMessageSequence.prototype.createdAt = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * PullMessageSequence senderId.
         * @member {string} senderId
         * @memberof chat.PullMessageSequence
         * @instance
         */
        PullMessageSequence.prototype.senderId = "";

        /**
         * PullMessageSequence atList.
         * @member {Array.<string>} atList
         * @memberof chat.PullMessageSequence
         * @instance
         */
        PullMessageSequence.prototype.atList = $util.emptyArray;

        /**
         * PullMessageSequence delList.
         * @member {Array.<string>} delList
         * @memberof chat.PullMessageSequence
         * @instance
         */
        PullMessageSequence.prototype.delList = $util.emptyArray;

        /**
         * Creates a new PullMessageSequence instance using the specified properties.
         * @function create
         * @memberof chat.PullMessageSequence
         * @static
         * @param {chat.IPullMessageSequence=} [properties] Properties to set
         * @returns {chat.PullMessageSequence} PullMessageSequence instance
         */
        PullMessageSequence.create = function create(properties) {
            return new PullMessageSequence(properties);
        };

        /**
         * Encodes the specified PullMessageSequence message. Does not implicitly {@link chat.PullMessageSequence.verify|verify} messages.
         * @function encode
         * @memberof chat.PullMessageSequence
         * @static
         * @param {chat.IPullMessageSequence} message PullMessageSequence message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        PullMessageSequence.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.chatId != null && Object.hasOwnProperty.call(message, "chatId"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.chatId);
            if (message.messageId != null && Object.hasOwnProperty.call(message, "messageId"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.messageId);
            if (message.createdAt != null && Object.hasOwnProperty.call(message, "createdAt"))
                writer.uint32(/* id 3, wireType 0 =*/24).int64(message.createdAt);
            if (message.senderId != null && Object.hasOwnProperty.call(message, "senderId"))
                writer.uint32(/* id 4, wireType 2 =*/34).string(message.senderId);
            if (message.atList != null && message.atList.length)
                for (let i = 0; i < message.atList.length; ++i)
                    writer.uint32(/* id 5, wireType 2 =*/42).string(message.atList[i]);
            if (message.delList != null && message.delList.length)
                for (let i = 0; i < message.delList.length; ++i)
                    writer.uint32(/* id 6, wireType 2 =*/50).string(message.delList[i]);
            return writer;
        };

        /**
         * Encodes the specified PullMessageSequence message, length delimited. Does not implicitly {@link chat.PullMessageSequence.verify|verify} messages.
         * @function encodeDelimited
         * @memberof chat.PullMessageSequence
         * @static
         * @param {chat.IPullMessageSequence} message PullMessageSequence message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        PullMessageSequence.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a PullMessageSequence message from the specified reader or buffer.
         * @function decode
         * @memberof chat.PullMessageSequence
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {chat.PullMessageSequence} PullMessageSequence
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        PullMessageSequence.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.chat.PullMessageSequence();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1: {
                        message.chatId = reader.string();
                        break;
                    }
                case 2: {
                        message.messageId = reader.string();
                        break;
                    }
                case 3: {
                        message.createdAt = reader.int64();
                        break;
                    }
                case 4: {
                        message.senderId = reader.string();
                        break;
                    }
                case 5: {
                        if (!(message.atList && message.atList.length))
                            message.atList = [];
                        message.atList.push(reader.string());
                        break;
                    }
                case 6: {
                        if (!(message.delList && message.delList.length))
                            message.delList = [];
                        message.delList.push(reader.string());
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a PullMessageSequence message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof chat.PullMessageSequence
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {chat.PullMessageSequence} PullMessageSequence
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        PullMessageSequence.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a PullMessageSequence message.
         * @function verify
         * @memberof chat.PullMessageSequence
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        PullMessageSequence.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.chatId != null && message.hasOwnProperty("chatId"))
                if (!$util.isString(message.chatId))
                    return "chatId: string expected";
            if (message.messageId != null && message.hasOwnProperty("messageId"))
                if (!$util.isString(message.messageId))
                    return "messageId: string expected";
            if (message.createdAt != null && message.hasOwnProperty("createdAt"))
                if (!$util.isInteger(message.createdAt) && !(message.createdAt && $util.isInteger(message.createdAt.low) && $util.isInteger(message.createdAt.high)))
                    return "createdAt: integer|Long expected";
            if (message.senderId != null && message.hasOwnProperty("senderId"))
                if (!$util.isString(message.senderId))
                    return "senderId: string expected";
            if (message.atList != null && message.hasOwnProperty("atList")) {
                if (!Array.isArray(message.atList))
                    return "atList: array expected";
                for (let i = 0; i < message.atList.length; ++i)
                    if (!$util.isString(message.atList[i]))
                        return "atList: string[] expected";
            }
            if (message.delList != null && message.hasOwnProperty("delList")) {
                if (!Array.isArray(message.delList))
                    return "delList: array expected";
                for (let i = 0; i < message.delList.length; ++i)
                    if (!$util.isString(message.delList[i]))
                        return "delList: string[] expected";
            }
            return null;
        };

        /**
         * Creates a PullMessageSequence message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof chat.PullMessageSequence
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {chat.PullMessageSequence} PullMessageSequence
         */
        PullMessageSequence.fromObject = function fromObject(object) {
            if (object instanceof $root.chat.PullMessageSequence)
                return object;
            let message = new $root.chat.PullMessageSequence();
            if (object.chatId != null)
                message.chatId = String(object.chatId);
            if (object.messageId != null)
                message.messageId = String(object.messageId);
            if (object.createdAt != null)
                if ($util.Long)
                    (message.createdAt = $util.Long.fromValue(object.createdAt)).unsigned = false;
                else if (typeof object.createdAt === "string")
                    message.createdAt = parseInt(object.createdAt, 10);
                else if (typeof object.createdAt === "number")
                    message.createdAt = object.createdAt;
                else if (typeof object.createdAt === "object")
                    message.createdAt = new $util.LongBits(object.createdAt.low >>> 0, object.createdAt.high >>> 0).toNumber();
            if (object.senderId != null)
                message.senderId = String(object.senderId);
            if (object.atList) {
                if (!Array.isArray(object.atList))
                    throw TypeError(".chat.PullMessageSequence.atList: array expected");
                message.atList = [];
                for (let i = 0; i < object.atList.length; ++i)
                    message.atList[i] = String(object.atList[i]);
            }
            if (object.delList) {
                if (!Array.isArray(object.delList))
                    throw TypeError(".chat.PullMessageSequence.delList: array expected");
                message.delList = [];
                for (let i = 0; i < object.delList.length; ++i)
                    message.delList[i] = String(object.delList[i]);
            }
            return message;
        };

        /**
         * Creates a plain object from a PullMessageSequence message. Also converts values to other types if specified.
         * @function toObject
         * @memberof chat.PullMessageSequence
         * @static
         * @param {chat.PullMessageSequence} message PullMessageSequence
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        PullMessageSequence.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.arrays || options.defaults) {
                object.atList = [];
                object.delList = [];
            }
            if (options.defaults) {
                object.chatId = "";
                object.messageId = "";
                if ($util.Long) {
                    let long = new $util.Long(0, 0, false);
                    object.createdAt = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.createdAt = options.longs === String ? "0" : 0;
                object.senderId = "";
            }
            if (message.chatId != null && message.hasOwnProperty("chatId"))
                object.chatId = message.chatId;
            if (message.messageId != null && message.hasOwnProperty("messageId"))
                object.messageId = message.messageId;
            if (message.createdAt != null && message.hasOwnProperty("createdAt"))
                if (typeof message.createdAt === "number")
                    object.createdAt = options.longs === String ? String(message.createdAt) : message.createdAt;
                else
                    object.createdAt = options.longs === String ? $util.Long.prototype.toString.call(message.createdAt) : options.longs === Number ? new $util.LongBits(message.createdAt.low >>> 0, message.createdAt.high >>> 0).toNumber() : message.createdAt;
            if (message.senderId != null && message.hasOwnProperty("senderId"))
                object.senderId = message.senderId;
            if (message.atList && message.atList.length) {
                object.atList = [];
                for (let j = 0; j < message.atList.length; ++j)
                    object.atList[j] = message.atList[j];
            }
            if (message.delList && message.delList.length) {
                object.delList = [];
                for (let j = 0; j < message.delList.length; ++j)
                    object.delList[j] = message.delList[j];
            }
            return object;
        };

        /**
         * Converts this PullMessageSequence to JSON.
         * @function toJSON
         * @memberof chat.PullMessageSequence
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        PullMessageSequence.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for PullMessageSequence
         * @function getTypeUrl
         * @memberof chat.PullMessageSequence
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        PullMessageSequence.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/chat.PullMessageSequence";
        };

        return PullMessageSequence;
    })();

    chat.PullMessageIdListResponse = (function() {

        /**
         * Properties of a PullMessageIdListResponse.
         * @memberof chat
         * @interface IPullMessageIdListResponse
         * @property {Array.<chat.IPullMessageSequence>|null} [messageSequenceList] PullMessageIdListResponse messageSequenceList
         * @property {number|Long|null} [maxSequence] PullMessageIdListResponse maxSequence
         */

        /**
         * Constructs a new PullMessageIdListResponse.
         * @memberof chat
         * @classdesc Represents a PullMessageIdListResponse.
         * @implements IPullMessageIdListResponse
         * @constructor
         * @param {chat.IPullMessageIdListResponse=} [properties] Properties to set
         */
        function PullMessageIdListResponse(properties) {
            this.messageSequenceList = [];
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * PullMessageIdListResponse messageSequenceList.
         * @member {Array.<chat.IPullMessageSequence>} messageSequenceList
         * @memberof chat.PullMessageIdListResponse
         * @instance
         */
        PullMessageIdListResponse.prototype.messageSequenceList = $util.emptyArray;

        /**
         * PullMessageIdListResponse maxSequence.
         * @member {number|Long} maxSequence
         * @memberof chat.PullMessageIdListResponse
         * @instance
         */
        PullMessageIdListResponse.prototype.maxSequence = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * Creates a new PullMessageIdListResponse instance using the specified properties.
         * @function create
         * @memberof chat.PullMessageIdListResponse
         * @static
         * @param {chat.IPullMessageIdListResponse=} [properties] Properties to set
         * @returns {chat.PullMessageIdListResponse} PullMessageIdListResponse instance
         */
        PullMessageIdListResponse.create = function create(properties) {
            return new PullMessageIdListResponse(properties);
        };

        /**
         * Encodes the specified PullMessageIdListResponse message. Does not implicitly {@link chat.PullMessageIdListResponse.verify|verify} messages.
         * @function encode
         * @memberof chat.PullMessageIdListResponse
         * @static
         * @param {chat.IPullMessageIdListResponse} message PullMessageIdListResponse message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        PullMessageIdListResponse.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.messageSequenceList != null && message.messageSequenceList.length)
                for (let i = 0; i < message.messageSequenceList.length; ++i)
                    $root.chat.PullMessageSequence.encode(message.messageSequenceList[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
            if (message.maxSequence != null && Object.hasOwnProperty.call(message, "maxSequence"))
                writer.uint32(/* id 2, wireType 0 =*/16).int64(message.maxSequence);
            return writer;
        };

        /**
         * Encodes the specified PullMessageIdListResponse message, length delimited. Does not implicitly {@link chat.PullMessageIdListResponse.verify|verify} messages.
         * @function encodeDelimited
         * @memberof chat.PullMessageIdListResponse
         * @static
         * @param {chat.IPullMessageIdListResponse} message PullMessageIdListResponse message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        PullMessageIdListResponse.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a PullMessageIdListResponse message from the specified reader or buffer.
         * @function decode
         * @memberof chat.PullMessageIdListResponse
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {chat.PullMessageIdListResponse} PullMessageIdListResponse
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        PullMessageIdListResponse.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.chat.PullMessageIdListResponse();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1: {
                        if (!(message.messageSequenceList && message.messageSequenceList.length))
                            message.messageSequenceList = [];
                        message.messageSequenceList.push($root.chat.PullMessageSequence.decode(reader, reader.uint32()));
                        break;
                    }
                case 2: {
                        message.maxSequence = reader.int64();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a PullMessageIdListResponse message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof chat.PullMessageIdListResponse
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {chat.PullMessageIdListResponse} PullMessageIdListResponse
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        PullMessageIdListResponse.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a PullMessageIdListResponse message.
         * @function verify
         * @memberof chat.PullMessageIdListResponse
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        PullMessageIdListResponse.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.messageSequenceList != null && message.hasOwnProperty("messageSequenceList")) {
                if (!Array.isArray(message.messageSequenceList))
                    return "messageSequenceList: array expected";
                for (let i = 0; i < message.messageSequenceList.length; ++i) {
                    let error = $root.chat.PullMessageSequence.verify(message.messageSequenceList[i]);
                    if (error)
                        return "messageSequenceList." + error;
                }
            }
            if (message.maxSequence != null && message.hasOwnProperty("maxSequence"))
                if (!$util.isInteger(message.maxSequence) && !(message.maxSequence && $util.isInteger(message.maxSequence.low) && $util.isInteger(message.maxSequence.high)))
                    return "maxSequence: integer|Long expected";
            return null;
        };

        /**
         * Creates a PullMessageIdListResponse message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof chat.PullMessageIdListResponse
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {chat.PullMessageIdListResponse} PullMessageIdListResponse
         */
        PullMessageIdListResponse.fromObject = function fromObject(object) {
            if (object instanceof $root.chat.PullMessageIdListResponse)
                return object;
            let message = new $root.chat.PullMessageIdListResponse();
            if (object.messageSequenceList) {
                if (!Array.isArray(object.messageSequenceList))
                    throw TypeError(".chat.PullMessageIdListResponse.messageSequenceList: array expected");
                message.messageSequenceList = [];
                for (let i = 0; i < object.messageSequenceList.length; ++i) {
                    if (typeof object.messageSequenceList[i] !== "object")
                        throw TypeError(".chat.PullMessageIdListResponse.messageSequenceList: object expected");
                    message.messageSequenceList[i] = $root.chat.PullMessageSequence.fromObject(object.messageSequenceList[i]);
                }
            }
            if (object.maxSequence != null)
                if ($util.Long)
                    (message.maxSequence = $util.Long.fromValue(object.maxSequence)).unsigned = false;
                else if (typeof object.maxSequence === "string")
                    message.maxSequence = parseInt(object.maxSequence, 10);
                else if (typeof object.maxSequence === "number")
                    message.maxSequence = object.maxSequence;
                else if (typeof object.maxSequence === "object")
                    message.maxSequence = new $util.LongBits(object.maxSequence.low >>> 0, object.maxSequence.high >>> 0).toNumber();
            return message;
        };

        /**
         * Creates a plain object from a PullMessageIdListResponse message. Also converts values to other types if specified.
         * @function toObject
         * @memberof chat.PullMessageIdListResponse
         * @static
         * @param {chat.PullMessageIdListResponse} message PullMessageIdListResponse
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        PullMessageIdListResponse.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.arrays || options.defaults)
                object.messageSequenceList = [];
            if (options.defaults)
                if ($util.Long) {
                    let long = new $util.Long(0, 0, false);
                    object.maxSequence = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.maxSequence = options.longs === String ? "0" : 0;
            if (message.messageSequenceList && message.messageSequenceList.length) {
                object.messageSequenceList = [];
                for (let j = 0; j < message.messageSequenceList.length; ++j)
                    object.messageSequenceList[j] = $root.chat.PullMessageSequence.toObject(message.messageSequenceList[j], options);
            }
            if (message.maxSequence != null && message.hasOwnProperty("maxSequence"))
                if (typeof message.maxSequence === "number")
                    object.maxSequence = options.longs === String ? String(message.maxSequence) : message.maxSequence;
                else
                    object.maxSequence = options.longs === String ? $util.Long.prototype.toString.call(message.maxSequence) : options.longs === Number ? new $util.LongBits(message.maxSequence.low >>> 0, message.maxSequence.high >>> 0).toNumber() : message.maxSequence;
            return object;
        };

        /**
         * Converts this PullMessageIdListResponse to JSON.
         * @function toJSON
         * @memberof chat.PullMessageIdListResponse
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        PullMessageIdListResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for PullMessageIdListResponse
         * @function getTypeUrl
         * @memberof chat.PullMessageIdListResponse
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        PullMessageIdListResponse.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/chat.PullMessageIdListResponse";
        };

        return PullMessageIdListResponse;
    })();

    chat.PullMessageInfoListRequest = (function() {

        /**
         * Properties of a PullMessageInfoListRequest.
         * @memberof chat
         * @interface IPullMessageInfoListRequest
         * @property {number|null} [msgType] PullMessageInfoListRequest msgType
         * @property {Array.<string>|null} [messageIdList] PullMessageInfoListRequest messageIdList
         */

        /**
         * Constructs a new PullMessageInfoListRequest.
         * @memberof chat
         * @classdesc Represents a PullMessageInfoListRequest.
         * @implements IPullMessageInfoListRequest
         * @constructor
         * @param {chat.IPullMessageInfoListRequest=} [properties] Properties to set
         */
        function PullMessageInfoListRequest(properties) {
            this.messageIdList = [];
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * PullMessageInfoListRequest msgType.
         * @member {number} msgType
         * @memberof chat.PullMessageInfoListRequest
         * @instance
         */
        PullMessageInfoListRequest.prototype.msgType = 0;

        /**
         * PullMessageInfoListRequest messageIdList.
         * @member {Array.<string>} messageIdList
         * @memberof chat.PullMessageInfoListRequest
         * @instance
         */
        PullMessageInfoListRequest.prototype.messageIdList = $util.emptyArray;

        /**
         * Creates a new PullMessageInfoListRequest instance using the specified properties.
         * @function create
         * @memberof chat.PullMessageInfoListRequest
         * @static
         * @param {chat.IPullMessageInfoListRequest=} [properties] Properties to set
         * @returns {chat.PullMessageInfoListRequest} PullMessageInfoListRequest instance
         */
        PullMessageInfoListRequest.create = function create(properties) {
            return new PullMessageInfoListRequest(properties);
        };

        /**
         * Encodes the specified PullMessageInfoListRequest message. Does not implicitly {@link chat.PullMessageInfoListRequest.verify|verify} messages.
         * @function encode
         * @memberof chat.PullMessageInfoListRequest
         * @static
         * @param {chat.IPullMessageInfoListRequest} message PullMessageInfoListRequest message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        PullMessageInfoListRequest.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.msgType != null && Object.hasOwnProperty.call(message, "msgType"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.msgType);
            if (message.messageIdList != null && message.messageIdList.length)
                for (let i = 0; i < message.messageIdList.length; ++i)
                    writer.uint32(/* id 2, wireType 2 =*/18).string(message.messageIdList[i]);
            return writer;
        };

        /**
         * Encodes the specified PullMessageInfoListRequest message, length delimited. Does not implicitly {@link chat.PullMessageInfoListRequest.verify|verify} messages.
         * @function encodeDelimited
         * @memberof chat.PullMessageInfoListRequest
         * @static
         * @param {chat.IPullMessageInfoListRequest} message PullMessageInfoListRequest message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        PullMessageInfoListRequest.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a PullMessageInfoListRequest message from the specified reader or buffer.
         * @function decode
         * @memberof chat.PullMessageInfoListRequest
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {chat.PullMessageInfoListRequest} PullMessageInfoListRequest
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        PullMessageInfoListRequest.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.chat.PullMessageInfoListRequest();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1: {
                        message.msgType = reader.int32();
                        break;
                    }
                case 2: {
                        if (!(message.messageIdList && message.messageIdList.length))
                            message.messageIdList = [];
                        message.messageIdList.push(reader.string());
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a PullMessageInfoListRequest message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof chat.PullMessageInfoListRequest
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {chat.PullMessageInfoListRequest} PullMessageInfoListRequest
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        PullMessageInfoListRequest.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a PullMessageInfoListRequest message.
         * @function verify
         * @memberof chat.PullMessageInfoListRequest
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        PullMessageInfoListRequest.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.msgType != null && message.hasOwnProperty("msgType"))
                if (!$util.isInteger(message.msgType))
                    return "msgType: integer expected";
            if (message.messageIdList != null && message.hasOwnProperty("messageIdList")) {
                if (!Array.isArray(message.messageIdList))
                    return "messageIdList: array expected";
                for (let i = 0; i < message.messageIdList.length; ++i)
                    if (!$util.isString(message.messageIdList[i]))
                        return "messageIdList: string[] expected";
            }
            return null;
        };

        /**
         * Creates a PullMessageInfoListRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof chat.PullMessageInfoListRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {chat.PullMessageInfoListRequest} PullMessageInfoListRequest
         */
        PullMessageInfoListRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.chat.PullMessageInfoListRequest)
                return object;
            let message = new $root.chat.PullMessageInfoListRequest();
            if (object.msgType != null)
                message.msgType = object.msgType | 0;
            if (object.messageIdList) {
                if (!Array.isArray(object.messageIdList))
                    throw TypeError(".chat.PullMessageInfoListRequest.messageIdList: array expected");
                message.messageIdList = [];
                for (let i = 0; i < object.messageIdList.length; ++i)
                    message.messageIdList[i] = String(object.messageIdList[i]);
            }
            return message;
        };

        /**
         * Creates a plain object from a PullMessageInfoListRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof chat.PullMessageInfoListRequest
         * @static
         * @param {chat.PullMessageInfoListRequest} message PullMessageInfoListRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        PullMessageInfoListRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.arrays || options.defaults)
                object.messageIdList = [];
            if (options.defaults)
                object.msgType = 0;
            if (message.msgType != null && message.hasOwnProperty("msgType"))
                object.msgType = message.msgType;
            if (message.messageIdList && message.messageIdList.length) {
                object.messageIdList = [];
                for (let j = 0; j < message.messageIdList.length; ++j)
                    object.messageIdList[j] = message.messageIdList[j];
            }
            return object;
        };

        /**
         * Converts this PullMessageInfoListRequest to JSON.
         * @function toJSON
         * @memberof chat.PullMessageInfoListRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        PullMessageInfoListRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for PullMessageInfoListRequest
         * @function getTypeUrl
         * @memberof chat.PullMessageInfoListRequest
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        PullMessageInfoListRequest.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/chat.PullMessageInfoListRequest";
        };

        return PullMessageInfoListRequest;
    })();

    chat.MessageInfo = (function() {

        /**
         * Properties of a MessageInfo.
         * @memberof chat
         * @interface IMessageInfo
         * @property {string|null} [chatId] MessageInfo chatId
         * @property {string|null} [messageId] MessageInfo messageId
         * @property {number|Long|null} [msgSeq] MessageInfo msgSeq
         * @property {number|Long|null} [expireDuration] MessageInfo expireDuration
         * @property {number|null} [msgAction] MessageInfo msgAction
         * @property {string|null} [linkMsgId] MessageInfo linkMsgId
         * @property {string|null} [payload] MessageInfo payload
         * @property {number|null} [payloadType] MessageInfo payloadType
         * @property {string|null} [senderId] MessageInfo senderId
         * @property {string|null} [receiverId] MessageInfo receiverId
         * @property {number|Long|null} [createdAt] MessageInfo createdAt
         * @property {number|null} [encryptIndex] MessageInfo encryptIndex
         * @property {string|null} [cliMsgId] MessageInfo cliMsgId
         * @property {Array.<string>|null} [expectReadList] MessageInfo expectReadList
         * @property {number|null} [chatType] MessageInfo chatType
         */

        /**
         * Constructs a new MessageInfo.
         * @memberof chat
         * @classdesc Represents a MessageInfo.
         * @implements IMessageInfo
         * @constructor
         * @param {chat.IMessageInfo=} [properties] Properties to set
         */
        function MessageInfo(properties) {
            this.expectReadList = [];
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * MessageInfo chatId.
         * @member {string} chatId
         * @memberof chat.MessageInfo
         * @instance
         */
        MessageInfo.prototype.chatId = "";

        /**
         * MessageInfo messageId.
         * @member {string} messageId
         * @memberof chat.MessageInfo
         * @instance
         */
        MessageInfo.prototype.messageId = "";

        /**
         * MessageInfo msgSeq.
         * @member {number|Long} msgSeq
         * @memberof chat.MessageInfo
         * @instance
         */
        MessageInfo.prototype.msgSeq = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * MessageInfo expireDuration.
         * @member {number|Long} expireDuration
         * @memberof chat.MessageInfo
         * @instance
         */
        MessageInfo.prototype.expireDuration = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * MessageInfo msgAction.
         * @member {number} msgAction
         * @memberof chat.MessageInfo
         * @instance
         */
        MessageInfo.prototype.msgAction = 0;

        /**
         * MessageInfo linkMsgId.
         * @member {string} linkMsgId
         * @memberof chat.MessageInfo
         * @instance
         */
        MessageInfo.prototype.linkMsgId = "";

        /**
         * MessageInfo payload.
         * @member {string} payload
         * @memberof chat.MessageInfo
         * @instance
         */
        MessageInfo.prototype.payload = "";

        /**
         * MessageInfo payloadType.
         * @member {number} payloadType
         * @memberof chat.MessageInfo
         * @instance
         */
        MessageInfo.prototype.payloadType = 0;

        /**
         * MessageInfo senderId.
         * @member {string} senderId
         * @memberof chat.MessageInfo
         * @instance
         */
        MessageInfo.prototype.senderId = "";

        /**
         * MessageInfo receiverId.
         * @member {string} receiverId
         * @memberof chat.MessageInfo
         * @instance
         */
        MessageInfo.prototype.receiverId = "";

        /**
         * MessageInfo createdAt.
         * @member {number|Long} createdAt
         * @memberof chat.MessageInfo
         * @instance
         */
        MessageInfo.prototype.createdAt = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * MessageInfo encryptIndex.
         * @member {number} encryptIndex
         * @memberof chat.MessageInfo
         * @instance
         */
        MessageInfo.prototype.encryptIndex = 0;

        /**
         * MessageInfo cliMsgId.
         * @member {string} cliMsgId
         * @memberof chat.MessageInfo
         * @instance
         */
        MessageInfo.prototype.cliMsgId = "";

        /**
         * MessageInfo expectReadList.
         * @member {Array.<string>} expectReadList
         * @memberof chat.MessageInfo
         * @instance
         */
        MessageInfo.prototype.expectReadList = $util.emptyArray;

        /**
         * MessageInfo chatType.
         * @member {number} chatType
         * @memberof chat.MessageInfo
         * @instance
         */
        MessageInfo.prototype.chatType = 0;

        /**
         * Creates a new MessageInfo instance using the specified properties.
         * @function create
         * @memberof chat.MessageInfo
         * @static
         * @param {chat.IMessageInfo=} [properties] Properties to set
         * @returns {chat.MessageInfo} MessageInfo instance
         */
        MessageInfo.create = function create(properties) {
            return new MessageInfo(properties);
        };

        /**
         * Encodes the specified MessageInfo message. Does not implicitly {@link chat.MessageInfo.verify|verify} messages.
         * @function encode
         * @memberof chat.MessageInfo
         * @static
         * @param {chat.IMessageInfo} message MessageInfo message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        MessageInfo.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.chatId != null && Object.hasOwnProperty.call(message, "chatId"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.chatId);
            if (message.messageId != null && Object.hasOwnProperty.call(message, "messageId"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.messageId);
            if (message.msgSeq != null && Object.hasOwnProperty.call(message, "msgSeq"))
                writer.uint32(/* id 3, wireType 0 =*/24).int64(message.msgSeq);
            if (message.expireDuration != null && Object.hasOwnProperty.call(message, "expireDuration"))
                writer.uint32(/* id 4, wireType 0 =*/32).int64(message.expireDuration);
            if (message.msgAction != null && Object.hasOwnProperty.call(message, "msgAction"))
                writer.uint32(/* id 5, wireType 0 =*/40).int32(message.msgAction);
            if (message.linkMsgId != null && Object.hasOwnProperty.call(message, "linkMsgId"))
                writer.uint32(/* id 6, wireType 2 =*/50).string(message.linkMsgId);
            if (message.payload != null && Object.hasOwnProperty.call(message, "payload"))
                writer.uint32(/* id 7, wireType 2 =*/58).string(message.payload);
            if (message.payloadType != null && Object.hasOwnProperty.call(message, "payloadType"))
                writer.uint32(/* id 8, wireType 0 =*/64).int32(message.payloadType);
            if (message.senderId != null && Object.hasOwnProperty.call(message, "senderId"))
                writer.uint32(/* id 9, wireType 2 =*/74).string(message.senderId);
            if (message.receiverId != null && Object.hasOwnProperty.call(message, "receiverId"))
                writer.uint32(/* id 10, wireType 2 =*/82).string(message.receiverId);
            if (message.createdAt != null && Object.hasOwnProperty.call(message, "createdAt"))
                writer.uint32(/* id 11, wireType 0 =*/88).int64(message.createdAt);
            if (message.encryptIndex != null && Object.hasOwnProperty.call(message, "encryptIndex"))
                writer.uint32(/* id 12, wireType 0 =*/96).int32(message.encryptIndex);
            if (message.cliMsgId != null && Object.hasOwnProperty.call(message, "cliMsgId"))
                writer.uint32(/* id 13, wireType 2 =*/106).string(message.cliMsgId);
            if (message.expectReadList != null && message.expectReadList.length)
                for (let i = 0; i < message.expectReadList.length; ++i)
                    writer.uint32(/* id 14, wireType 2 =*/114).string(message.expectReadList[i]);
            if (message.chatType != null && Object.hasOwnProperty.call(message, "chatType"))
                writer.uint32(/* id 15, wireType 0 =*/120).int32(message.chatType);
            return writer;
        };

        /**
         * Encodes the specified MessageInfo message, length delimited. Does not implicitly {@link chat.MessageInfo.verify|verify} messages.
         * @function encodeDelimited
         * @memberof chat.MessageInfo
         * @static
         * @param {chat.IMessageInfo} message MessageInfo message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        MessageInfo.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a MessageInfo message from the specified reader or buffer.
         * @function decode
         * @memberof chat.MessageInfo
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {chat.MessageInfo} MessageInfo
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        MessageInfo.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.chat.MessageInfo();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1: {
                        message.chatId = reader.string();
                        break;
                    }
                case 2: {
                        message.messageId = reader.string();
                        break;
                    }
                case 3: {
                        message.msgSeq = reader.int64();
                        break;
                    }
                case 4: {
                        message.expireDuration = reader.int64();
                        break;
                    }
                case 5: {
                        message.msgAction = reader.int32();
                        break;
                    }
                case 6: {
                        message.linkMsgId = reader.string();
                        break;
                    }
                case 7: {
                        message.payload = reader.string();
                        break;
                    }
                case 8: {
                        message.payloadType = reader.int32();
                        break;
                    }
                case 9: {
                        message.senderId = reader.string();
                        break;
                    }
                case 10: {
                        message.receiverId = reader.string();
                        break;
                    }
                case 11: {
                        message.createdAt = reader.int64();
                        break;
                    }
                case 12: {
                        message.encryptIndex = reader.int32();
                        break;
                    }
                case 13: {
                        message.cliMsgId = reader.string();
                        break;
                    }
                case 14: {
                        if (!(message.expectReadList && message.expectReadList.length))
                            message.expectReadList = [];
                        message.expectReadList.push(reader.string());
                        break;
                    }
                case 15: {
                        message.chatType = reader.int32();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a MessageInfo message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof chat.MessageInfo
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {chat.MessageInfo} MessageInfo
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        MessageInfo.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a MessageInfo message.
         * @function verify
         * @memberof chat.MessageInfo
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        MessageInfo.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.chatId != null && message.hasOwnProperty("chatId"))
                if (!$util.isString(message.chatId))
                    return "chatId: string expected";
            if (message.messageId != null && message.hasOwnProperty("messageId"))
                if (!$util.isString(message.messageId))
                    return "messageId: string expected";
            if (message.msgSeq != null && message.hasOwnProperty("msgSeq"))
                if (!$util.isInteger(message.msgSeq) && !(message.msgSeq && $util.isInteger(message.msgSeq.low) && $util.isInteger(message.msgSeq.high)))
                    return "msgSeq: integer|Long expected";
            if (message.expireDuration != null && message.hasOwnProperty("expireDuration"))
                if (!$util.isInteger(message.expireDuration) && !(message.expireDuration && $util.isInteger(message.expireDuration.low) && $util.isInteger(message.expireDuration.high)))
                    return "expireDuration: integer|Long expected";
            if (message.msgAction != null && message.hasOwnProperty("msgAction"))
                if (!$util.isInteger(message.msgAction))
                    return "msgAction: integer expected";
            if (message.linkMsgId != null && message.hasOwnProperty("linkMsgId"))
                if (!$util.isString(message.linkMsgId))
                    return "linkMsgId: string expected";
            if (message.payload != null && message.hasOwnProperty("payload"))
                if (!$util.isString(message.payload))
                    return "payload: string expected";
            if (message.payloadType != null && message.hasOwnProperty("payloadType"))
                if (!$util.isInteger(message.payloadType))
                    return "payloadType: integer expected";
            if (message.senderId != null && message.hasOwnProperty("senderId"))
                if (!$util.isString(message.senderId))
                    return "senderId: string expected";
            if (message.receiverId != null && message.hasOwnProperty("receiverId"))
                if (!$util.isString(message.receiverId))
                    return "receiverId: string expected";
            if (message.createdAt != null && message.hasOwnProperty("createdAt"))
                if (!$util.isInteger(message.createdAt) && !(message.createdAt && $util.isInteger(message.createdAt.low) && $util.isInteger(message.createdAt.high)))
                    return "createdAt: integer|Long expected";
            if (message.encryptIndex != null && message.hasOwnProperty("encryptIndex"))
                if (!$util.isInteger(message.encryptIndex))
                    return "encryptIndex: integer expected";
            if (message.cliMsgId != null && message.hasOwnProperty("cliMsgId"))
                if (!$util.isString(message.cliMsgId))
                    return "cliMsgId: string expected";
            if (message.expectReadList != null && message.hasOwnProperty("expectReadList")) {
                if (!Array.isArray(message.expectReadList))
                    return "expectReadList: array expected";
                for (let i = 0; i < message.expectReadList.length; ++i)
                    if (!$util.isString(message.expectReadList[i]))
                        return "expectReadList: string[] expected";
            }
            if (message.chatType != null && message.hasOwnProperty("chatType"))
                if (!$util.isInteger(message.chatType))
                    return "chatType: integer expected";
            return null;
        };

        /**
         * Creates a MessageInfo message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof chat.MessageInfo
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {chat.MessageInfo} MessageInfo
         */
        MessageInfo.fromObject = function fromObject(object) {
            if (object instanceof $root.chat.MessageInfo)
                return object;
            let message = new $root.chat.MessageInfo();
            if (object.chatId != null)
                message.chatId = String(object.chatId);
            if (object.messageId != null)
                message.messageId = String(object.messageId);
            if (object.msgSeq != null)
                if ($util.Long)
                    (message.msgSeq = $util.Long.fromValue(object.msgSeq)).unsigned = false;
                else if (typeof object.msgSeq === "string")
                    message.msgSeq = parseInt(object.msgSeq, 10);
                else if (typeof object.msgSeq === "number")
                    message.msgSeq = object.msgSeq;
                else if (typeof object.msgSeq === "object")
                    message.msgSeq = new $util.LongBits(object.msgSeq.low >>> 0, object.msgSeq.high >>> 0).toNumber();
            if (object.expireDuration != null)
                if ($util.Long)
                    (message.expireDuration = $util.Long.fromValue(object.expireDuration)).unsigned = false;
                else if (typeof object.expireDuration === "string")
                    message.expireDuration = parseInt(object.expireDuration, 10);
                else if (typeof object.expireDuration === "number")
                    message.expireDuration = object.expireDuration;
                else if (typeof object.expireDuration === "object")
                    message.expireDuration = new $util.LongBits(object.expireDuration.low >>> 0, object.expireDuration.high >>> 0).toNumber();
            if (object.msgAction != null)
                message.msgAction = object.msgAction | 0;
            if (object.linkMsgId != null)
                message.linkMsgId = String(object.linkMsgId);
            if (object.payload != null)
                message.payload = String(object.payload);
            if (object.payloadType != null)
                message.payloadType = object.payloadType | 0;
            if (object.senderId != null)
                message.senderId = String(object.senderId);
            if (object.receiverId != null)
                message.receiverId = String(object.receiverId);
            if (object.createdAt != null)
                if ($util.Long)
                    (message.createdAt = $util.Long.fromValue(object.createdAt)).unsigned = false;
                else if (typeof object.createdAt === "string")
                    message.createdAt = parseInt(object.createdAt, 10);
                else if (typeof object.createdAt === "number")
                    message.createdAt = object.createdAt;
                else if (typeof object.createdAt === "object")
                    message.createdAt = new $util.LongBits(object.createdAt.low >>> 0, object.createdAt.high >>> 0).toNumber();
            if (object.encryptIndex != null)
                message.encryptIndex = object.encryptIndex | 0;
            if (object.cliMsgId != null)
                message.cliMsgId = String(object.cliMsgId);
            if (object.expectReadList) {
                if (!Array.isArray(object.expectReadList))
                    throw TypeError(".chat.MessageInfo.expectReadList: array expected");
                message.expectReadList = [];
                for (let i = 0; i < object.expectReadList.length; ++i)
                    message.expectReadList[i] = String(object.expectReadList[i]);
            }
            if (object.chatType != null)
                message.chatType = object.chatType | 0;
            return message;
        };

        /**
         * Creates a plain object from a MessageInfo message. Also converts values to other types if specified.
         * @function toObject
         * @memberof chat.MessageInfo
         * @static
         * @param {chat.MessageInfo} message MessageInfo
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        MessageInfo.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.arrays || options.defaults)
                object.expectReadList = [];
            if (options.defaults) {
                object.chatId = "";
                object.messageId = "";
                if ($util.Long) {
                    let long = new $util.Long(0, 0, false);
                    object.msgSeq = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.msgSeq = options.longs === String ? "0" : 0;
                if ($util.Long) {
                    let long = new $util.Long(0, 0, false);
                    object.expireDuration = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.expireDuration = options.longs === String ? "0" : 0;
                object.msgAction = 0;
                object.linkMsgId = "";
                object.payload = "";
                object.payloadType = 0;
                object.senderId = "";
                object.receiverId = "";
                if ($util.Long) {
                    let long = new $util.Long(0, 0, false);
                    object.createdAt = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.createdAt = options.longs === String ? "0" : 0;
                object.encryptIndex = 0;
                object.cliMsgId = "";
                object.chatType = 0;
            }
            if (message.chatId != null && message.hasOwnProperty("chatId"))
                object.chatId = message.chatId;
            if (message.messageId != null && message.hasOwnProperty("messageId"))
                object.messageId = message.messageId;
            if (message.msgSeq != null && message.hasOwnProperty("msgSeq"))
                if (typeof message.msgSeq === "number")
                    object.msgSeq = options.longs === String ? String(message.msgSeq) : message.msgSeq;
                else
                    object.msgSeq = options.longs === String ? $util.Long.prototype.toString.call(message.msgSeq) : options.longs === Number ? new $util.LongBits(message.msgSeq.low >>> 0, message.msgSeq.high >>> 0).toNumber() : message.msgSeq;
            if (message.expireDuration != null && message.hasOwnProperty("expireDuration"))
                if (typeof message.expireDuration === "number")
                    object.expireDuration = options.longs === String ? String(message.expireDuration) : message.expireDuration;
                else
                    object.expireDuration = options.longs === String ? $util.Long.prototype.toString.call(message.expireDuration) : options.longs === Number ? new $util.LongBits(message.expireDuration.low >>> 0, message.expireDuration.high >>> 0).toNumber() : message.expireDuration;
            if (message.msgAction != null && message.hasOwnProperty("msgAction"))
                object.msgAction = message.msgAction;
            if (message.linkMsgId != null && message.hasOwnProperty("linkMsgId"))
                object.linkMsgId = message.linkMsgId;
            if (message.payload != null && message.hasOwnProperty("payload"))
                object.payload = message.payload;
            if (message.payloadType != null && message.hasOwnProperty("payloadType"))
                object.payloadType = message.payloadType;
            if (message.senderId != null && message.hasOwnProperty("senderId"))
                object.senderId = message.senderId;
            if (message.receiverId != null && message.hasOwnProperty("receiverId"))
                object.receiverId = message.receiverId;
            if (message.createdAt != null && message.hasOwnProperty("createdAt"))
                if (typeof message.createdAt === "number")
                    object.createdAt = options.longs === String ? String(message.createdAt) : message.createdAt;
                else
                    object.createdAt = options.longs === String ? $util.Long.prototype.toString.call(message.createdAt) : options.longs === Number ? new $util.LongBits(message.createdAt.low >>> 0, message.createdAt.high >>> 0).toNumber() : message.createdAt;
            if (message.encryptIndex != null && message.hasOwnProperty("encryptIndex"))
                object.encryptIndex = message.encryptIndex;
            if (message.cliMsgId != null && message.hasOwnProperty("cliMsgId"))
                object.cliMsgId = message.cliMsgId;
            if (message.expectReadList && message.expectReadList.length) {
                object.expectReadList = [];
                for (let j = 0; j < message.expectReadList.length; ++j)
                    object.expectReadList[j] = message.expectReadList[j];
            }
            if (message.chatType != null && message.hasOwnProperty("chatType"))
                object.chatType = message.chatType;
            return object;
        };

        /**
         * Converts this MessageInfo to JSON.
         * @function toJSON
         * @memberof chat.MessageInfo
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        MessageInfo.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for MessageInfo
         * @function getTypeUrl
         * @memberof chat.MessageInfo
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        MessageInfo.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/chat.MessageInfo";
        };

        return MessageInfo;
    })();

    chat.PullMessageInfoListResponse = (function() {

        /**
         * Properties of a PullMessageInfoListResponse.
         * @memberof chat
         * @interface IPullMessageInfoListResponse
         * @property {Array.<chat.IMessageInfo>|null} [messageInfoList] PullMessageInfoListResponse messageInfoList
         */

        /**
         * Constructs a new PullMessageInfoListResponse.
         * @memberof chat
         * @classdesc Represents a PullMessageInfoListResponse.
         * @implements IPullMessageInfoListResponse
         * @constructor
         * @param {chat.IPullMessageInfoListResponse=} [properties] Properties to set
         */
        function PullMessageInfoListResponse(properties) {
            this.messageInfoList = [];
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * PullMessageInfoListResponse messageInfoList.
         * @member {Array.<chat.IMessageInfo>} messageInfoList
         * @memberof chat.PullMessageInfoListResponse
         * @instance
         */
        PullMessageInfoListResponse.prototype.messageInfoList = $util.emptyArray;

        /**
         * Creates a new PullMessageInfoListResponse instance using the specified properties.
         * @function create
         * @memberof chat.PullMessageInfoListResponse
         * @static
         * @param {chat.IPullMessageInfoListResponse=} [properties] Properties to set
         * @returns {chat.PullMessageInfoListResponse} PullMessageInfoListResponse instance
         */
        PullMessageInfoListResponse.create = function create(properties) {
            return new PullMessageInfoListResponse(properties);
        };

        /**
         * Encodes the specified PullMessageInfoListResponse message. Does not implicitly {@link chat.PullMessageInfoListResponse.verify|verify} messages.
         * @function encode
         * @memberof chat.PullMessageInfoListResponse
         * @static
         * @param {chat.IPullMessageInfoListResponse} message PullMessageInfoListResponse message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        PullMessageInfoListResponse.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.messageInfoList != null && message.messageInfoList.length)
                for (let i = 0; i < message.messageInfoList.length; ++i)
                    $root.chat.MessageInfo.encode(message.messageInfoList[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified PullMessageInfoListResponse message, length delimited. Does not implicitly {@link chat.PullMessageInfoListResponse.verify|verify} messages.
         * @function encodeDelimited
         * @memberof chat.PullMessageInfoListResponse
         * @static
         * @param {chat.IPullMessageInfoListResponse} message PullMessageInfoListResponse message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        PullMessageInfoListResponse.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a PullMessageInfoListResponse message from the specified reader or buffer.
         * @function decode
         * @memberof chat.PullMessageInfoListResponse
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {chat.PullMessageInfoListResponse} PullMessageInfoListResponse
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        PullMessageInfoListResponse.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.chat.PullMessageInfoListResponse();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1: {
                        if (!(message.messageInfoList && message.messageInfoList.length))
                            message.messageInfoList = [];
                        message.messageInfoList.push($root.chat.MessageInfo.decode(reader, reader.uint32()));
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a PullMessageInfoListResponse message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof chat.PullMessageInfoListResponse
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {chat.PullMessageInfoListResponse} PullMessageInfoListResponse
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        PullMessageInfoListResponse.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a PullMessageInfoListResponse message.
         * @function verify
         * @memberof chat.PullMessageInfoListResponse
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        PullMessageInfoListResponse.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.messageInfoList != null && message.hasOwnProperty("messageInfoList")) {
                if (!Array.isArray(message.messageInfoList))
                    return "messageInfoList: array expected";
                for (let i = 0; i < message.messageInfoList.length; ++i) {
                    let error = $root.chat.MessageInfo.verify(message.messageInfoList[i]);
                    if (error)
                        return "messageInfoList." + error;
                }
            }
            return null;
        };

        /**
         * Creates a PullMessageInfoListResponse message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof chat.PullMessageInfoListResponse
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {chat.PullMessageInfoListResponse} PullMessageInfoListResponse
         */
        PullMessageInfoListResponse.fromObject = function fromObject(object) {
            if (object instanceof $root.chat.PullMessageInfoListResponse)
                return object;
            let message = new $root.chat.PullMessageInfoListResponse();
            if (object.messageInfoList) {
                if (!Array.isArray(object.messageInfoList))
                    throw TypeError(".chat.PullMessageInfoListResponse.messageInfoList: array expected");
                message.messageInfoList = [];
                for (let i = 0; i < object.messageInfoList.length; ++i) {
                    if (typeof object.messageInfoList[i] !== "object")
                        throw TypeError(".chat.PullMessageInfoListResponse.messageInfoList: object expected");
                    message.messageInfoList[i] = $root.chat.MessageInfo.fromObject(object.messageInfoList[i]);
                }
            }
            return message;
        };

        /**
         * Creates a plain object from a PullMessageInfoListResponse message. Also converts values to other types if specified.
         * @function toObject
         * @memberof chat.PullMessageInfoListResponse
         * @static
         * @param {chat.PullMessageInfoListResponse} message PullMessageInfoListResponse
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        PullMessageInfoListResponse.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.arrays || options.defaults)
                object.messageInfoList = [];
            if (message.messageInfoList && message.messageInfoList.length) {
                object.messageInfoList = [];
                for (let j = 0; j < message.messageInfoList.length; ++j)
                    object.messageInfoList[j] = $root.chat.MessageInfo.toObject(message.messageInfoList[j], options);
            }
            return object;
        };

        /**
         * Converts this PullMessageInfoListResponse to JSON.
         * @function toJSON
         * @memberof chat.PullMessageInfoListResponse
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        PullMessageInfoListResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for PullMessageInfoListResponse
         * @function getTypeUrl
         * @memberof chat.PullMessageInfoListResponse
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        PullMessageInfoListResponse.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/chat.PullMessageInfoListResponse";
        };

        return PullMessageInfoListResponse;
    })();

    chat.MessageArrivalReplyRequest = (function() {

        /**
         * Properties of a MessageArrivalReplyRequest.
         * @memberof chat
         * @interface IMessageArrivalReplyRequest
         * @property {string|null} [chatId] MessageArrivalReplyRequest chatId
         * @property {Array.<string>|null} [messageIdList] MessageArrivalReplyRequest messageIdList
         */

        /**
         * Constructs a new MessageArrivalReplyRequest.
         * @memberof chat
         * @classdesc Represents a MessageArrivalReplyRequest.
         * @implements IMessageArrivalReplyRequest
         * @constructor
         * @param {chat.IMessageArrivalReplyRequest=} [properties] Properties to set
         */
        function MessageArrivalReplyRequest(properties) {
            this.messageIdList = [];
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * MessageArrivalReplyRequest chatId.
         * @member {string} chatId
         * @memberof chat.MessageArrivalReplyRequest
         * @instance
         */
        MessageArrivalReplyRequest.prototype.chatId = "";

        /**
         * MessageArrivalReplyRequest messageIdList.
         * @member {Array.<string>} messageIdList
         * @memberof chat.MessageArrivalReplyRequest
         * @instance
         */
        MessageArrivalReplyRequest.prototype.messageIdList = $util.emptyArray;

        /**
         * Creates a new MessageArrivalReplyRequest instance using the specified properties.
         * @function create
         * @memberof chat.MessageArrivalReplyRequest
         * @static
         * @param {chat.IMessageArrivalReplyRequest=} [properties] Properties to set
         * @returns {chat.MessageArrivalReplyRequest} MessageArrivalReplyRequest instance
         */
        MessageArrivalReplyRequest.create = function create(properties) {
            return new MessageArrivalReplyRequest(properties);
        };

        /**
         * Encodes the specified MessageArrivalReplyRequest message. Does not implicitly {@link chat.MessageArrivalReplyRequest.verify|verify} messages.
         * @function encode
         * @memberof chat.MessageArrivalReplyRequest
         * @static
         * @param {chat.IMessageArrivalReplyRequest} message MessageArrivalReplyRequest message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        MessageArrivalReplyRequest.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.chatId != null && Object.hasOwnProperty.call(message, "chatId"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.chatId);
            if (message.messageIdList != null && message.messageIdList.length)
                for (let i = 0; i < message.messageIdList.length; ++i)
                    writer.uint32(/* id 2, wireType 2 =*/18).string(message.messageIdList[i]);
            return writer;
        };

        /**
         * Encodes the specified MessageArrivalReplyRequest message, length delimited. Does not implicitly {@link chat.MessageArrivalReplyRequest.verify|verify} messages.
         * @function encodeDelimited
         * @memberof chat.MessageArrivalReplyRequest
         * @static
         * @param {chat.IMessageArrivalReplyRequest} message MessageArrivalReplyRequest message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        MessageArrivalReplyRequest.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a MessageArrivalReplyRequest message from the specified reader or buffer.
         * @function decode
         * @memberof chat.MessageArrivalReplyRequest
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {chat.MessageArrivalReplyRequest} MessageArrivalReplyRequest
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        MessageArrivalReplyRequest.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.chat.MessageArrivalReplyRequest();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1: {
                        message.chatId = reader.string();
                        break;
                    }
                case 2: {
                        if (!(message.messageIdList && message.messageIdList.length))
                            message.messageIdList = [];
                        message.messageIdList.push(reader.string());
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a MessageArrivalReplyRequest message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof chat.MessageArrivalReplyRequest
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {chat.MessageArrivalReplyRequest} MessageArrivalReplyRequest
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        MessageArrivalReplyRequest.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a MessageArrivalReplyRequest message.
         * @function verify
         * @memberof chat.MessageArrivalReplyRequest
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        MessageArrivalReplyRequest.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.chatId != null && message.hasOwnProperty("chatId"))
                if (!$util.isString(message.chatId))
                    return "chatId: string expected";
            if (message.messageIdList != null && message.hasOwnProperty("messageIdList")) {
                if (!Array.isArray(message.messageIdList))
                    return "messageIdList: array expected";
                for (let i = 0; i < message.messageIdList.length; ++i)
                    if (!$util.isString(message.messageIdList[i]))
                        return "messageIdList: string[] expected";
            }
            return null;
        };

        /**
         * Creates a MessageArrivalReplyRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof chat.MessageArrivalReplyRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {chat.MessageArrivalReplyRequest} MessageArrivalReplyRequest
         */
        MessageArrivalReplyRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.chat.MessageArrivalReplyRequest)
                return object;
            let message = new $root.chat.MessageArrivalReplyRequest();
            if (object.chatId != null)
                message.chatId = String(object.chatId);
            if (object.messageIdList) {
                if (!Array.isArray(object.messageIdList))
                    throw TypeError(".chat.MessageArrivalReplyRequest.messageIdList: array expected");
                message.messageIdList = [];
                for (let i = 0; i < object.messageIdList.length; ++i)
                    message.messageIdList[i] = String(object.messageIdList[i]);
            }
            return message;
        };

        /**
         * Creates a plain object from a MessageArrivalReplyRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof chat.MessageArrivalReplyRequest
         * @static
         * @param {chat.MessageArrivalReplyRequest} message MessageArrivalReplyRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        MessageArrivalReplyRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.arrays || options.defaults)
                object.messageIdList = [];
            if (options.defaults)
                object.chatId = "";
            if (message.chatId != null && message.hasOwnProperty("chatId"))
                object.chatId = message.chatId;
            if (message.messageIdList && message.messageIdList.length) {
                object.messageIdList = [];
                for (let j = 0; j < message.messageIdList.length; ++j)
                    object.messageIdList[j] = message.messageIdList[j];
            }
            return object;
        };

        /**
         * Converts this MessageArrivalReplyRequest to JSON.
         * @function toJSON
         * @memberof chat.MessageArrivalReplyRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        MessageArrivalReplyRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for MessageArrivalReplyRequest
         * @function getTypeUrl
         * @memberof chat.MessageArrivalReplyRequest
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        MessageArrivalReplyRequest.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/chat.MessageArrivalReplyRequest";
        };

        return MessageArrivalReplyRequest;
    })();

    chat.MessageArrivalReplyResponse = (function() {

        /**
         * Properties of a MessageArrivalReplyResponse.
         * @memberof chat
         * @interface IMessageArrivalReplyResponse
         * @property {number|null} [code] MessageArrivalReplyResponse code
         */

        /**
         * Constructs a new MessageArrivalReplyResponse.
         * @memberof chat
         * @classdesc Represents a MessageArrivalReplyResponse.
         * @implements IMessageArrivalReplyResponse
         * @constructor
         * @param {chat.IMessageArrivalReplyResponse=} [properties] Properties to set
         */
        function MessageArrivalReplyResponse(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * MessageArrivalReplyResponse code.
         * @member {number} code
         * @memberof chat.MessageArrivalReplyResponse
         * @instance
         */
        MessageArrivalReplyResponse.prototype.code = 0;

        /**
         * Creates a new MessageArrivalReplyResponse instance using the specified properties.
         * @function create
         * @memberof chat.MessageArrivalReplyResponse
         * @static
         * @param {chat.IMessageArrivalReplyResponse=} [properties] Properties to set
         * @returns {chat.MessageArrivalReplyResponse} MessageArrivalReplyResponse instance
         */
        MessageArrivalReplyResponse.create = function create(properties) {
            return new MessageArrivalReplyResponse(properties);
        };

        /**
         * Encodes the specified MessageArrivalReplyResponse message. Does not implicitly {@link chat.MessageArrivalReplyResponse.verify|verify} messages.
         * @function encode
         * @memberof chat.MessageArrivalReplyResponse
         * @static
         * @param {chat.IMessageArrivalReplyResponse} message MessageArrivalReplyResponse message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        MessageArrivalReplyResponse.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.code != null && Object.hasOwnProperty.call(message, "code"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.code);
            return writer;
        };

        /**
         * Encodes the specified MessageArrivalReplyResponse message, length delimited. Does not implicitly {@link chat.MessageArrivalReplyResponse.verify|verify} messages.
         * @function encodeDelimited
         * @memberof chat.MessageArrivalReplyResponse
         * @static
         * @param {chat.IMessageArrivalReplyResponse} message MessageArrivalReplyResponse message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        MessageArrivalReplyResponse.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a MessageArrivalReplyResponse message from the specified reader or buffer.
         * @function decode
         * @memberof chat.MessageArrivalReplyResponse
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {chat.MessageArrivalReplyResponse} MessageArrivalReplyResponse
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        MessageArrivalReplyResponse.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.chat.MessageArrivalReplyResponse();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1: {
                        message.code = reader.int32();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a MessageArrivalReplyResponse message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof chat.MessageArrivalReplyResponse
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {chat.MessageArrivalReplyResponse} MessageArrivalReplyResponse
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        MessageArrivalReplyResponse.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a MessageArrivalReplyResponse message.
         * @function verify
         * @memberof chat.MessageArrivalReplyResponse
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        MessageArrivalReplyResponse.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.code != null && message.hasOwnProperty("code"))
                if (!$util.isInteger(message.code))
                    return "code: integer expected";
            return null;
        };

        /**
         * Creates a MessageArrivalReplyResponse message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof chat.MessageArrivalReplyResponse
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {chat.MessageArrivalReplyResponse} MessageArrivalReplyResponse
         */
        MessageArrivalReplyResponse.fromObject = function fromObject(object) {
            if (object instanceof $root.chat.MessageArrivalReplyResponse)
                return object;
            let message = new $root.chat.MessageArrivalReplyResponse();
            if (object.code != null)
                message.code = object.code | 0;
            return message;
        };

        /**
         * Creates a plain object from a MessageArrivalReplyResponse message. Also converts values to other types if specified.
         * @function toObject
         * @memberof chat.MessageArrivalReplyResponse
         * @static
         * @param {chat.MessageArrivalReplyResponse} message MessageArrivalReplyResponse
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        MessageArrivalReplyResponse.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults)
                object.code = 0;
            if (message.code != null && message.hasOwnProperty("code"))
                object.code = message.code;
            return object;
        };

        /**
         * Converts this MessageArrivalReplyResponse to JSON.
         * @function toJSON
         * @memberof chat.MessageArrivalReplyResponse
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        MessageArrivalReplyResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for MessageArrivalReplyResponse
         * @function getTypeUrl
         * @memberof chat.MessageArrivalReplyResponse
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        MessageArrivalReplyResponse.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/chat.MessageArrivalReplyResponse";
        };

        return MessageArrivalReplyResponse;
    })();

    chat.ReadBurnMessageReplyRequest = (function() {

        /**
         * Properties of a ReadBurnMessageReplyRequest.
         * @memberof chat
         * @interface IReadBurnMessageReplyRequest
         * @property {string|null} [chatId] ReadBurnMessageReplyRequest chatId
         * @property {Array.<string>|null} [messageIdList] ReadBurnMessageReplyRequest messageIdList
         */

        /**
         * Constructs a new ReadBurnMessageReplyRequest.
         * @memberof chat
         * @classdesc Represents a ReadBurnMessageReplyRequest.
         * @implements IReadBurnMessageReplyRequest
         * @constructor
         * @param {chat.IReadBurnMessageReplyRequest=} [properties] Properties to set
         */
        function ReadBurnMessageReplyRequest(properties) {
            this.messageIdList = [];
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ReadBurnMessageReplyRequest chatId.
         * @member {string} chatId
         * @memberof chat.ReadBurnMessageReplyRequest
         * @instance
         */
        ReadBurnMessageReplyRequest.prototype.chatId = "";

        /**
         * ReadBurnMessageReplyRequest messageIdList.
         * @member {Array.<string>} messageIdList
         * @memberof chat.ReadBurnMessageReplyRequest
         * @instance
         */
        ReadBurnMessageReplyRequest.prototype.messageIdList = $util.emptyArray;

        /**
         * Creates a new ReadBurnMessageReplyRequest instance using the specified properties.
         * @function create
         * @memberof chat.ReadBurnMessageReplyRequest
         * @static
         * @param {chat.IReadBurnMessageReplyRequest=} [properties] Properties to set
         * @returns {chat.ReadBurnMessageReplyRequest} ReadBurnMessageReplyRequest instance
         */
        ReadBurnMessageReplyRequest.create = function create(properties) {
            return new ReadBurnMessageReplyRequest(properties);
        };

        /**
         * Encodes the specified ReadBurnMessageReplyRequest message. Does not implicitly {@link chat.ReadBurnMessageReplyRequest.verify|verify} messages.
         * @function encode
         * @memberof chat.ReadBurnMessageReplyRequest
         * @static
         * @param {chat.IReadBurnMessageReplyRequest} message ReadBurnMessageReplyRequest message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ReadBurnMessageReplyRequest.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.chatId != null && Object.hasOwnProperty.call(message, "chatId"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.chatId);
            if (message.messageIdList != null && message.messageIdList.length)
                for (let i = 0; i < message.messageIdList.length; ++i)
                    writer.uint32(/* id 2, wireType 2 =*/18).string(message.messageIdList[i]);
            return writer;
        };

        /**
         * Encodes the specified ReadBurnMessageReplyRequest message, length delimited. Does not implicitly {@link chat.ReadBurnMessageReplyRequest.verify|verify} messages.
         * @function encodeDelimited
         * @memberof chat.ReadBurnMessageReplyRequest
         * @static
         * @param {chat.IReadBurnMessageReplyRequest} message ReadBurnMessageReplyRequest message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ReadBurnMessageReplyRequest.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a ReadBurnMessageReplyRequest message from the specified reader or buffer.
         * @function decode
         * @memberof chat.ReadBurnMessageReplyRequest
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {chat.ReadBurnMessageReplyRequest} ReadBurnMessageReplyRequest
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ReadBurnMessageReplyRequest.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.chat.ReadBurnMessageReplyRequest();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1: {
                        message.chatId = reader.string();
                        break;
                    }
                case 2: {
                        if (!(message.messageIdList && message.messageIdList.length))
                            message.messageIdList = [];
                        message.messageIdList.push(reader.string());
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a ReadBurnMessageReplyRequest message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof chat.ReadBurnMessageReplyRequest
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {chat.ReadBurnMessageReplyRequest} ReadBurnMessageReplyRequest
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ReadBurnMessageReplyRequest.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a ReadBurnMessageReplyRequest message.
         * @function verify
         * @memberof chat.ReadBurnMessageReplyRequest
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        ReadBurnMessageReplyRequest.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.chatId != null && message.hasOwnProperty("chatId"))
                if (!$util.isString(message.chatId))
                    return "chatId: string expected";
            if (message.messageIdList != null && message.hasOwnProperty("messageIdList")) {
                if (!Array.isArray(message.messageIdList))
                    return "messageIdList: array expected";
                for (let i = 0; i < message.messageIdList.length; ++i)
                    if (!$util.isString(message.messageIdList[i]))
                        return "messageIdList: string[] expected";
            }
            return null;
        };

        /**
         * Creates a ReadBurnMessageReplyRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof chat.ReadBurnMessageReplyRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {chat.ReadBurnMessageReplyRequest} ReadBurnMessageReplyRequest
         */
        ReadBurnMessageReplyRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.chat.ReadBurnMessageReplyRequest)
                return object;
            let message = new $root.chat.ReadBurnMessageReplyRequest();
            if (object.chatId != null)
                message.chatId = String(object.chatId);
            if (object.messageIdList) {
                if (!Array.isArray(object.messageIdList))
                    throw TypeError(".chat.ReadBurnMessageReplyRequest.messageIdList: array expected");
                message.messageIdList = [];
                for (let i = 0; i < object.messageIdList.length; ++i)
                    message.messageIdList[i] = String(object.messageIdList[i]);
            }
            return message;
        };

        /**
         * Creates a plain object from a ReadBurnMessageReplyRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof chat.ReadBurnMessageReplyRequest
         * @static
         * @param {chat.ReadBurnMessageReplyRequest} message ReadBurnMessageReplyRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ReadBurnMessageReplyRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.arrays || options.defaults)
                object.messageIdList = [];
            if (options.defaults)
                object.chatId = "";
            if (message.chatId != null && message.hasOwnProperty("chatId"))
                object.chatId = message.chatId;
            if (message.messageIdList && message.messageIdList.length) {
                object.messageIdList = [];
                for (let j = 0; j < message.messageIdList.length; ++j)
                    object.messageIdList[j] = message.messageIdList[j];
            }
            return object;
        };

        /**
         * Converts this ReadBurnMessageReplyRequest to JSON.
         * @function toJSON
         * @memberof chat.ReadBurnMessageReplyRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ReadBurnMessageReplyRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for ReadBurnMessageReplyRequest
         * @function getTypeUrl
         * @memberof chat.ReadBurnMessageReplyRequest
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        ReadBurnMessageReplyRequest.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/chat.ReadBurnMessageReplyRequest";
        };

        return ReadBurnMessageReplyRequest;
    })();

    chat.ReadBurnMessageReplyResponse = (function() {

        /**
         * Properties of a ReadBurnMessageReplyResponse.
         * @memberof chat
         * @interface IReadBurnMessageReplyResponse
         * @property {number|null} [code] ReadBurnMessageReplyResponse code
         * @property {number|Long|null} [createdAt] ReadBurnMessageReplyResponse createdAt
         */

        /**
         * Constructs a new ReadBurnMessageReplyResponse.
         * @memberof chat
         * @classdesc Represents a ReadBurnMessageReplyResponse.
         * @implements IReadBurnMessageReplyResponse
         * @constructor
         * @param {chat.IReadBurnMessageReplyResponse=} [properties] Properties to set
         */
        function ReadBurnMessageReplyResponse(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ReadBurnMessageReplyResponse code.
         * @member {number} code
         * @memberof chat.ReadBurnMessageReplyResponse
         * @instance
         */
        ReadBurnMessageReplyResponse.prototype.code = 0;

        /**
         * ReadBurnMessageReplyResponse createdAt.
         * @member {number|Long} createdAt
         * @memberof chat.ReadBurnMessageReplyResponse
         * @instance
         */
        ReadBurnMessageReplyResponse.prototype.createdAt = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * Creates a new ReadBurnMessageReplyResponse instance using the specified properties.
         * @function create
         * @memberof chat.ReadBurnMessageReplyResponse
         * @static
         * @param {chat.IReadBurnMessageReplyResponse=} [properties] Properties to set
         * @returns {chat.ReadBurnMessageReplyResponse} ReadBurnMessageReplyResponse instance
         */
        ReadBurnMessageReplyResponse.create = function create(properties) {
            return new ReadBurnMessageReplyResponse(properties);
        };

        /**
         * Encodes the specified ReadBurnMessageReplyResponse message. Does not implicitly {@link chat.ReadBurnMessageReplyResponse.verify|verify} messages.
         * @function encode
         * @memberof chat.ReadBurnMessageReplyResponse
         * @static
         * @param {chat.IReadBurnMessageReplyResponse} message ReadBurnMessageReplyResponse message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ReadBurnMessageReplyResponse.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.code != null && Object.hasOwnProperty.call(message, "code"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.code);
            if (message.createdAt != null && Object.hasOwnProperty.call(message, "createdAt"))
                writer.uint32(/* id 2, wireType 0 =*/16).int64(message.createdAt);
            return writer;
        };

        /**
         * Encodes the specified ReadBurnMessageReplyResponse message, length delimited. Does not implicitly {@link chat.ReadBurnMessageReplyResponse.verify|verify} messages.
         * @function encodeDelimited
         * @memberof chat.ReadBurnMessageReplyResponse
         * @static
         * @param {chat.IReadBurnMessageReplyResponse} message ReadBurnMessageReplyResponse message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ReadBurnMessageReplyResponse.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a ReadBurnMessageReplyResponse message from the specified reader or buffer.
         * @function decode
         * @memberof chat.ReadBurnMessageReplyResponse
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {chat.ReadBurnMessageReplyResponse} ReadBurnMessageReplyResponse
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ReadBurnMessageReplyResponse.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.chat.ReadBurnMessageReplyResponse();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1: {
                        message.code = reader.int32();
                        break;
                    }
                case 2: {
                        message.createdAt = reader.int64();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a ReadBurnMessageReplyResponse message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof chat.ReadBurnMessageReplyResponse
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {chat.ReadBurnMessageReplyResponse} ReadBurnMessageReplyResponse
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ReadBurnMessageReplyResponse.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a ReadBurnMessageReplyResponse message.
         * @function verify
         * @memberof chat.ReadBurnMessageReplyResponse
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        ReadBurnMessageReplyResponse.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.code != null && message.hasOwnProperty("code"))
                if (!$util.isInteger(message.code))
                    return "code: integer expected";
            if (message.createdAt != null && message.hasOwnProperty("createdAt"))
                if (!$util.isInteger(message.createdAt) && !(message.createdAt && $util.isInteger(message.createdAt.low) && $util.isInteger(message.createdAt.high)))
                    return "createdAt: integer|Long expected";
            return null;
        };

        /**
         * Creates a ReadBurnMessageReplyResponse message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof chat.ReadBurnMessageReplyResponse
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {chat.ReadBurnMessageReplyResponse} ReadBurnMessageReplyResponse
         */
        ReadBurnMessageReplyResponse.fromObject = function fromObject(object) {
            if (object instanceof $root.chat.ReadBurnMessageReplyResponse)
                return object;
            let message = new $root.chat.ReadBurnMessageReplyResponse();
            if (object.code != null)
                message.code = object.code | 0;
            if (object.createdAt != null)
                if ($util.Long)
                    (message.createdAt = $util.Long.fromValue(object.createdAt)).unsigned = false;
                else if (typeof object.createdAt === "string")
                    message.createdAt = parseInt(object.createdAt, 10);
                else if (typeof object.createdAt === "number")
                    message.createdAt = object.createdAt;
                else if (typeof object.createdAt === "object")
                    message.createdAt = new $util.LongBits(object.createdAt.low >>> 0, object.createdAt.high >>> 0).toNumber();
            return message;
        };

        /**
         * Creates a plain object from a ReadBurnMessageReplyResponse message. Also converts values to other types if specified.
         * @function toObject
         * @memberof chat.ReadBurnMessageReplyResponse
         * @static
         * @param {chat.ReadBurnMessageReplyResponse} message ReadBurnMessageReplyResponse
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ReadBurnMessageReplyResponse.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.code = 0;
                if ($util.Long) {
                    let long = new $util.Long(0, 0, false);
                    object.createdAt = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.createdAt = options.longs === String ? "0" : 0;
            }
            if (message.code != null && message.hasOwnProperty("code"))
                object.code = message.code;
            if (message.createdAt != null && message.hasOwnProperty("createdAt"))
                if (typeof message.createdAt === "number")
                    object.createdAt = options.longs === String ? String(message.createdAt) : message.createdAt;
                else
                    object.createdAt = options.longs === String ? $util.Long.prototype.toString.call(message.createdAt) : options.longs === Number ? new $util.LongBits(message.createdAt.low >>> 0, message.createdAt.high >>> 0).toNumber() : message.createdAt;
            return object;
        };

        /**
         * Converts this ReadBurnMessageReplyResponse to JSON.
         * @function toJSON
         * @memberof chat.ReadBurnMessageReplyResponse
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ReadBurnMessageReplyResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for ReadBurnMessageReplyResponse
         * @function getTypeUrl
         * @memberof chat.ReadBurnMessageReplyResponse
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        ReadBurnMessageReplyResponse.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/chat.ReadBurnMessageReplyResponse";
        };

        return ReadBurnMessageReplyResponse;
    })();

    chat.GetMediaCallTokenRequest = (function() {

        /**
         * Properties of a GetMediaCallTokenRequest.
         * @memberof chat
         * @interface IGetMediaCallTokenRequest
         * @property {string|null} [targetId] GetMediaCallTokenRequest targetId
         * @property {number|null} [type] GetMediaCallTokenRequest type
         * @property {string|null} [chatId] GetMediaCallTokenRequest chatId
         */

        /**
         * Constructs a new GetMediaCallTokenRequest.
         * @memberof chat
         * @classdesc Represents a GetMediaCallTokenRequest.
         * @implements IGetMediaCallTokenRequest
         * @constructor
         * @param {chat.IGetMediaCallTokenRequest=} [properties] Properties to set
         */
        function GetMediaCallTokenRequest(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * GetMediaCallTokenRequest targetId.
         * @member {string} targetId
         * @memberof chat.GetMediaCallTokenRequest
         * @instance
         */
        GetMediaCallTokenRequest.prototype.targetId = "";

        /**
         * GetMediaCallTokenRequest type.
         * @member {number} type
         * @memberof chat.GetMediaCallTokenRequest
         * @instance
         */
        GetMediaCallTokenRequest.prototype.type = 0;

        /**
         * GetMediaCallTokenRequest chatId.
         * @member {string} chatId
         * @memberof chat.GetMediaCallTokenRequest
         * @instance
         */
        GetMediaCallTokenRequest.prototype.chatId = "";

        /**
         * Creates a new GetMediaCallTokenRequest instance using the specified properties.
         * @function create
         * @memberof chat.GetMediaCallTokenRequest
         * @static
         * @param {chat.IGetMediaCallTokenRequest=} [properties] Properties to set
         * @returns {chat.GetMediaCallTokenRequest} GetMediaCallTokenRequest instance
         */
        GetMediaCallTokenRequest.create = function create(properties) {
            return new GetMediaCallTokenRequest(properties);
        };

        /**
         * Encodes the specified GetMediaCallTokenRequest message. Does not implicitly {@link chat.GetMediaCallTokenRequest.verify|verify} messages.
         * @function encode
         * @memberof chat.GetMediaCallTokenRequest
         * @static
         * @param {chat.IGetMediaCallTokenRequest} message GetMediaCallTokenRequest message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        GetMediaCallTokenRequest.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.targetId != null && Object.hasOwnProperty.call(message, "targetId"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.targetId);
            if (message.type != null && Object.hasOwnProperty.call(message, "type"))
                writer.uint32(/* id 2, wireType 0 =*/16).int32(message.type);
            if (message.chatId != null && Object.hasOwnProperty.call(message, "chatId"))
                writer.uint32(/* id 3, wireType 2 =*/26).string(message.chatId);
            return writer;
        };

        /**
         * Encodes the specified GetMediaCallTokenRequest message, length delimited. Does not implicitly {@link chat.GetMediaCallTokenRequest.verify|verify} messages.
         * @function encodeDelimited
         * @memberof chat.GetMediaCallTokenRequest
         * @static
         * @param {chat.IGetMediaCallTokenRequest} message GetMediaCallTokenRequest message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        GetMediaCallTokenRequest.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a GetMediaCallTokenRequest message from the specified reader or buffer.
         * @function decode
         * @memberof chat.GetMediaCallTokenRequest
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {chat.GetMediaCallTokenRequest} GetMediaCallTokenRequest
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        GetMediaCallTokenRequest.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.chat.GetMediaCallTokenRequest();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1: {
                        message.targetId = reader.string();
                        break;
                    }
                case 2: {
                        message.type = reader.int32();
                        break;
                    }
                case 3: {
                        message.chatId = reader.string();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a GetMediaCallTokenRequest message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof chat.GetMediaCallTokenRequest
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {chat.GetMediaCallTokenRequest} GetMediaCallTokenRequest
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        GetMediaCallTokenRequest.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a GetMediaCallTokenRequest message.
         * @function verify
         * @memberof chat.GetMediaCallTokenRequest
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        GetMediaCallTokenRequest.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.targetId != null && message.hasOwnProperty("targetId"))
                if (!$util.isString(message.targetId))
                    return "targetId: string expected";
            if (message.type != null && message.hasOwnProperty("type"))
                if (!$util.isInteger(message.type))
                    return "type: integer expected";
            if (message.chatId != null && message.hasOwnProperty("chatId"))
                if (!$util.isString(message.chatId))
                    return "chatId: string expected";
            return null;
        };

        /**
         * Creates a GetMediaCallTokenRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof chat.GetMediaCallTokenRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {chat.GetMediaCallTokenRequest} GetMediaCallTokenRequest
         */
        GetMediaCallTokenRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.chat.GetMediaCallTokenRequest)
                return object;
            let message = new $root.chat.GetMediaCallTokenRequest();
            if (object.targetId != null)
                message.targetId = String(object.targetId);
            if (object.type != null)
                message.type = object.type | 0;
            if (object.chatId != null)
                message.chatId = String(object.chatId);
            return message;
        };

        /**
         * Creates a plain object from a GetMediaCallTokenRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof chat.GetMediaCallTokenRequest
         * @static
         * @param {chat.GetMediaCallTokenRequest} message GetMediaCallTokenRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        GetMediaCallTokenRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.targetId = "";
                object.type = 0;
                object.chatId = "";
            }
            if (message.targetId != null && message.hasOwnProperty("targetId"))
                object.targetId = message.targetId;
            if (message.type != null && message.hasOwnProperty("type"))
                object.type = message.type;
            if (message.chatId != null && message.hasOwnProperty("chatId"))
                object.chatId = message.chatId;
            return object;
        };

        /**
         * Converts this GetMediaCallTokenRequest to JSON.
         * @function toJSON
         * @memberof chat.GetMediaCallTokenRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        GetMediaCallTokenRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for GetMediaCallTokenRequest
         * @function getTypeUrl
         * @memberof chat.GetMediaCallTokenRequest
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        GetMediaCallTokenRequest.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/chat.GetMediaCallTokenRequest";
        };

        return GetMediaCallTokenRequest;
    })();

    chat.GetMediaCallTokenResponse = (function() {

        /**
         * Properties of a GetMediaCallTokenResponse.
         * @memberof chat
         * @interface IGetMediaCallTokenResponse
         * @property {number|null} [isBusy] GetMediaCallTokenResponse isBusy
         * @property {string|null} [rtcToken] GetMediaCallTokenResponse rtcToken
         * @property {string|null} [roomId] GetMediaCallTokenResponse roomId
         * @property {number|null} [statusCode] GetMediaCallTokenResponse statusCode
         */

        /**
         * Constructs a new GetMediaCallTokenResponse.
         * @memberof chat
         * @classdesc Represents a GetMediaCallTokenResponse.
         * @implements IGetMediaCallTokenResponse
         * @constructor
         * @param {chat.IGetMediaCallTokenResponse=} [properties] Properties to set
         */
        function GetMediaCallTokenResponse(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * GetMediaCallTokenResponse isBusy.
         * @member {number} isBusy
         * @memberof chat.GetMediaCallTokenResponse
         * @instance
         */
        GetMediaCallTokenResponse.prototype.isBusy = 0;

        /**
         * GetMediaCallTokenResponse rtcToken.
         * @member {string} rtcToken
         * @memberof chat.GetMediaCallTokenResponse
         * @instance
         */
        GetMediaCallTokenResponse.prototype.rtcToken = "";

        /**
         * GetMediaCallTokenResponse roomId.
         * @member {string} roomId
         * @memberof chat.GetMediaCallTokenResponse
         * @instance
         */
        GetMediaCallTokenResponse.prototype.roomId = "";

        /**
         * GetMediaCallTokenResponse statusCode.
         * @member {number} statusCode
         * @memberof chat.GetMediaCallTokenResponse
         * @instance
         */
        GetMediaCallTokenResponse.prototype.statusCode = 0;

        /**
         * Creates a new GetMediaCallTokenResponse instance using the specified properties.
         * @function create
         * @memberof chat.GetMediaCallTokenResponse
         * @static
         * @param {chat.IGetMediaCallTokenResponse=} [properties] Properties to set
         * @returns {chat.GetMediaCallTokenResponse} GetMediaCallTokenResponse instance
         */
        GetMediaCallTokenResponse.create = function create(properties) {
            return new GetMediaCallTokenResponse(properties);
        };

        /**
         * Encodes the specified GetMediaCallTokenResponse message. Does not implicitly {@link chat.GetMediaCallTokenResponse.verify|verify} messages.
         * @function encode
         * @memberof chat.GetMediaCallTokenResponse
         * @static
         * @param {chat.IGetMediaCallTokenResponse} message GetMediaCallTokenResponse message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        GetMediaCallTokenResponse.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.isBusy != null && Object.hasOwnProperty.call(message, "isBusy"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.isBusy);
            if (message.rtcToken != null && Object.hasOwnProperty.call(message, "rtcToken"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.rtcToken);
            if (message.roomId != null && Object.hasOwnProperty.call(message, "roomId"))
                writer.uint32(/* id 3, wireType 2 =*/26).string(message.roomId);
            if (message.statusCode != null && Object.hasOwnProperty.call(message, "statusCode"))
                writer.uint32(/* id 4, wireType 0 =*/32).int32(message.statusCode);
            return writer;
        };

        /**
         * Encodes the specified GetMediaCallTokenResponse message, length delimited. Does not implicitly {@link chat.GetMediaCallTokenResponse.verify|verify} messages.
         * @function encodeDelimited
         * @memberof chat.GetMediaCallTokenResponse
         * @static
         * @param {chat.IGetMediaCallTokenResponse} message GetMediaCallTokenResponse message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        GetMediaCallTokenResponse.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a GetMediaCallTokenResponse message from the specified reader or buffer.
         * @function decode
         * @memberof chat.GetMediaCallTokenResponse
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {chat.GetMediaCallTokenResponse} GetMediaCallTokenResponse
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        GetMediaCallTokenResponse.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.chat.GetMediaCallTokenResponse();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1: {
                        message.isBusy = reader.int32();
                        break;
                    }
                case 2: {
                        message.rtcToken = reader.string();
                        break;
                    }
                case 3: {
                        message.roomId = reader.string();
                        break;
                    }
                case 4: {
                        message.statusCode = reader.int32();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a GetMediaCallTokenResponse message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof chat.GetMediaCallTokenResponse
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {chat.GetMediaCallTokenResponse} GetMediaCallTokenResponse
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        GetMediaCallTokenResponse.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a GetMediaCallTokenResponse message.
         * @function verify
         * @memberof chat.GetMediaCallTokenResponse
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        GetMediaCallTokenResponse.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.isBusy != null && message.hasOwnProperty("isBusy"))
                if (!$util.isInteger(message.isBusy))
                    return "isBusy: integer expected";
            if (message.rtcToken != null && message.hasOwnProperty("rtcToken"))
                if (!$util.isString(message.rtcToken))
                    return "rtcToken: string expected";
            if (message.roomId != null && message.hasOwnProperty("roomId"))
                if (!$util.isString(message.roomId))
                    return "roomId: string expected";
            if (message.statusCode != null && message.hasOwnProperty("statusCode"))
                if (!$util.isInteger(message.statusCode))
                    return "statusCode: integer expected";
            return null;
        };

        /**
         * Creates a GetMediaCallTokenResponse message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof chat.GetMediaCallTokenResponse
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {chat.GetMediaCallTokenResponse} GetMediaCallTokenResponse
         */
        GetMediaCallTokenResponse.fromObject = function fromObject(object) {
            if (object instanceof $root.chat.GetMediaCallTokenResponse)
                return object;
            let message = new $root.chat.GetMediaCallTokenResponse();
            if (object.isBusy != null)
                message.isBusy = object.isBusy | 0;
            if (object.rtcToken != null)
                message.rtcToken = String(object.rtcToken);
            if (object.roomId != null)
                message.roomId = String(object.roomId);
            if (object.statusCode != null)
                message.statusCode = object.statusCode | 0;
            return message;
        };

        /**
         * Creates a plain object from a GetMediaCallTokenResponse message. Also converts values to other types if specified.
         * @function toObject
         * @memberof chat.GetMediaCallTokenResponse
         * @static
         * @param {chat.GetMediaCallTokenResponse} message GetMediaCallTokenResponse
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        GetMediaCallTokenResponse.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.isBusy = 0;
                object.rtcToken = "";
                object.roomId = "";
                object.statusCode = 0;
            }
            if (message.isBusy != null && message.hasOwnProperty("isBusy"))
                object.isBusy = message.isBusy;
            if (message.rtcToken != null && message.hasOwnProperty("rtcToken"))
                object.rtcToken = message.rtcToken;
            if (message.roomId != null && message.hasOwnProperty("roomId"))
                object.roomId = message.roomId;
            if (message.statusCode != null && message.hasOwnProperty("statusCode"))
                object.statusCode = message.statusCode;
            return object;
        };

        /**
         * Converts this GetMediaCallTokenResponse to JSON.
         * @function toJSON
         * @memberof chat.GetMediaCallTokenResponse
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        GetMediaCallTokenResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for GetMediaCallTokenResponse
         * @function getTypeUrl
         * @memberof chat.GetMediaCallTokenResponse
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        GetMediaCallTokenResponse.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/chat.GetMediaCallTokenResponse";
        };

        return GetMediaCallTokenResponse;
    })();

    chat.MediaCallOperateRequest = (function() {

        /**
         * Properties of a MediaCallOperateRequest.
         * @memberof chat
         * @interface IMediaCallOperateRequest
         * @property {number|null} [opeType] MediaCallOperateRequest opeType
         * @property {string|null} [chatId] MediaCallOperateRequest chatId
         * @property {string|null} [msgExtContent] MediaCallOperateRequest msgExtContent
         * @property {string|null} [messageId] MediaCallOperateRequest messageId
         * @property {string|null} [roomId] MediaCallOperateRequest roomId
         * @property {string|null} [targetId] MediaCallOperateRequest targetId
         * @property {string|null} [originUid] MediaCallOperateRequest originUid
         * @property {string|null} [cliMsgId] MediaCallOperateRequest cliMsgId
         */

        /**
         * Constructs a new MediaCallOperateRequest.
         * @memberof chat
         * @classdesc Represents a MediaCallOperateRequest.
         * @implements IMediaCallOperateRequest
         * @constructor
         * @param {chat.IMediaCallOperateRequest=} [properties] Properties to set
         */
        function MediaCallOperateRequest(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * MediaCallOperateRequest opeType.
         * @member {number} opeType
         * @memberof chat.MediaCallOperateRequest
         * @instance
         */
        MediaCallOperateRequest.prototype.opeType = 0;

        /**
         * MediaCallOperateRequest chatId.
         * @member {string} chatId
         * @memberof chat.MediaCallOperateRequest
         * @instance
         */
        MediaCallOperateRequest.prototype.chatId = "";

        /**
         * MediaCallOperateRequest msgExtContent.
         * @member {string} msgExtContent
         * @memberof chat.MediaCallOperateRequest
         * @instance
         */
        MediaCallOperateRequest.prototype.msgExtContent = "";

        /**
         * MediaCallOperateRequest messageId.
         * @member {string} messageId
         * @memberof chat.MediaCallOperateRequest
         * @instance
         */
        MediaCallOperateRequest.prototype.messageId = "";

        /**
         * MediaCallOperateRequest roomId.
         * @member {string} roomId
         * @memberof chat.MediaCallOperateRequest
         * @instance
         */
        MediaCallOperateRequest.prototype.roomId = "";

        /**
         * MediaCallOperateRequest targetId.
         * @member {string} targetId
         * @memberof chat.MediaCallOperateRequest
         * @instance
         */
        MediaCallOperateRequest.prototype.targetId = "";

        /**
         * MediaCallOperateRequest originUid.
         * @member {string} originUid
         * @memberof chat.MediaCallOperateRequest
         * @instance
         */
        MediaCallOperateRequest.prototype.originUid = "";

        /**
         * MediaCallOperateRequest cliMsgId.
         * @member {string} cliMsgId
         * @memberof chat.MediaCallOperateRequest
         * @instance
         */
        MediaCallOperateRequest.prototype.cliMsgId = "";

        /**
         * Creates a new MediaCallOperateRequest instance using the specified properties.
         * @function create
         * @memberof chat.MediaCallOperateRequest
         * @static
         * @param {chat.IMediaCallOperateRequest=} [properties] Properties to set
         * @returns {chat.MediaCallOperateRequest} MediaCallOperateRequest instance
         */
        MediaCallOperateRequest.create = function create(properties) {
            return new MediaCallOperateRequest(properties);
        };

        /**
         * Encodes the specified MediaCallOperateRequest message. Does not implicitly {@link chat.MediaCallOperateRequest.verify|verify} messages.
         * @function encode
         * @memberof chat.MediaCallOperateRequest
         * @static
         * @param {chat.IMediaCallOperateRequest} message MediaCallOperateRequest message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        MediaCallOperateRequest.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.opeType != null && Object.hasOwnProperty.call(message, "opeType"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.opeType);
            if (message.chatId != null && Object.hasOwnProperty.call(message, "chatId"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.chatId);
            if (message.msgExtContent != null && Object.hasOwnProperty.call(message, "msgExtContent"))
                writer.uint32(/* id 3, wireType 2 =*/26).string(message.msgExtContent);
            if (message.messageId != null && Object.hasOwnProperty.call(message, "messageId"))
                writer.uint32(/* id 4, wireType 2 =*/34).string(message.messageId);
            if (message.roomId != null && Object.hasOwnProperty.call(message, "roomId"))
                writer.uint32(/* id 5, wireType 2 =*/42).string(message.roomId);
            if (message.targetId != null && Object.hasOwnProperty.call(message, "targetId"))
                writer.uint32(/* id 7, wireType 2 =*/58).string(message.targetId);
            if (message.originUid != null && Object.hasOwnProperty.call(message, "originUid"))
                writer.uint32(/* id 8, wireType 2 =*/66).string(message.originUid);
            if (message.cliMsgId != null && Object.hasOwnProperty.call(message, "cliMsgId"))
                writer.uint32(/* id 9, wireType 2 =*/74).string(message.cliMsgId);
            return writer;
        };

        /**
         * Encodes the specified MediaCallOperateRequest message, length delimited. Does not implicitly {@link chat.MediaCallOperateRequest.verify|verify} messages.
         * @function encodeDelimited
         * @memberof chat.MediaCallOperateRequest
         * @static
         * @param {chat.IMediaCallOperateRequest} message MediaCallOperateRequest message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        MediaCallOperateRequest.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a MediaCallOperateRequest message from the specified reader or buffer.
         * @function decode
         * @memberof chat.MediaCallOperateRequest
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {chat.MediaCallOperateRequest} MediaCallOperateRequest
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        MediaCallOperateRequest.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.chat.MediaCallOperateRequest();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1: {
                        message.opeType = reader.int32();
                        break;
                    }
                case 2: {
                        message.chatId = reader.string();
                        break;
                    }
                case 3: {
                        message.msgExtContent = reader.string();
                        break;
                    }
                case 4: {
                        message.messageId = reader.string();
                        break;
                    }
                case 5: {
                        message.roomId = reader.string();
                        break;
                    }
                case 7: {
                        message.targetId = reader.string();
                        break;
                    }
                case 8: {
                        message.originUid = reader.string();
                        break;
                    }
                case 9: {
                        message.cliMsgId = reader.string();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a MediaCallOperateRequest message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof chat.MediaCallOperateRequest
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {chat.MediaCallOperateRequest} MediaCallOperateRequest
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        MediaCallOperateRequest.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a MediaCallOperateRequest message.
         * @function verify
         * @memberof chat.MediaCallOperateRequest
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        MediaCallOperateRequest.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.opeType != null && message.hasOwnProperty("opeType"))
                if (!$util.isInteger(message.opeType))
                    return "opeType: integer expected";
            if (message.chatId != null && message.hasOwnProperty("chatId"))
                if (!$util.isString(message.chatId))
                    return "chatId: string expected";
            if (message.msgExtContent != null && message.hasOwnProperty("msgExtContent"))
                if (!$util.isString(message.msgExtContent))
                    return "msgExtContent: string expected";
            if (message.messageId != null && message.hasOwnProperty("messageId"))
                if (!$util.isString(message.messageId))
                    return "messageId: string expected";
            if (message.roomId != null && message.hasOwnProperty("roomId"))
                if (!$util.isString(message.roomId))
                    return "roomId: string expected";
            if (message.targetId != null && message.hasOwnProperty("targetId"))
                if (!$util.isString(message.targetId))
                    return "targetId: string expected";
            if (message.originUid != null && message.hasOwnProperty("originUid"))
                if (!$util.isString(message.originUid))
                    return "originUid: string expected";
            if (message.cliMsgId != null && message.hasOwnProperty("cliMsgId"))
                if (!$util.isString(message.cliMsgId))
                    return "cliMsgId: string expected";
            return null;
        };

        /**
         * Creates a MediaCallOperateRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof chat.MediaCallOperateRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {chat.MediaCallOperateRequest} MediaCallOperateRequest
         */
        MediaCallOperateRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.chat.MediaCallOperateRequest)
                return object;
            let message = new $root.chat.MediaCallOperateRequest();
            if (object.opeType != null)
                message.opeType = object.opeType | 0;
            if (object.chatId != null)
                message.chatId = String(object.chatId);
            if (object.msgExtContent != null)
                message.msgExtContent = String(object.msgExtContent);
            if (object.messageId != null)
                message.messageId = String(object.messageId);
            if (object.roomId != null)
                message.roomId = String(object.roomId);
            if (object.targetId != null)
                message.targetId = String(object.targetId);
            if (object.originUid != null)
                message.originUid = String(object.originUid);
            if (object.cliMsgId != null)
                message.cliMsgId = String(object.cliMsgId);
            return message;
        };

        /**
         * Creates a plain object from a MediaCallOperateRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof chat.MediaCallOperateRequest
         * @static
         * @param {chat.MediaCallOperateRequest} message MediaCallOperateRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        MediaCallOperateRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.opeType = 0;
                object.chatId = "";
                object.msgExtContent = "";
                object.messageId = "";
                object.roomId = "";
                object.targetId = "";
                object.originUid = "";
                object.cliMsgId = "";
            }
            if (message.opeType != null && message.hasOwnProperty("opeType"))
                object.opeType = message.opeType;
            if (message.chatId != null && message.hasOwnProperty("chatId"))
                object.chatId = message.chatId;
            if (message.msgExtContent != null && message.hasOwnProperty("msgExtContent"))
                object.msgExtContent = message.msgExtContent;
            if (message.messageId != null && message.hasOwnProperty("messageId"))
                object.messageId = message.messageId;
            if (message.roomId != null && message.hasOwnProperty("roomId"))
                object.roomId = message.roomId;
            if (message.targetId != null && message.hasOwnProperty("targetId"))
                object.targetId = message.targetId;
            if (message.originUid != null && message.hasOwnProperty("originUid"))
                object.originUid = message.originUid;
            if (message.cliMsgId != null && message.hasOwnProperty("cliMsgId"))
                object.cliMsgId = message.cliMsgId;
            return object;
        };

        /**
         * Converts this MediaCallOperateRequest to JSON.
         * @function toJSON
         * @memberof chat.MediaCallOperateRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        MediaCallOperateRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for MediaCallOperateRequest
         * @function getTypeUrl
         * @memberof chat.MediaCallOperateRequest
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        MediaCallOperateRequest.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/chat.MediaCallOperateRequest";
        };

        return MediaCallOperateRequest;
    })();

    chat.MediaCallOperateResponse = (function() {

        /**
         * Properties of a MediaCallOperateResponse.
         * @memberof chat
         * @interface IMediaCallOperateResponse
         * @property {string|null} [messageId] MediaCallOperateResponse messageId
         * @property {number|null} [code] MediaCallOperateResponse code
         * @property {number|Long|null} [sequence] MediaCallOperateResponse sequence
         * @property {number|Long|null} [createdAt] MediaCallOperateResponse createdAt
         * @property {string|null} [cliMsgId] MediaCallOperateResponse cliMsgId
         */

        /**
         * Constructs a new MediaCallOperateResponse.
         * @memberof chat
         * @classdesc Represents a MediaCallOperateResponse.
         * @implements IMediaCallOperateResponse
         * @constructor
         * @param {chat.IMediaCallOperateResponse=} [properties] Properties to set
         */
        function MediaCallOperateResponse(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * MediaCallOperateResponse messageId.
         * @member {string} messageId
         * @memberof chat.MediaCallOperateResponse
         * @instance
         */
        MediaCallOperateResponse.prototype.messageId = "";

        /**
         * MediaCallOperateResponse code.
         * @member {number} code
         * @memberof chat.MediaCallOperateResponse
         * @instance
         */
        MediaCallOperateResponse.prototype.code = 0;

        /**
         * MediaCallOperateResponse sequence.
         * @member {number|Long} sequence
         * @memberof chat.MediaCallOperateResponse
         * @instance
         */
        MediaCallOperateResponse.prototype.sequence = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * MediaCallOperateResponse createdAt.
         * @member {number|Long} createdAt
         * @memberof chat.MediaCallOperateResponse
         * @instance
         */
        MediaCallOperateResponse.prototype.createdAt = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * MediaCallOperateResponse cliMsgId.
         * @member {string} cliMsgId
         * @memberof chat.MediaCallOperateResponse
         * @instance
         */
        MediaCallOperateResponse.prototype.cliMsgId = "";

        /**
         * Creates a new MediaCallOperateResponse instance using the specified properties.
         * @function create
         * @memberof chat.MediaCallOperateResponse
         * @static
         * @param {chat.IMediaCallOperateResponse=} [properties] Properties to set
         * @returns {chat.MediaCallOperateResponse} MediaCallOperateResponse instance
         */
        MediaCallOperateResponse.create = function create(properties) {
            return new MediaCallOperateResponse(properties);
        };

        /**
         * Encodes the specified MediaCallOperateResponse message. Does not implicitly {@link chat.MediaCallOperateResponse.verify|verify} messages.
         * @function encode
         * @memberof chat.MediaCallOperateResponse
         * @static
         * @param {chat.IMediaCallOperateResponse} message MediaCallOperateResponse message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        MediaCallOperateResponse.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.messageId != null && Object.hasOwnProperty.call(message, "messageId"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.messageId);
            if (message.code != null && Object.hasOwnProperty.call(message, "code"))
                writer.uint32(/* id 2, wireType 0 =*/16).int32(message.code);
            if (message.sequence != null && Object.hasOwnProperty.call(message, "sequence"))
                writer.uint32(/* id 3, wireType 0 =*/24).int64(message.sequence);
            if (message.createdAt != null && Object.hasOwnProperty.call(message, "createdAt"))
                writer.uint32(/* id 4, wireType 0 =*/32).int64(message.createdAt);
            if (message.cliMsgId != null && Object.hasOwnProperty.call(message, "cliMsgId"))
                writer.uint32(/* id 5, wireType 2 =*/42).string(message.cliMsgId);
            return writer;
        };

        /**
         * Encodes the specified MediaCallOperateResponse message, length delimited. Does not implicitly {@link chat.MediaCallOperateResponse.verify|verify} messages.
         * @function encodeDelimited
         * @memberof chat.MediaCallOperateResponse
         * @static
         * @param {chat.IMediaCallOperateResponse} message MediaCallOperateResponse message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        MediaCallOperateResponse.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a MediaCallOperateResponse message from the specified reader or buffer.
         * @function decode
         * @memberof chat.MediaCallOperateResponse
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {chat.MediaCallOperateResponse} MediaCallOperateResponse
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        MediaCallOperateResponse.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.chat.MediaCallOperateResponse();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1: {
                        message.messageId = reader.string();
                        break;
                    }
                case 2: {
                        message.code = reader.int32();
                        break;
                    }
                case 3: {
                        message.sequence = reader.int64();
                        break;
                    }
                case 4: {
                        message.createdAt = reader.int64();
                        break;
                    }
                case 5: {
                        message.cliMsgId = reader.string();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a MediaCallOperateResponse message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof chat.MediaCallOperateResponse
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {chat.MediaCallOperateResponse} MediaCallOperateResponse
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        MediaCallOperateResponse.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a MediaCallOperateResponse message.
         * @function verify
         * @memberof chat.MediaCallOperateResponse
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        MediaCallOperateResponse.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.messageId != null && message.hasOwnProperty("messageId"))
                if (!$util.isString(message.messageId))
                    return "messageId: string expected";
            if (message.code != null && message.hasOwnProperty("code"))
                if (!$util.isInteger(message.code))
                    return "code: integer expected";
            if (message.sequence != null && message.hasOwnProperty("sequence"))
                if (!$util.isInteger(message.sequence) && !(message.sequence && $util.isInteger(message.sequence.low) && $util.isInteger(message.sequence.high)))
                    return "sequence: integer|Long expected";
            if (message.createdAt != null && message.hasOwnProperty("createdAt"))
                if (!$util.isInteger(message.createdAt) && !(message.createdAt && $util.isInteger(message.createdAt.low) && $util.isInteger(message.createdAt.high)))
                    return "createdAt: integer|Long expected";
            if (message.cliMsgId != null && message.hasOwnProperty("cliMsgId"))
                if (!$util.isString(message.cliMsgId))
                    return "cliMsgId: string expected";
            return null;
        };

        /**
         * Creates a MediaCallOperateResponse message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof chat.MediaCallOperateResponse
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {chat.MediaCallOperateResponse} MediaCallOperateResponse
         */
        MediaCallOperateResponse.fromObject = function fromObject(object) {
            if (object instanceof $root.chat.MediaCallOperateResponse)
                return object;
            let message = new $root.chat.MediaCallOperateResponse();
            if (object.messageId != null)
                message.messageId = String(object.messageId);
            if (object.code != null)
                message.code = object.code | 0;
            if (object.sequence != null)
                if ($util.Long)
                    (message.sequence = $util.Long.fromValue(object.sequence)).unsigned = false;
                else if (typeof object.sequence === "string")
                    message.sequence = parseInt(object.sequence, 10);
                else if (typeof object.sequence === "number")
                    message.sequence = object.sequence;
                else if (typeof object.sequence === "object")
                    message.sequence = new $util.LongBits(object.sequence.low >>> 0, object.sequence.high >>> 0).toNumber();
            if (object.createdAt != null)
                if ($util.Long)
                    (message.createdAt = $util.Long.fromValue(object.createdAt)).unsigned = false;
                else if (typeof object.createdAt === "string")
                    message.createdAt = parseInt(object.createdAt, 10);
                else if (typeof object.createdAt === "number")
                    message.createdAt = object.createdAt;
                else if (typeof object.createdAt === "object")
                    message.createdAt = new $util.LongBits(object.createdAt.low >>> 0, object.createdAt.high >>> 0).toNumber();
            if (object.cliMsgId != null)
                message.cliMsgId = String(object.cliMsgId);
            return message;
        };

        /**
         * Creates a plain object from a MediaCallOperateResponse message. Also converts values to other types if specified.
         * @function toObject
         * @memberof chat.MediaCallOperateResponse
         * @static
         * @param {chat.MediaCallOperateResponse} message MediaCallOperateResponse
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        MediaCallOperateResponse.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.messageId = "";
                object.code = 0;
                if ($util.Long) {
                    let long = new $util.Long(0, 0, false);
                    object.sequence = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.sequence = options.longs === String ? "0" : 0;
                if ($util.Long) {
                    let long = new $util.Long(0, 0, false);
                    object.createdAt = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.createdAt = options.longs === String ? "0" : 0;
                object.cliMsgId = "";
            }
            if (message.messageId != null && message.hasOwnProperty("messageId"))
                object.messageId = message.messageId;
            if (message.code != null && message.hasOwnProperty("code"))
                object.code = message.code;
            if (message.sequence != null && message.hasOwnProperty("sequence"))
                if (typeof message.sequence === "number")
                    object.sequence = options.longs === String ? String(message.sequence) : message.sequence;
                else
                    object.sequence = options.longs === String ? $util.Long.prototype.toString.call(message.sequence) : options.longs === Number ? new $util.LongBits(message.sequence.low >>> 0, message.sequence.high >>> 0).toNumber() : message.sequence;
            if (message.createdAt != null && message.hasOwnProperty("createdAt"))
                if (typeof message.createdAt === "number")
                    object.createdAt = options.longs === String ? String(message.createdAt) : message.createdAt;
                else
                    object.createdAt = options.longs === String ? $util.Long.prototype.toString.call(message.createdAt) : options.longs === Number ? new $util.LongBits(message.createdAt.low >>> 0, message.createdAt.high >>> 0).toNumber() : message.createdAt;
            if (message.cliMsgId != null && message.hasOwnProperty("cliMsgId"))
                object.cliMsgId = message.cliMsgId;
            return object;
        };

        /**
         * Converts this MediaCallOperateResponse to JSON.
         * @function toJSON
         * @memberof chat.MediaCallOperateResponse
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        MediaCallOperateResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for MediaCallOperateResponse
         * @function getTypeUrl
         * @memberof chat.MediaCallOperateResponse
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        MediaCallOperateResponse.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/chat.MediaCallOperateResponse";
        };

        return MediaCallOperateResponse;
    })();

    chat.MediaCallOperateV2Request = (function() {

        /**
         * Properties of a MediaCallOperateV2Request.
         * @memberof chat
         * @interface IMediaCallOperateV2Request
         * @property {number|null} [opeType] MediaCallOperateV2Request opeType
         * @property {string|null} [chatId] MediaCallOperateV2Request chatId
         * @property {string|null} [msgExtContent] MediaCallOperateV2Request msgExtContent
         * @property {string|null} [messageId] MediaCallOperateV2Request messageId
         * @property {string|null} [roomId] MediaCallOperateV2Request roomId
         * @property {Array.<string>|null} [targetIds] MediaCallOperateV2Request targetIds
         * @property {string|null} [originUid] MediaCallOperateV2Request originUid
         * @property {string|null} [cliMsgId] MediaCallOperateV2Request cliMsgId
         * @property {number|Long|null} [busy] MediaCallOperateV2Request busy
         * @property {string|null} [name] MediaCallOperateV2Request name
         * @property {string|null} [groupId] MediaCallOperateV2Request groupId
         * @property {string|null} [tGroupId] MediaCallOperateV2Request tGroupId
         */

        /**
         * Constructs a new MediaCallOperateV2Request.
         * @memberof chat
         * @classdesc Represents a MediaCallOperateV2Request.
         * @implements IMediaCallOperateV2Request
         * @constructor
         * @param {chat.IMediaCallOperateV2Request=} [properties] Properties to set
         */
        function MediaCallOperateV2Request(properties) {
            this.targetIds = [];
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * MediaCallOperateV2Request opeType.
         * @member {number} opeType
         * @memberof chat.MediaCallOperateV2Request
         * @instance
         */
        MediaCallOperateV2Request.prototype.opeType = 0;

        /**
         * MediaCallOperateV2Request chatId.
         * @member {string} chatId
         * @memberof chat.MediaCallOperateV2Request
         * @instance
         */
        MediaCallOperateV2Request.prototype.chatId = "";

        /**
         * MediaCallOperateV2Request msgExtContent.
         * @member {string} msgExtContent
         * @memberof chat.MediaCallOperateV2Request
         * @instance
         */
        MediaCallOperateV2Request.prototype.msgExtContent = "";

        /**
         * MediaCallOperateV2Request messageId.
         * @member {string} messageId
         * @memberof chat.MediaCallOperateV2Request
         * @instance
         */
        MediaCallOperateV2Request.prototype.messageId = "";

        /**
         * MediaCallOperateV2Request roomId.
         * @member {string} roomId
         * @memberof chat.MediaCallOperateV2Request
         * @instance
         */
        MediaCallOperateV2Request.prototype.roomId = "";

        /**
         * MediaCallOperateV2Request targetIds.
         * @member {Array.<string>} targetIds
         * @memberof chat.MediaCallOperateV2Request
         * @instance
         */
        MediaCallOperateV2Request.prototype.targetIds = $util.emptyArray;

        /**
         * MediaCallOperateV2Request originUid.
         * @member {string} originUid
         * @memberof chat.MediaCallOperateV2Request
         * @instance
         */
        MediaCallOperateV2Request.prototype.originUid = "";

        /**
         * MediaCallOperateV2Request cliMsgId.
         * @member {string} cliMsgId
         * @memberof chat.MediaCallOperateV2Request
         * @instance
         */
        MediaCallOperateV2Request.prototype.cliMsgId = "";

        /**
         * MediaCallOperateV2Request busy.
         * @member {number|Long} busy
         * @memberof chat.MediaCallOperateV2Request
         * @instance
         */
        MediaCallOperateV2Request.prototype.busy = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * MediaCallOperateV2Request name.
         * @member {string} name
         * @memberof chat.MediaCallOperateV2Request
         * @instance
         */
        MediaCallOperateV2Request.prototype.name = "";

        /**
         * MediaCallOperateV2Request groupId.
         * @member {string} groupId
         * @memberof chat.MediaCallOperateV2Request
         * @instance
         */
        MediaCallOperateV2Request.prototype.groupId = "";

        /**
         * MediaCallOperateV2Request tGroupId.
         * @member {string} tGroupId
         * @memberof chat.MediaCallOperateV2Request
         * @instance
         */
        MediaCallOperateV2Request.prototype.tGroupId = "";

        /**
         * Creates a new MediaCallOperateV2Request instance using the specified properties.
         * @function create
         * @memberof chat.MediaCallOperateV2Request
         * @static
         * @param {chat.IMediaCallOperateV2Request=} [properties] Properties to set
         * @returns {chat.MediaCallOperateV2Request} MediaCallOperateV2Request instance
         */
        MediaCallOperateV2Request.create = function create(properties) {
            return new MediaCallOperateV2Request(properties);
        };

        /**
         * Encodes the specified MediaCallOperateV2Request message. Does not implicitly {@link chat.MediaCallOperateV2Request.verify|verify} messages.
         * @function encode
         * @memberof chat.MediaCallOperateV2Request
         * @static
         * @param {chat.IMediaCallOperateV2Request} message MediaCallOperateV2Request message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        MediaCallOperateV2Request.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.opeType != null && Object.hasOwnProperty.call(message, "opeType"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.opeType);
            if (message.chatId != null && Object.hasOwnProperty.call(message, "chatId"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.chatId);
            if (message.msgExtContent != null && Object.hasOwnProperty.call(message, "msgExtContent"))
                writer.uint32(/* id 3, wireType 2 =*/26).string(message.msgExtContent);
            if (message.messageId != null && Object.hasOwnProperty.call(message, "messageId"))
                writer.uint32(/* id 4, wireType 2 =*/34).string(message.messageId);
            if (message.roomId != null && Object.hasOwnProperty.call(message, "roomId"))
                writer.uint32(/* id 5, wireType 2 =*/42).string(message.roomId);
            if (message.targetIds != null && message.targetIds.length)
                for (let i = 0; i < message.targetIds.length; ++i)
                    writer.uint32(/* id 7, wireType 2 =*/58).string(message.targetIds[i]);
            if (message.originUid != null && Object.hasOwnProperty.call(message, "originUid"))
                writer.uint32(/* id 8, wireType 2 =*/66).string(message.originUid);
            if (message.cliMsgId != null && Object.hasOwnProperty.call(message, "cliMsgId"))
                writer.uint32(/* id 9, wireType 2 =*/74).string(message.cliMsgId);
            if (message.busy != null && Object.hasOwnProperty.call(message, "busy"))
                writer.uint32(/* id 10, wireType 0 =*/80).int64(message.busy);
            if (message.name != null && Object.hasOwnProperty.call(message, "name"))
                writer.uint32(/* id 11, wireType 2 =*/90).string(message.name);
            if (message.groupId != null && Object.hasOwnProperty.call(message, "groupId"))
                writer.uint32(/* id 12, wireType 2 =*/98).string(message.groupId);
            if (message.tGroupId != null && Object.hasOwnProperty.call(message, "tGroupId"))
                writer.uint32(/* id 13, wireType 2 =*/106).string(message.tGroupId);
            return writer;
        };

        /**
         * Encodes the specified MediaCallOperateV2Request message, length delimited. Does not implicitly {@link chat.MediaCallOperateV2Request.verify|verify} messages.
         * @function encodeDelimited
         * @memberof chat.MediaCallOperateV2Request
         * @static
         * @param {chat.IMediaCallOperateV2Request} message MediaCallOperateV2Request message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        MediaCallOperateV2Request.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a MediaCallOperateV2Request message from the specified reader or buffer.
         * @function decode
         * @memberof chat.MediaCallOperateV2Request
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {chat.MediaCallOperateV2Request} MediaCallOperateV2Request
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        MediaCallOperateV2Request.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.chat.MediaCallOperateV2Request();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1: {
                        message.opeType = reader.int32();
                        break;
                    }
                case 2: {
                        message.chatId = reader.string();
                        break;
                    }
                case 3: {
                        message.msgExtContent = reader.string();
                        break;
                    }
                case 4: {
                        message.messageId = reader.string();
                        break;
                    }
                case 5: {
                        message.roomId = reader.string();
                        break;
                    }
                case 7: {
                        if (!(message.targetIds && message.targetIds.length))
                            message.targetIds = [];
                        message.targetIds.push(reader.string());
                        break;
                    }
                case 8: {
                        message.originUid = reader.string();
                        break;
                    }
                case 9: {
                        message.cliMsgId = reader.string();
                        break;
                    }
                case 10: {
                        message.busy = reader.int64();
                        break;
                    }
                case 11: {
                        message.name = reader.string();
                        break;
                    }
                case 12: {
                        message.groupId = reader.string();
                        break;
                    }
                case 13: {
                        message.tGroupId = reader.string();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a MediaCallOperateV2Request message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof chat.MediaCallOperateV2Request
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {chat.MediaCallOperateV2Request} MediaCallOperateV2Request
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        MediaCallOperateV2Request.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a MediaCallOperateV2Request message.
         * @function verify
         * @memberof chat.MediaCallOperateV2Request
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        MediaCallOperateV2Request.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.opeType != null && message.hasOwnProperty("opeType"))
                if (!$util.isInteger(message.opeType))
                    return "opeType: integer expected";
            if (message.chatId != null && message.hasOwnProperty("chatId"))
                if (!$util.isString(message.chatId))
                    return "chatId: string expected";
            if (message.msgExtContent != null && message.hasOwnProperty("msgExtContent"))
                if (!$util.isString(message.msgExtContent))
                    return "msgExtContent: string expected";
            if (message.messageId != null && message.hasOwnProperty("messageId"))
                if (!$util.isString(message.messageId))
                    return "messageId: string expected";
            if (message.roomId != null && message.hasOwnProperty("roomId"))
                if (!$util.isString(message.roomId))
                    return "roomId: string expected";
            if (message.targetIds != null && message.hasOwnProperty("targetIds")) {
                if (!Array.isArray(message.targetIds))
                    return "targetIds: array expected";
                for (let i = 0; i < message.targetIds.length; ++i)
                    if (!$util.isString(message.targetIds[i]))
                        return "targetIds: string[] expected";
            }
            if (message.originUid != null && message.hasOwnProperty("originUid"))
                if (!$util.isString(message.originUid))
                    return "originUid: string expected";
            if (message.cliMsgId != null && message.hasOwnProperty("cliMsgId"))
                if (!$util.isString(message.cliMsgId))
                    return "cliMsgId: string expected";
            if (message.busy != null && message.hasOwnProperty("busy"))
                if (!$util.isInteger(message.busy) && !(message.busy && $util.isInteger(message.busy.low) && $util.isInteger(message.busy.high)))
                    return "busy: integer|Long expected";
            if (message.name != null && message.hasOwnProperty("name"))
                if (!$util.isString(message.name))
                    return "name: string expected";
            if (message.groupId != null && message.hasOwnProperty("groupId"))
                if (!$util.isString(message.groupId))
                    return "groupId: string expected";
            if (message.tGroupId != null && message.hasOwnProperty("tGroupId"))
                if (!$util.isString(message.tGroupId))
                    return "tGroupId: string expected";
            return null;
        };

        /**
         * Creates a MediaCallOperateV2Request message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof chat.MediaCallOperateV2Request
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {chat.MediaCallOperateV2Request} MediaCallOperateV2Request
         */
        MediaCallOperateV2Request.fromObject = function fromObject(object) {
            if (object instanceof $root.chat.MediaCallOperateV2Request)
                return object;
            let message = new $root.chat.MediaCallOperateV2Request();
            if (object.opeType != null)
                message.opeType = object.opeType | 0;
            if (object.chatId != null)
                message.chatId = String(object.chatId);
            if (object.msgExtContent != null)
                message.msgExtContent = String(object.msgExtContent);
            if (object.messageId != null)
                message.messageId = String(object.messageId);
            if (object.roomId != null)
                message.roomId = String(object.roomId);
            if (object.targetIds) {
                if (!Array.isArray(object.targetIds))
                    throw TypeError(".chat.MediaCallOperateV2Request.targetIds: array expected");
                message.targetIds = [];
                for (let i = 0; i < object.targetIds.length; ++i)
                    message.targetIds[i] = String(object.targetIds[i]);
            }
            if (object.originUid != null)
                message.originUid = String(object.originUid);
            if (object.cliMsgId != null)
                message.cliMsgId = String(object.cliMsgId);
            if (object.busy != null)
                if ($util.Long)
                    (message.busy = $util.Long.fromValue(object.busy)).unsigned = false;
                else if (typeof object.busy === "string")
                    message.busy = parseInt(object.busy, 10);
                else if (typeof object.busy === "number")
                    message.busy = object.busy;
                else if (typeof object.busy === "object")
                    message.busy = new $util.LongBits(object.busy.low >>> 0, object.busy.high >>> 0).toNumber();
            if (object.name != null)
                message.name = String(object.name);
            if (object.groupId != null)
                message.groupId = String(object.groupId);
            if (object.tGroupId != null)
                message.tGroupId = String(object.tGroupId);
            return message;
        };

        /**
         * Creates a plain object from a MediaCallOperateV2Request message. Also converts values to other types if specified.
         * @function toObject
         * @memberof chat.MediaCallOperateV2Request
         * @static
         * @param {chat.MediaCallOperateV2Request} message MediaCallOperateV2Request
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        MediaCallOperateV2Request.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.arrays || options.defaults)
                object.targetIds = [];
            if (options.defaults) {
                object.opeType = 0;
                object.chatId = "";
                object.msgExtContent = "";
                object.messageId = "";
                object.roomId = "";
                object.originUid = "";
                object.cliMsgId = "";
                if ($util.Long) {
                    let long = new $util.Long(0, 0, false);
                    object.busy = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.busy = options.longs === String ? "0" : 0;
                object.name = "";
                object.groupId = "";
                object.tGroupId = "";
            }
            if (message.opeType != null && message.hasOwnProperty("opeType"))
                object.opeType = message.opeType;
            if (message.chatId != null && message.hasOwnProperty("chatId"))
                object.chatId = message.chatId;
            if (message.msgExtContent != null && message.hasOwnProperty("msgExtContent"))
                object.msgExtContent = message.msgExtContent;
            if (message.messageId != null && message.hasOwnProperty("messageId"))
                object.messageId = message.messageId;
            if (message.roomId != null && message.hasOwnProperty("roomId"))
                object.roomId = message.roomId;
            if (message.targetIds && message.targetIds.length) {
                object.targetIds = [];
                for (let j = 0; j < message.targetIds.length; ++j)
                    object.targetIds[j] = message.targetIds[j];
            }
            if (message.originUid != null && message.hasOwnProperty("originUid"))
                object.originUid = message.originUid;
            if (message.cliMsgId != null && message.hasOwnProperty("cliMsgId"))
                object.cliMsgId = message.cliMsgId;
            if (message.busy != null && message.hasOwnProperty("busy"))
                if (typeof message.busy === "number")
                    object.busy = options.longs === String ? String(message.busy) : message.busy;
                else
                    object.busy = options.longs === String ? $util.Long.prototype.toString.call(message.busy) : options.longs === Number ? new $util.LongBits(message.busy.low >>> 0, message.busy.high >>> 0).toNumber() : message.busy;
            if (message.name != null && message.hasOwnProperty("name"))
                object.name = message.name;
            if (message.groupId != null && message.hasOwnProperty("groupId"))
                object.groupId = message.groupId;
            if (message.tGroupId != null && message.hasOwnProperty("tGroupId"))
                object.tGroupId = message.tGroupId;
            return object;
        };

        /**
         * Converts this MediaCallOperateV2Request to JSON.
         * @function toJSON
         * @memberof chat.MediaCallOperateV2Request
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        MediaCallOperateV2Request.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for MediaCallOperateV2Request
         * @function getTypeUrl
         * @memberof chat.MediaCallOperateV2Request
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        MediaCallOperateV2Request.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/chat.MediaCallOperateV2Request";
        };

        return MediaCallOperateV2Request;
    })();

    chat.MediaCallOperateV2Response = (function() {

        /**
         * Properties of a MediaCallOperateV2Response.
         * @memberof chat
         * @interface IMediaCallOperateV2Response
         * @property {number|Long|null} [createdAt] MediaCallOperateV2Response createdAt
         * @property {Array.<chat.IMediaCallOperateV2ResponseItem>|null} [records] MediaCallOperateV2Response records
         */

        /**
         * Constructs a new MediaCallOperateV2Response.
         * @memberof chat
         * @classdesc Represents a MediaCallOperateV2Response.
         * @implements IMediaCallOperateV2Response
         * @constructor
         * @param {chat.IMediaCallOperateV2Response=} [properties] Properties to set
         */
        function MediaCallOperateV2Response(properties) {
            this.records = [];
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * MediaCallOperateV2Response createdAt.
         * @member {number|Long} createdAt
         * @memberof chat.MediaCallOperateV2Response
         * @instance
         */
        MediaCallOperateV2Response.prototype.createdAt = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * MediaCallOperateV2Response records.
         * @member {Array.<chat.IMediaCallOperateV2ResponseItem>} records
         * @memberof chat.MediaCallOperateV2Response
         * @instance
         */
        MediaCallOperateV2Response.prototype.records = $util.emptyArray;

        /**
         * Creates a new MediaCallOperateV2Response instance using the specified properties.
         * @function create
         * @memberof chat.MediaCallOperateV2Response
         * @static
         * @param {chat.IMediaCallOperateV2Response=} [properties] Properties to set
         * @returns {chat.MediaCallOperateV2Response} MediaCallOperateV2Response instance
         */
        MediaCallOperateV2Response.create = function create(properties) {
            return new MediaCallOperateV2Response(properties);
        };

        /**
         * Encodes the specified MediaCallOperateV2Response message. Does not implicitly {@link chat.MediaCallOperateV2Response.verify|verify} messages.
         * @function encode
         * @memberof chat.MediaCallOperateV2Response
         * @static
         * @param {chat.IMediaCallOperateV2Response} message MediaCallOperateV2Response message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        MediaCallOperateV2Response.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.createdAt != null && Object.hasOwnProperty.call(message, "createdAt"))
                writer.uint32(/* id 1, wireType 0 =*/8).int64(message.createdAt);
            if (message.records != null && message.records.length)
                for (let i = 0; i < message.records.length; ++i)
                    $root.chat.MediaCallOperateV2ResponseItem.encode(message.records[i], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified MediaCallOperateV2Response message, length delimited. Does not implicitly {@link chat.MediaCallOperateV2Response.verify|verify} messages.
         * @function encodeDelimited
         * @memberof chat.MediaCallOperateV2Response
         * @static
         * @param {chat.IMediaCallOperateV2Response} message MediaCallOperateV2Response message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        MediaCallOperateV2Response.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a MediaCallOperateV2Response message from the specified reader or buffer.
         * @function decode
         * @memberof chat.MediaCallOperateV2Response
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {chat.MediaCallOperateV2Response} MediaCallOperateV2Response
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        MediaCallOperateV2Response.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.chat.MediaCallOperateV2Response();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1: {
                        message.createdAt = reader.int64();
                        break;
                    }
                case 2: {
                        if (!(message.records && message.records.length))
                            message.records = [];
                        message.records.push($root.chat.MediaCallOperateV2ResponseItem.decode(reader, reader.uint32()));
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a MediaCallOperateV2Response message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof chat.MediaCallOperateV2Response
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {chat.MediaCallOperateV2Response} MediaCallOperateV2Response
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        MediaCallOperateV2Response.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a MediaCallOperateV2Response message.
         * @function verify
         * @memberof chat.MediaCallOperateV2Response
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        MediaCallOperateV2Response.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.createdAt != null && message.hasOwnProperty("createdAt"))
                if (!$util.isInteger(message.createdAt) && !(message.createdAt && $util.isInteger(message.createdAt.low) && $util.isInteger(message.createdAt.high)))
                    return "createdAt: integer|Long expected";
            if (message.records != null && message.hasOwnProperty("records")) {
                if (!Array.isArray(message.records))
                    return "records: array expected";
                for (let i = 0; i < message.records.length; ++i) {
                    let error = $root.chat.MediaCallOperateV2ResponseItem.verify(message.records[i]);
                    if (error)
                        return "records." + error;
                }
            }
            return null;
        };

        /**
         * Creates a MediaCallOperateV2Response message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof chat.MediaCallOperateV2Response
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {chat.MediaCallOperateV2Response} MediaCallOperateV2Response
         */
        MediaCallOperateV2Response.fromObject = function fromObject(object) {
            if (object instanceof $root.chat.MediaCallOperateV2Response)
                return object;
            let message = new $root.chat.MediaCallOperateV2Response();
            if (object.createdAt != null)
                if ($util.Long)
                    (message.createdAt = $util.Long.fromValue(object.createdAt)).unsigned = false;
                else if (typeof object.createdAt === "string")
                    message.createdAt = parseInt(object.createdAt, 10);
                else if (typeof object.createdAt === "number")
                    message.createdAt = object.createdAt;
                else if (typeof object.createdAt === "object")
                    message.createdAt = new $util.LongBits(object.createdAt.low >>> 0, object.createdAt.high >>> 0).toNumber();
            if (object.records) {
                if (!Array.isArray(object.records))
                    throw TypeError(".chat.MediaCallOperateV2Response.records: array expected");
                message.records = [];
                for (let i = 0; i < object.records.length; ++i) {
                    if (typeof object.records[i] !== "object")
                        throw TypeError(".chat.MediaCallOperateV2Response.records: object expected");
                    message.records[i] = $root.chat.MediaCallOperateV2ResponseItem.fromObject(object.records[i]);
                }
            }
            return message;
        };

        /**
         * Creates a plain object from a MediaCallOperateV2Response message. Also converts values to other types if specified.
         * @function toObject
         * @memberof chat.MediaCallOperateV2Response
         * @static
         * @param {chat.MediaCallOperateV2Response} message MediaCallOperateV2Response
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        MediaCallOperateV2Response.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.arrays || options.defaults)
                object.records = [];
            if (options.defaults)
                if ($util.Long) {
                    let long = new $util.Long(0, 0, false);
                    object.createdAt = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.createdAt = options.longs === String ? "0" : 0;
            if (message.createdAt != null && message.hasOwnProperty("createdAt"))
                if (typeof message.createdAt === "number")
                    object.createdAt = options.longs === String ? String(message.createdAt) : message.createdAt;
                else
                    object.createdAt = options.longs === String ? $util.Long.prototype.toString.call(message.createdAt) : options.longs === Number ? new $util.LongBits(message.createdAt.low >>> 0, message.createdAt.high >>> 0).toNumber() : message.createdAt;
            if (message.records && message.records.length) {
                object.records = [];
                for (let j = 0; j < message.records.length; ++j)
                    object.records[j] = $root.chat.MediaCallOperateV2ResponseItem.toObject(message.records[j], options);
            }
            return object;
        };

        /**
         * Converts this MediaCallOperateV2Response to JSON.
         * @function toJSON
         * @memberof chat.MediaCallOperateV2Response
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        MediaCallOperateV2Response.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for MediaCallOperateV2Response
         * @function getTypeUrl
         * @memberof chat.MediaCallOperateV2Response
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        MediaCallOperateV2Response.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/chat.MediaCallOperateV2Response";
        };

        return MediaCallOperateV2Response;
    })();

    chat.MediaCallOperateV2ResponseItem = (function() {

        /**
         * Properties of a MediaCallOperateV2ResponseItem.
         * @memberof chat
         * @interface IMediaCallOperateV2ResponseItem
         * @property {string|null} [messageId] MediaCallOperateV2ResponseItem messageId
         * @property {number|Long|null} [sequence] MediaCallOperateV2ResponseItem sequence
         * @property {string|null} [userId] MediaCallOperateV2ResponseItem userId
         * @property {number|null} [code] MediaCallOperateV2ResponseItem code
         * @property {string|null} [cliMsgId] MediaCallOperateV2ResponseItem cliMsgId
         */

        /**
         * Constructs a new MediaCallOperateV2ResponseItem.
         * @memberof chat
         * @classdesc Represents a MediaCallOperateV2ResponseItem.
         * @implements IMediaCallOperateV2ResponseItem
         * @constructor
         * @param {chat.IMediaCallOperateV2ResponseItem=} [properties] Properties to set
         */
        function MediaCallOperateV2ResponseItem(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * MediaCallOperateV2ResponseItem messageId.
         * @member {string} messageId
         * @memberof chat.MediaCallOperateV2ResponseItem
         * @instance
         */
        MediaCallOperateV2ResponseItem.prototype.messageId = "";

        /**
         * MediaCallOperateV2ResponseItem sequence.
         * @member {number|Long} sequence
         * @memberof chat.MediaCallOperateV2ResponseItem
         * @instance
         */
        MediaCallOperateV2ResponseItem.prototype.sequence = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * MediaCallOperateV2ResponseItem userId.
         * @member {string} userId
         * @memberof chat.MediaCallOperateV2ResponseItem
         * @instance
         */
        MediaCallOperateV2ResponseItem.prototype.userId = "";

        /**
         * MediaCallOperateV2ResponseItem code.
         * @member {number} code
         * @memberof chat.MediaCallOperateV2ResponseItem
         * @instance
         */
        MediaCallOperateV2ResponseItem.prototype.code = 0;

        /**
         * MediaCallOperateV2ResponseItem cliMsgId.
         * @member {string} cliMsgId
         * @memberof chat.MediaCallOperateV2ResponseItem
         * @instance
         */
        MediaCallOperateV2ResponseItem.prototype.cliMsgId = "";

        /**
         * Creates a new MediaCallOperateV2ResponseItem instance using the specified properties.
         * @function create
         * @memberof chat.MediaCallOperateV2ResponseItem
         * @static
         * @param {chat.IMediaCallOperateV2ResponseItem=} [properties] Properties to set
         * @returns {chat.MediaCallOperateV2ResponseItem} MediaCallOperateV2ResponseItem instance
         */
        MediaCallOperateV2ResponseItem.create = function create(properties) {
            return new MediaCallOperateV2ResponseItem(properties);
        };

        /**
         * Encodes the specified MediaCallOperateV2ResponseItem message. Does not implicitly {@link chat.MediaCallOperateV2ResponseItem.verify|verify} messages.
         * @function encode
         * @memberof chat.MediaCallOperateV2ResponseItem
         * @static
         * @param {chat.IMediaCallOperateV2ResponseItem} message MediaCallOperateV2ResponseItem message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        MediaCallOperateV2ResponseItem.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.messageId != null && Object.hasOwnProperty.call(message, "messageId"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.messageId);
            if (message.sequence != null && Object.hasOwnProperty.call(message, "sequence"))
                writer.uint32(/* id 2, wireType 0 =*/16).int64(message.sequence);
            if (message.userId != null && Object.hasOwnProperty.call(message, "userId"))
                writer.uint32(/* id 3, wireType 2 =*/26).string(message.userId);
            if (message.code != null && Object.hasOwnProperty.call(message, "code"))
                writer.uint32(/* id 4, wireType 0 =*/32).int32(message.code);
            if (message.cliMsgId != null && Object.hasOwnProperty.call(message, "cliMsgId"))
                writer.uint32(/* id 5, wireType 2 =*/42).string(message.cliMsgId);
            return writer;
        };

        /**
         * Encodes the specified MediaCallOperateV2ResponseItem message, length delimited. Does not implicitly {@link chat.MediaCallOperateV2ResponseItem.verify|verify} messages.
         * @function encodeDelimited
         * @memberof chat.MediaCallOperateV2ResponseItem
         * @static
         * @param {chat.IMediaCallOperateV2ResponseItem} message MediaCallOperateV2ResponseItem message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        MediaCallOperateV2ResponseItem.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a MediaCallOperateV2ResponseItem message from the specified reader or buffer.
         * @function decode
         * @memberof chat.MediaCallOperateV2ResponseItem
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {chat.MediaCallOperateV2ResponseItem} MediaCallOperateV2ResponseItem
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        MediaCallOperateV2ResponseItem.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.chat.MediaCallOperateV2ResponseItem();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1: {
                        message.messageId = reader.string();
                        break;
                    }
                case 2: {
                        message.sequence = reader.int64();
                        break;
                    }
                case 3: {
                        message.userId = reader.string();
                        break;
                    }
                case 4: {
                        message.code = reader.int32();
                        break;
                    }
                case 5: {
                        message.cliMsgId = reader.string();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a MediaCallOperateV2ResponseItem message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof chat.MediaCallOperateV2ResponseItem
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {chat.MediaCallOperateV2ResponseItem} MediaCallOperateV2ResponseItem
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        MediaCallOperateV2ResponseItem.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a MediaCallOperateV2ResponseItem message.
         * @function verify
         * @memberof chat.MediaCallOperateV2ResponseItem
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        MediaCallOperateV2ResponseItem.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.messageId != null && message.hasOwnProperty("messageId"))
                if (!$util.isString(message.messageId))
                    return "messageId: string expected";
            if (message.sequence != null && message.hasOwnProperty("sequence"))
                if (!$util.isInteger(message.sequence) && !(message.sequence && $util.isInteger(message.sequence.low) && $util.isInteger(message.sequence.high)))
                    return "sequence: integer|Long expected";
            if (message.userId != null && message.hasOwnProperty("userId"))
                if (!$util.isString(message.userId))
                    return "userId: string expected";
            if (message.code != null && message.hasOwnProperty("code"))
                if (!$util.isInteger(message.code))
                    return "code: integer expected";
            if (message.cliMsgId != null && message.hasOwnProperty("cliMsgId"))
                if (!$util.isString(message.cliMsgId))
                    return "cliMsgId: string expected";
            return null;
        };

        /**
         * Creates a MediaCallOperateV2ResponseItem message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof chat.MediaCallOperateV2ResponseItem
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {chat.MediaCallOperateV2ResponseItem} MediaCallOperateV2ResponseItem
         */
        MediaCallOperateV2ResponseItem.fromObject = function fromObject(object) {
            if (object instanceof $root.chat.MediaCallOperateV2ResponseItem)
                return object;
            let message = new $root.chat.MediaCallOperateV2ResponseItem();
            if (object.messageId != null)
                message.messageId = String(object.messageId);
            if (object.sequence != null)
                if ($util.Long)
                    (message.sequence = $util.Long.fromValue(object.sequence)).unsigned = false;
                else if (typeof object.sequence === "string")
                    message.sequence = parseInt(object.sequence, 10);
                else if (typeof object.sequence === "number")
                    message.sequence = object.sequence;
                else if (typeof object.sequence === "object")
                    message.sequence = new $util.LongBits(object.sequence.low >>> 0, object.sequence.high >>> 0).toNumber();
            if (object.userId != null)
                message.userId = String(object.userId);
            if (object.code != null)
                message.code = object.code | 0;
            if (object.cliMsgId != null)
                message.cliMsgId = String(object.cliMsgId);
            return message;
        };

        /**
         * Creates a plain object from a MediaCallOperateV2ResponseItem message. Also converts values to other types if specified.
         * @function toObject
         * @memberof chat.MediaCallOperateV2ResponseItem
         * @static
         * @param {chat.MediaCallOperateV2ResponseItem} message MediaCallOperateV2ResponseItem
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        MediaCallOperateV2ResponseItem.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.messageId = "";
                if ($util.Long) {
                    let long = new $util.Long(0, 0, false);
                    object.sequence = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.sequence = options.longs === String ? "0" : 0;
                object.userId = "";
                object.code = 0;
                object.cliMsgId = "";
            }
            if (message.messageId != null && message.hasOwnProperty("messageId"))
                object.messageId = message.messageId;
            if (message.sequence != null && message.hasOwnProperty("sequence"))
                if (typeof message.sequence === "number")
                    object.sequence = options.longs === String ? String(message.sequence) : message.sequence;
                else
                    object.sequence = options.longs === String ? $util.Long.prototype.toString.call(message.sequence) : options.longs === Number ? new $util.LongBits(message.sequence.low >>> 0, message.sequence.high >>> 0).toNumber() : message.sequence;
            if (message.userId != null && message.hasOwnProperty("userId"))
                object.userId = message.userId;
            if (message.code != null && message.hasOwnProperty("code"))
                object.code = message.code;
            if (message.cliMsgId != null && message.hasOwnProperty("cliMsgId"))
                object.cliMsgId = message.cliMsgId;
            return object;
        };

        /**
         * Converts this MediaCallOperateV2ResponseItem to JSON.
         * @function toJSON
         * @memberof chat.MediaCallOperateV2ResponseItem
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        MediaCallOperateV2ResponseItem.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for MediaCallOperateV2ResponseItem
         * @function getTypeUrl
         * @memberof chat.MediaCallOperateV2ResponseItem
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        MediaCallOperateV2ResponseItem.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/chat.MediaCallOperateV2ResponseItem";
        };

        return MediaCallOperateV2ResponseItem;
    })();

    chat.MediaCallOperateCalleeV2Request = (function() {

        /**
         * Properties of a MediaCallOperateCalleeV2Request.
         * @memberof chat
         * @interface IMediaCallOperateCalleeV2Request
         * @property {number|null} [opeType] MediaCallOperateCalleeV2Request opeType
         * @property {string|null} [chatId] MediaCallOperateCalleeV2Request chatId
         * @property {string|null} [msgExtContent] MediaCallOperateCalleeV2Request msgExtContent
         * @property {string|null} [messageId] MediaCallOperateCalleeV2Request messageId
         * @property {string|null} [roomId] MediaCallOperateCalleeV2Request roomId
         * @property {string|null} [targetId] MediaCallOperateCalleeV2Request targetId
         * @property {string|null} [originUid] MediaCallOperateCalleeV2Request originUid
         * @property {string|null} [cliMsgId] MediaCallOperateCalleeV2Request cliMsgId
         * @property {string|null} [groupId] MediaCallOperateCalleeV2Request groupId
         */

        /**
         * Constructs a new MediaCallOperateCalleeV2Request.
         * @memberof chat
         * @classdesc Represents a MediaCallOperateCalleeV2Request.
         * @implements IMediaCallOperateCalleeV2Request
         * @constructor
         * @param {chat.IMediaCallOperateCalleeV2Request=} [properties] Properties to set
         */
        function MediaCallOperateCalleeV2Request(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * MediaCallOperateCalleeV2Request opeType.
         * @member {number} opeType
         * @memberof chat.MediaCallOperateCalleeV2Request
         * @instance
         */
        MediaCallOperateCalleeV2Request.prototype.opeType = 0;

        /**
         * MediaCallOperateCalleeV2Request chatId.
         * @member {string} chatId
         * @memberof chat.MediaCallOperateCalleeV2Request
         * @instance
         */
        MediaCallOperateCalleeV2Request.prototype.chatId = "";

        /**
         * MediaCallOperateCalleeV2Request msgExtContent.
         * @member {string} msgExtContent
         * @memberof chat.MediaCallOperateCalleeV2Request
         * @instance
         */
        MediaCallOperateCalleeV2Request.prototype.msgExtContent = "";

        /**
         * MediaCallOperateCalleeV2Request messageId.
         * @member {string} messageId
         * @memberof chat.MediaCallOperateCalleeV2Request
         * @instance
         */
        MediaCallOperateCalleeV2Request.prototype.messageId = "";

        /**
         * MediaCallOperateCalleeV2Request roomId.
         * @member {string} roomId
         * @memberof chat.MediaCallOperateCalleeV2Request
         * @instance
         */
        MediaCallOperateCalleeV2Request.prototype.roomId = "";

        /**
         * MediaCallOperateCalleeV2Request targetId.
         * @member {string} targetId
         * @memberof chat.MediaCallOperateCalleeV2Request
         * @instance
         */
        MediaCallOperateCalleeV2Request.prototype.targetId = "";

        /**
         * MediaCallOperateCalleeV2Request originUid.
         * @member {string} originUid
         * @memberof chat.MediaCallOperateCalleeV2Request
         * @instance
         */
        MediaCallOperateCalleeV2Request.prototype.originUid = "";

        /**
         * MediaCallOperateCalleeV2Request cliMsgId.
         * @member {string} cliMsgId
         * @memberof chat.MediaCallOperateCalleeV2Request
         * @instance
         */
        MediaCallOperateCalleeV2Request.prototype.cliMsgId = "";

        /**
         * MediaCallOperateCalleeV2Request groupId.
         * @member {string} groupId
         * @memberof chat.MediaCallOperateCalleeV2Request
         * @instance
         */
        MediaCallOperateCalleeV2Request.prototype.groupId = "";

        /**
         * Creates a new MediaCallOperateCalleeV2Request instance using the specified properties.
         * @function create
         * @memberof chat.MediaCallOperateCalleeV2Request
         * @static
         * @param {chat.IMediaCallOperateCalleeV2Request=} [properties] Properties to set
         * @returns {chat.MediaCallOperateCalleeV2Request} MediaCallOperateCalleeV2Request instance
         */
        MediaCallOperateCalleeV2Request.create = function create(properties) {
            return new MediaCallOperateCalleeV2Request(properties);
        };

        /**
         * Encodes the specified MediaCallOperateCalleeV2Request message. Does not implicitly {@link chat.MediaCallOperateCalleeV2Request.verify|verify} messages.
         * @function encode
         * @memberof chat.MediaCallOperateCalleeV2Request
         * @static
         * @param {chat.IMediaCallOperateCalleeV2Request} message MediaCallOperateCalleeV2Request message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        MediaCallOperateCalleeV2Request.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.opeType != null && Object.hasOwnProperty.call(message, "opeType"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.opeType);
            if (message.chatId != null && Object.hasOwnProperty.call(message, "chatId"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.chatId);
            if (message.msgExtContent != null && Object.hasOwnProperty.call(message, "msgExtContent"))
                writer.uint32(/* id 3, wireType 2 =*/26).string(message.msgExtContent);
            if (message.messageId != null && Object.hasOwnProperty.call(message, "messageId"))
                writer.uint32(/* id 4, wireType 2 =*/34).string(message.messageId);
            if (message.roomId != null && Object.hasOwnProperty.call(message, "roomId"))
                writer.uint32(/* id 5, wireType 2 =*/42).string(message.roomId);
            if (message.targetId != null && Object.hasOwnProperty.call(message, "targetId"))
                writer.uint32(/* id 7, wireType 2 =*/58).string(message.targetId);
            if (message.originUid != null && Object.hasOwnProperty.call(message, "originUid"))
                writer.uint32(/* id 8, wireType 2 =*/66).string(message.originUid);
            if (message.cliMsgId != null && Object.hasOwnProperty.call(message, "cliMsgId"))
                writer.uint32(/* id 9, wireType 2 =*/74).string(message.cliMsgId);
            if (message.groupId != null && Object.hasOwnProperty.call(message, "groupId"))
                writer.uint32(/* id 10, wireType 2 =*/82).string(message.groupId);
            return writer;
        };

        /**
         * Encodes the specified MediaCallOperateCalleeV2Request message, length delimited. Does not implicitly {@link chat.MediaCallOperateCalleeV2Request.verify|verify} messages.
         * @function encodeDelimited
         * @memberof chat.MediaCallOperateCalleeV2Request
         * @static
         * @param {chat.IMediaCallOperateCalleeV2Request} message MediaCallOperateCalleeV2Request message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        MediaCallOperateCalleeV2Request.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a MediaCallOperateCalleeV2Request message from the specified reader or buffer.
         * @function decode
         * @memberof chat.MediaCallOperateCalleeV2Request
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {chat.MediaCallOperateCalleeV2Request} MediaCallOperateCalleeV2Request
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        MediaCallOperateCalleeV2Request.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.chat.MediaCallOperateCalleeV2Request();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1: {
                        message.opeType = reader.int32();
                        break;
                    }
                case 2: {
                        message.chatId = reader.string();
                        break;
                    }
                case 3: {
                        message.msgExtContent = reader.string();
                        break;
                    }
                case 4: {
                        message.messageId = reader.string();
                        break;
                    }
                case 5: {
                        message.roomId = reader.string();
                        break;
                    }
                case 7: {
                        message.targetId = reader.string();
                        break;
                    }
                case 8: {
                        message.originUid = reader.string();
                        break;
                    }
                case 9: {
                        message.cliMsgId = reader.string();
                        break;
                    }
                case 10: {
                        message.groupId = reader.string();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a MediaCallOperateCalleeV2Request message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof chat.MediaCallOperateCalleeV2Request
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {chat.MediaCallOperateCalleeV2Request} MediaCallOperateCalleeV2Request
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        MediaCallOperateCalleeV2Request.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a MediaCallOperateCalleeV2Request message.
         * @function verify
         * @memberof chat.MediaCallOperateCalleeV2Request
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        MediaCallOperateCalleeV2Request.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.opeType != null && message.hasOwnProperty("opeType"))
                if (!$util.isInteger(message.opeType))
                    return "opeType: integer expected";
            if (message.chatId != null && message.hasOwnProperty("chatId"))
                if (!$util.isString(message.chatId))
                    return "chatId: string expected";
            if (message.msgExtContent != null && message.hasOwnProperty("msgExtContent"))
                if (!$util.isString(message.msgExtContent))
                    return "msgExtContent: string expected";
            if (message.messageId != null && message.hasOwnProperty("messageId"))
                if (!$util.isString(message.messageId))
                    return "messageId: string expected";
            if (message.roomId != null && message.hasOwnProperty("roomId"))
                if (!$util.isString(message.roomId))
                    return "roomId: string expected";
            if (message.targetId != null && message.hasOwnProperty("targetId"))
                if (!$util.isString(message.targetId))
                    return "targetId: string expected";
            if (message.originUid != null && message.hasOwnProperty("originUid"))
                if (!$util.isString(message.originUid))
                    return "originUid: string expected";
            if (message.cliMsgId != null && message.hasOwnProperty("cliMsgId"))
                if (!$util.isString(message.cliMsgId))
                    return "cliMsgId: string expected";
            if (message.groupId != null && message.hasOwnProperty("groupId"))
                if (!$util.isString(message.groupId))
                    return "groupId: string expected";
            return null;
        };

        /**
         * Creates a MediaCallOperateCalleeV2Request message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof chat.MediaCallOperateCalleeV2Request
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {chat.MediaCallOperateCalleeV2Request} MediaCallOperateCalleeV2Request
         */
        MediaCallOperateCalleeV2Request.fromObject = function fromObject(object) {
            if (object instanceof $root.chat.MediaCallOperateCalleeV2Request)
                return object;
            let message = new $root.chat.MediaCallOperateCalleeV2Request();
            if (object.opeType != null)
                message.opeType = object.opeType | 0;
            if (object.chatId != null)
                message.chatId = String(object.chatId);
            if (object.msgExtContent != null)
                message.msgExtContent = String(object.msgExtContent);
            if (object.messageId != null)
                message.messageId = String(object.messageId);
            if (object.roomId != null)
                message.roomId = String(object.roomId);
            if (object.targetId != null)
                message.targetId = String(object.targetId);
            if (object.originUid != null)
                message.originUid = String(object.originUid);
            if (object.cliMsgId != null)
                message.cliMsgId = String(object.cliMsgId);
            if (object.groupId != null)
                message.groupId = String(object.groupId);
            return message;
        };

        /**
         * Creates a plain object from a MediaCallOperateCalleeV2Request message. Also converts values to other types if specified.
         * @function toObject
         * @memberof chat.MediaCallOperateCalleeV2Request
         * @static
         * @param {chat.MediaCallOperateCalleeV2Request} message MediaCallOperateCalleeV2Request
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        MediaCallOperateCalleeV2Request.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.opeType = 0;
                object.chatId = "";
                object.msgExtContent = "";
                object.messageId = "";
                object.roomId = "";
                object.targetId = "";
                object.originUid = "";
                object.cliMsgId = "";
                object.groupId = "";
            }
            if (message.opeType != null && message.hasOwnProperty("opeType"))
                object.opeType = message.opeType;
            if (message.chatId != null && message.hasOwnProperty("chatId"))
                object.chatId = message.chatId;
            if (message.msgExtContent != null && message.hasOwnProperty("msgExtContent"))
                object.msgExtContent = message.msgExtContent;
            if (message.messageId != null && message.hasOwnProperty("messageId"))
                object.messageId = message.messageId;
            if (message.roomId != null && message.hasOwnProperty("roomId"))
                object.roomId = message.roomId;
            if (message.targetId != null && message.hasOwnProperty("targetId"))
                object.targetId = message.targetId;
            if (message.originUid != null && message.hasOwnProperty("originUid"))
                object.originUid = message.originUid;
            if (message.cliMsgId != null && message.hasOwnProperty("cliMsgId"))
                object.cliMsgId = message.cliMsgId;
            if (message.groupId != null && message.hasOwnProperty("groupId"))
                object.groupId = message.groupId;
            return object;
        };

        /**
         * Converts this MediaCallOperateCalleeV2Request to JSON.
         * @function toJSON
         * @memberof chat.MediaCallOperateCalleeV2Request
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        MediaCallOperateCalleeV2Request.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for MediaCallOperateCalleeV2Request
         * @function getTypeUrl
         * @memberof chat.MediaCallOperateCalleeV2Request
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        MediaCallOperateCalleeV2Request.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/chat.MediaCallOperateCalleeV2Request";
        };

        return MediaCallOperateCalleeV2Request;
    })();

    chat.MediaCallOperateCalleeV2Response = (function() {

        /**
         * Properties of a MediaCallOperateCalleeV2Response.
         * @memberof chat
         * @interface IMediaCallOperateCalleeV2Response
         * @property {string|null} [messageId] MediaCallOperateCalleeV2Response messageId
         * @property {number|Long|null} [sequence] MediaCallOperateCalleeV2Response sequence
         * @property {string|null} [userId] MediaCallOperateCalleeV2Response userId
         * @property {number|null} [code] MediaCallOperateCalleeV2Response code
         * @property {string|null} [cliMsgId] MediaCallOperateCalleeV2Response cliMsgId
         * @property {number|Long|null} [createdAt] MediaCallOperateCalleeV2Response createdAt
         * @property {chat.IMediaCallOperateCalleeV2ResponseGroup|null} [group] MediaCallOperateCalleeV2Response group
         */

        /**
         * Constructs a new MediaCallOperateCalleeV2Response.
         * @memberof chat
         * @classdesc Represents a MediaCallOperateCalleeV2Response.
         * @implements IMediaCallOperateCalleeV2Response
         * @constructor
         * @param {chat.IMediaCallOperateCalleeV2Response=} [properties] Properties to set
         */
        function MediaCallOperateCalleeV2Response(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * MediaCallOperateCalleeV2Response messageId.
         * @member {string} messageId
         * @memberof chat.MediaCallOperateCalleeV2Response
         * @instance
         */
        MediaCallOperateCalleeV2Response.prototype.messageId = "";

        /**
         * MediaCallOperateCalleeV2Response sequence.
         * @member {number|Long} sequence
         * @memberof chat.MediaCallOperateCalleeV2Response
         * @instance
         */
        MediaCallOperateCalleeV2Response.prototype.sequence = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * MediaCallOperateCalleeV2Response userId.
         * @member {string} userId
         * @memberof chat.MediaCallOperateCalleeV2Response
         * @instance
         */
        MediaCallOperateCalleeV2Response.prototype.userId = "";

        /**
         * MediaCallOperateCalleeV2Response code.
         * @member {number} code
         * @memberof chat.MediaCallOperateCalleeV2Response
         * @instance
         */
        MediaCallOperateCalleeV2Response.prototype.code = 0;

        /**
         * MediaCallOperateCalleeV2Response cliMsgId.
         * @member {string} cliMsgId
         * @memberof chat.MediaCallOperateCalleeV2Response
         * @instance
         */
        MediaCallOperateCalleeV2Response.prototype.cliMsgId = "";

        /**
         * MediaCallOperateCalleeV2Response createdAt.
         * @member {number|Long} createdAt
         * @memberof chat.MediaCallOperateCalleeV2Response
         * @instance
         */
        MediaCallOperateCalleeV2Response.prototype.createdAt = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * MediaCallOperateCalleeV2Response group.
         * @member {chat.IMediaCallOperateCalleeV2ResponseGroup|null|undefined} group
         * @memberof chat.MediaCallOperateCalleeV2Response
         * @instance
         */
        MediaCallOperateCalleeV2Response.prototype.group = null;

        /**
         * Creates a new MediaCallOperateCalleeV2Response instance using the specified properties.
         * @function create
         * @memberof chat.MediaCallOperateCalleeV2Response
         * @static
         * @param {chat.IMediaCallOperateCalleeV2Response=} [properties] Properties to set
         * @returns {chat.MediaCallOperateCalleeV2Response} MediaCallOperateCalleeV2Response instance
         */
        MediaCallOperateCalleeV2Response.create = function create(properties) {
            return new MediaCallOperateCalleeV2Response(properties);
        };

        /**
         * Encodes the specified MediaCallOperateCalleeV2Response message. Does not implicitly {@link chat.MediaCallOperateCalleeV2Response.verify|verify} messages.
         * @function encode
         * @memberof chat.MediaCallOperateCalleeV2Response
         * @static
         * @param {chat.IMediaCallOperateCalleeV2Response} message MediaCallOperateCalleeV2Response message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        MediaCallOperateCalleeV2Response.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.messageId != null && Object.hasOwnProperty.call(message, "messageId"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.messageId);
            if (message.sequence != null && Object.hasOwnProperty.call(message, "sequence"))
                writer.uint32(/* id 2, wireType 0 =*/16).int64(message.sequence);
            if (message.userId != null && Object.hasOwnProperty.call(message, "userId"))
                writer.uint32(/* id 3, wireType 2 =*/26).string(message.userId);
            if (message.code != null && Object.hasOwnProperty.call(message, "code"))
                writer.uint32(/* id 4, wireType 0 =*/32).int32(message.code);
            if (message.cliMsgId != null && Object.hasOwnProperty.call(message, "cliMsgId"))
                writer.uint32(/* id 5, wireType 2 =*/42).string(message.cliMsgId);
            if (message.createdAt != null && Object.hasOwnProperty.call(message, "createdAt"))
                writer.uint32(/* id 6, wireType 0 =*/48).int64(message.createdAt);
            if (message.group != null && Object.hasOwnProperty.call(message, "group"))
                $root.chat.MediaCallOperateCalleeV2ResponseGroup.encode(message.group, writer.uint32(/* id 7, wireType 2 =*/58).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified MediaCallOperateCalleeV2Response message, length delimited. Does not implicitly {@link chat.MediaCallOperateCalleeV2Response.verify|verify} messages.
         * @function encodeDelimited
         * @memberof chat.MediaCallOperateCalleeV2Response
         * @static
         * @param {chat.IMediaCallOperateCalleeV2Response} message MediaCallOperateCalleeV2Response message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        MediaCallOperateCalleeV2Response.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a MediaCallOperateCalleeV2Response message from the specified reader or buffer.
         * @function decode
         * @memberof chat.MediaCallOperateCalleeV2Response
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {chat.MediaCallOperateCalleeV2Response} MediaCallOperateCalleeV2Response
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        MediaCallOperateCalleeV2Response.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.chat.MediaCallOperateCalleeV2Response();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1: {
                        message.messageId = reader.string();
                        break;
                    }
                case 2: {
                        message.sequence = reader.int64();
                        break;
                    }
                case 3: {
                        message.userId = reader.string();
                        break;
                    }
                case 4: {
                        message.code = reader.int32();
                        break;
                    }
                case 5: {
                        message.cliMsgId = reader.string();
                        break;
                    }
                case 6: {
                        message.createdAt = reader.int64();
                        break;
                    }
                case 7: {
                        message.group = $root.chat.MediaCallOperateCalleeV2ResponseGroup.decode(reader, reader.uint32());
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a MediaCallOperateCalleeV2Response message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof chat.MediaCallOperateCalleeV2Response
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {chat.MediaCallOperateCalleeV2Response} MediaCallOperateCalleeV2Response
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        MediaCallOperateCalleeV2Response.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a MediaCallOperateCalleeV2Response message.
         * @function verify
         * @memberof chat.MediaCallOperateCalleeV2Response
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        MediaCallOperateCalleeV2Response.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.messageId != null && message.hasOwnProperty("messageId"))
                if (!$util.isString(message.messageId))
                    return "messageId: string expected";
            if (message.sequence != null && message.hasOwnProperty("sequence"))
                if (!$util.isInteger(message.sequence) && !(message.sequence && $util.isInteger(message.sequence.low) && $util.isInteger(message.sequence.high)))
                    return "sequence: integer|Long expected";
            if (message.userId != null && message.hasOwnProperty("userId"))
                if (!$util.isString(message.userId))
                    return "userId: string expected";
            if (message.code != null && message.hasOwnProperty("code"))
                if (!$util.isInteger(message.code))
                    return "code: integer expected";
            if (message.cliMsgId != null && message.hasOwnProperty("cliMsgId"))
                if (!$util.isString(message.cliMsgId))
                    return "cliMsgId: string expected";
            if (message.createdAt != null && message.hasOwnProperty("createdAt"))
                if (!$util.isInteger(message.createdAt) && !(message.createdAt && $util.isInteger(message.createdAt.low) && $util.isInteger(message.createdAt.high)))
                    return "createdAt: integer|Long expected";
            if (message.group != null && message.hasOwnProperty("group")) {
                let error = $root.chat.MediaCallOperateCalleeV2ResponseGroup.verify(message.group);
                if (error)
                    return "group." + error;
            }
            return null;
        };

        /**
         * Creates a MediaCallOperateCalleeV2Response message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof chat.MediaCallOperateCalleeV2Response
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {chat.MediaCallOperateCalleeV2Response} MediaCallOperateCalleeV2Response
         */
        MediaCallOperateCalleeV2Response.fromObject = function fromObject(object) {
            if (object instanceof $root.chat.MediaCallOperateCalleeV2Response)
                return object;
            let message = new $root.chat.MediaCallOperateCalleeV2Response();
            if (object.messageId != null)
                message.messageId = String(object.messageId);
            if (object.sequence != null)
                if ($util.Long)
                    (message.sequence = $util.Long.fromValue(object.sequence)).unsigned = false;
                else if (typeof object.sequence === "string")
                    message.sequence = parseInt(object.sequence, 10);
                else if (typeof object.sequence === "number")
                    message.sequence = object.sequence;
                else if (typeof object.sequence === "object")
                    message.sequence = new $util.LongBits(object.sequence.low >>> 0, object.sequence.high >>> 0).toNumber();
            if (object.userId != null)
                message.userId = String(object.userId);
            if (object.code != null)
                message.code = object.code | 0;
            if (object.cliMsgId != null)
                message.cliMsgId = String(object.cliMsgId);
            if (object.createdAt != null)
                if ($util.Long)
                    (message.createdAt = $util.Long.fromValue(object.createdAt)).unsigned = false;
                else if (typeof object.createdAt === "string")
                    message.createdAt = parseInt(object.createdAt, 10);
                else if (typeof object.createdAt === "number")
                    message.createdAt = object.createdAt;
                else if (typeof object.createdAt === "object")
                    message.createdAt = new $util.LongBits(object.createdAt.low >>> 0, object.createdAt.high >>> 0).toNumber();
            if (object.group != null) {
                if (typeof object.group !== "object")
                    throw TypeError(".chat.MediaCallOperateCalleeV2Response.group: object expected");
                message.group = $root.chat.MediaCallOperateCalleeV2ResponseGroup.fromObject(object.group);
            }
            return message;
        };

        /**
         * Creates a plain object from a MediaCallOperateCalleeV2Response message. Also converts values to other types if specified.
         * @function toObject
         * @memberof chat.MediaCallOperateCalleeV2Response
         * @static
         * @param {chat.MediaCallOperateCalleeV2Response} message MediaCallOperateCalleeV2Response
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        MediaCallOperateCalleeV2Response.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.messageId = "";
                if ($util.Long) {
                    let long = new $util.Long(0, 0, false);
                    object.sequence = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.sequence = options.longs === String ? "0" : 0;
                object.userId = "";
                object.code = 0;
                object.cliMsgId = "";
                if ($util.Long) {
                    let long = new $util.Long(0, 0, false);
                    object.createdAt = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.createdAt = options.longs === String ? "0" : 0;
                object.group = null;
            }
            if (message.messageId != null && message.hasOwnProperty("messageId"))
                object.messageId = message.messageId;
            if (message.sequence != null && message.hasOwnProperty("sequence"))
                if (typeof message.sequence === "number")
                    object.sequence = options.longs === String ? String(message.sequence) : message.sequence;
                else
                    object.sequence = options.longs === String ? $util.Long.prototype.toString.call(message.sequence) : options.longs === Number ? new $util.LongBits(message.sequence.low >>> 0, message.sequence.high >>> 0).toNumber() : message.sequence;
            if (message.userId != null && message.hasOwnProperty("userId"))
                object.userId = message.userId;
            if (message.code != null && message.hasOwnProperty("code"))
                object.code = message.code;
            if (message.cliMsgId != null && message.hasOwnProperty("cliMsgId"))
                object.cliMsgId = message.cliMsgId;
            if (message.createdAt != null && message.hasOwnProperty("createdAt"))
                if (typeof message.createdAt === "number")
                    object.createdAt = options.longs === String ? String(message.createdAt) : message.createdAt;
                else
                    object.createdAt = options.longs === String ? $util.Long.prototype.toString.call(message.createdAt) : options.longs === Number ? new $util.LongBits(message.createdAt.low >>> 0, message.createdAt.high >>> 0).toNumber() : message.createdAt;
            if (message.group != null && message.hasOwnProperty("group"))
                object.group = $root.chat.MediaCallOperateCalleeV2ResponseGroup.toObject(message.group, options);
            return object;
        };

        /**
         * Converts this MediaCallOperateCalleeV2Response to JSON.
         * @function toJSON
         * @memberof chat.MediaCallOperateCalleeV2Response
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        MediaCallOperateCalleeV2Response.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for MediaCallOperateCalleeV2Response
         * @function getTypeUrl
         * @memberof chat.MediaCallOperateCalleeV2Response
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        MediaCallOperateCalleeV2Response.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/chat.MediaCallOperateCalleeV2Response";
        };

        return MediaCallOperateCalleeV2Response;
    })();

    chat.MediaCallOperateCalleeV2ResponseGroup = (function() {

        /**
         * Properties of a MediaCallOperateCalleeV2ResponseGroup.
         * @memberof chat
         * @interface IMediaCallOperateCalleeV2ResponseGroup
         * @property {string|null} [roomId] MediaCallOperateCalleeV2ResponseGroup roomId
         * @property {number|Long|null} [busy] MediaCallOperateCalleeV2ResponseGroup busy
         * @property {string|null} [groupId] MediaCallOperateCalleeV2ResponseGroup groupId
         * @property {string|null} [tGroupId] MediaCallOperateCalleeV2ResponseGroup tGroupId
         * @property {string|null} [senderId] MediaCallOperateCalleeV2ResponseGroup senderId
         */

        /**
         * Constructs a new MediaCallOperateCalleeV2ResponseGroup.
         * @memberof chat
         * @classdesc Represents a MediaCallOperateCalleeV2ResponseGroup.
         * @implements IMediaCallOperateCalleeV2ResponseGroup
         * @constructor
         * @param {chat.IMediaCallOperateCalleeV2ResponseGroup=} [properties] Properties to set
         */
        function MediaCallOperateCalleeV2ResponseGroup(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * MediaCallOperateCalleeV2ResponseGroup roomId.
         * @member {string} roomId
         * @memberof chat.MediaCallOperateCalleeV2ResponseGroup
         * @instance
         */
        MediaCallOperateCalleeV2ResponseGroup.prototype.roomId = "";

        /**
         * MediaCallOperateCalleeV2ResponseGroup busy.
         * @member {number|Long} busy
         * @memberof chat.MediaCallOperateCalleeV2ResponseGroup
         * @instance
         */
        MediaCallOperateCalleeV2ResponseGroup.prototype.busy = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * MediaCallOperateCalleeV2ResponseGroup groupId.
         * @member {string} groupId
         * @memberof chat.MediaCallOperateCalleeV2ResponseGroup
         * @instance
         */
        MediaCallOperateCalleeV2ResponseGroup.prototype.groupId = "";

        /**
         * MediaCallOperateCalleeV2ResponseGroup tGroupId.
         * @member {string} tGroupId
         * @memberof chat.MediaCallOperateCalleeV2ResponseGroup
         * @instance
         */
        MediaCallOperateCalleeV2ResponseGroup.prototype.tGroupId = "";

        /**
         * MediaCallOperateCalleeV2ResponseGroup senderId.
         * @member {string} senderId
         * @memberof chat.MediaCallOperateCalleeV2ResponseGroup
         * @instance
         */
        MediaCallOperateCalleeV2ResponseGroup.prototype.senderId = "";

        /**
         * Creates a new MediaCallOperateCalleeV2ResponseGroup instance using the specified properties.
         * @function create
         * @memberof chat.MediaCallOperateCalleeV2ResponseGroup
         * @static
         * @param {chat.IMediaCallOperateCalleeV2ResponseGroup=} [properties] Properties to set
         * @returns {chat.MediaCallOperateCalleeV2ResponseGroup} MediaCallOperateCalleeV2ResponseGroup instance
         */
        MediaCallOperateCalleeV2ResponseGroup.create = function create(properties) {
            return new MediaCallOperateCalleeV2ResponseGroup(properties);
        };

        /**
         * Encodes the specified MediaCallOperateCalleeV2ResponseGroup message. Does not implicitly {@link chat.MediaCallOperateCalleeV2ResponseGroup.verify|verify} messages.
         * @function encode
         * @memberof chat.MediaCallOperateCalleeV2ResponseGroup
         * @static
         * @param {chat.IMediaCallOperateCalleeV2ResponseGroup} message MediaCallOperateCalleeV2ResponseGroup message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        MediaCallOperateCalleeV2ResponseGroup.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.roomId != null && Object.hasOwnProperty.call(message, "roomId"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.roomId);
            if (message.busy != null && Object.hasOwnProperty.call(message, "busy"))
                writer.uint32(/* id 2, wireType 0 =*/16).int64(message.busy);
            if (message.groupId != null && Object.hasOwnProperty.call(message, "groupId"))
                writer.uint32(/* id 3, wireType 2 =*/26).string(message.groupId);
            if (message.tGroupId != null && Object.hasOwnProperty.call(message, "tGroupId"))
                writer.uint32(/* id 4, wireType 2 =*/34).string(message.tGroupId);
            if (message.senderId != null && Object.hasOwnProperty.call(message, "senderId"))
                writer.uint32(/* id 5, wireType 2 =*/42).string(message.senderId);
            return writer;
        };

        /**
         * Encodes the specified MediaCallOperateCalleeV2ResponseGroup message, length delimited. Does not implicitly {@link chat.MediaCallOperateCalleeV2ResponseGroup.verify|verify} messages.
         * @function encodeDelimited
         * @memberof chat.MediaCallOperateCalleeV2ResponseGroup
         * @static
         * @param {chat.IMediaCallOperateCalleeV2ResponseGroup} message MediaCallOperateCalleeV2ResponseGroup message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        MediaCallOperateCalleeV2ResponseGroup.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a MediaCallOperateCalleeV2ResponseGroup message from the specified reader or buffer.
         * @function decode
         * @memberof chat.MediaCallOperateCalleeV2ResponseGroup
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {chat.MediaCallOperateCalleeV2ResponseGroup} MediaCallOperateCalleeV2ResponseGroup
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        MediaCallOperateCalleeV2ResponseGroup.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.chat.MediaCallOperateCalleeV2ResponseGroup();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1: {
                        message.roomId = reader.string();
                        break;
                    }
                case 2: {
                        message.busy = reader.int64();
                        break;
                    }
                case 3: {
                        message.groupId = reader.string();
                        break;
                    }
                case 4: {
                        message.tGroupId = reader.string();
                        break;
                    }
                case 5: {
                        message.senderId = reader.string();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a MediaCallOperateCalleeV2ResponseGroup message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof chat.MediaCallOperateCalleeV2ResponseGroup
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {chat.MediaCallOperateCalleeV2ResponseGroup} MediaCallOperateCalleeV2ResponseGroup
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        MediaCallOperateCalleeV2ResponseGroup.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a MediaCallOperateCalleeV2ResponseGroup message.
         * @function verify
         * @memberof chat.MediaCallOperateCalleeV2ResponseGroup
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        MediaCallOperateCalleeV2ResponseGroup.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.roomId != null && message.hasOwnProperty("roomId"))
                if (!$util.isString(message.roomId))
                    return "roomId: string expected";
            if (message.busy != null && message.hasOwnProperty("busy"))
                if (!$util.isInteger(message.busy) && !(message.busy && $util.isInteger(message.busy.low) && $util.isInteger(message.busy.high)))
                    return "busy: integer|Long expected";
            if (message.groupId != null && message.hasOwnProperty("groupId"))
                if (!$util.isString(message.groupId))
                    return "groupId: string expected";
            if (message.tGroupId != null && message.hasOwnProperty("tGroupId"))
                if (!$util.isString(message.tGroupId))
                    return "tGroupId: string expected";
            if (message.senderId != null && message.hasOwnProperty("senderId"))
                if (!$util.isString(message.senderId))
                    return "senderId: string expected";
            return null;
        };

        /**
         * Creates a MediaCallOperateCalleeV2ResponseGroup message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof chat.MediaCallOperateCalleeV2ResponseGroup
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {chat.MediaCallOperateCalleeV2ResponseGroup} MediaCallOperateCalleeV2ResponseGroup
         */
        MediaCallOperateCalleeV2ResponseGroup.fromObject = function fromObject(object) {
            if (object instanceof $root.chat.MediaCallOperateCalleeV2ResponseGroup)
                return object;
            let message = new $root.chat.MediaCallOperateCalleeV2ResponseGroup();
            if (object.roomId != null)
                message.roomId = String(object.roomId);
            if (object.busy != null)
                if ($util.Long)
                    (message.busy = $util.Long.fromValue(object.busy)).unsigned = false;
                else if (typeof object.busy === "string")
                    message.busy = parseInt(object.busy, 10);
                else if (typeof object.busy === "number")
                    message.busy = object.busy;
                else if (typeof object.busy === "object")
                    message.busy = new $util.LongBits(object.busy.low >>> 0, object.busy.high >>> 0).toNumber();
            if (object.groupId != null)
                message.groupId = String(object.groupId);
            if (object.tGroupId != null)
                message.tGroupId = String(object.tGroupId);
            if (object.senderId != null)
                message.senderId = String(object.senderId);
            return message;
        };

        /**
         * Creates a plain object from a MediaCallOperateCalleeV2ResponseGroup message. Also converts values to other types if specified.
         * @function toObject
         * @memberof chat.MediaCallOperateCalleeV2ResponseGroup
         * @static
         * @param {chat.MediaCallOperateCalleeV2ResponseGroup} message MediaCallOperateCalleeV2ResponseGroup
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        MediaCallOperateCalleeV2ResponseGroup.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.roomId = "";
                if ($util.Long) {
                    let long = new $util.Long(0, 0, false);
                    object.busy = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.busy = options.longs === String ? "0" : 0;
                object.groupId = "";
                object.tGroupId = "";
                object.senderId = "";
            }
            if (message.roomId != null && message.hasOwnProperty("roomId"))
                object.roomId = message.roomId;
            if (message.busy != null && message.hasOwnProperty("busy"))
                if (typeof message.busy === "number")
                    object.busy = options.longs === String ? String(message.busy) : message.busy;
                else
                    object.busy = options.longs === String ? $util.Long.prototype.toString.call(message.busy) : options.longs === Number ? new $util.LongBits(message.busy.low >>> 0, message.busy.high >>> 0).toNumber() : message.busy;
            if (message.groupId != null && message.hasOwnProperty("groupId"))
                object.groupId = message.groupId;
            if (message.tGroupId != null && message.hasOwnProperty("tGroupId"))
                object.tGroupId = message.tGroupId;
            if (message.senderId != null && message.hasOwnProperty("senderId"))
                object.senderId = message.senderId;
            return object;
        };

        /**
         * Converts this MediaCallOperateCalleeV2ResponseGroup to JSON.
         * @function toJSON
         * @memberof chat.MediaCallOperateCalleeV2ResponseGroup
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        MediaCallOperateCalleeV2ResponseGroup.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for MediaCallOperateCalleeV2ResponseGroup
         * @function getTypeUrl
         * @memberof chat.MediaCallOperateCalleeV2ResponseGroup
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        MediaCallOperateCalleeV2ResponseGroup.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/chat.MediaCallOperateCalleeV2ResponseGroup";
        };

        return MediaCallOperateCalleeV2ResponseGroup;
    })();

    chat.SyncMediaCallInfoRequest = (function() {

        /**
         * Properties of a SyncMediaCallInfoRequest.
         * @memberof chat
         * @interface ISyncMediaCallInfoRequest
         * @property {string|null} [roomId] SyncMediaCallInfoRequest roomId
         * @property {string|null} [chatId] SyncMediaCallInfoRequest chatId
         * @property {string|null} [messageId] SyncMediaCallInfoRequest messageId
         * @property {string|null} [originUid] SyncMediaCallInfoRequest originUid
         */

        /**
         * Constructs a new SyncMediaCallInfoRequest.
         * @memberof chat
         * @classdesc Represents a SyncMediaCallInfoRequest.
         * @implements ISyncMediaCallInfoRequest
         * @constructor
         * @param {chat.ISyncMediaCallInfoRequest=} [properties] Properties to set
         */
        function SyncMediaCallInfoRequest(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * SyncMediaCallInfoRequest roomId.
         * @member {string} roomId
         * @memberof chat.SyncMediaCallInfoRequest
         * @instance
         */
        SyncMediaCallInfoRequest.prototype.roomId = "";

        /**
         * SyncMediaCallInfoRequest chatId.
         * @member {string} chatId
         * @memberof chat.SyncMediaCallInfoRequest
         * @instance
         */
        SyncMediaCallInfoRequest.prototype.chatId = "";

        /**
         * SyncMediaCallInfoRequest messageId.
         * @member {string} messageId
         * @memberof chat.SyncMediaCallInfoRequest
         * @instance
         */
        SyncMediaCallInfoRequest.prototype.messageId = "";

        /**
         * SyncMediaCallInfoRequest originUid.
         * @member {string} originUid
         * @memberof chat.SyncMediaCallInfoRequest
         * @instance
         */
        SyncMediaCallInfoRequest.prototype.originUid = "";

        /**
         * Creates a new SyncMediaCallInfoRequest instance using the specified properties.
         * @function create
         * @memberof chat.SyncMediaCallInfoRequest
         * @static
         * @param {chat.ISyncMediaCallInfoRequest=} [properties] Properties to set
         * @returns {chat.SyncMediaCallInfoRequest} SyncMediaCallInfoRequest instance
         */
        SyncMediaCallInfoRequest.create = function create(properties) {
            return new SyncMediaCallInfoRequest(properties);
        };

        /**
         * Encodes the specified SyncMediaCallInfoRequest message. Does not implicitly {@link chat.SyncMediaCallInfoRequest.verify|verify} messages.
         * @function encode
         * @memberof chat.SyncMediaCallInfoRequest
         * @static
         * @param {chat.ISyncMediaCallInfoRequest} message SyncMediaCallInfoRequest message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        SyncMediaCallInfoRequest.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.roomId != null && Object.hasOwnProperty.call(message, "roomId"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.roomId);
            if (message.chatId != null && Object.hasOwnProperty.call(message, "chatId"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.chatId);
            if (message.messageId != null && Object.hasOwnProperty.call(message, "messageId"))
                writer.uint32(/* id 3, wireType 2 =*/26).string(message.messageId);
            if (message.originUid != null && Object.hasOwnProperty.call(message, "originUid"))
                writer.uint32(/* id 4, wireType 2 =*/34).string(message.originUid);
            return writer;
        };

        /**
         * Encodes the specified SyncMediaCallInfoRequest message, length delimited. Does not implicitly {@link chat.SyncMediaCallInfoRequest.verify|verify} messages.
         * @function encodeDelimited
         * @memberof chat.SyncMediaCallInfoRequest
         * @static
         * @param {chat.ISyncMediaCallInfoRequest} message SyncMediaCallInfoRequest message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        SyncMediaCallInfoRequest.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a SyncMediaCallInfoRequest message from the specified reader or buffer.
         * @function decode
         * @memberof chat.SyncMediaCallInfoRequest
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {chat.SyncMediaCallInfoRequest} SyncMediaCallInfoRequest
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        SyncMediaCallInfoRequest.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.chat.SyncMediaCallInfoRequest();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1: {
                        message.roomId = reader.string();
                        break;
                    }
                case 2: {
                        message.chatId = reader.string();
                        break;
                    }
                case 3: {
                        message.messageId = reader.string();
                        break;
                    }
                case 4: {
                        message.originUid = reader.string();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a SyncMediaCallInfoRequest message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof chat.SyncMediaCallInfoRequest
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {chat.SyncMediaCallInfoRequest} SyncMediaCallInfoRequest
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        SyncMediaCallInfoRequest.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a SyncMediaCallInfoRequest message.
         * @function verify
         * @memberof chat.SyncMediaCallInfoRequest
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        SyncMediaCallInfoRequest.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.roomId != null && message.hasOwnProperty("roomId"))
                if (!$util.isString(message.roomId))
                    return "roomId: string expected";
            if (message.chatId != null && message.hasOwnProperty("chatId"))
                if (!$util.isString(message.chatId))
                    return "chatId: string expected";
            if (message.messageId != null && message.hasOwnProperty("messageId"))
                if (!$util.isString(message.messageId))
                    return "messageId: string expected";
            if (message.originUid != null && message.hasOwnProperty("originUid"))
                if (!$util.isString(message.originUid))
                    return "originUid: string expected";
            return null;
        };

        /**
         * Creates a SyncMediaCallInfoRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof chat.SyncMediaCallInfoRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {chat.SyncMediaCallInfoRequest} SyncMediaCallInfoRequest
         */
        SyncMediaCallInfoRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.chat.SyncMediaCallInfoRequest)
                return object;
            let message = new $root.chat.SyncMediaCallInfoRequest();
            if (object.roomId != null)
                message.roomId = String(object.roomId);
            if (object.chatId != null)
                message.chatId = String(object.chatId);
            if (object.messageId != null)
                message.messageId = String(object.messageId);
            if (object.originUid != null)
                message.originUid = String(object.originUid);
            return message;
        };

        /**
         * Creates a plain object from a SyncMediaCallInfoRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof chat.SyncMediaCallInfoRequest
         * @static
         * @param {chat.SyncMediaCallInfoRequest} message SyncMediaCallInfoRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        SyncMediaCallInfoRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.roomId = "";
                object.chatId = "";
                object.messageId = "";
                object.originUid = "";
            }
            if (message.roomId != null && message.hasOwnProperty("roomId"))
                object.roomId = message.roomId;
            if (message.chatId != null && message.hasOwnProperty("chatId"))
                object.chatId = message.chatId;
            if (message.messageId != null && message.hasOwnProperty("messageId"))
                object.messageId = message.messageId;
            if (message.originUid != null && message.hasOwnProperty("originUid"))
                object.originUid = message.originUid;
            return object;
        };

        /**
         * Converts this SyncMediaCallInfoRequest to JSON.
         * @function toJSON
         * @memberof chat.SyncMediaCallInfoRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        SyncMediaCallInfoRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for SyncMediaCallInfoRequest
         * @function getTypeUrl
         * @memberof chat.SyncMediaCallInfoRequest
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        SyncMediaCallInfoRequest.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/chat.SyncMediaCallInfoRequest";
        };

        return SyncMediaCallInfoRequest;
    })();

    chat.SyncMediaCallInfoResponse = (function() {

        /**
         * Properties of a SyncMediaCallInfoResponse.
         * @memberof chat
         * @interface ISyncMediaCallInfoResponse
         * @property {number|null} [code] SyncMediaCallInfoResponse code
         * @property {string|null} [messageId] SyncMediaCallInfoResponse messageId
         */

        /**
         * Constructs a new SyncMediaCallInfoResponse.
         * @memberof chat
         * @classdesc Represents a SyncMediaCallInfoResponse.
         * @implements ISyncMediaCallInfoResponse
         * @constructor
         * @param {chat.ISyncMediaCallInfoResponse=} [properties] Properties to set
         */
        function SyncMediaCallInfoResponse(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * SyncMediaCallInfoResponse code.
         * @member {number} code
         * @memberof chat.SyncMediaCallInfoResponse
         * @instance
         */
        SyncMediaCallInfoResponse.prototype.code = 0;

        /**
         * SyncMediaCallInfoResponse messageId.
         * @member {string} messageId
         * @memberof chat.SyncMediaCallInfoResponse
         * @instance
         */
        SyncMediaCallInfoResponse.prototype.messageId = "";

        /**
         * Creates a new SyncMediaCallInfoResponse instance using the specified properties.
         * @function create
         * @memberof chat.SyncMediaCallInfoResponse
         * @static
         * @param {chat.ISyncMediaCallInfoResponse=} [properties] Properties to set
         * @returns {chat.SyncMediaCallInfoResponse} SyncMediaCallInfoResponse instance
         */
        SyncMediaCallInfoResponse.create = function create(properties) {
            return new SyncMediaCallInfoResponse(properties);
        };

        /**
         * Encodes the specified SyncMediaCallInfoResponse message. Does not implicitly {@link chat.SyncMediaCallInfoResponse.verify|verify} messages.
         * @function encode
         * @memberof chat.SyncMediaCallInfoResponse
         * @static
         * @param {chat.ISyncMediaCallInfoResponse} message SyncMediaCallInfoResponse message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        SyncMediaCallInfoResponse.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.messageId != null && Object.hasOwnProperty.call(message, "messageId"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.messageId);
            if (message.code != null && Object.hasOwnProperty.call(message, "code"))
                writer.uint32(/* id 2, wireType 0 =*/16).int32(message.code);
            return writer;
        };

        /**
         * Encodes the specified SyncMediaCallInfoResponse message, length delimited. Does not implicitly {@link chat.SyncMediaCallInfoResponse.verify|verify} messages.
         * @function encodeDelimited
         * @memberof chat.SyncMediaCallInfoResponse
         * @static
         * @param {chat.ISyncMediaCallInfoResponse} message SyncMediaCallInfoResponse message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        SyncMediaCallInfoResponse.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a SyncMediaCallInfoResponse message from the specified reader or buffer.
         * @function decode
         * @memberof chat.SyncMediaCallInfoResponse
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {chat.SyncMediaCallInfoResponse} SyncMediaCallInfoResponse
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        SyncMediaCallInfoResponse.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.chat.SyncMediaCallInfoResponse();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 2: {
                        message.code = reader.int32();
                        break;
                    }
                case 1: {
                        message.messageId = reader.string();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a SyncMediaCallInfoResponse message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof chat.SyncMediaCallInfoResponse
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {chat.SyncMediaCallInfoResponse} SyncMediaCallInfoResponse
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        SyncMediaCallInfoResponse.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a SyncMediaCallInfoResponse message.
         * @function verify
         * @memberof chat.SyncMediaCallInfoResponse
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        SyncMediaCallInfoResponse.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.code != null && message.hasOwnProperty("code"))
                if (!$util.isInteger(message.code))
                    return "code: integer expected";
            if (message.messageId != null && message.hasOwnProperty("messageId"))
                if (!$util.isString(message.messageId))
                    return "messageId: string expected";
            return null;
        };

        /**
         * Creates a SyncMediaCallInfoResponse message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof chat.SyncMediaCallInfoResponse
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {chat.SyncMediaCallInfoResponse} SyncMediaCallInfoResponse
         */
        SyncMediaCallInfoResponse.fromObject = function fromObject(object) {
            if (object instanceof $root.chat.SyncMediaCallInfoResponse)
                return object;
            let message = new $root.chat.SyncMediaCallInfoResponse();
            if (object.code != null)
                message.code = object.code | 0;
            if (object.messageId != null)
                message.messageId = String(object.messageId);
            return message;
        };

        /**
         * Creates a plain object from a SyncMediaCallInfoResponse message. Also converts values to other types if specified.
         * @function toObject
         * @memberof chat.SyncMediaCallInfoResponse
         * @static
         * @param {chat.SyncMediaCallInfoResponse} message SyncMediaCallInfoResponse
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        SyncMediaCallInfoResponse.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.messageId = "";
                object.code = 0;
            }
            if (message.messageId != null && message.hasOwnProperty("messageId"))
                object.messageId = message.messageId;
            if (message.code != null && message.hasOwnProperty("code"))
                object.code = message.code;
            return object;
        };

        /**
         * Converts this SyncMediaCallInfoResponse to JSON.
         * @function toJSON
         * @memberof chat.SyncMediaCallInfoResponse
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        SyncMediaCallInfoResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for SyncMediaCallInfoResponse
         * @function getTypeUrl
         * @memberof chat.SyncMediaCallInfoResponse
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        SyncMediaCallInfoResponse.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/chat.SyncMediaCallInfoResponse";
        };

        return SyncMediaCallInfoResponse;
    })();

    chat.SyncMediaCallInfoV2Request = (function() {

        /**
         * Properties of a SyncMediaCallInfoV2Request.
         * @memberof chat
         * @interface ISyncMediaCallInfoV2Request
         * @property {string|null} [roomId] SyncMediaCallInfoV2Request roomId
         * @property {string|null} [chatId] SyncMediaCallInfoV2Request chatId
         * @property {string|null} [messageId] SyncMediaCallInfoV2Request messageId
         * @property {string|null} [originUid] SyncMediaCallInfoV2Request originUid
         */

        /**
         * Constructs a new SyncMediaCallInfoV2Request.
         * @memberof chat
         * @classdesc Represents a SyncMediaCallInfoV2Request.
         * @implements ISyncMediaCallInfoV2Request
         * @constructor
         * @param {chat.ISyncMediaCallInfoV2Request=} [properties] Properties to set
         */
        function SyncMediaCallInfoV2Request(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * SyncMediaCallInfoV2Request roomId.
         * @member {string} roomId
         * @memberof chat.SyncMediaCallInfoV2Request
         * @instance
         */
        SyncMediaCallInfoV2Request.prototype.roomId = "";

        /**
         * SyncMediaCallInfoV2Request chatId.
         * @member {string} chatId
         * @memberof chat.SyncMediaCallInfoV2Request
         * @instance
         */
        SyncMediaCallInfoV2Request.prototype.chatId = "";

        /**
         * SyncMediaCallInfoV2Request messageId.
         * @member {string} messageId
         * @memberof chat.SyncMediaCallInfoV2Request
         * @instance
         */
        SyncMediaCallInfoV2Request.prototype.messageId = "";

        /**
         * SyncMediaCallInfoV2Request originUid.
         * @member {string} originUid
         * @memberof chat.SyncMediaCallInfoV2Request
         * @instance
         */
        SyncMediaCallInfoV2Request.prototype.originUid = "";

        /**
         * Creates a new SyncMediaCallInfoV2Request instance using the specified properties.
         * @function create
         * @memberof chat.SyncMediaCallInfoV2Request
         * @static
         * @param {chat.ISyncMediaCallInfoV2Request=} [properties] Properties to set
         * @returns {chat.SyncMediaCallInfoV2Request} SyncMediaCallInfoV2Request instance
         */
        SyncMediaCallInfoV2Request.create = function create(properties) {
            return new SyncMediaCallInfoV2Request(properties);
        };

        /**
         * Encodes the specified SyncMediaCallInfoV2Request message. Does not implicitly {@link chat.SyncMediaCallInfoV2Request.verify|verify} messages.
         * @function encode
         * @memberof chat.SyncMediaCallInfoV2Request
         * @static
         * @param {chat.ISyncMediaCallInfoV2Request} message SyncMediaCallInfoV2Request message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        SyncMediaCallInfoV2Request.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.roomId != null && Object.hasOwnProperty.call(message, "roomId"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.roomId);
            if (message.chatId != null && Object.hasOwnProperty.call(message, "chatId"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.chatId);
            if (message.messageId != null && Object.hasOwnProperty.call(message, "messageId"))
                writer.uint32(/* id 3, wireType 2 =*/26).string(message.messageId);
            if (message.originUid != null && Object.hasOwnProperty.call(message, "originUid"))
                writer.uint32(/* id 4, wireType 2 =*/34).string(message.originUid);
            return writer;
        };

        /**
         * Encodes the specified SyncMediaCallInfoV2Request message, length delimited. Does not implicitly {@link chat.SyncMediaCallInfoV2Request.verify|verify} messages.
         * @function encodeDelimited
         * @memberof chat.SyncMediaCallInfoV2Request
         * @static
         * @param {chat.ISyncMediaCallInfoV2Request} message SyncMediaCallInfoV2Request message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        SyncMediaCallInfoV2Request.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a SyncMediaCallInfoV2Request message from the specified reader or buffer.
         * @function decode
         * @memberof chat.SyncMediaCallInfoV2Request
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {chat.SyncMediaCallInfoV2Request} SyncMediaCallInfoV2Request
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        SyncMediaCallInfoV2Request.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.chat.SyncMediaCallInfoV2Request();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1: {
                        message.roomId = reader.string();
                        break;
                    }
                case 2: {
                        message.chatId = reader.string();
                        break;
                    }
                case 3: {
                        message.messageId = reader.string();
                        break;
                    }
                case 4: {
                        message.originUid = reader.string();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a SyncMediaCallInfoV2Request message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof chat.SyncMediaCallInfoV2Request
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {chat.SyncMediaCallInfoV2Request} SyncMediaCallInfoV2Request
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        SyncMediaCallInfoV2Request.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a SyncMediaCallInfoV2Request message.
         * @function verify
         * @memberof chat.SyncMediaCallInfoV2Request
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        SyncMediaCallInfoV2Request.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.roomId != null && message.hasOwnProperty("roomId"))
                if (!$util.isString(message.roomId))
                    return "roomId: string expected";
            if (message.chatId != null && message.hasOwnProperty("chatId"))
                if (!$util.isString(message.chatId))
                    return "chatId: string expected";
            if (message.messageId != null && message.hasOwnProperty("messageId"))
                if (!$util.isString(message.messageId))
                    return "messageId: string expected";
            if (message.originUid != null && message.hasOwnProperty("originUid"))
                if (!$util.isString(message.originUid))
                    return "originUid: string expected";
            return null;
        };

        /**
         * Creates a SyncMediaCallInfoV2Request message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof chat.SyncMediaCallInfoV2Request
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {chat.SyncMediaCallInfoV2Request} SyncMediaCallInfoV2Request
         */
        SyncMediaCallInfoV2Request.fromObject = function fromObject(object) {
            if (object instanceof $root.chat.SyncMediaCallInfoV2Request)
                return object;
            let message = new $root.chat.SyncMediaCallInfoV2Request();
            if (object.roomId != null)
                message.roomId = String(object.roomId);
            if (object.chatId != null)
                message.chatId = String(object.chatId);
            if (object.messageId != null)
                message.messageId = String(object.messageId);
            if (object.originUid != null)
                message.originUid = String(object.originUid);
            return message;
        };

        /**
         * Creates a plain object from a SyncMediaCallInfoV2Request message. Also converts values to other types if specified.
         * @function toObject
         * @memberof chat.SyncMediaCallInfoV2Request
         * @static
         * @param {chat.SyncMediaCallInfoV2Request} message SyncMediaCallInfoV2Request
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        SyncMediaCallInfoV2Request.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.roomId = "";
                object.chatId = "";
                object.messageId = "";
                object.originUid = "";
            }
            if (message.roomId != null && message.hasOwnProperty("roomId"))
                object.roomId = message.roomId;
            if (message.chatId != null && message.hasOwnProperty("chatId"))
                object.chatId = message.chatId;
            if (message.messageId != null && message.hasOwnProperty("messageId"))
                object.messageId = message.messageId;
            if (message.originUid != null && message.hasOwnProperty("originUid"))
                object.originUid = message.originUid;
            return object;
        };

        /**
         * Converts this SyncMediaCallInfoV2Request to JSON.
         * @function toJSON
         * @memberof chat.SyncMediaCallInfoV2Request
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        SyncMediaCallInfoV2Request.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for SyncMediaCallInfoV2Request
         * @function getTypeUrl
         * @memberof chat.SyncMediaCallInfoV2Request
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        SyncMediaCallInfoV2Request.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/chat.SyncMediaCallInfoV2Request";
        };

        return SyncMediaCallInfoV2Request;
    })();

    chat.SyncMediaCallInfoV2Response = (function() {

        /**
         * Properties of a SyncMediaCallInfoV2Response.
         * @memberof chat
         * @interface ISyncMediaCallInfoV2Response
         * @property {number|null} [code] SyncMediaCallInfoV2Response code
         * @property {string|null} [messageId] SyncMediaCallInfoV2Response messageId
         * @property {Array.<chat.ISyncMediaCallInfoV2Members>|null} [members] SyncMediaCallInfoV2Response members
         * @property {string|null} [name] SyncMediaCallInfoV2Response name
         * @property {string|null} [createUser] SyncMediaCallInfoV2Response createUser
         * @property {number|Long|null} [busy] SyncMediaCallInfoV2Response busy
         * @property {boolean|null} [isPrivate] SyncMediaCallInfoV2Response isPrivate
         * @property {number|Long|null} [expireTime] SyncMediaCallInfoV2Response expireTime
         * @property {number|Long|null} [status] SyncMediaCallInfoV2Response status
         * @property {number|Long|null} [createdAt] SyncMediaCallInfoV2Response createdAt
         * @property {number|Long|null} [type] SyncMediaCallInfoV2Response type
         * @property {Array.<string>|null} [inviteUsers] SyncMediaCallInfoV2Response inviteUsers
         * @property {string|null} [tGroupId] SyncMediaCallInfoV2Response tGroupId
         * @property {string|null} [groupId] SyncMediaCallInfoV2Response groupId
         */

        /**
         * Constructs a new SyncMediaCallInfoV2Response.
         * @memberof chat
         * @classdesc Represents a SyncMediaCallInfoV2Response.
         * @implements ISyncMediaCallInfoV2Response
         * @constructor
         * @param {chat.ISyncMediaCallInfoV2Response=} [properties] Properties to set
         */
        function SyncMediaCallInfoV2Response(properties) {
            this.members = [];
            this.inviteUsers = [];
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * SyncMediaCallInfoV2Response code.
         * @member {number} code
         * @memberof chat.SyncMediaCallInfoV2Response
         * @instance
         */
        SyncMediaCallInfoV2Response.prototype.code = 0;

        /**
         * SyncMediaCallInfoV2Response messageId.
         * @member {string} messageId
         * @memberof chat.SyncMediaCallInfoV2Response
         * @instance
         */
        SyncMediaCallInfoV2Response.prototype.messageId = "";

        /**
         * SyncMediaCallInfoV2Response members.
         * @member {Array.<chat.ISyncMediaCallInfoV2Members>} members
         * @memberof chat.SyncMediaCallInfoV2Response
         * @instance
         */
        SyncMediaCallInfoV2Response.prototype.members = $util.emptyArray;

        /**
         * SyncMediaCallInfoV2Response name.
         * @member {string} name
         * @memberof chat.SyncMediaCallInfoV2Response
         * @instance
         */
        SyncMediaCallInfoV2Response.prototype.name = "";

        /**
         * SyncMediaCallInfoV2Response createUser.
         * @member {string} createUser
         * @memberof chat.SyncMediaCallInfoV2Response
         * @instance
         */
        SyncMediaCallInfoV2Response.prototype.createUser = "";

        /**
         * SyncMediaCallInfoV2Response busy.
         * @member {number|Long} busy
         * @memberof chat.SyncMediaCallInfoV2Response
         * @instance
         */
        SyncMediaCallInfoV2Response.prototype.busy = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * SyncMediaCallInfoV2Response isPrivate.
         * @member {boolean} isPrivate
         * @memberof chat.SyncMediaCallInfoV2Response
         * @instance
         */
        SyncMediaCallInfoV2Response.prototype.isPrivate = false;

        /**
         * SyncMediaCallInfoV2Response expireTime.
         * @member {number|Long} expireTime
         * @memberof chat.SyncMediaCallInfoV2Response
         * @instance
         */
        SyncMediaCallInfoV2Response.prototype.expireTime = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * SyncMediaCallInfoV2Response status.
         * @member {number|Long} status
         * @memberof chat.SyncMediaCallInfoV2Response
         * @instance
         */
        SyncMediaCallInfoV2Response.prototype.status = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * SyncMediaCallInfoV2Response createdAt.
         * @member {number|Long} createdAt
         * @memberof chat.SyncMediaCallInfoV2Response
         * @instance
         */
        SyncMediaCallInfoV2Response.prototype.createdAt = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * SyncMediaCallInfoV2Response type.
         * @member {number|Long} type
         * @memberof chat.SyncMediaCallInfoV2Response
         * @instance
         */
        SyncMediaCallInfoV2Response.prototype.type = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * SyncMediaCallInfoV2Response inviteUsers.
         * @member {Array.<string>} inviteUsers
         * @memberof chat.SyncMediaCallInfoV2Response
         * @instance
         */
        SyncMediaCallInfoV2Response.prototype.inviteUsers = $util.emptyArray;

        /**
         * SyncMediaCallInfoV2Response tGroupId.
         * @member {string} tGroupId
         * @memberof chat.SyncMediaCallInfoV2Response
         * @instance
         */
        SyncMediaCallInfoV2Response.prototype.tGroupId = "";

        /**
         * SyncMediaCallInfoV2Response groupId.
         * @member {string} groupId
         * @memberof chat.SyncMediaCallInfoV2Response
         * @instance
         */
        SyncMediaCallInfoV2Response.prototype.groupId = "";

        /**
         * Creates a new SyncMediaCallInfoV2Response instance using the specified properties.
         * @function create
         * @memberof chat.SyncMediaCallInfoV2Response
         * @static
         * @param {chat.ISyncMediaCallInfoV2Response=} [properties] Properties to set
         * @returns {chat.SyncMediaCallInfoV2Response} SyncMediaCallInfoV2Response instance
         */
        SyncMediaCallInfoV2Response.create = function create(properties) {
            return new SyncMediaCallInfoV2Response(properties);
        };

        /**
         * Encodes the specified SyncMediaCallInfoV2Response message. Does not implicitly {@link chat.SyncMediaCallInfoV2Response.verify|verify} messages.
         * @function encode
         * @memberof chat.SyncMediaCallInfoV2Response
         * @static
         * @param {chat.ISyncMediaCallInfoV2Response} message SyncMediaCallInfoV2Response message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        SyncMediaCallInfoV2Response.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.messageId != null && Object.hasOwnProperty.call(message, "messageId"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.messageId);
            if (message.code != null && Object.hasOwnProperty.call(message, "code"))
                writer.uint32(/* id 2, wireType 0 =*/16).int32(message.code);
            if (message.members != null && message.members.length)
                for (let i = 0; i < message.members.length; ++i)
                    $root.chat.SyncMediaCallInfoV2Members.encode(message.members[i], writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
            if (message.name != null && Object.hasOwnProperty.call(message, "name"))
                writer.uint32(/* id 4, wireType 2 =*/34).string(message.name);
            if (message.createUser != null && Object.hasOwnProperty.call(message, "createUser"))
                writer.uint32(/* id 5, wireType 2 =*/42).string(message.createUser);
            if (message.busy != null && Object.hasOwnProperty.call(message, "busy"))
                writer.uint32(/* id 6, wireType 0 =*/48).int64(message.busy);
            if (message.isPrivate != null && Object.hasOwnProperty.call(message, "isPrivate"))
                writer.uint32(/* id 7, wireType 0 =*/56).bool(message.isPrivate);
            if (message.expireTime != null && Object.hasOwnProperty.call(message, "expireTime"))
                writer.uint32(/* id 8, wireType 0 =*/64).int64(message.expireTime);
            if (message.status != null && Object.hasOwnProperty.call(message, "status"))
                writer.uint32(/* id 9, wireType 0 =*/72).int64(message.status);
            if (message.createdAt != null && Object.hasOwnProperty.call(message, "createdAt"))
                writer.uint32(/* id 10, wireType 0 =*/80).int64(message.createdAt);
            if (message.type != null && Object.hasOwnProperty.call(message, "type"))
                writer.uint32(/* id 11, wireType 0 =*/88).int64(message.type);
            if (message.inviteUsers != null && message.inviteUsers.length)
                for (let i = 0; i < message.inviteUsers.length; ++i)
                    writer.uint32(/* id 12, wireType 2 =*/98).string(message.inviteUsers[i]);
            if (message.tGroupId != null && Object.hasOwnProperty.call(message, "tGroupId"))
                writer.uint32(/* id 13, wireType 2 =*/106).string(message.tGroupId);
            if (message.groupId != null && Object.hasOwnProperty.call(message, "groupId"))
                writer.uint32(/* id 14, wireType 2 =*/114).string(message.groupId);
            return writer;
        };

        /**
         * Encodes the specified SyncMediaCallInfoV2Response message, length delimited. Does not implicitly {@link chat.SyncMediaCallInfoV2Response.verify|verify} messages.
         * @function encodeDelimited
         * @memberof chat.SyncMediaCallInfoV2Response
         * @static
         * @param {chat.ISyncMediaCallInfoV2Response} message SyncMediaCallInfoV2Response message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        SyncMediaCallInfoV2Response.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a SyncMediaCallInfoV2Response message from the specified reader or buffer.
         * @function decode
         * @memberof chat.SyncMediaCallInfoV2Response
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {chat.SyncMediaCallInfoV2Response} SyncMediaCallInfoV2Response
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        SyncMediaCallInfoV2Response.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.chat.SyncMediaCallInfoV2Response();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 2: {
                        message.code = reader.int32();
                        break;
                    }
                case 1: {
                        message.messageId = reader.string();
                        break;
                    }
                case 3: {
                        if (!(message.members && message.members.length))
                            message.members = [];
                        message.members.push($root.chat.SyncMediaCallInfoV2Members.decode(reader, reader.uint32()));
                        break;
                    }
                case 4: {
                        message.name = reader.string();
                        break;
                    }
                case 5: {
                        message.createUser = reader.string();
                        break;
                    }
                case 6: {
                        message.busy = reader.int64();
                        break;
                    }
                case 7: {
                        message.isPrivate = reader.bool();
                        break;
                    }
                case 8: {
                        message.expireTime = reader.int64();
                        break;
                    }
                case 9: {
                        message.status = reader.int64();
                        break;
                    }
                case 10: {
                        message.createdAt = reader.int64();
                        break;
                    }
                case 11: {
                        message.type = reader.int64();
                        break;
                    }
                case 12: {
                        if (!(message.inviteUsers && message.inviteUsers.length))
                            message.inviteUsers = [];
                        message.inviteUsers.push(reader.string());
                        break;
                    }
                case 13: {
                        message.tGroupId = reader.string();
                        break;
                    }
                case 14: {
                        message.groupId = reader.string();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a SyncMediaCallInfoV2Response message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof chat.SyncMediaCallInfoV2Response
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {chat.SyncMediaCallInfoV2Response} SyncMediaCallInfoV2Response
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        SyncMediaCallInfoV2Response.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a SyncMediaCallInfoV2Response message.
         * @function verify
         * @memberof chat.SyncMediaCallInfoV2Response
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        SyncMediaCallInfoV2Response.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.code != null && message.hasOwnProperty("code"))
                if (!$util.isInteger(message.code))
                    return "code: integer expected";
            if (message.messageId != null && message.hasOwnProperty("messageId"))
                if (!$util.isString(message.messageId))
                    return "messageId: string expected";
            if (message.members != null && message.hasOwnProperty("members")) {
                if (!Array.isArray(message.members))
                    return "members: array expected";
                for (let i = 0; i < message.members.length; ++i) {
                    let error = $root.chat.SyncMediaCallInfoV2Members.verify(message.members[i]);
                    if (error)
                        return "members." + error;
                }
            }
            if (message.name != null && message.hasOwnProperty("name"))
                if (!$util.isString(message.name))
                    return "name: string expected";
            if (message.createUser != null && message.hasOwnProperty("createUser"))
                if (!$util.isString(message.createUser))
                    return "createUser: string expected";
            if (message.busy != null && message.hasOwnProperty("busy"))
                if (!$util.isInteger(message.busy) && !(message.busy && $util.isInteger(message.busy.low) && $util.isInteger(message.busy.high)))
                    return "busy: integer|Long expected";
            if (message.isPrivate != null && message.hasOwnProperty("isPrivate"))
                if (typeof message.isPrivate !== "boolean")
                    return "isPrivate: boolean expected";
            if (message.expireTime != null && message.hasOwnProperty("expireTime"))
                if (!$util.isInteger(message.expireTime) && !(message.expireTime && $util.isInteger(message.expireTime.low) && $util.isInteger(message.expireTime.high)))
                    return "expireTime: integer|Long expected";
            if (message.status != null && message.hasOwnProperty("status"))
                if (!$util.isInteger(message.status) && !(message.status && $util.isInteger(message.status.low) && $util.isInteger(message.status.high)))
                    return "status: integer|Long expected";
            if (message.createdAt != null && message.hasOwnProperty("createdAt"))
                if (!$util.isInteger(message.createdAt) && !(message.createdAt && $util.isInteger(message.createdAt.low) && $util.isInteger(message.createdAt.high)))
                    return "createdAt: integer|Long expected";
            if (message.type != null && message.hasOwnProperty("type"))
                if (!$util.isInteger(message.type) && !(message.type && $util.isInteger(message.type.low) && $util.isInteger(message.type.high)))
                    return "type: integer|Long expected";
            if (message.inviteUsers != null && message.hasOwnProperty("inviteUsers")) {
                if (!Array.isArray(message.inviteUsers))
                    return "inviteUsers: array expected";
                for (let i = 0; i < message.inviteUsers.length; ++i)
                    if (!$util.isString(message.inviteUsers[i]))
                        return "inviteUsers: string[] expected";
            }
            if (message.tGroupId != null && message.hasOwnProperty("tGroupId"))
                if (!$util.isString(message.tGroupId))
                    return "tGroupId: string expected";
            if (message.groupId != null && message.hasOwnProperty("groupId"))
                if (!$util.isString(message.groupId))
                    return "groupId: string expected";
            return null;
        };

        /**
         * Creates a SyncMediaCallInfoV2Response message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof chat.SyncMediaCallInfoV2Response
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {chat.SyncMediaCallInfoV2Response} SyncMediaCallInfoV2Response
         */
        SyncMediaCallInfoV2Response.fromObject = function fromObject(object) {
            if (object instanceof $root.chat.SyncMediaCallInfoV2Response)
                return object;
            let message = new $root.chat.SyncMediaCallInfoV2Response();
            if (object.code != null)
                message.code = object.code | 0;
            if (object.messageId != null)
                message.messageId = String(object.messageId);
            if (object.members) {
                if (!Array.isArray(object.members))
                    throw TypeError(".chat.SyncMediaCallInfoV2Response.members: array expected");
                message.members = [];
                for (let i = 0; i < object.members.length; ++i) {
                    if (typeof object.members[i] !== "object")
                        throw TypeError(".chat.SyncMediaCallInfoV2Response.members: object expected");
                    message.members[i] = $root.chat.SyncMediaCallInfoV2Members.fromObject(object.members[i]);
                }
            }
            if (object.name != null)
                message.name = String(object.name);
            if (object.createUser != null)
                message.createUser = String(object.createUser);
            if (object.busy != null)
                if ($util.Long)
                    (message.busy = $util.Long.fromValue(object.busy)).unsigned = false;
                else if (typeof object.busy === "string")
                    message.busy = parseInt(object.busy, 10);
                else if (typeof object.busy === "number")
                    message.busy = object.busy;
                else if (typeof object.busy === "object")
                    message.busy = new $util.LongBits(object.busy.low >>> 0, object.busy.high >>> 0).toNumber();
            if (object.isPrivate != null)
                message.isPrivate = Boolean(object.isPrivate);
            if (object.expireTime != null)
                if ($util.Long)
                    (message.expireTime = $util.Long.fromValue(object.expireTime)).unsigned = false;
                else if (typeof object.expireTime === "string")
                    message.expireTime = parseInt(object.expireTime, 10);
                else if (typeof object.expireTime === "number")
                    message.expireTime = object.expireTime;
                else if (typeof object.expireTime === "object")
                    message.expireTime = new $util.LongBits(object.expireTime.low >>> 0, object.expireTime.high >>> 0).toNumber();
            if (object.status != null)
                if ($util.Long)
                    (message.status = $util.Long.fromValue(object.status)).unsigned = false;
                else if (typeof object.status === "string")
                    message.status = parseInt(object.status, 10);
                else if (typeof object.status === "number")
                    message.status = object.status;
                else if (typeof object.status === "object")
                    message.status = new $util.LongBits(object.status.low >>> 0, object.status.high >>> 0).toNumber();
            if (object.createdAt != null)
                if ($util.Long)
                    (message.createdAt = $util.Long.fromValue(object.createdAt)).unsigned = false;
                else if (typeof object.createdAt === "string")
                    message.createdAt = parseInt(object.createdAt, 10);
                else if (typeof object.createdAt === "number")
                    message.createdAt = object.createdAt;
                else if (typeof object.createdAt === "object")
                    message.createdAt = new $util.LongBits(object.createdAt.low >>> 0, object.createdAt.high >>> 0).toNumber();
            if (object.type != null)
                if ($util.Long)
                    (message.type = $util.Long.fromValue(object.type)).unsigned = false;
                else if (typeof object.type === "string")
                    message.type = parseInt(object.type, 10);
                else if (typeof object.type === "number")
                    message.type = object.type;
                else if (typeof object.type === "object")
                    message.type = new $util.LongBits(object.type.low >>> 0, object.type.high >>> 0).toNumber();
            if (object.inviteUsers) {
                if (!Array.isArray(object.inviteUsers))
                    throw TypeError(".chat.SyncMediaCallInfoV2Response.inviteUsers: array expected");
                message.inviteUsers = [];
                for (let i = 0; i < object.inviteUsers.length; ++i)
                    message.inviteUsers[i] = String(object.inviteUsers[i]);
            }
            if (object.tGroupId != null)
                message.tGroupId = String(object.tGroupId);
            if (object.groupId != null)
                message.groupId = String(object.groupId);
            return message;
        };

        /**
         * Creates a plain object from a SyncMediaCallInfoV2Response message. Also converts values to other types if specified.
         * @function toObject
         * @memberof chat.SyncMediaCallInfoV2Response
         * @static
         * @param {chat.SyncMediaCallInfoV2Response} message SyncMediaCallInfoV2Response
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        SyncMediaCallInfoV2Response.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.arrays || options.defaults) {
                object.members = [];
                object.inviteUsers = [];
            }
            if (options.defaults) {
                object.messageId = "";
                object.code = 0;
                object.name = "";
                object.createUser = "";
                if ($util.Long) {
                    let long = new $util.Long(0, 0, false);
                    object.busy = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.busy = options.longs === String ? "0" : 0;
                object.isPrivate = false;
                if ($util.Long) {
                    let long = new $util.Long(0, 0, false);
                    object.expireTime = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.expireTime = options.longs === String ? "0" : 0;
                if ($util.Long) {
                    let long = new $util.Long(0, 0, false);
                    object.status = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.status = options.longs === String ? "0" : 0;
                if ($util.Long) {
                    let long = new $util.Long(0, 0, false);
                    object.createdAt = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.createdAt = options.longs === String ? "0" : 0;
                if ($util.Long) {
                    let long = new $util.Long(0, 0, false);
                    object.type = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.type = options.longs === String ? "0" : 0;
                object.tGroupId = "";
                object.groupId = "";
            }
            if (message.messageId != null && message.hasOwnProperty("messageId"))
                object.messageId = message.messageId;
            if (message.code != null && message.hasOwnProperty("code"))
                object.code = message.code;
            if (message.members && message.members.length) {
                object.members = [];
                for (let j = 0; j < message.members.length; ++j)
                    object.members[j] = $root.chat.SyncMediaCallInfoV2Members.toObject(message.members[j], options);
            }
            if (message.name != null && message.hasOwnProperty("name"))
                object.name = message.name;
            if (message.createUser != null && message.hasOwnProperty("createUser"))
                object.createUser = message.createUser;
            if (message.busy != null && message.hasOwnProperty("busy"))
                if (typeof message.busy === "number")
                    object.busy = options.longs === String ? String(message.busy) : message.busy;
                else
                    object.busy = options.longs === String ? $util.Long.prototype.toString.call(message.busy) : options.longs === Number ? new $util.LongBits(message.busy.low >>> 0, message.busy.high >>> 0).toNumber() : message.busy;
            if (message.isPrivate != null && message.hasOwnProperty("isPrivate"))
                object.isPrivate = message.isPrivate;
            if (message.expireTime != null && message.hasOwnProperty("expireTime"))
                if (typeof message.expireTime === "number")
                    object.expireTime = options.longs === String ? String(message.expireTime) : message.expireTime;
                else
                    object.expireTime = options.longs === String ? $util.Long.prototype.toString.call(message.expireTime) : options.longs === Number ? new $util.LongBits(message.expireTime.low >>> 0, message.expireTime.high >>> 0).toNumber() : message.expireTime;
            if (message.status != null && message.hasOwnProperty("status"))
                if (typeof message.status === "number")
                    object.status = options.longs === String ? String(message.status) : message.status;
                else
                    object.status = options.longs === String ? $util.Long.prototype.toString.call(message.status) : options.longs === Number ? new $util.LongBits(message.status.low >>> 0, message.status.high >>> 0).toNumber() : message.status;
            if (message.createdAt != null && message.hasOwnProperty("createdAt"))
                if (typeof message.createdAt === "number")
                    object.createdAt = options.longs === String ? String(message.createdAt) : message.createdAt;
                else
                    object.createdAt = options.longs === String ? $util.Long.prototype.toString.call(message.createdAt) : options.longs === Number ? new $util.LongBits(message.createdAt.low >>> 0, message.createdAt.high >>> 0).toNumber() : message.createdAt;
            if (message.type != null && message.hasOwnProperty("type"))
                if (typeof message.type === "number")
                    object.type = options.longs === String ? String(message.type) : message.type;
                else
                    object.type = options.longs === String ? $util.Long.prototype.toString.call(message.type) : options.longs === Number ? new $util.LongBits(message.type.low >>> 0, message.type.high >>> 0).toNumber() : message.type;
            if (message.inviteUsers && message.inviteUsers.length) {
                object.inviteUsers = [];
                for (let j = 0; j < message.inviteUsers.length; ++j)
                    object.inviteUsers[j] = message.inviteUsers[j];
            }
            if (message.tGroupId != null && message.hasOwnProperty("tGroupId"))
                object.tGroupId = message.tGroupId;
            if (message.groupId != null && message.hasOwnProperty("groupId"))
                object.groupId = message.groupId;
            return object;
        };

        /**
         * Converts this SyncMediaCallInfoV2Response to JSON.
         * @function toJSON
         * @memberof chat.SyncMediaCallInfoV2Response
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        SyncMediaCallInfoV2Response.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for SyncMediaCallInfoV2Response
         * @function getTypeUrl
         * @memberof chat.SyncMediaCallInfoV2Response
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        SyncMediaCallInfoV2Response.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/chat.SyncMediaCallInfoV2Response";
        };

        return SyncMediaCallInfoV2Response;
    })();

    chat.SyncMediaCallInfoV2Members = (function() {

        /**
         * Properties of a SyncMediaCallInfoV2Members.
         * @memberof chat
         * @interface ISyncMediaCallInfoV2Members
         * @property {string|null} [userId] SyncMediaCallInfoV2Members userId
         * @property {number|Long|null} [status] SyncMediaCallInfoV2Members status
         * @property {number|Long|null} [role] SyncMediaCallInfoV2Members role
         * @property {string|null} [inviteUserId] SyncMediaCallInfoV2Members inviteUserId
         */

        /**
         * Constructs a new SyncMediaCallInfoV2Members.
         * @memberof chat
         * @classdesc Represents a SyncMediaCallInfoV2Members.
         * @implements ISyncMediaCallInfoV2Members
         * @constructor
         * @param {chat.ISyncMediaCallInfoV2Members=} [properties] Properties to set
         */
        function SyncMediaCallInfoV2Members(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * SyncMediaCallInfoV2Members userId.
         * @member {string} userId
         * @memberof chat.SyncMediaCallInfoV2Members
         * @instance
         */
        SyncMediaCallInfoV2Members.prototype.userId = "";

        /**
         * SyncMediaCallInfoV2Members status.
         * @member {number|Long} status
         * @memberof chat.SyncMediaCallInfoV2Members
         * @instance
         */
        SyncMediaCallInfoV2Members.prototype.status = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * SyncMediaCallInfoV2Members role.
         * @member {number|Long} role
         * @memberof chat.SyncMediaCallInfoV2Members
         * @instance
         */
        SyncMediaCallInfoV2Members.prototype.role = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * SyncMediaCallInfoV2Members inviteUserId.
         * @member {string} inviteUserId
         * @memberof chat.SyncMediaCallInfoV2Members
         * @instance
         */
        SyncMediaCallInfoV2Members.prototype.inviteUserId = "";

        /**
         * Creates a new SyncMediaCallInfoV2Members instance using the specified properties.
         * @function create
         * @memberof chat.SyncMediaCallInfoV2Members
         * @static
         * @param {chat.ISyncMediaCallInfoV2Members=} [properties] Properties to set
         * @returns {chat.SyncMediaCallInfoV2Members} SyncMediaCallInfoV2Members instance
         */
        SyncMediaCallInfoV2Members.create = function create(properties) {
            return new SyncMediaCallInfoV2Members(properties);
        };

        /**
         * Encodes the specified SyncMediaCallInfoV2Members message. Does not implicitly {@link chat.SyncMediaCallInfoV2Members.verify|verify} messages.
         * @function encode
         * @memberof chat.SyncMediaCallInfoV2Members
         * @static
         * @param {chat.ISyncMediaCallInfoV2Members} message SyncMediaCallInfoV2Members message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        SyncMediaCallInfoV2Members.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.userId != null && Object.hasOwnProperty.call(message, "userId"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.userId);
            if (message.status != null && Object.hasOwnProperty.call(message, "status"))
                writer.uint32(/* id 2, wireType 0 =*/16).int64(message.status);
            if (message.role != null && Object.hasOwnProperty.call(message, "role"))
                writer.uint32(/* id 3, wireType 0 =*/24).int64(message.role);
            if (message.inviteUserId != null && Object.hasOwnProperty.call(message, "inviteUserId"))
                writer.uint32(/* id 4, wireType 2 =*/34).string(message.inviteUserId);
            return writer;
        };

        /**
         * Encodes the specified SyncMediaCallInfoV2Members message, length delimited. Does not implicitly {@link chat.SyncMediaCallInfoV2Members.verify|verify} messages.
         * @function encodeDelimited
         * @memberof chat.SyncMediaCallInfoV2Members
         * @static
         * @param {chat.ISyncMediaCallInfoV2Members} message SyncMediaCallInfoV2Members message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        SyncMediaCallInfoV2Members.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a SyncMediaCallInfoV2Members message from the specified reader or buffer.
         * @function decode
         * @memberof chat.SyncMediaCallInfoV2Members
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {chat.SyncMediaCallInfoV2Members} SyncMediaCallInfoV2Members
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        SyncMediaCallInfoV2Members.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.chat.SyncMediaCallInfoV2Members();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1: {
                        message.userId = reader.string();
                        break;
                    }
                case 2: {
                        message.status = reader.int64();
                        break;
                    }
                case 3: {
                        message.role = reader.int64();
                        break;
                    }
                case 4: {
                        message.inviteUserId = reader.string();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a SyncMediaCallInfoV2Members message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof chat.SyncMediaCallInfoV2Members
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {chat.SyncMediaCallInfoV2Members} SyncMediaCallInfoV2Members
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        SyncMediaCallInfoV2Members.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a SyncMediaCallInfoV2Members message.
         * @function verify
         * @memberof chat.SyncMediaCallInfoV2Members
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        SyncMediaCallInfoV2Members.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.userId != null && message.hasOwnProperty("userId"))
                if (!$util.isString(message.userId))
                    return "userId: string expected";
            if (message.status != null && message.hasOwnProperty("status"))
                if (!$util.isInteger(message.status) && !(message.status && $util.isInteger(message.status.low) && $util.isInteger(message.status.high)))
                    return "status: integer|Long expected";
            if (message.role != null && message.hasOwnProperty("role"))
                if (!$util.isInteger(message.role) && !(message.role && $util.isInteger(message.role.low) && $util.isInteger(message.role.high)))
                    return "role: integer|Long expected";
            if (message.inviteUserId != null && message.hasOwnProperty("inviteUserId"))
                if (!$util.isString(message.inviteUserId))
                    return "inviteUserId: string expected";
            return null;
        };

        /**
         * Creates a SyncMediaCallInfoV2Members message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof chat.SyncMediaCallInfoV2Members
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {chat.SyncMediaCallInfoV2Members} SyncMediaCallInfoV2Members
         */
        SyncMediaCallInfoV2Members.fromObject = function fromObject(object) {
            if (object instanceof $root.chat.SyncMediaCallInfoV2Members)
                return object;
            let message = new $root.chat.SyncMediaCallInfoV2Members();
            if (object.userId != null)
                message.userId = String(object.userId);
            if (object.status != null)
                if ($util.Long)
                    (message.status = $util.Long.fromValue(object.status)).unsigned = false;
                else if (typeof object.status === "string")
                    message.status = parseInt(object.status, 10);
                else if (typeof object.status === "number")
                    message.status = object.status;
                else if (typeof object.status === "object")
                    message.status = new $util.LongBits(object.status.low >>> 0, object.status.high >>> 0).toNumber();
            if (object.role != null)
                if ($util.Long)
                    (message.role = $util.Long.fromValue(object.role)).unsigned = false;
                else if (typeof object.role === "string")
                    message.role = parseInt(object.role, 10);
                else if (typeof object.role === "number")
                    message.role = object.role;
                else if (typeof object.role === "object")
                    message.role = new $util.LongBits(object.role.low >>> 0, object.role.high >>> 0).toNumber();
            if (object.inviteUserId != null)
                message.inviteUserId = String(object.inviteUserId);
            return message;
        };

        /**
         * Creates a plain object from a SyncMediaCallInfoV2Members message. Also converts values to other types if specified.
         * @function toObject
         * @memberof chat.SyncMediaCallInfoV2Members
         * @static
         * @param {chat.SyncMediaCallInfoV2Members} message SyncMediaCallInfoV2Members
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        SyncMediaCallInfoV2Members.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.userId = "";
                if ($util.Long) {
                    let long = new $util.Long(0, 0, false);
                    object.status = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.status = options.longs === String ? "0" : 0;
                if ($util.Long) {
                    let long = new $util.Long(0, 0, false);
                    object.role = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.role = options.longs === String ? "0" : 0;
                object.inviteUserId = "";
            }
            if (message.userId != null && message.hasOwnProperty("userId"))
                object.userId = message.userId;
            if (message.status != null && message.hasOwnProperty("status"))
                if (typeof message.status === "number")
                    object.status = options.longs === String ? String(message.status) : message.status;
                else
                    object.status = options.longs === String ? $util.Long.prototype.toString.call(message.status) : options.longs === Number ? new $util.LongBits(message.status.low >>> 0, message.status.high >>> 0).toNumber() : message.status;
            if (message.role != null && message.hasOwnProperty("role"))
                if (typeof message.role === "number")
                    object.role = options.longs === String ? String(message.role) : message.role;
                else
                    object.role = options.longs === String ? $util.Long.prototype.toString.call(message.role) : options.longs === Number ? new $util.LongBits(message.role.low >>> 0, message.role.high >>> 0).toNumber() : message.role;
            if (message.inviteUserId != null && message.hasOwnProperty("inviteUserId"))
                object.inviteUserId = message.inviteUserId;
            return object;
        };

        /**
         * Converts this SyncMediaCallInfoV2Members to JSON.
         * @function toJSON
         * @memberof chat.SyncMediaCallInfoV2Members
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        SyncMediaCallInfoV2Members.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for SyncMediaCallInfoV2Members
         * @function getTypeUrl
         * @memberof chat.SyncMediaCallInfoV2Members
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        SyncMediaCallInfoV2Members.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/chat.SyncMediaCallInfoV2Members";
        };

        return SyncMediaCallInfoV2Members;
    })();

    chat.PullGroupMsgReadReplyRequest = (function() {

        /**
         * Properties of a PullGroupMsgReadReplyRequest.
         * @memberof chat
         * @interface IPullGroupMsgReadReplyRequest
         * @property {number|Long|null} [sequence] PullGroupMsgReadReplyRequest sequence
         * @property {number|null} [msgType] PullGroupMsgReadReplyRequest msgType
         */

        /**
         * Constructs a new PullGroupMsgReadReplyRequest.
         * @memberof chat
         * @classdesc Represents a PullGroupMsgReadReplyRequest.
         * @implements IPullGroupMsgReadReplyRequest
         * @constructor
         * @param {chat.IPullGroupMsgReadReplyRequest=} [properties] Properties to set
         */
        function PullGroupMsgReadReplyRequest(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * PullGroupMsgReadReplyRequest sequence.
         * @member {number|Long} sequence
         * @memberof chat.PullGroupMsgReadReplyRequest
         * @instance
         */
        PullGroupMsgReadReplyRequest.prototype.sequence = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * PullGroupMsgReadReplyRequest msgType.
         * @member {number} msgType
         * @memberof chat.PullGroupMsgReadReplyRequest
         * @instance
         */
        PullGroupMsgReadReplyRequest.prototype.msgType = 0;

        /**
         * Creates a new PullGroupMsgReadReplyRequest instance using the specified properties.
         * @function create
         * @memberof chat.PullGroupMsgReadReplyRequest
         * @static
         * @param {chat.IPullGroupMsgReadReplyRequest=} [properties] Properties to set
         * @returns {chat.PullGroupMsgReadReplyRequest} PullGroupMsgReadReplyRequest instance
         */
        PullGroupMsgReadReplyRequest.create = function create(properties) {
            return new PullGroupMsgReadReplyRequest(properties);
        };

        /**
         * Encodes the specified PullGroupMsgReadReplyRequest message. Does not implicitly {@link chat.PullGroupMsgReadReplyRequest.verify|verify} messages.
         * @function encode
         * @memberof chat.PullGroupMsgReadReplyRequest
         * @static
         * @param {chat.IPullGroupMsgReadReplyRequest} message PullGroupMsgReadReplyRequest message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        PullGroupMsgReadReplyRequest.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.sequence != null && Object.hasOwnProperty.call(message, "sequence"))
                writer.uint32(/* id 1, wireType 0 =*/8).int64(message.sequence);
            if (message.msgType != null && Object.hasOwnProperty.call(message, "msgType"))
                writer.uint32(/* id 2, wireType 0 =*/16).int32(message.msgType);
            return writer;
        };

        /**
         * Encodes the specified PullGroupMsgReadReplyRequest message, length delimited. Does not implicitly {@link chat.PullGroupMsgReadReplyRequest.verify|verify} messages.
         * @function encodeDelimited
         * @memberof chat.PullGroupMsgReadReplyRequest
         * @static
         * @param {chat.IPullGroupMsgReadReplyRequest} message PullGroupMsgReadReplyRequest message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        PullGroupMsgReadReplyRequest.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a PullGroupMsgReadReplyRequest message from the specified reader or buffer.
         * @function decode
         * @memberof chat.PullGroupMsgReadReplyRequest
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {chat.PullGroupMsgReadReplyRequest} PullGroupMsgReadReplyRequest
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        PullGroupMsgReadReplyRequest.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.chat.PullGroupMsgReadReplyRequest();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1: {
                        message.sequence = reader.int64();
                        break;
                    }
                case 2: {
                        message.msgType = reader.int32();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a PullGroupMsgReadReplyRequest message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof chat.PullGroupMsgReadReplyRequest
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {chat.PullGroupMsgReadReplyRequest} PullGroupMsgReadReplyRequest
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        PullGroupMsgReadReplyRequest.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a PullGroupMsgReadReplyRequest message.
         * @function verify
         * @memberof chat.PullGroupMsgReadReplyRequest
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        PullGroupMsgReadReplyRequest.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.sequence != null && message.hasOwnProperty("sequence"))
                if (!$util.isInteger(message.sequence) && !(message.sequence && $util.isInteger(message.sequence.low) && $util.isInteger(message.sequence.high)))
                    return "sequence: integer|Long expected";
            if (message.msgType != null && message.hasOwnProperty("msgType"))
                if (!$util.isInteger(message.msgType))
                    return "msgType: integer expected";
            return null;
        };

        /**
         * Creates a PullGroupMsgReadReplyRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof chat.PullGroupMsgReadReplyRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {chat.PullGroupMsgReadReplyRequest} PullGroupMsgReadReplyRequest
         */
        PullGroupMsgReadReplyRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.chat.PullGroupMsgReadReplyRequest)
                return object;
            let message = new $root.chat.PullGroupMsgReadReplyRequest();
            if (object.sequence != null)
                if ($util.Long)
                    (message.sequence = $util.Long.fromValue(object.sequence)).unsigned = false;
                else if (typeof object.sequence === "string")
                    message.sequence = parseInt(object.sequence, 10);
                else if (typeof object.sequence === "number")
                    message.sequence = object.sequence;
                else if (typeof object.sequence === "object")
                    message.sequence = new $util.LongBits(object.sequence.low >>> 0, object.sequence.high >>> 0).toNumber();
            if (object.msgType != null)
                message.msgType = object.msgType | 0;
            return message;
        };

        /**
         * Creates a plain object from a PullGroupMsgReadReplyRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof chat.PullGroupMsgReadReplyRequest
         * @static
         * @param {chat.PullGroupMsgReadReplyRequest} message PullGroupMsgReadReplyRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        PullGroupMsgReadReplyRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                if ($util.Long) {
                    let long = new $util.Long(0, 0, false);
                    object.sequence = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.sequence = options.longs === String ? "0" : 0;
                object.msgType = 0;
            }
            if (message.sequence != null && message.hasOwnProperty("sequence"))
                if (typeof message.sequence === "number")
                    object.sequence = options.longs === String ? String(message.sequence) : message.sequence;
                else
                    object.sequence = options.longs === String ? $util.Long.prototype.toString.call(message.sequence) : options.longs === Number ? new $util.LongBits(message.sequence.low >>> 0, message.sequence.high >>> 0).toNumber() : message.sequence;
            if (message.msgType != null && message.hasOwnProperty("msgType"))
                object.msgType = message.msgType;
            return object;
        };

        /**
         * Converts this PullGroupMsgReadReplyRequest to JSON.
         * @function toJSON
         * @memberof chat.PullGroupMsgReadReplyRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        PullGroupMsgReadReplyRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for PullGroupMsgReadReplyRequest
         * @function getTypeUrl
         * @memberof chat.PullGroupMsgReadReplyRequest
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        PullGroupMsgReadReplyRequest.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/chat.PullGroupMsgReadReplyRequest";
        };

        return PullGroupMsgReadReplyRequest;
    })();

    chat.PullGroupMsgReadReply = (function() {

        /**
         * Properties of a PullGroupMsgReadReply.
         * @memberof chat
         * @interface IPullGroupMsgReadReply
         * @property {string|null} [chatId] PullGroupMsgReadReply chatId
         * @property {string|null} [messageId] PullGroupMsgReadReply messageId
         * @property {string|null} [senderId] PullGroupMsgReadReply senderId
         * @property {string|null} [cliMsgId] PullGroupMsgReadReply cliMsgId
         * @property {number|Long|null} [createdAt] PullGroupMsgReadReply createdAt
         */

        /**
         * Constructs a new PullGroupMsgReadReply.
         * @memberof chat
         * @classdesc Represents a PullGroupMsgReadReply.
         * @implements IPullGroupMsgReadReply
         * @constructor
         * @param {chat.IPullGroupMsgReadReply=} [properties] Properties to set
         */
        function PullGroupMsgReadReply(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * PullGroupMsgReadReply chatId.
         * @member {string} chatId
         * @memberof chat.PullGroupMsgReadReply
         * @instance
         */
        PullGroupMsgReadReply.prototype.chatId = "";

        /**
         * PullGroupMsgReadReply messageId.
         * @member {string} messageId
         * @memberof chat.PullGroupMsgReadReply
         * @instance
         */
        PullGroupMsgReadReply.prototype.messageId = "";

        /**
         * PullGroupMsgReadReply senderId.
         * @member {string} senderId
         * @memberof chat.PullGroupMsgReadReply
         * @instance
         */
        PullGroupMsgReadReply.prototype.senderId = "";

        /**
         * PullGroupMsgReadReply cliMsgId.
         * @member {string} cliMsgId
         * @memberof chat.PullGroupMsgReadReply
         * @instance
         */
        PullGroupMsgReadReply.prototype.cliMsgId = "";

        /**
         * PullGroupMsgReadReply createdAt.
         * @member {number|Long} createdAt
         * @memberof chat.PullGroupMsgReadReply
         * @instance
         */
        PullGroupMsgReadReply.prototype.createdAt = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * Creates a new PullGroupMsgReadReply instance using the specified properties.
         * @function create
         * @memberof chat.PullGroupMsgReadReply
         * @static
         * @param {chat.IPullGroupMsgReadReply=} [properties] Properties to set
         * @returns {chat.PullGroupMsgReadReply} PullGroupMsgReadReply instance
         */
        PullGroupMsgReadReply.create = function create(properties) {
            return new PullGroupMsgReadReply(properties);
        };

        /**
         * Encodes the specified PullGroupMsgReadReply message. Does not implicitly {@link chat.PullGroupMsgReadReply.verify|verify} messages.
         * @function encode
         * @memberof chat.PullGroupMsgReadReply
         * @static
         * @param {chat.IPullGroupMsgReadReply} message PullGroupMsgReadReply message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        PullGroupMsgReadReply.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.chatId != null && Object.hasOwnProperty.call(message, "chatId"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.chatId);
            if (message.messageId != null && Object.hasOwnProperty.call(message, "messageId"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.messageId);
            if (message.senderId != null && Object.hasOwnProperty.call(message, "senderId"))
                writer.uint32(/* id 3, wireType 2 =*/26).string(message.senderId);
            if (message.cliMsgId != null && Object.hasOwnProperty.call(message, "cliMsgId"))
                writer.uint32(/* id 4, wireType 2 =*/34).string(message.cliMsgId);
            if (message.createdAt != null && Object.hasOwnProperty.call(message, "createdAt"))
                writer.uint32(/* id 5, wireType 0 =*/40).int64(message.createdAt);
            return writer;
        };

        /**
         * Encodes the specified PullGroupMsgReadReply message, length delimited. Does not implicitly {@link chat.PullGroupMsgReadReply.verify|verify} messages.
         * @function encodeDelimited
         * @memberof chat.PullGroupMsgReadReply
         * @static
         * @param {chat.IPullGroupMsgReadReply} message PullGroupMsgReadReply message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        PullGroupMsgReadReply.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a PullGroupMsgReadReply message from the specified reader or buffer.
         * @function decode
         * @memberof chat.PullGroupMsgReadReply
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {chat.PullGroupMsgReadReply} PullGroupMsgReadReply
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        PullGroupMsgReadReply.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.chat.PullGroupMsgReadReply();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1: {
                        message.chatId = reader.string();
                        break;
                    }
                case 2: {
                        message.messageId = reader.string();
                        break;
                    }
                case 3: {
                        message.senderId = reader.string();
                        break;
                    }
                case 4: {
                        message.cliMsgId = reader.string();
                        break;
                    }
                case 5: {
                        message.createdAt = reader.int64();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a PullGroupMsgReadReply message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof chat.PullGroupMsgReadReply
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {chat.PullGroupMsgReadReply} PullGroupMsgReadReply
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        PullGroupMsgReadReply.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a PullGroupMsgReadReply message.
         * @function verify
         * @memberof chat.PullGroupMsgReadReply
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        PullGroupMsgReadReply.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.chatId != null && message.hasOwnProperty("chatId"))
                if (!$util.isString(message.chatId))
                    return "chatId: string expected";
            if (message.messageId != null && message.hasOwnProperty("messageId"))
                if (!$util.isString(message.messageId))
                    return "messageId: string expected";
            if (message.senderId != null && message.hasOwnProperty("senderId"))
                if (!$util.isString(message.senderId))
                    return "senderId: string expected";
            if (message.cliMsgId != null && message.hasOwnProperty("cliMsgId"))
                if (!$util.isString(message.cliMsgId))
                    return "cliMsgId: string expected";
            if (message.createdAt != null && message.hasOwnProperty("createdAt"))
                if (!$util.isInteger(message.createdAt) && !(message.createdAt && $util.isInteger(message.createdAt.low) && $util.isInteger(message.createdAt.high)))
                    return "createdAt: integer|Long expected";
            return null;
        };

        /**
         * Creates a PullGroupMsgReadReply message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof chat.PullGroupMsgReadReply
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {chat.PullGroupMsgReadReply} PullGroupMsgReadReply
         */
        PullGroupMsgReadReply.fromObject = function fromObject(object) {
            if (object instanceof $root.chat.PullGroupMsgReadReply)
                return object;
            let message = new $root.chat.PullGroupMsgReadReply();
            if (object.chatId != null)
                message.chatId = String(object.chatId);
            if (object.messageId != null)
                message.messageId = String(object.messageId);
            if (object.senderId != null)
                message.senderId = String(object.senderId);
            if (object.cliMsgId != null)
                message.cliMsgId = String(object.cliMsgId);
            if (object.createdAt != null)
                if ($util.Long)
                    (message.createdAt = $util.Long.fromValue(object.createdAt)).unsigned = false;
                else if (typeof object.createdAt === "string")
                    message.createdAt = parseInt(object.createdAt, 10);
                else if (typeof object.createdAt === "number")
                    message.createdAt = object.createdAt;
                else if (typeof object.createdAt === "object")
                    message.createdAt = new $util.LongBits(object.createdAt.low >>> 0, object.createdAt.high >>> 0).toNumber();
            return message;
        };

        /**
         * Creates a plain object from a PullGroupMsgReadReply message. Also converts values to other types if specified.
         * @function toObject
         * @memberof chat.PullGroupMsgReadReply
         * @static
         * @param {chat.PullGroupMsgReadReply} message PullGroupMsgReadReply
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        PullGroupMsgReadReply.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.chatId = "";
                object.messageId = "";
                object.senderId = "";
                object.cliMsgId = "";
                if ($util.Long) {
                    let long = new $util.Long(0, 0, false);
                    object.createdAt = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.createdAt = options.longs === String ? "0" : 0;
            }
            if (message.chatId != null && message.hasOwnProperty("chatId"))
                object.chatId = message.chatId;
            if (message.messageId != null && message.hasOwnProperty("messageId"))
                object.messageId = message.messageId;
            if (message.senderId != null && message.hasOwnProperty("senderId"))
                object.senderId = message.senderId;
            if (message.cliMsgId != null && message.hasOwnProperty("cliMsgId"))
                object.cliMsgId = message.cliMsgId;
            if (message.createdAt != null && message.hasOwnProperty("createdAt"))
                if (typeof message.createdAt === "number")
                    object.createdAt = options.longs === String ? String(message.createdAt) : message.createdAt;
                else
                    object.createdAt = options.longs === String ? $util.Long.prototype.toString.call(message.createdAt) : options.longs === Number ? new $util.LongBits(message.createdAt.low >>> 0, message.createdAt.high >>> 0).toNumber() : message.createdAt;
            return object;
        };

        /**
         * Converts this PullGroupMsgReadReply to JSON.
         * @function toJSON
         * @memberof chat.PullGroupMsgReadReply
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        PullGroupMsgReadReply.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for PullGroupMsgReadReply
         * @function getTypeUrl
         * @memberof chat.PullGroupMsgReadReply
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        PullGroupMsgReadReply.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/chat.PullGroupMsgReadReply";
        };

        return PullGroupMsgReadReply;
    })();

    chat.PullGroupMsgReadReplyResponse = (function() {

        /**
         * Properties of a PullGroupMsgReadReplyResponse.
         * @memberof chat
         * @interface IPullGroupMsgReadReplyResponse
         * @property {Array.<chat.IPullGroupMsgReadReply>|null} [list] PullGroupMsgReadReplyResponse list
         * @property {number|Long|null} [maxSequence] PullGroupMsgReadReplyResponse maxSequence
         */

        /**
         * Constructs a new PullGroupMsgReadReplyResponse.
         * @memberof chat
         * @classdesc Represents a PullGroupMsgReadReplyResponse.
         * @implements IPullGroupMsgReadReplyResponse
         * @constructor
         * @param {chat.IPullGroupMsgReadReplyResponse=} [properties] Properties to set
         */
        function PullGroupMsgReadReplyResponse(properties) {
            this.list = [];
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * PullGroupMsgReadReplyResponse list.
         * @member {Array.<chat.IPullGroupMsgReadReply>} list
         * @memberof chat.PullGroupMsgReadReplyResponse
         * @instance
         */
        PullGroupMsgReadReplyResponse.prototype.list = $util.emptyArray;

        /**
         * PullGroupMsgReadReplyResponse maxSequence.
         * @member {number|Long} maxSequence
         * @memberof chat.PullGroupMsgReadReplyResponse
         * @instance
         */
        PullGroupMsgReadReplyResponse.prototype.maxSequence = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * Creates a new PullGroupMsgReadReplyResponse instance using the specified properties.
         * @function create
         * @memberof chat.PullGroupMsgReadReplyResponse
         * @static
         * @param {chat.IPullGroupMsgReadReplyResponse=} [properties] Properties to set
         * @returns {chat.PullGroupMsgReadReplyResponse} PullGroupMsgReadReplyResponse instance
         */
        PullGroupMsgReadReplyResponse.create = function create(properties) {
            return new PullGroupMsgReadReplyResponse(properties);
        };

        /**
         * Encodes the specified PullGroupMsgReadReplyResponse message. Does not implicitly {@link chat.PullGroupMsgReadReplyResponse.verify|verify} messages.
         * @function encode
         * @memberof chat.PullGroupMsgReadReplyResponse
         * @static
         * @param {chat.IPullGroupMsgReadReplyResponse} message PullGroupMsgReadReplyResponse message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        PullGroupMsgReadReplyResponse.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.list != null && message.list.length)
                for (let i = 0; i < message.list.length; ++i)
                    $root.chat.PullGroupMsgReadReply.encode(message.list[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
            if (message.maxSequence != null && Object.hasOwnProperty.call(message, "maxSequence"))
                writer.uint32(/* id 2, wireType 0 =*/16).int64(message.maxSequence);
            return writer;
        };

        /**
         * Encodes the specified PullGroupMsgReadReplyResponse message, length delimited. Does not implicitly {@link chat.PullGroupMsgReadReplyResponse.verify|verify} messages.
         * @function encodeDelimited
         * @memberof chat.PullGroupMsgReadReplyResponse
         * @static
         * @param {chat.IPullGroupMsgReadReplyResponse} message PullGroupMsgReadReplyResponse message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        PullGroupMsgReadReplyResponse.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a PullGroupMsgReadReplyResponse message from the specified reader or buffer.
         * @function decode
         * @memberof chat.PullGroupMsgReadReplyResponse
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {chat.PullGroupMsgReadReplyResponse} PullGroupMsgReadReplyResponse
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        PullGroupMsgReadReplyResponse.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.chat.PullGroupMsgReadReplyResponse();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1: {
                        if (!(message.list && message.list.length))
                            message.list = [];
                        message.list.push($root.chat.PullGroupMsgReadReply.decode(reader, reader.uint32()));
                        break;
                    }
                case 2: {
                        message.maxSequence = reader.int64();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a PullGroupMsgReadReplyResponse message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof chat.PullGroupMsgReadReplyResponse
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {chat.PullGroupMsgReadReplyResponse} PullGroupMsgReadReplyResponse
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        PullGroupMsgReadReplyResponse.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a PullGroupMsgReadReplyResponse message.
         * @function verify
         * @memberof chat.PullGroupMsgReadReplyResponse
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        PullGroupMsgReadReplyResponse.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.list != null && message.hasOwnProperty("list")) {
                if (!Array.isArray(message.list))
                    return "list: array expected";
                for (let i = 0; i < message.list.length; ++i) {
                    let error = $root.chat.PullGroupMsgReadReply.verify(message.list[i]);
                    if (error)
                        return "list." + error;
                }
            }
            if (message.maxSequence != null && message.hasOwnProperty("maxSequence"))
                if (!$util.isInteger(message.maxSequence) && !(message.maxSequence && $util.isInteger(message.maxSequence.low) && $util.isInteger(message.maxSequence.high)))
                    return "maxSequence: integer|Long expected";
            return null;
        };

        /**
         * Creates a PullGroupMsgReadReplyResponse message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof chat.PullGroupMsgReadReplyResponse
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {chat.PullGroupMsgReadReplyResponse} PullGroupMsgReadReplyResponse
         */
        PullGroupMsgReadReplyResponse.fromObject = function fromObject(object) {
            if (object instanceof $root.chat.PullGroupMsgReadReplyResponse)
                return object;
            let message = new $root.chat.PullGroupMsgReadReplyResponse();
            if (object.list) {
                if (!Array.isArray(object.list))
                    throw TypeError(".chat.PullGroupMsgReadReplyResponse.list: array expected");
                message.list = [];
                for (let i = 0; i < object.list.length; ++i) {
                    if (typeof object.list[i] !== "object")
                        throw TypeError(".chat.PullGroupMsgReadReplyResponse.list: object expected");
                    message.list[i] = $root.chat.PullGroupMsgReadReply.fromObject(object.list[i]);
                }
            }
            if (object.maxSequence != null)
                if ($util.Long)
                    (message.maxSequence = $util.Long.fromValue(object.maxSequence)).unsigned = false;
                else if (typeof object.maxSequence === "string")
                    message.maxSequence = parseInt(object.maxSequence, 10);
                else if (typeof object.maxSequence === "number")
                    message.maxSequence = object.maxSequence;
                else if (typeof object.maxSequence === "object")
                    message.maxSequence = new $util.LongBits(object.maxSequence.low >>> 0, object.maxSequence.high >>> 0).toNumber();
            return message;
        };

        /**
         * Creates a plain object from a PullGroupMsgReadReplyResponse message. Also converts values to other types if specified.
         * @function toObject
         * @memberof chat.PullGroupMsgReadReplyResponse
         * @static
         * @param {chat.PullGroupMsgReadReplyResponse} message PullGroupMsgReadReplyResponse
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        PullGroupMsgReadReplyResponse.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.arrays || options.defaults)
                object.list = [];
            if (options.defaults)
                if ($util.Long) {
                    let long = new $util.Long(0, 0, false);
                    object.maxSequence = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.maxSequence = options.longs === String ? "0" : 0;
            if (message.list && message.list.length) {
                object.list = [];
                for (let j = 0; j < message.list.length; ++j)
                    object.list[j] = $root.chat.PullGroupMsgReadReply.toObject(message.list[j], options);
            }
            if (message.maxSequence != null && message.hasOwnProperty("maxSequence"))
                if (typeof message.maxSequence === "number")
                    object.maxSequence = options.longs === String ? String(message.maxSequence) : message.maxSequence;
                else
                    object.maxSequence = options.longs === String ? $util.Long.prototype.toString.call(message.maxSequence) : options.longs === Number ? new $util.LongBits(message.maxSequence.low >>> 0, message.maxSequence.high >>> 0).toNumber() : message.maxSequence;
            return object;
        };

        /**
         * Converts this PullGroupMsgReadReplyResponse to JSON.
         * @function toJSON
         * @memberof chat.PullGroupMsgReadReplyResponse
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        PullGroupMsgReadReplyResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for PullGroupMsgReadReplyResponse
         * @function getTypeUrl
         * @memberof chat.PullGroupMsgReadReplyResponse
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        PullGroupMsgReadReplyResponse.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/chat.PullGroupMsgReadReplyResponse";
        };

        return PullGroupMsgReadReplyResponse;
    })();

    chat.ResetMediaCallUserStatusRequest = (function() {

        /**
         * Properties of a ResetMediaCallUserStatusRequest.
         * @memberof chat
         * @interface IResetMediaCallUserStatusRequest
         * @property {string|null} [roomId] ResetMediaCallUserStatusRequest roomId
         */

        /**
         * Constructs a new ResetMediaCallUserStatusRequest.
         * @memberof chat
         * @classdesc Represents a ResetMediaCallUserStatusRequest.
         * @implements IResetMediaCallUserStatusRequest
         * @constructor
         * @param {chat.IResetMediaCallUserStatusRequest=} [properties] Properties to set
         */
        function ResetMediaCallUserStatusRequest(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ResetMediaCallUserStatusRequest roomId.
         * @member {string} roomId
         * @memberof chat.ResetMediaCallUserStatusRequest
         * @instance
         */
        ResetMediaCallUserStatusRequest.prototype.roomId = "";

        /**
         * Creates a new ResetMediaCallUserStatusRequest instance using the specified properties.
         * @function create
         * @memberof chat.ResetMediaCallUserStatusRequest
         * @static
         * @param {chat.IResetMediaCallUserStatusRequest=} [properties] Properties to set
         * @returns {chat.ResetMediaCallUserStatusRequest} ResetMediaCallUserStatusRequest instance
         */
        ResetMediaCallUserStatusRequest.create = function create(properties) {
            return new ResetMediaCallUserStatusRequest(properties);
        };

        /**
         * Encodes the specified ResetMediaCallUserStatusRequest message. Does not implicitly {@link chat.ResetMediaCallUserStatusRequest.verify|verify} messages.
         * @function encode
         * @memberof chat.ResetMediaCallUserStatusRequest
         * @static
         * @param {chat.IResetMediaCallUserStatusRequest} message ResetMediaCallUserStatusRequest message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ResetMediaCallUserStatusRequest.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.roomId != null && Object.hasOwnProperty.call(message, "roomId"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.roomId);
            return writer;
        };

        /**
         * Encodes the specified ResetMediaCallUserStatusRequest message, length delimited. Does not implicitly {@link chat.ResetMediaCallUserStatusRequest.verify|verify} messages.
         * @function encodeDelimited
         * @memberof chat.ResetMediaCallUserStatusRequest
         * @static
         * @param {chat.IResetMediaCallUserStatusRequest} message ResetMediaCallUserStatusRequest message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ResetMediaCallUserStatusRequest.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a ResetMediaCallUserStatusRequest message from the specified reader or buffer.
         * @function decode
         * @memberof chat.ResetMediaCallUserStatusRequest
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {chat.ResetMediaCallUserStatusRequest} ResetMediaCallUserStatusRequest
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ResetMediaCallUserStatusRequest.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.chat.ResetMediaCallUserStatusRequest();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1: {
                        message.roomId = reader.string();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a ResetMediaCallUserStatusRequest message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof chat.ResetMediaCallUserStatusRequest
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {chat.ResetMediaCallUserStatusRequest} ResetMediaCallUserStatusRequest
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ResetMediaCallUserStatusRequest.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a ResetMediaCallUserStatusRequest message.
         * @function verify
         * @memberof chat.ResetMediaCallUserStatusRequest
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        ResetMediaCallUserStatusRequest.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.roomId != null && message.hasOwnProperty("roomId"))
                if (!$util.isString(message.roomId))
                    return "roomId: string expected";
            return null;
        };

        /**
         * Creates a ResetMediaCallUserStatusRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof chat.ResetMediaCallUserStatusRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {chat.ResetMediaCallUserStatusRequest} ResetMediaCallUserStatusRequest
         */
        ResetMediaCallUserStatusRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.chat.ResetMediaCallUserStatusRequest)
                return object;
            let message = new $root.chat.ResetMediaCallUserStatusRequest();
            if (object.roomId != null)
                message.roomId = String(object.roomId);
            return message;
        };

        /**
         * Creates a plain object from a ResetMediaCallUserStatusRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof chat.ResetMediaCallUserStatusRequest
         * @static
         * @param {chat.ResetMediaCallUserStatusRequest} message ResetMediaCallUserStatusRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ResetMediaCallUserStatusRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults)
                object.roomId = "";
            if (message.roomId != null && message.hasOwnProperty("roomId"))
                object.roomId = message.roomId;
            return object;
        };

        /**
         * Converts this ResetMediaCallUserStatusRequest to JSON.
         * @function toJSON
         * @memberof chat.ResetMediaCallUserStatusRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ResetMediaCallUserStatusRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for ResetMediaCallUserStatusRequest
         * @function getTypeUrl
         * @memberof chat.ResetMediaCallUserStatusRequest
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        ResetMediaCallUserStatusRequest.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/chat.ResetMediaCallUserStatusRequest";
        };

        return ResetMediaCallUserStatusRequest;
    })();

    chat.ResetMediaCallUserStatusResponse = (function() {

        /**
         * Properties of a ResetMediaCallUserStatusResponse.
         * @memberof chat
         * @interface IResetMediaCallUserStatusResponse
         * @property {number|null} [code] ResetMediaCallUserStatusResponse code
         */

        /**
         * Constructs a new ResetMediaCallUserStatusResponse.
         * @memberof chat
         * @classdesc Represents a ResetMediaCallUserStatusResponse.
         * @implements IResetMediaCallUserStatusResponse
         * @constructor
         * @param {chat.IResetMediaCallUserStatusResponse=} [properties] Properties to set
         */
        function ResetMediaCallUserStatusResponse(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ResetMediaCallUserStatusResponse code.
         * @member {number} code
         * @memberof chat.ResetMediaCallUserStatusResponse
         * @instance
         */
        ResetMediaCallUserStatusResponse.prototype.code = 0;

        /**
         * Creates a new ResetMediaCallUserStatusResponse instance using the specified properties.
         * @function create
         * @memberof chat.ResetMediaCallUserStatusResponse
         * @static
         * @param {chat.IResetMediaCallUserStatusResponse=} [properties] Properties to set
         * @returns {chat.ResetMediaCallUserStatusResponse} ResetMediaCallUserStatusResponse instance
         */
        ResetMediaCallUserStatusResponse.create = function create(properties) {
            return new ResetMediaCallUserStatusResponse(properties);
        };

        /**
         * Encodes the specified ResetMediaCallUserStatusResponse message. Does not implicitly {@link chat.ResetMediaCallUserStatusResponse.verify|verify} messages.
         * @function encode
         * @memberof chat.ResetMediaCallUserStatusResponse
         * @static
         * @param {chat.IResetMediaCallUserStatusResponse} message ResetMediaCallUserStatusResponse message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ResetMediaCallUserStatusResponse.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.code != null && Object.hasOwnProperty.call(message, "code"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.code);
            return writer;
        };

        /**
         * Encodes the specified ResetMediaCallUserStatusResponse message, length delimited. Does not implicitly {@link chat.ResetMediaCallUserStatusResponse.verify|verify} messages.
         * @function encodeDelimited
         * @memberof chat.ResetMediaCallUserStatusResponse
         * @static
         * @param {chat.IResetMediaCallUserStatusResponse} message ResetMediaCallUserStatusResponse message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ResetMediaCallUserStatusResponse.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a ResetMediaCallUserStatusResponse message from the specified reader or buffer.
         * @function decode
         * @memberof chat.ResetMediaCallUserStatusResponse
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {chat.ResetMediaCallUserStatusResponse} ResetMediaCallUserStatusResponse
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ResetMediaCallUserStatusResponse.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.chat.ResetMediaCallUserStatusResponse();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1: {
                        message.code = reader.int32();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a ResetMediaCallUserStatusResponse message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof chat.ResetMediaCallUserStatusResponse
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {chat.ResetMediaCallUserStatusResponse} ResetMediaCallUserStatusResponse
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ResetMediaCallUserStatusResponse.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a ResetMediaCallUserStatusResponse message.
         * @function verify
         * @memberof chat.ResetMediaCallUserStatusResponse
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        ResetMediaCallUserStatusResponse.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.code != null && message.hasOwnProperty("code"))
                if (!$util.isInteger(message.code))
                    return "code: integer expected";
            return null;
        };

        /**
         * Creates a ResetMediaCallUserStatusResponse message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof chat.ResetMediaCallUserStatusResponse
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {chat.ResetMediaCallUserStatusResponse} ResetMediaCallUserStatusResponse
         */
        ResetMediaCallUserStatusResponse.fromObject = function fromObject(object) {
            if (object instanceof $root.chat.ResetMediaCallUserStatusResponse)
                return object;
            let message = new $root.chat.ResetMediaCallUserStatusResponse();
            if (object.code != null)
                message.code = object.code | 0;
            return message;
        };

        /**
         * Creates a plain object from a ResetMediaCallUserStatusResponse message. Also converts values to other types if specified.
         * @function toObject
         * @memberof chat.ResetMediaCallUserStatusResponse
         * @static
         * @param {chat.ResetMediaCallUserStatusResponse} message ResetMediaCallUserStatusResponse
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ResetMediaCallUserStatusResponse.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults)
                object.code = 0;
            if (message.code != null && message.hasOwnProperty("code"))
                object.code = message.code;
            return object;
        };

        /**
         * Converts this ResetMediaCallUserStatusResponse to JSON.
         * @function toJSON
         * @memberof chat.ResetMediaCallUserStatusResponse
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ResetMediaCallUserStatusResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for ResetMediaCallUserStatusResponse
         * @function getTypeUrl
         * @memberof chat.ResetMediaCallUserStatusResponse
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        ResetMediaCallUserStatusResponse.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/chat.ResetMediaCallUserStatusResponse";
        };

        return ResetMediaCallUserStatusResponse;
    })();

    chat.DirectPush = (function() {

        /**
         * Properties of a DirectPush.
         * @memberof chat
         * @interface IDirectPush
         * @property {number|null} [pushAction] DirectPush pushAction
         * @property {number|null} [pushType] DirectPush pushType
         * @property {string|null} [content] DirectPush content
         */

        /**
         * Constructs a new DirectPush.
         * @memberof chat
         * @classdesc Represents a DirectPush.
         * @implements IDirectPush
         * @constructor
         * @param {chat.IDirectPush=} [properties] Properties to set
         */
        function DirectPush(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * DirectPush pushAction.
         * @member {number} pushAction
         * @memberof chat.DirectPush
         * @instance
         */
        DirectPush.prototype.pushAction = 0;

        /**
         * DirectPush pushType.
         * @member {number} pushType
         * @memberof chat.DirectPush
         * @instance
         */
        DirectPush.prototype.pushType = 0;

        /**
         * DirectPush content.
         * @member {string} content
         * @memberof chat.DirectPush
         * @instance
         */
        DirectPush.prototype.content = "";

        /**
         * Creates a new DirectPush instance using the specified properties.
         * @function create
         * @memberof chat.DirectPush
         * @static
         * @param {chat.IDirectPush=} [properties] Properties to set
         * @returns {chat.DirectPush} DirectPush instance
         */
        DirectPush.create = function create(properties) {
            return new DirectPush(properties);
        };

        /**
         * Encodes the specified DirectPush message. Does not implicitly {@link chat.DirectPush.verify|verify} messages.
         * @function encode
         * @memberof chat.DirectPush
         * @static
         * @param {chat.IDirectPush} message DirectPush message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        DirectPush.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.pushAction != null && Object.hasOwnProperty.call(message, "pushAction"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.pushAction);
            if (message.pushType != null && Object.hasOwnProperty.call(message, "pushType"))
                writer.uint32(/* id 2, wireType 0 =*/16).int32(message.pushType);
            if (message.content != null && Object.hasOwnProperty.call(message, "content"))
                writer.uint32(/* id 3, wireType 2 =*/26).string(message.content);
            return writer;
        };

        /**
         * Encodes the specified DirectPush message, length delimited. Does not implicitly {@link chat.DirectPush.verify|verify} messages.
         * @function encodeDelimited
         * @memberof chat.DirectPush
         * @static
         * @param {chat.IDirectPush} message DirectPush message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        DirectPush.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a DirectPush message from the specified reader or buffer.
         * @function decode
         * @memberof chat.DirectPush
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {chat.DirectPush} DirectPush
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        DirectPush.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.chat.DirectPush();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1: {
                        message.pushAction = reader.int32();
                        break;
                    }
                case 2: {
                        message.pushType = reader.int32();
                        break;
                    }
                case 3: {
                        message.content = reader.string();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a DirectPush message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof chat.DirectPush
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {chat.DirectPush} DirectPush
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        DirectPush.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a DirectPush message.
         * @function verify
         * @memberof chat.DirectPush
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        DirectPush.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.pushAction != null && message.hasOwnProperty("pushAction"))
                if (!$util.isInteger(message.pushAction))
                    return "pushAction: integer expected";
            if (message.pushType != null && message.hasOwnProperty("pushType"))
                if (!$util.isInteger(message.pushType))
                    return "pushType: integer expected";
            if (message.content != null && message.hasOwnProperty("content"))
                if (!$util.isString(message.content))
                    return "content: string expected";
            return null;
        };

        /**
         * Creates a DirectPush message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof chat.DirectPush
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {chat.DirectPush} DirectPush
         */
        DirectPush.fromObject = function fromObject(object) {
            if (object instanceof $root.chat.DirectPush)
                return object;
            let message = new $root.chat.DirectPush();
            if (object.pushAction != null)
                message.pushAction = object.pushAction | 0;
            if (object.pushType != null)
                message.pushType = object.pushType | 0;
            if (object.content != null)
                message.content = String(object.content);
            return message;
        };

        /**
         * Creates a plain object from a DirectPush message. Also converts values to other types if specified.
         * @function toObject
         * @memberof chat.DirectPush
         * @static
         * @param {chat.DirectPush} message DirectPush
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        DirectPush.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.pushAction = 0;
                object.pushType = 0;
                object.content = "";
            }
            if (message.pushAction != null && message.hasOwnProperty("pushAction"))
                object.pushAction = message.pushAction;
            if (message.pushType != null && message.hasOwnProperty("pushType"))
                object.pushType = message.pushType;
            if (message.content != null && message.hasOwnProperty("content"))
                object.content = message.content;
            return object;
        };

        /**
         * Converts this DirectPush to JSON.
         * @function toJSON
         * @memberof chat.DirectPush
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        DirectPush.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for DirectPush
         * @function getTypeUrl
         * @memberof chat.DirectPush
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        DirectPush.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/chat.DirectPush";
        };

        return DirectPush;
    })();

    chat.PushOnlineMsg = (function() {

        /**
         * Properties of a PushOnlineMsg.
         * @memberof chat
         * @interface IPushOnlineMsg
         * @property {number|null} [chatType] PushOnlineMsg chatType
         * @property {chat.IMessageInfo|null} [messageInfo] PushOnlineMsg messageInfo
         */

        /**
         * Constructs a new PushOnlineMsg.
         * @memberof chat
         * @classdesc Represents a PushOnlineMsg.
         * @implements IPushOnlineMsg
         * @constructor
         * @param {chat.IPushOnlineMsg=} [properties] Properties to set
         */
        function PushOnlineMsg(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * PushOnlineMsg chatType.
         * @member {number} chatType
         * @memberof chat.PushOnlineMsg
         * @instance
         */
        PushOnlineMsg.prototype.chatType = 0;

        /**
         * PushOnlineMsg messageInfo.
         * @member {chat.IMessageInfo|null|undefined} messageInfo
         * @memberof chat.PushOnlineMsg
         * @instance
         */
        PushOnlineMsg.prototype.messageInfo = null;

        /**
         * Creates a new PushOnlineMsg instance using the specified properties.
         * @function create
         * @memberof chat.PushOnlineMsg
         * @static
         * @param {chat.IPushOnlineMsg=} [properties] Properties to set
         * @returns {chat.PushOnlineMsg} PushOnlineMsg instance
         */
        PushOnlineMsg.create = function create(properties) {
            return new PushOnlineMsg(properties);
        };

        /**
         * Encodes the specified PushOnlineMsg message. Does not implicitly {@link chat.PushOnlineMsg.verify|verify} messages.
         * @function encode
         * @memberof chat.PushOnlineMsg
         * @static
         * @param {chat.IPushOnlineMsg} message PushOnlineMsg message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        PushOnlineMsg.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.chatType != null && Object.hasOwnProperty.call(message, "chatType"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.chatType);
            if (message.messageInfo != null && Object.hasOwnProperty.call(message, "messageInfo"))
                $root.chat.MessageInfo.encode(message.messageInfo, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified PushOnlineMsg message, length delimited. Does not implicitly {@link chat.PushOnlineMsg.verify|verify} messages.
         * @function encodeDelimited
         * @memberof chat.PushOnlineMsg
         * @static
         * @param {chat.IPushOnlineMsg} message PushOnlineMsg message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        PushOnlineMsg.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a PushOnlineMsg message from the specified reader or buffer.
         * @function decode
         * @memberof chat.PushOnlineMsg
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {chat.PushOnlineMsg} PushOnlineMsg
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        PushOnlineMsg.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.chat.PushOnlineMsg();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1: {
                        message.chatType = reader.int32();
                        break;
                    }
                case 2: {
                        message.messageInfo = $root.chat.MessageInfo.decode(reader, reader.uint32());
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a PushOnlineMsg message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof chat.PushOnlineMsg
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {chat.PushOnlineMsg} PushOnlineMsg
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        PushOnlineMsg.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a PushOnlineMsg message.
         * @function verify
         * @memberof chat.PushOnlineMsg
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        PushOnlineMsg.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.chatType != null && message.hasOwnProperty("chatType"))
                if (!$util.isInteger(message.chatType))
                    return "chatType: integer expected";
            if (message.messageInfo != null && message.hasOwnProperty("messageInfo")) {
                let error = $root.chat.MessageInfo.verify(message.messageInfo);
                if (error)
                    return "messageInfo." + error;
            }
            return null;
        };

        /**
         * Creates a PushOnlineMsg message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof chat.PushOnlineMsg
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {chat.PushOnlineMsg} PushOnlineMsg
         */
        PushOnlineMsg.fromObject = function fromObject(object) {
            if (object instanceof $root.chat.PushOnlineMsg)
                return object;
            let message = new $root.chat.PushOnlineMsg();
            if (object.chatType != null)
                message.chatType = object.chatType | 0;
            if (object.messageInfo != null) {
                if (typeof object.messageInfo !== "object")
                    throw TypeError(".chat.PushOnlineMsg.messageInfo: object expected");
                message.messageInfo = $root.chat.MessageInfo.fromObject(object.messageInfo);
            }
            return message;
        };

        /**
         * Creates a plain object from a PushOnlineMsg message. Also converts values to other types if specified.
         * @function toObject
         * @memberof chat.PushOnlineMsg
         * @static
         * @param {chat.PushOnlineMsg} message PushOnlineMsg
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        PushOnlineMsg.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.chatType = 0;
                object.messageInfo = null;
            }
            if (message.chatType != null && message.hasOwnProperty("chatType"))
                object.chatType = message.chatType;
            if (message.messageInfo != null && message.hasOwnProperty("messageInfo"))
                object.messageInfo = $root.chat.MessageInfo.toObject(message.messageInfo, options);
            return object;
        };

        /**
         * Converts this PushOnlineMsg to JSON.
         * @function toJSON
         * @memberof chat.PushOnlineMsg
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        PushOnlineMsg.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for PushOnlineMsg
         * @function getTypeUrl
         * @memberof chat.PushOnlineMsg
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        PushOnlineMsg.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/chat.PushOnlineMsg";
        };

        return PushOnlineMsg;
    })();

    chat.PullChatsMaxSeqRequest = (function() {

        /**
         * Properties of a PullChatsMaxSeqRequest.
         * @memberof chat
         * @interface IPullChatsMaxSeqRequest
         * @property {Array.<string>|null} [chatIds] PullChatsMaxSeqRequest chatIds
         */

        /**
         * Constructs a new PullChatsMaxSeqRequest.
         * @memberof chat
         * @classdesc Represents a PullChatsMaxSeqRequest.
         * @implements IPullChatsMaxSeqRequest
         * @constructor
         * @param {chat.IPullChatsMaxSeqRequest=} [properties] Properties to set
         */
        function PullChatsMaxSeqRequest(properties) {
            this.chatIds = [];
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * PullChatsMaxSeqRequest chatIds.
         * @member {Array.<string>} chatIds
         * @memberof chat.PullChatsMaxSeqRequest
         * @instance
         */
        PullChatsMaxSeqRequest.prototype.chatIds = $util.emptyArray;

        /**
         * Creates a new PullChatsMaxSeqRequest instance using the specified properties.
         * @function create
         * @memberof chat.PullChatsMaxSeqRequest
         * @static
         * @param {chat.IPullChatsMaxSeqRequest=} [properties] Properties to set
         * @returns {chat.PullChatsMaxSeqRequest} PullChatsMaxSeqRequest instance
         */
        PullChatsMaxSeqRequest.create = function create(properties) {
            return new PullChatsMaxSeqRequest(properties);
        };

        /**
         * Encodes the specified PullChatsMaxSeqRequest message. Does not implicitly {@link chat.PullChatsMaxSeqRequest.verify|verify} messages.
         * @function encode
         * @memberof chat.PullChatsMaxSeqRequest
         * @static
         * @param {chat.IPullChatsMaxSeqRequest} message PullChatsMaxSeqRequest message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        PullChatsMaxSeqRequest.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.chatIds != null && message.chatIds.length)
                for (let i = 0; i < message.chatIds.length; ++i)
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.chatIds[i]);
            return writer;
        };

        /**
         * Encodes the specified PullChatsMaxSeqRequest message, length delimited. Does not implicitly {@link chat.PullChatsMaxSeqRequest.verify|verify} messages.
         * @function encodeDelimited
         * @memberof chat.PullChatsMaxSeqRequest
         * @static
         * @param {chat.IPullChatsMaxSeqRequest} message PullChatsMaxSeqRequest message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        PullChatsMaxSeqRequest.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a PullChatsMaxSeqRequest message from the specified reader or buffer.
         * @function decode
         * @memberof chat.PullChatsMaxSeqRequest
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {chat.PullChatsMaxSeqRequest} PullChatsMaxSeqRequest
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        PullChatsMaxSeqRequest.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.chat.PullChatsMaxSeqRequest();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1: {
                        if (!(message.chatIds && message.chatIds.length))
                            message.chatIds = [];
                        message.chatIds.push(reader.string());
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a PullChatsMaxSeqRequest message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof chat.PullChatsMaxSeqRequest
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {chat.PullChatsMaxSeqRequest} PullChatsMaxSeqRequest
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        PullChatsMaxSeqRequest.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a PullChatsMaxSeqRequest message.
         * @function verify
         * @memberof chat.PullChatsMaxSeqRequest
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        PullChatsMaxSeqRequest.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.chatIds != null && message.hasOwnProperty("chatIds")) {
                if (!Array.isArray(message.chatIds))
                    return "chatIds: array expected";
                for (let i = 0; i < message.chatIds.length; ++i)
                    if (!$util.isString(message.chatIds[i]))
                        return "chatIds: string[] expected";
            }
            return null;
        };

        /**
         * Creates a PullChatsMaxSeqRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof chat.PullChatsMaxSeqRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {chat.PullChatsMaxSeqRequest} PullChatsMaxSeqRequest
         */
        PullChatsMaxSeqRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.chat.PullChatsMaxSeqRequest)
                return object;
            let message = new $root.chat.PullChatsMaxSeqRequest();
            if (object.chatIds) {
                if (!Array.isArray(object.chatIds))
                    throw TypeError(".chat.PullChatsMaxSeqRequest.chatIds: array expected");
                message.chatIds = [];
                for (let i = 0; i < object.chatIds.length; ++i)
                    message.chatIds[i] = String(object.chatIds[i]);
            }
            return message;
        };

        /**
         * Creates a plain object from a PullChatsMaxSeqRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof chat.PullChatsMaxSeqRequest
         * @static
         * @param {chat.PullChatsMaxSeqRequest} message PullChatsMaxSeqRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        PullChatsMaxSeqRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.arrays || options.defaults)
                object.chatIds = [];
            if (message.chatIds && message.chatIds.length) {
                object.chatIds = [];
                for (let j = 0; j < message.chatIds.length; ++j)
                    object.chatIds[j] = message.chatIds[j];
            }
            return object;
        };

        /**
         * Converts this PullChatsMaxSeqRequest to JSON.
         * @function toJSON
         * @memberof chat.PullChatsMaxSeqRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        PullChatsMaxSeqRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for PullChatsMaxSeqRequest
         * @function getTypeUrl
         * @memberof chat.PullChatsMaxSeqRequest
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        PullChatsMaxSeqRequest.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/chat.PullChatsMaxSeqRequest";
        };

        return PullChatsMaxSeqRequest;
    })();

    chat.PullChatsMaxSeqResponse = (function() {

        /**
         * Properties of a PullChatsMaxSeqResponse.
         * @memberof chat
         * @interface IPullChatsMaxSeqResponse
         * @property {Object.<string,number|Long>|null} [maxSeqs] PullChatsMaxSeqResponse maxSeqs
         */

        /**
         * Constructs a new PullChatsMaxSeqResponse.
         * @memberof chat
         * @classdesc Represents a PullChatsMaxSeqResponse.
         * @implements IPullChatsMaxSeqResponse
         * @constructor
         * @param {chat.IPullChatsMaxSeqResponse=} [properties] Properties to set
         */
        function PullChatsMaxSeqResponse(properties) {
            this.maxSeqs = {};
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * PullChatsMaxSeqResponse maxSeqs.
         * @member {Object.<string,number|Long>} maxSeqs
         * @memberof chat.PullChatsMaxSeqResponse
         * @instance
         */
        PullChatsMaxSeqResponse.prototype.maxSeqs = $util.emptyObject;

        /**
         * Creates a new PullChatsMaxSeqResponse instance using the specified properties.
         * @function create
         * @memberof chat.PullChatsMaxSeqResponse
         * @static
         * @param {chat.IPullChatsMaxSeqResponse=} [properties] Properties to set
         * @returns {chat.PullChatsMaxSeqResponse} PullChatsMaxSeqResponse instance
         */
        PullChatsMaxSeqResponse.create = function create(properties) {
            return new PullChatsMaxSeqResponse(properties);
        };

        /**
         * Encodes the specified PullChatsMaxSeqResponse message. Does not implicitly {@link chat.PullChatsMaxSeqResponse.verify|verify} messages.
         * @function encode
         * @memberof chat.PullChatsMaxSeqResponse
         * @static
         * @param {chat.IPullChatsMaxSeqResponse} message PullChatsMaxSeqResponse message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        PullChatsMaxSeqResponse.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.maxSeqs != null && Object.hasOwnProperty.call(message, "maxSeqs"))
                for (let keys = Object.keys(message.maxSeqs), i = 0; i < keys.length; ++i)
                    writer.uint32(/* id 1, wireType 2 =*/10).fork().uint32(/* id 1, wireType 2 =*/10).string(keys[i]).uint32(/* id 2, wireType 0 =*/16).int64(message.maxSeqs[keys[i]]).ldelim();
            return writer;
        };

        /**
         * Encodes the specified PullChatsMaxSeqResponse message, length delimited. Does not implicitly {@link chat.PullChatsMaxSeqResponse.verify|verify} messages.
         * @function encodeDelimited
         * @memberof chat.PullChatsMaxSeqResponse
         * @static
         * @param {chat.IPullChatsMaxSeqResponse} message PullChatsMaxSeqResponse message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        PullChatsMaxSeqResponse.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a PullChatsMaxSeqResponse message from the specified reader or buffer.
         * @function decode
         * @memberof chat.PullChatsMaxSeqResponse
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {chat.PullChatsMaxSeqResponse} PullChatsMaxSeqResponse
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        PullChatsMaxSeqResponse.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.chat.PullChatsMaxSeqResponse(), key, value;
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1: {
                        if (message.maxSeqs === $util.emptyObject)
                            message.maxSeqs = {};
                        let end2 = reader.uint32() + reader.pos;
                        key = "";
                        value = 0;
                        while (reader.pos < end2) {
                            let tag2 = reader.uint32();
                            switch (tag2 >>> 3) {
                            case 1:
                                key = reader.string();
                                break;
                            case 2:
                                value = reader.int64();
                                break;
                            default:
                                reader.skipType(tag2 & 7);
                                break;
                            }
                        }
                        message.maxSeqs[key] = value;
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a PullChatsMaxSeqResponse message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof chat.PullChatsMaxSeqResponse
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {chat.PullChatsMaxSeqResponse} PullChatsMaxSeqResponse
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        PullChatsMaxSeqResponse.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a PullChatsMaxSeqResponse message.
         * @function verify
         * @memberof chat.PullChatsMaxSeqResponse
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        PullChatsMaxSeqResponse.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.maxSeqs != null && message.hasOwnProperty("maxSeqs")) {
                if (!$util.isObject(message.maxSeqs))
                    return "maxSeqs: object expected";
                let key = Object.keys(message.maxSeqs);
                for (let i = 0; i < key.length; ++i)
                    if (!$util.isInteger(message.maxSeqs[key[i]]) && !(message.maxSeqs[key[i]] && $util.isInteger(message.maxSeqs[key[i]].low) && $util.isInteger(message.maxSeqs[key[i]].high)))
                        return "maxSeqs: integer|Long{k:string} expected";
            }
            return null;
        };

        /**
         * Creates a PullChatsMaxSeqResponse message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof chat.PullChatsMaxSeqResponse
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {chat.PullChatsMaxSeqResponse} PullChatsMaxSeqResponse
         */
        PullChatsMaxSeqResponse.fromObject = function fromObject(object) {
            if (object instanceof $root.chat.PullChatsMaxSeqResponse)
                return object;
            let message = new $root.chat.PullChatsMaxSeqResponse();
            if (object.maxSeqs) {
                if (typeof object.maxSeqs !== "object")
                    throw TypeError(".chat.PullChatsMaxSeqResponse.maxSeqs: object expected");
                message.maxSeqs = {};
                for (let keys = Object.keys(object.maxSeqs), i = 0; i < keys.length; ++i)
                    if ($util.Long)
                        (message.maxSeqs[keys[i]] = $util.Long.fromValue(object.maxSeqs[keys[i]])).unsigned = false;
                    else if (typeof object.maxSeqs[keys[i]] === "string")
                        message.maxSeqs[keys[i]] = parseInt(object.maxSeqs[keys[i]], 10);
                    else if (typeof object.maxSeqs[keys[i]] === "number")
                        message.maxSeqs[keys[i]] = object.maxSeqs[keys[i]];
                    else if (typeof object.maxSeqs[keys[i]] === "object")
                        message.maxSeqs[keys[i]] = new $util.LongBits(object.maxSeqs[keys[i]].low >>> 0, object.maxSeqs[keys[i]].high >>> 0).toNumber();
            }
            return message;
        };

        /**
         * Creates a plain object from a PullChatsMaxSeqResponse message. Also converts values to other types if specified.
         * @function toObject
         * @memberof chat.PullChatsMaxSeqResponse
         * @static
         * @param {chat.PullChatsMaxSeqResponse} message PullChatsMaxSeqResponse
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        PullChatsMaxSeqResponse.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.objects || options.defaults)
                object.maxSeqs = {};
            let keys2;
            if (message.maxSeqs && (keys2 = Object.keys(message.maxSeqs)).length) {
                object.maxSeqs = {};
                for (let j = 0; j < keys2.length; ++j)
                    if (typeof message.maxSeqs[keys2[j]] === "number")
                        object.maxSeqs[keys2[j]] = options.longs === String ? String(message.maxSeqs[keys2[j]]) : message.maxSeqs[keys2[j]];
                    else
                        object.maxSeqs[keys2[j]] = options.longs === String ? $util.Long.prototype.toString.call(message.maxSeqs[keys2[j]]) : options.longs === Number ? new $util.LongBits(message.maxSeqs[keys2[j]].low >>> 0, message.maxSeqs[keys2[j]].high >>> 0).toNumber() : message.maxSeqs[keys2[j]];
            }
            return object;
        };

        /**
         * Converts this PullChatsMaxSeqResponse to JSON.
         * @function toJSON
         * @memberof chat.PullChatsMaxSeqResponse
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        PullChatsMaxSeqResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for PullChatsMaxSeqResponse
         * @function getTypeUrl
         * @memberof chat.PullChatsMaxSeqResponse
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        PullChatsMaxSeqResponse.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/chat.PullChatsMaxSeqResponse";
        };

        return PullChatsMaxSeqResponse;
    })();

    chat.PullMsgsBySeqRangesRequest = (function() {

        /**
         * Properties of a PullMsgsBySeqRangesRequest.
         * @memberof chat
         * @interface IPullMsgsBySeqRangesRequest
         * @property {Array.<chat.IChatSeqRange>|null} [chatSeqs] PullMsgsBySeqRangesRequest chatSeqs
         */

        /**
         * Constructs a new PullMsgsBySeqRangesRequest.
         * @memberof chat
         * @classdesc Represents a PullMsgsBySeqRangesRequest.
         * @implements IPullMsgsBySeqRangesRequest
         * @constructor
         * @param {chat.IPullMsgsBySeqRangesRequest=} [properties] Properties to set
         */
        function PullMsgsBySeqRangesRequest(properties) {
            this.chatSeqs = [];
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * PullMsgsBySeqRangesRequest chatSeqs.
         * @member {Array.<chat.IChatSeqRange>} chatSeqs
         * @memberof chat.PullMsgsBySeqRangesRequest
         * @instance
         */
        PullMsgsBySeqRangesRequest.prototype.chatSeqs = $util.emptyArray;

        /**
         * Creates a new PullMsgsBySeqRangesRequest instance using the specified properties.
         * @function create
         * @memberof chat.PullMsgsBySeqRangesRequest
         * @static
         * @param {chat.IPullMsgsBySeqRangesRequest=} [properties] Properties to set
         * @returns {chat.PullMsgsBySeqRangesRequest} PullMsgsBySeqRangesRequest instance
         */
        PullMsgsBySeqRangesRequest.create = function create(properties) {
            return new PullMsgsBySeqRangesRequest(properties);
        };

        /**
         * Encodes the specified PullMsgsBySeqRangesRequest message. Does not implicitly {@link chat.PullMsgsBySeqRangesRequest.verify|verify} messages.
         * @function encode
         * @memberof chat.PullMsgsBySeqRangesRequest
         * @static
         * @param {chat.IPullMsgsBySeqRangesRequest} message PullMsgsBySeqRangesRequest message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        PullMsgsBySeqRangesRequest.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.chatSeqs != null && message.chatSeqs.length)
                for (let i = 0; i < message.chatSeqs.length; ++i)
                    $root.chat.ChatSeqRange.encode(message.chatSeqs[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified PullMsgsBySeqRangesRequest message, length delimited. Does not implicitly {@link chat.PullMsgsBySeqRangesRequest.verify|verify} messages.
         * @function encodeDelimited
         * @memberof chat.PullMsgsBySeqRangesRequest
         * @static
         * @param {chat.IPullMsgsBySeqRangesRequest} message PullMsgsBySeqRangesRequest message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        PullMsgsBySeqRangesRequest.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a PullMsgsBySeqRangesRequest message from the specified reader or buffer.
         * @function decode
         * @memberof chat.PullMsgsBySeqRangesRequest
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {chat.PullMsgsBySeqRangesRequest} PullMsgsBySeqRangesRequest
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        PullMsgsBySeqRangesRequest.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.chat.PullMsgsBySeqRangesRequest();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1: {
                        if (!(message.chatSeqs && message.chatSeqs.length))
                            message.chatSeqs = [];
                        message.chatSeqs.push($root.chat.ChatSeqRange.decode(reader, reader.uint32()));
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a PullMsgsBySeqRangesRequest message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof chat.PullMsgsBySeqRangesRequest
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {chat.PullMsgsBySeqRangesRequest} PullMsgsBySeqRangesRequest
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        PullMsgsBySeqRangesRequest.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a PullMsgsBySeqRangesRequest message.
         * @function verify
         * @memberof chat.PullMsgsBySeqRangesRequest
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        PullMsgsBySeqRangesRequest.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.chatSeqs != null && message.hasOwnProperty("chatSeqs")) {
                if (!Array.isArray(message.chatSeqs))
                    return "chatSeqs: array expected";
                for (let i = 0; i < message.chatSeqs.length; ++i) {
                    let error = $root.chat.ChatSeqRange.verify(message.chatSeqs[i]);
                    if (error)
                        return "chatSeqs." + error;
                }
            }
            return null;
        };

        /**
         * Creates a PullMsgsBySeqRangesRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof chat.PullMsgsBySeqRangesRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {chat.PullMsgsBySeqRangesRequest} PullMsgsBySeqRangesRequest
         */
        PullMsgsBySeqRangesRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.chat.PullMsgsBySeqRangesRequest)
                return object;
            let message = new $root.chat.PullMsgsBySeqRangesRequest();
            if (object.chatSeqs) {
                if (!Array.isArray(object.chatSeqs))
                    throw TypeError(".chat.PullMsgsBySeqRangesRequest.chatSeqs: array expected");
                message.chatSeqs = [];
                for (let i = 0; i < object.chatSeqs.length; ++i) {
                    if (typeof object.chatSeqs[i] !== "object")
                        throw TypeError(".chat.PullMsgsBySeqRangesRequest.chatSeqs: object expected");
                    message.chatSeqs[i] = $root.chat.ChatSeqRange.fromObject(object.chatSeqs[i]);
                }
            }
            return message;
        };

        /**
         * Creates a plain object from a PullMsgsBySeqRangesRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof chat.PullMsgsBySeqRangesRequest
         * @static
         * @param {chat.PullMsgsBySeqRangesRequest} message PullMsgsBySeqRangesRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        PullMsgsBySeqRangesRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.arrays || options.defaults)
                object.chatSeqs = [];
            if (message.chatSeqs && message.chatSeqs.length) {
                object.chatSeqs = [];
                for (let j = 0; j < message.chatSeqs.length; ++j)
                    object.chatSeqs[j] = $root.chat.ChatSeqRange.toObject(message.chatSeqs[j], options);
            }
            return object;
        };

        /**
         * Converts this PullMsgsBySeqRangesRequest to JSON.
         * @function toJSON
         * @memberof chat.PullMsgsBySeqRangesRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        PullMsgsBySeqRangesRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for PullMsgsBySeqRangesRequest
         * @function getTypeUrl
         * @memberof chat.PullMsgsBySeqRangesRequest
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        PullMsgsBySeqRangesRequest.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/chat.PullMsgsBySeqRangesRequest";
        };

        return PullMsgsBySeqRangesRequest;
    })();

    chat.ChatSeqRange = (function() {

        /**
         * Properties of a ChatSeqRange.
         * @memberof chat
         * @interface IChatSeqRange
         * @property {string|null} [chatId] ChatSeqRange chatId
         * @property {number|Long|null} [seqStart] ChatSeqRange seqStart
         * @property {number|Long|null} [seqEnd] ChatSeqRange seqEnd
         */

        /**
         * Constructs a new ChatSeqRange.
         * @memberof chat
         * @classdesc Represents a ChatSeqRange.
         * @implements IChatSeqRange
         * @constructor
         * @param {chat.IChatSeqRange=} [properties] Properties to set
         */
        function ChatSeqRange(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ChatSeqRange chatId.
         * @member {string} chatId
         * @memberof chat.ChatSeqRange
         * @instance
         */
        ChatSeqRange.prototype.chatId = "";

        /**
         * ChatSeqRange seqStart.
         * @member {number|Long} seqStart
         * @memberof chat.ChatSeqRange
         * @instance
         */
        ChatSeqRange.prototype.seqStart = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * ChatSeqRange seqEnd.
         * @member {number|Long} seqEnd
         * @memberof chat.ChatSeqRange
         * @instance
         */
        ChatSeqRange.prototype.seqEnd = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * Creates a new ChatSeqRange instance using the specified properties.
         * @function create
         * @memberof chat.ChatSeqRange
         * @static
         * @param {chat.IChatSeqRange=} [properties] Properties to set
         * @returns {chat.ChatSeqRange} ChatSeqRange instance
         */
        ChatSeqRange.create = function create(properties) {
            return new ChatSeqRange(properties);
        };

        /**
         * Encodes the specified ChatSeqRange message. Does not implicitly {@link chat.ChatSeqRange.verify|verify} messages.
         * @function encode
         * @memberof chat.ChatSeqRange
         * @static
         * @param {chat.IChatSeqRange} message ChatSeqRange message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ChatSeqRange.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.chatId != null && Object.hasOwnProperty.call(message, "chatId"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.chatId);
            if (message.seqStart != null && Object.hasOwnProperty.call(message, "seqStart"))
                writer.uint32(/* id 2, wireType 0 =*/16).int64(message.seqStart);
            if (message.seqEnd != null && Object.hasOwnProperty.call(message, "seqEnd"))
                writer.uint32(/* id 3, wireType 0 =*/24).int64(message.seqEnd);
            return writer;
        };

        /**
         * Encodes the specified ChatSeqRange message, length delimited. Does not implicitly {@link chat.ChatSeqRange.verify|verify} messages.
         * @function encodeDelimited
         * @memberof chat.ChatSeqRange
         * @static
         * @param {chat.IChatSeqRange} message ChatSeqRange message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ChatSeqRange.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a ChatSeqRange message from the specified reader or buffer.
         * @function decode
         * @memberof chat.ChatSeqRange
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {chat.ChatSeqRange} ChatSeqRange
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ChatSeqRange.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.chat.ChatSeqRange();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1: {
                        message.chatId = reader.string();
                        break;
                    }
                case 2: {
                        message.seqStart = reader.int64();
                        break;
                    }
                case 3: {
                        message.seqEnd = reader.int64();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a ChatSeqRange message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof chat.ChatSeqRange
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {chat.ChatSeqRange} ChatSeqRange
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ChatSeqRange.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a ChatSeqRange message.
         * @function verify
         * @memberof chat.ChatSeqRange
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        ChatSeqRange.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.chatId != null && message.hasOwnProperty("chatId"))
                if (!$util.isString(message.chatId))
                    return "chatId: string expected";
            if (message.seqStart != null && message.hasOwnProperty("seqStart"))
                if (!$util.isInteger(message.seqStart) && !(message.seqStart && $util.isInteger(message.seqStart.low) && $util.isInteger(message.seqStart.high)))
                    return "seqStart: integer|Long expected";
            if (message.seqEnd != null && message.hasOwnProperty("seqEnd"))
                if (!$util.isInteger(message.seqEnd) && !(message.seqEnd && $util.isInteger(message.seqEnd.low) && $util.isInteger(message.seqEnd.high)))
                    return "seqEnd: integer|Long expected";
            return null;
        };

        /**
         * Creates a ChatSeqRange message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof chat.ChatSeqRange
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {chat.ChatSeqRange} ChatSeqRange
         */
        ChatSeqRange.fromObject = function fromObject(object) {
            if (object instanceof $root.chat.ChatSeqRange)
                return object;
            let message = new $root.chat.ChatSeqRange();
            if (object.chatId != null)
                message.chatId = String(object.chatId);
            if (object.seqStart != null)
                if ($util.Long)
                    (message.seqStart = $util.Long.fromValue(object.seqStart)).unsigned = false;
                else if (typeof object.seqStart === "string")
                    message.seqStart = parseInt(object.seqStart, 10);
                else if (typeof object.seqStart === "number")
                    message.seqStart = object.seqStart;
                else if (typeof object.seqStart === "object")
                    message.seqStart = new $util.LongBits(object.seqStart.low >>> 0, object.seqStart.high >>> 0).toNumber();
            if (object.seqEnd != null)
                if ($util.Long)
                    (message.seqEnd = $util.Long.fromValue(object.seqEnd)).unsigned = false;
                else if (typeof object.seqEnd === "string")
                    message.seqEnd = parseInt(object.seqEnd, 10);
                else if (typeof object.seqEnd === "number")
                    message.seqEnd = object.seqEnd;
                else if (typeof object.seqEnd === "object")
                    message.seqEnd = new $util.LongBits(object.seqEnd.low >>> 0, object.seqEnd.high >>> 0).toNumber();
            return message;
        };

        /**
         * Creates a plain object from a ChatSeqRange message. Also converts values to other types if specified.
         * @function toObject
         * @memberof chat.ChatSeqRange
         * @static
         * @param {chat.ChatSeqRange} message ChatSeqRange
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ChatSeqRange.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.chatId = "";
                if ($util.Long) {
                    let long = new $util.Long(0, 0, false);
                    object.seqStart = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.seqStart = options.longs === String ? "0" : 0;
                if ($util.Long) {
                    let long = new $util.Long(0, 0, false);
                    object.seqEnd = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.seqEnd = options.longs === String ? "0" : 0;
            }
            if (message.chatId != null && message.hasOwnProperty("chatId"))
                object.chatId = message.chatId;
            if (message.seqStart != null && message.hasOwnProperty("seqStart"))
                if (typeof message.seqStart === "number")
                    object.seqStart = options.longs === String ? String(message.seqStart) : message.seqStart;
                else
                    object.seqStart = options.longs === String ? $util.Long.prototype.toString.call(message.seqStart) : options.longs === Number ? new $util.LongBits(message.seqStart.low >>> 0, message.seqStart.high >>> 0).toNumber() : message.seqStart;
            if (message.seqEnd != null && message.hasOwnProperty("seqEnd"))
                if (typeof message.seqEnd === "number")
                    object.seqEnd = options.longs === String ? String(message.seqEnd) : message.seqEnd;
                else
                    object.seqEnd = options.longs === String ? $util.Long.prototype.toString.call(message.seqEnd) : options.longs === Number ? new $util.LongBits(message.seqEnd.low >>> 0, message.seqEnd.high >>> 0).toNumber() : message.seqEnd;
            return object;
        };

        /**
         * Converts this ChatSeqRange to JSON.
         * @function toJSON
         * @memberof chat.ChatSeqRange
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ChatSeqRange.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for ChatSeqRange
         * @function getTypeUrl
         * @memberof chat.ChatSeqRange
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        ChatSeqRange.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/chat.ChatSeqRange";
        };

        return ChatSeqRange;
    })();

    chat.MessageInfoList = (function() {

        /**
         * Properties of a MessageInfoList.
         * @memberof chat
         * @interface IMessageInfoList
         * @property {Array.<chat.IMessageInfo>|null} [items] MessageInfoList items
         * @property {string|null} [chatId] MessageInfoList chatId
         */

        /**
         * Constructs a new MessageInfoList.
         * @memberof chat
         * @classdesc Represents a MessageInfoList.
         * @implements IMessageInfoList
         * @constructor
         * @param {chat.IMessageInfoList=} [properties] Properties to set
         */
        function MessageInfoList(properties) {
            this.items = [];
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * MessageInfoList items.
         * @member {Array.<chat.IMessageInfo>} items
         * @memberof chat.MessageInfoList
         * @instance
         */
        MessageInfoList.prototype.items = $util.emptyArray;

        /**
         * MessageInfoList chatId.
         * @member {string} chatId
         * @memberof chat.MessageInfoList
         * @instance
         */
        MessageInfoList.prototype.chatId = "";

        /**
         * Creates a new MessageInfoList instance using the specified properties.
         * @function create
         * @memberof chat.MessageInfoList
         * @static
         * @param {chat.IMessageInfoList=} [properties] Properties to set
         * @returns {chat.MessageInfoList} MessageInfoList instance
         */
        MessageInfoList.create = function create(properties) {
            return new MessageInfoList(properties);
        };

        /**
         * Encodes the specified MessageInfoList message. Does not implicitly {@link chat.MessageInfoList.verify|verify} messages.
         * @function encode
         * @memberof chat.MessageInfoList
         * @static
         * @param {chat.IMessageInfoList} message MessageInfoList message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        MessageInfoList.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.items != null && message.items.length)
                for (let i = 0; i < message.items.length; ++i)
                    $root.chat.MessageInfo.encode(message.items[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
            if (message.chatId != null && Object.hasOwnProperty.call(message, "chatId"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.chatId);
            return writer;
        };

        /**
         * Encodes the specified MessageInfoList message, length delimited. Does not implicitly {@link chat.MessageInfoList.verify|verify} messages.
         * @function encodeDelimited
         * @memberof chat.MessageInfoList
         * @static
         * @param {chat.IMessageInfoList} message MessageInfoList message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        MessageInfoList.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a MessageInfoList message from the specified reader or buffer.
         * @function decode
         * @memberof chat.MessageInfoList
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {chat.MessageInfoList} MessageInfoList
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        MessageInfoList.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.chat.MessageInfoList();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1: {
                        if (!(message.items && message.items.length))
                            message.items = [];
                        message.items.push($root.chat.MessageInfo.decode(reader, reader.uint32()));
                        break;
                    }
                case 2: {
                        message.chatId = reader.string();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a MessageInfoList message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof chat.MessageInfoList
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {chat.MessageInfoList} MessageInfoList
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        MessageInfoList.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a MessageInfoList message.
         * @function verify
         * @memberof chat.MessageInfoList
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        MessageInfoList.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.items != null && message.hasOwnProperty("items")) {
                if (!Array.isArray(message.items))
                    return "items: array expected";
                for (let i = 0; i < message.items.length; ++i) {
                    let error = $root.chat.MessageInfo.verify(message.items[i]);
                    if (error)
                        return "items." + error;
                }
            }
            if (message.chatId != null && message.hasOwnProperty("chatId"))
                if (!$util.isString(message.chatId))
                    return "chatId: string expected";
            return null;
        };

        /**
         * Creates a MessageInfoList message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof chat.MessageInfoList
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {chat.MessageInfoList} MessageInfoList
         */
        MessageInfoList.fromObject = function fromObject(object) {
            if (object instanceof $root.chat.MessageInfoList)
                return object;
            let message = new $root.chat.MessageInfoList();
            if (object.items) {
                if (!Array.isArray(object.items))
                    throw TypeError(".chat.MessageInfoList.items: array expected");
                message.items = [];
                for (let i = 0; i < object.items.length; ++i) {
                    if (typeof object.items[i] !== "object")
                        throw TypeError(".chat.MessageInfoList.items: object expected");
                    message.items[i] = $root.chat.MessageInfo.fromObject(object.items[i]);
                }
            }
            if (object.chatId != null)
                message.chatId = String(object.chatId);
            return message;
        };

        /**
         * Creates a plain object from a MessageInfoList message. Also converts values to other types if specified.
         * @function toObject
         * @memberof chat.MessageInfoList
         * @static
         * @param {chat.MessageInfoList} message MessageInfoList
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        MessageInfoList.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.arrays || options.defaults)
                object.items = [];
            if (options.defaults)
                object.chatId = "";
            if (message.items && message.items.length) {
                object.items = [];
                for (let j = 0; j < message.items.length; ++j)
                    object.items[j] = $root.chat.MessageInfo.toObject(message.items[j], options);
            }
            if (message.chatId != null && message.hasOwnProperty("chatId"))
                object.chatId = message.chatId;
            return object;
        };

        /**
         * Converts this MessageInfoList to JSON.
         * @function toJSON
         * @memberof chat.MessageInfoList
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        MessageInfoList.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for MessageInfoList
         * @function getTypeUrl
         * @memberof chat.MessageInfoList
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        MessageInfoList.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/chat.MessageInfoList";
        };

        return MessageInfoList;
    })();

    chat.PullMsgsBySeqRangesResponse = (function() {

        /**
         * Properties of a PullMsgsBySeqRangesResponse.
         * @memberof chat
         * @interface IPullMsgsBySeqRangesResponse
         * @property {Array.<chat.IMessageInfoList>|null} [msgInfos] PullMsgsBySeqRangesResponse msgInfos
         */

        /**
         * Constructs a new PullMsgsBySeqRangesResponse.
         * @memberof chat
         * @classdesc Represents a PullMsgsBySeqRangesResponse.
         * @implements IPullMsgsBySeqRangesResponse
         * @constructor
         * @param {chat.IPullMsgsBySeqRangesResponse=} [properties] Properties to set
         */
        function PullMsgsBySeqRangesResponse(properties) {
            this.msgInfos = [];
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * PullMsgsBySeqRangesResponse msgInfos.
         * @member {Array.<chat.IMessageInfoList>} msgInfos
         * @memberof chat.PullMsgsBySeqRangesResponse
         * @instance
         */
        PullMsgsBySeqRangesResponse.prototype.msgInfos = $util.emptyArray;

        /**
         * Creates a new PullMsgsBySeqRangesResponse instance using the specified properties.
         * @function create
         * @memberof chat.PullMsgsBySeqRangesResponse
         * @static
         * @param {chat.IPullMsgsBySeqRangesResponse=} [properties] Properties to set
         * @returns {chat.PullMsgsBySeqRangesResponse} PullMsgsBySeqRangesResponse instance
         */
        PullMsgsBySeqRangesResponse.create = function create(properties) {
            return new PullMsgsBySeqRangesResponse(properties);
        };

        /**
         * Encodes the specified PullMsgsBySeqRangesResponse message. Does not implicitly {@link chat.PullMsgsBySeqRangesResponse.verify|verify} messages.
         * @function encode
         * @memberof chat.PullMsgsBySeqRangesResponse
         * @static
         * @param {chat.IPullMsgsBySeqRangesResponse} message PullMsgsBySeqRangesResponse message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        PullMsgsBySeqRangesResponse.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.msgInfos != null && message.msgInfos.length)
                for (let i = 0; i < message.msgInfos.length; ++i)
                    $root.chat.MessageInfoList.encode(message.msgInfos[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified PullMsgsBySeqRangesResponse message, length delimited. Does not implicitly {@link chat.PullMsgsBySeqRangesResponse.verify|verify} messages.
         * @function encodeDelimited
         * @memberof chat.PullMsgsBySeqRangesResponse
         * @static
         * @param {chat.IPullMsgsBySeqRangesResponse} message PullMsgsBySeqRangesResponse message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        PullMsgsBySeqRangesResponse.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a PullMsgsBySeqRangesResponse message from the specified reader or buffer.
         * @function decode
         * @memberof chat.PullMsgsBySeqRangesResponse
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {chat.PullMsgsBySeqRangesResponse} PullMsgsBySeqRangesResponse
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        PullMsgsBySeqRangesResponse.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.chat.PullMsgsBySeqRangesResponse();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1: {
                        if (!(message.msgInfos && message.msgInfos.length))
                            message.msgInfos = [];
                        message.msgInfos.push($root.chat.MessageInfoList.decode(reader, reader.uint32()));
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a PullMsgsBySeqRangesResponse message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof chat.PullMsgsBySeqRangesResponse
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {chat.PullMsgsBySeqRangesResponse} PullMsgsBySeqRangesResponse
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        PullMsgsBySeqRangesResponse.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a PullMsgsBySeqRangesResponse message.
         * @function verify
         * @memberof chat.PullMsgsBySeqRangesResponse
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        PullMsgsBySeqRangesResponse.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.msgInfos != null && message.hasOwnProperty("msgInfos")) {
                if (!Array.isArray(message.msgInfos))
                    return "msgInfos: array expected";
                for (let i = 0; i < message.msgInfos.length; ++i) {
                    let error = $root.chat.MessageInfoList.verify(message.msgInfos[i]);
                    if (error)
                        return "msgInfos." + error;
                }
            }
            return null;
        };

        /**
         * Creates a PullMsgsBySeqRangesResponse message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof chat.PullMsgsBySeqRangesResponse
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {chat.PullMsgsBySeqRangesResponse} PullMsgsBySeqRangesResponse
         */
        PullMsgsBySeqRangesResponse.fromObject = function fromObject(object) {
            if (object instanceof $root.chat.PullMsgsBySeqRangesResponse)
                return object;
            let message = new $root.chat.PullMsgsBySeqRangesResponse();
            if (object.msgInfos) {
                if (!Array.isArray(object.msgInfos))
                    throw TypeError(".chat.PullMsgsBySeqRangesResponse.msgInfos: array expected");
                message.msgInfos = [];
                for (let i = 0; i < object.msgInfos.length; ++i) {
                    if (typeof object.msgInfos[i] !== "object")
                        throw TypeError(".chat.PullMsgsBySeqRangesResponse.msgInfos: object expected");
                    message.msgInfos[i] = $root.chat.MessageInfoList.fromObject(object.msgInfos[i]);
                }
            }
            return message;
        };

        /**
         * Creates a plain object from a PullMsgsBySeqRangesResponse message. Also converts values to other types if specified.
         * @function toObject
         * @memberof chat.PullMsgsBySeqRangesResponse
         * @static
         * @param {chat.PullMsgsBySeqRangesResponse} message PullMsgsBySeqRangesResponse
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        PullMsgsBySeqRangesResponse.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.arrays || options.defaults)
                object.msgInfos = [];
            if (message.msgInfos && message.msgInfos.length) {
                object.msgInfos = [];
                for (let j = 0; j < message.msgInfos.length; ++j)
                    object.msgInfos[j] = $root.chat.MessageInfoList.toObject(message.msgInfos[j], options);
            }
            return object;
        };

        /**
         * Converts this PullMsgsBySeqRangesResponse to JSON.
         * @function toJSON
         * @memberof chat.PullMsgsBySeqRangesResponse
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        PullMsgsBySeqRangesResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for PullMsgsBySeqRangesResponse
         * @function getTypeUrl
         * @memberof chat.PullMsgsBySeqRangesResponse
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        PullMsgsBySeqRangesResponse.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/chat.PullMsgsBySeqRangesResponse";
        };

        return PullMsgsBySeqRangesResponse;
    })();

    chat.PullMsgsBySeqsRequest = (function() {

        /**
         * Properties of a PullMsgsBySeqsRequest.
         * @memberof chat
         * @interface IPullMsgsBySeqsRequest
         * @property {Array.<chat.IChatSeq>|null} [chatSeqs] PullMsgsBySeqsRequest chatSeqs
         */

        /**
         * Constructs a new PullMsgsBySeqsRequest.
         * @memberof chat
         * @classdesc Represents a PullMsgsBySeqsRequest.
         * @implements IPullMsgsBySeqsRequest
         * @constructor
         * @param {chat.IPullMsgsBySeqsRequest=} [properties] Properties to set
         */
        function PullMsgsBySeqsRequest(properties) {
            this.chatSeqs = [];
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * PullMsgsBySeqsRequest chatSeqs.
         * @member {Array.<chat.IChatSeq>} chatSeqs
         * @memberof chat.PullMsgsBySeqsRequest
         * @instance
         */
        PullMsgsBySeqsRequest.prototype.chatSeqs = $util.emptyArray;

        /**
         * Creates a new PullMsgsBySeqsRequest instance using the specified properties.
         * @function create
         * @memberof chat.PullMsgsBySeqsRequest
         * @static
         * @param {chat.IPullMsgsBySeqsRequest=} [properties] Properties to set
         * @returns {chat.PullMsgsBySeqsRequest} PullMsgsBySeqsRequest instance
         */
        PullMsgsBySeqsRequest.create = function create(properties) {
            return new PullMsgsBySeqsRequest(properties);
        };

        /**
         * Encodes the specified PullMsgsBySeqsRequest message. Does not implicitly {@link chat.PullMsgsBySeqsRequest.verify|verify} messages.
         * @function encode
         * @memberof chat.PullMsgsBySeqsRequest
         * @static
         * @param {chat.IPullMsgsBySeqsRequest} message PullMsgsBySeqsRequest message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        PullMsgsBySeqsRequest.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.chatSeqs != null && message.chatSeqs.length)
                for (let i = 0; i < message.chatSeqs.length; ++i)
                    $root.chat.ChatSeq.encode(message.chatSeqs[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified PullMsgsBySeqsRequest message, length delimited. Does not implicitly {@link chat.PullMsgsBySeqsRequest.verify|verify} messages.
         * @function encodeDelimited
         * @memberof chat.PullMsgsBySeqsRequest
         * @static
         * @param {chat.IPullMsgsBySeqsRequest} message PullMsgsBySeqsRequest message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        PullMsgsBySeqsRequest.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a PullMsgsBySeqsRequest message from the specified reader or buffer.
         * @function decode
         * @memberof chat.PullMsgsBySeqsRequest
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {chat.PullMsgsBySeqsRequest} PullMsgsBySeqsRequest
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        PullMsgsBySeqsRequest.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.chat.PullMsgsBySeqsRequest();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1: {
                        if (!(message.chatSeqs && message.chatSeqs.length))
                            message.chatSeqs = [];
                        message.chatSeqs.push($root.chat.ChatSeq.decode(reader, reader.uint32()));
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a PullMsgsBySeqsRequest message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof chat.PullMsgsBySeqsRequest
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {chat.PullMsgsBySeqsRequest} PullMsgsBySeqsRequest
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        PullMsgsBySeqsRequest.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a PullMsgsBySeqsRequest message.
         * @function verify
         * @memberof chat.PullMsgsBySeqsRequest
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        PullMsgsBySeqsRequest.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.chatSeqs != null && message.hasOwnProperty("chatSeqs")) {
                if (!Array.isArray(message.chatSeqs))
                    return "chatSeqs: array expected";
                for (let i = 0; i < message.chatSeqs.length; ++i) {
                    let error = $root.chat.ChatSeq.verify(message.chatSeqs[i]);
                    if (error)
                        return "chatSeqs." + error;
                }
            }
            return null;
        };

        /**
         * Creates a PullMsgsBySeqsRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof chat.PullMsgsBySeqsRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {chat.PullMsgsBySeqsRequest} PullMsgsBySeqsRequest
         */
        PullMsgsBySeqsRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.chat.PullMsgsBySeqsRequest)
                return object;
            let message = new $root.chat.PullMsgsBySeqsRequest();
            if (object.chatSeqs) {
                if (!Array.isArray(object.chatSeqs))
                    throw TypeError(".chat.PullMsgsBySeqsRequest.chatSeqs: array expected");
                message.chatSeqs = [];
                for (let i = 0; i < object.chatSeqs.length; ++i) {
                    if (typeof object.chatSeqs[i] !== "object")
                        throw TypeError(".chat.PullMsgsBySeqsRequest.chatSeqs: object expected");
                    message.chatSeqs[i] = $root.chat.ChatSeq.fromObject(object.chatSeqs[i]);
                }
            }
            return message;
        };

        /**
         * Creates a plain object from a PullMsgsBySeqsRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof chat.PullMsgsBySeqsRequest
         * @static
         * @param {chat.PullMsgsBySeqsRequest} message PullMsgsBySeqsRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        PullMsgsBySeqsRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.arrays || options.defaults)
                object.chatSeqs = [];
            if (message.chatSeqs && message.chatSeqs.length) {
                object.chatSeqs = [];
                for (let j = 0; j < message.chatSeqs.length; ++j)
                    object.chatSeqs[j] = $root.chat.ChatSeq.toObject(message.chatSeqs[j], options);
            }
            return object;
        };

        /**
         * Converts this PullMsgsBySeqsRequest to JSON.
         * @function toJSON
         * @memberof chat.PullMsgsBySeqsRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        PullMsgsBySeqsRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for PullMsgsBySeqsRequest
         * @function getTypeUrl
         * @memberof chat.PullMsgsBySeqsRequest
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        PullMsgsBySeqsRequest.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/chat.PullMsgsBySeqsRequest";
        };

        return PullMsgsBySeqsRequest;
    })();

    chat.PullMsgsBySeqsResponse = (function() {

        /**
         * Properties of a PullMsgsBySeqsResponse.
         * @memberof chat
         * @interface IPullMsgsBySeqsResponse
         * @property {Array.<chat.IMessageInfoList>|null} [msgInfos] PullMsgsBySeqsResponse msgInfos
         */

        /**
         * Constructs a new PullMsgsBySeqsResponse.
         * @memberof chat
         * @classdesc Represents a PullMsgsBySeqsResponse.
         * @implements IPullMsgsBySeqsResponse
         * @constructor
         * @param {chat.IPullMsgsBySeqsResponse=} [properties] Properties to set
         */
        function PullMsgsBySeqsResponse(properties) {
            this.msgInfos = [];
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * PullMsgsBySeqsResponse msgInfos.
         * @member {Array.<chat.IMessageInfoList>} msgInfos
         * @memberof chat.PullMsgsBySeqsResponse
         * @instance
         */
        PullMsgsBySeqsResponse.prototype.msgInfos = $util.emptyArray;

        /**
         * Creates a new PullMsgsBySeqsResponse instance using the specified properties.
         * @function create
         * @memberof chat.PullMsgsBySeqsResponse
         * @static
         * @param {chat.IPullMsgsBySeqsResponse=} [properties] Properties to set
         * @returns {chat.PullMsgsBySeqsResponse} PullMsgsBySeqsResponse instance
         */
        PullMsgsBySeqsResponse.create = function create(properties) {
            return new PullMsgsBySeqsResponse(properties);
        };

        /**
         * Encodes the specified PullMsgsBySeqsResponse message. Does not implicitly {@link chat.PullMsgsBySeqsResponse.verify|verify} messages.
         * @function encode
         * @memberof chat.PullMsgsBySeqsResponse
         * @static
         * @param {chat.IPullMsgsBySeqsResponse} message PullMsgsBySeqsResponse message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        PullMsgsBySeqsResponse.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.msgInfos != null && message.msgInfos.length)
                for (let i = 0; i < message.msgInfos.length; ++i)
                    $root.chat.MessageInfoList.encode(message.msgInfos[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified PullMsgsBySeqsResponse message, length delimited. Does not implicitly {@link chat.PullMsgsBySeqsResponse.verify|verify} messages.
         * @function encodeDelimited
         * @memberof chat.PullMsgsBySeqsResponse
         * @static
         * @param {chat.IPullMsgsBySeqsResponse} message PullMsgsBySeqsResponse message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        PullMsgsBySeqsResponse.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a PullMsgsBySeqsResponse message from the specified reader or buffer.
         * @function decode
         * @memberof chat.PullMsgsBySeqsResponse
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {chat.PullMsgsBySeqsResponse} PullMsgsBySeqsResponse
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        PullMsgsBySeqsResponse.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.chat.PullMsgsBySeqsResponse();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1: {
                        if (!(message.msgInfos && message.msgInfos.length))
                            message.msgInfos = [];
                        message.msgInfos.push($root.chat.MessageInfoList.decode(reader, reader.uint32()));
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a PullMsgsBySeqsResponse message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof chat.PullMsgsBySeqsResponse
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {chat.PullMsgsBySeqsResponse} PullMsgsBySeqsResponse
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        PullMsgsBySeqsResponse.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a PullMsgsBySeqsResponse message.
         * @function verify
         * @memberof chat.PullMsgsBySeqsResponse
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        PullMsgsBySeqsResponse.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.msgInfos != null && message.hasOwnProperty("msgInfos")) {
                if (!Array.isArray(message.msgInfos))
                    return "msgInfos: array expected";
                for (let i = 0; i < message.msgInfos.length; ++i) {
                    let error = $root.chat.MessageInfoList.verify(message.msgInfos[i]);
                    if (error)
                        return "msgInfos." + error;
                }
            }
            return null;
        };

        /**
         * Creates a PullMsgsBySeqsResponse message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof chat.PullMsgsBySeqsResponse
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {chat.PullMsgsBySeqsResponse} PullMsgsBySeqsResponse
         */
        PullMsgsBySeqsResponse.fromObject = function fromObject(object) {
            if (object instanceof $root.chat.PullMsgsBySeqsResponse)
                return object;
            let message = new $root.chat.PullMsgsBySeqsResponse();
            if (object.msgInfos) {
                if (!Array.isArray(object.msgInfos))
                    throw TypeError(".chat.PullMsgsBySeqsResponse.msgInfos: array expected");
                message.msgInfos = [];
                for (let i = 0; i < object.msgInfos.length; ++i) {
                    if (typeof object.msgInfos[i] !== "object")
                        throw TypeError(".chat.PullMsgsBySeqsResponse.msgInfos: object expected");
                    message.msgInfos[i] = $root.chat.MessageInfoList.fromObject(object.msgInfos[i]);
                }
            }
            return message;
        };

        /**
         * Creates a plain object from a PullMsgsBySeqsResponse message. Also converts values to other types if specified.
         * @function toObject
         * @memberof chat.PullMsgsBySeqsResponse
         * @static
         * @param {chat.PullMsgsBySeqsResponse} message PullMsgsBySeqsResponse
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        PullMsgsBySeqsResponse.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.arrays || options.defaults)
                object.msgInfos = [];
            if (message.msgInfos && message.msgInfos.length) {
                object.msgInfos = [];
                for (let j = 0; j < message.msgInfos.length; ++j)
                    object.msgInfos[j] = $root.chat.MessageInfoList.toObject(message.msgInfos[j], options);
            }
            return object;
        };

        /**
         * Converts this PullMsgsBySeqsResponse to JSON.
         * @function toJSON
         * @memberof chat.PullMsgsBySeqsResponse
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        PullMsgsBySeqsResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for PullMsgsBySeqsResponse
         * @function getTypeUrl
         * @memberof chat.PullMsgsBySeqsResponse
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        PullMsgsBySeqsResponse.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/chat.PullMsgsBySeqsResponse";
        };

        return PullMsgsBySeqsResponse;
    })();

    chat.ChatSeq = (function() {

        /**
         * Properties of a ChatSeq.
         * @memberof chat
         * @interface IChatSeq
         * @property {string|null} [chatId] ChatSeq chatId
         * @property {Array.<number|Long>|null} [seqs] ChatSeq seqs
         */

        /**
         * Constructs a new ChatSeq.
         * @memberof chat
         * @classdesc Represents a ChatSeq.
         * @implements IChatSeq
         * @constructor
         * @param {chat.IChatSeq=} [properties] Properties to set
         */
        function ChatSeq(properties) {
            this.seqs = [];
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ChatSeq chatId.
         * @member {string} chatId
         * @memberof chat.ChatSeq
         * @instance
         */
        ChatSeq.prototype.chatId = "";

        /**
         * ChatSeq seqs.
         * @member {Array.<number|Long>} seqs
         * @memberof chat.ChatSeq
         * @instance
         */
        ChatSeq.prototype.seqs = $util.emptyArray;

        /**
         * Creates a new ChatSeq instance using the specified properties.
         * @function create
         * @memberof chat.ChatSeq
         * @static
         * @param {chat.IChatSeq=} [properties] Properties to set
         * @returns {chat.ChatSeq} ChatSeq instance
         */
        ChatSeq.create = function create(properties) {
            return new ChatSeq(properties);
        };

        /**
         * Encodes the specified ChatSeq message. Does not implicitly {@link chat.ChatSeq.verify|verify} messages.
         * @function encode
         * @memberof chat.ChatSeq
         * @static
         * @param {chat.IChatSeq} message ChatSeq message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ChatSeq.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.chatId != null && Object.hasOwnProperty.call(message, "chatId"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.chatId);
            if (message.seqs != null && message.seqs.length) {
                writer.uint32(/* id 2, wireType 2 =*/18).fork();
                for (let i = 0; i < message.seqs.length; ++i)
                    writer.int64(message.seqs[i]);
                writer.ldelim();
            }
            return writer;
        };

        /**
         * Encodes the specified ChatSeq message, length delimited. Does not implicitly {@link chat.ChatSeq.verify|verify} messages.
         * @function encodeDelimited
         * @memberof chat.ChatSeq
         * @static
         * @param {chat.IChatSeq} message ChatSeq message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ChatSeq.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a ChatSeq message from the specified reader or buffer.
         * @function decode
         * @memberof chat.ChatSeq
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {chat.ChatSeq} ChatSeq
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ChatSeq.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.chat.ChatSeq();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1: {
                        message.chatId = reader.string();
                        break;
                    }
                case 2: {
                        if (!(message.seqs && message.seqs.length))
                            message.seqs = [];
                        if ((tag & 7) === 2) {
                            let end2 = reader.uint32() + reader.pos;
                            while (reader.pos < end2)
                                message.seqs.push(reader.int64());
                        } else
                            message.seqs.push(reader.int64());
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a ChatSeq message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof chat.ChatSeq
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {chat.ChatSeq} ChatSeq
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ChatSeq.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a ChatSeq message.
         * @function verify
         * @memberof chat.ChatSeq
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        ChatSeq.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.chatId != null && message.hasOwnProperty("chatId"))
                if (!$util.isString(message.chatId))
                    return "chatId: string expected";
            if (message.seqs != null && message.hasOwnProperty("seqs")) {
                if (!Array.isArray(message.seqs))
                    return "seqs: array expected";
                for (let i = 0; i < message.seqs.length; ++i)
                    if (!$util.isInteger(message.seqs[i]) && !(message.seqs[i] && $util.isInteger(message.seqs[i].low) && $util.isInteger(message.seqs[i].high)))
                        return "seqs: integer|Long[] expected";
            }
            return null;
        };

        /**
         * Creates a ChatSeq message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof chat.ChatSeq
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {chat.ChatSeq} ChatSeq
         */
        ChatSeq.fromObject = function fromObject(object) {
            if (object instanceof $root.chat.ChatSeq)
                return object;
            let message = new $root.chat.ChatSeq();
            if (object.chatId != null)
                message.chatId = String(object.chatId);
            if (object.seqs) {
                if (!Array.isArray(object.seqs))
                    throw TypeError(".chat.ChatSeq.seqs: array expected");
                message.seqs = [];
                for (let i = 0; i < object.seqs.length; ++i)
                    if ($util.Long)
                        (message.seqs[i] = $util.Long.fromValue(object.seqs[i])).unsigned = false;
                    else if (typeof object.seqs[i] === "string")
                        message.seqs[i] = parseInt(object.seqs[i], 10);
                    else if (typeof object.seqs[i] === "number")
                        message.seqs[i] = object.seqs[i];
                    else if (typeof object.seqs[i] === "object")
                        message.seqs[i] = new $util.LongBits(object.seqs[i].low >>> 0, object.seqs[i].high >>> 0).toNumber();
            }
            return message;
        };

        /**
         * Creates a plain object from a ChatSeq message. Also converts values to other types if specified.
         * @function toObject
         * @memberof chat.ChatSeq
         * @static
         * @param {chat.ChatSeq} message ChatSeq
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ChatSeq.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.arrays || options.defaults)
                object.seqs = [];
            if (options.defaults)
                object.chatId = "";
            if (message.chatId != null && message.hasOwnProperty("chatId"))
                object.chatId = message.chatId;
            if (message.seqs && message.seqs.length) {
                object.seqs = [];
                for (let j = 0; j < message.seqs.length; ++j)
                    if (typeof message.seqs[j] === "number")
                        object.seqs[j] = options.longs === String ? String(message.seqs[j]) : message.seqs[j];
                    else
                        object.seqs[j] = options.longs === String ? $util.Long.prototype.toString.call(message.seqs[j]) : options.longs === Number ? new $util.LongBits(message.seqs[j].low >>> 0, message.seqs[j].high >>> 0).toNumber() : message.seqs[j];
            }
            return object;
        };

        /**
         * Converts this ChatSeq to JSON.
         * @function toJSON
         * @memberof chat.ChatSeq
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ChatSeq.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for ChatSeq
         * @function getTypeUrl
         * @memberof chat.ChatSeq
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        ChatSeq.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/chat.ChatSeq";
        };

        return ChatSeq;
    })();

    chat.SendMessageV2Request = (function() {

        /**
         * Properties of a SendMessageV2Request.
         * @memberof chat
         * @interface ISendMessageV2Request
         * @property {chat.IMessageInfo|null} [messageInfo] SendMessageV2Request messageInfo
         */

        /**
         * Constructs a new SendMessageV2Request.
         * @memberof chat
         * @classdesc Represents a SendMessageV2Request.
         * @implements ISendMessageV2Request
         * @constructor
         * @param {chat.ISendMessageV2Request=} [properties] Properties to set
         */
        function SendMessageV2Request(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * SendMessageV2Request messageInfo.
         * @member {chat.IMessageInfo|null|undefined} messageInfo
         * @memberof chat.SendMessageV2Request
         * @instance
         */
        SendMessageV2Request.prototype.messageInfo = null;

        /**
         * Creates a new SendMessageV2Request instance using the specified properties.
         * @function create
         * @memberof chat.SendMessageV2Request
         * @static
         * @param {chat.ISendMessageV2Request=} [properties] Properties to set
         * @returns {chat.SendMessageV2Request} SendMessageV2Request instance
         */
        SendMessageV2Request.create = function create(properties) {
            return new SendMessageV2Request(properties);
        };

        /**
         * Encodes the specified SendMessageV2Request message. Does not implicitly {@link chat.SendMessageV2Request.verify|verify} messages.
         * @function encode
         * @memberof chat.SendMessageV2Request
         * @static
         * @param {chat.ISendMessageV2Request} message SendMessageV2Request message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        SendMessageV2Request.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.messageInfo != null && Object.hasOwnProperty.call(message, "messageInfo"))
                $root.chat.MessageInfo.encode(message.messageInfo, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified SendMessageV2Request message, length delimited. Does not implicitly {@link chat.SendMessageV2Request.verify|verify} messages.
         * @function encodeDelimited
         * @memberof chat.SendMessageV2Request
         * @static
         * @param {chat.ISendMessageV2Request} message SendMessageV2Request message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        SendMessageV2Request.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a SendMessageV2Request message from the specified reader or buffer.
         * @function decode
         * @memberof chat.SendMessageV2Request
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {chat.SendMessageV2Request} SendMessageV2Request
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        SendMessageV2Request.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.chat.SendMessageV2Request();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1: {
                        message.messageInfo = $root.chat.MessageInfo.decode(reader, reader.uint32());
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a SendMessageV2Request message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof chat.SendMessageV2Request
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {chat.SendMessageV2Request} SendMessageV2Request
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        SendMessageV2Request.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a SendMessageV2Request message.
         * @function verify
         * @memberof chat.SendMessageV2Request
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        SendMessageV2Request.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.messageInfo != null && message.hasOwnProperty("messageInfo")) {
                let error = $root.chat.MessageInfo.verify(message.messageInfo);
                if (error)
                    return "messageInfo." + error;
            }
            return null;
        };

        /**
         * Creates a SendMessageV2Request message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof chat.SendMessageV2Request
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {chat.SendMessageV2Request} SendMessageV2Request
         */
        SendMessageV2Request.fromObject = function fromObject(object) {
            if (object instanceof $root.chat.SendMessageV2Request)
                return object;
            let message = new $root.chat.SendMessageV2Request();
            if (object.messageInfo != null) {
                if (typeof object.messageInfo !== "object")
                    throw TypeError(".chat.SendMessageV2Request.messageInfo: object expected");
                message.messageInfo = $root.chat.MessageInfo.fromObject(object.messageInfo);
            }
            return message;
        };

        /**
         * Creates a plain object from a SendMessageV2Request message. Also converts values to other types if specified.
         * @function toObject
         * @memberof chat.SendMessageV2Request
         * @static
         * @param {chat.SendMessageV2Request} message SendMessageV2Request
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        SendMessageV2Request.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults)
                object.messageInfo = null;
            if (message.messageInfo != null && message.hasOwnProperty("messageInfo"))
                object.messageInfo = $root.chat.MessageInfo.toObject(message.messageInfo, options);
            return object;
        };

        /**
         * Converts this SendMessageV2Request to JSON.
         * @function toJSON
         * @memberof chat.SendMessageV2Request
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        SendMessageV2Request.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for SendMessageV2Request
         * @function getTypeUrl
         * @memberof chat.SendMessageV2Request
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        SendMessageV2Request.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/chat.SendMessageV2Request";
        };

        return SendMessageV2Request;
    })();

    chat.SendMessageV2Response = (function() {

        /**
         * Properties of a SendMessageV2Response.
         * @memberof chat
         * @interface ISendMessageV2Response
         * @property {number|null} [statusCode] SendMessageV2Response statusCode
         * @property {string|null} [messageId] SendMessageV2Response messageId
         * @property {number|Long|null} [messageSeq] SendMessageV2Response messageSeq
         * @property {string|null} [cliMsgId] SendMessageV2Response cliMsgId
         * @property {string|null} [chatId] SendMessageV2Response chatId
         * @property {number|Long|null} [createdAt] SendMessageV2Response createdAt
         */

        /**
         * Constructs a new SendMessageV2Response.
         * @memberof chat
         * @classdesc Represents a SendMessageV2Response.
         * @implements ISendMessageV2Response
         * @constructor
         * @param {chat.ISendMessageV2Response=} [properties] Properties to set
         */
        function SendMessageV2Response(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * SendMessageV2Response statusCode.
         * @member {number} statusCode
         * @memberof chat.SendMessageV2Response
         * @instance
         */
        SendMessageV2Response.prototype.statusCode = 0;

        /**
         * SendMessageV2Response messageId.
         * @member {string} messageId
         * @memberof chat.SendMessageV2Response
         * @instance
         */
        SendMessageV2Response.prototype.messageId = "";

        /**
         * SendMessageV2Response messageSeq.
         * @member {number|Long} messageSeq
         * @memberof chat.SendMessageV2Response
         * @instance
         */
        SendMessageV2Response.prototype.messageSeq = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * SendMessageV2Response cliMsgId.
         * @member {string} cliMsgId
         * @memberof chat.SendMessageV2Response
         * @instance
         */
        SendMessageV2Response.prototype.cliMsgId = "";

        /**
         * SendMessageV2Response chatId.
         * @member {string} chatId
         * @memberof chat.SendMessageV2Response
         * @instance
         */
        SendMessageV2Response.prototype.chatId = "";

        /**
         * SendMessageV2Response createdAt.
         * @member {number|Long} createdAt
         * @memberof chat.SendMessageV2Response
         * @instance
         */
        SendMessageV2Response.prototype.createdAt = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * Creates a new SendMessageV2Response instance using the specified properties.
         * @function create
         * @memberof chat.SendMessageV2Response
         * @static
         * @param {chat.ISendMessageV2Response=} [properties] Properties to set
         * @returns {chat.SendMessageV2Response} SendMessageV2Response instance
         */
        SendMessageV2Response.create = function create(properties) {
            return new SendMessageV2Response(properties);
        };

        /**
         * Encodes the specified SendMessageV2Response message. Does not implicitly {@link chat.SendMessageV2Response.verify|verify} messages.
         * @function encode
         * @memberof chat.SendMessageV2Response
         * @static
         * @param {chat.ISendMessageV2Response} message SendMessageV2Response message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        SendMessageV2Response.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.statusCode != null && Object.hasOwnProperty.call(message, "statusCode"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.statusCode);
            if (message.messageId != null && Object.hasOwnProperty.call(message, "messageId"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.messageId);
            if (message.messageSeq != null && Object.hasOwnProperty.call(message, "messageSeq"))
                writer.uint32(/* id 3, wireType 0 =*/24).int64(message.messageSeq);
            if (message.cliMsgId != null && Object.hasOwnProperty.call(message, "cliMsgId"))
                writer.uint32(/* id 4, wireType 2 =*/34).string(message.cliMsgId);
            if (message.chatId != null && Object.hasOwnProperty.call(message, "chatId"))
                writer.uint32(/* id 5, wireType 2 =*/42).string(message.chatId);
            if (message.createdAt != null && Object.hasOwnProperty.call(message, "createdAt"))
                writer.uint32(/* id 6, wireType 0 =*/48).int64(message.createdAt);
            return writer;
        };

        /**
         * Encodes the specified SendMessageV2Response message, length delimited. Does not implicitly {@link chat.SendMessageV2Response.verify|verify} messages.
         * @function encodeDelimited
         * @memberof chat.SendMessageV2Response
         * @static
         * @param {chat.ISendMessageV2Response} message SendMessageV2Response message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        SendMessageV2Response.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a SendMessageV2Response message from the specified reader or buffer.
         * @function decode
         * @memberof chat.SendMessageV2Response
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {chat.SendMessageV2Response} SendMessageV2Response
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        SendMessageV2Response.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.chat.SendMessageV2Response();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1: {
                        message.statusCode = reader.int32();
                        break;
                    }
                case 2: {
                        message.messageId = reader.string();
                        break;
                    }
                case 3: {
                        message.messageSeq = reader.int64();
                        break;
                    }
                case 4: {
                        message.cliMsgId = reader.string();
                        break;
                    }
                case 5: {
                        message.chatId = reader.string();
                        break;
                    }
                case 6: {
                        message.createdAt = reader.int64();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a SendMessageV2Response message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof chat.SendMessageV2Response
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {chat.SendMessageV2Response} SendMessageV2Response
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        SendMessageV2Response.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a SendMessageV2Response message.
         * @function verify
         * @memberof chat.SendMessageV2Response
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        SendMessageV2Response.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.statusCode != null && message.hasOwnProperty("statusCode"))
                if (!$util.isInteger(message.statusCode))
                    return "statusCode: integer expected";
            if (message.messageId != null && message.hasOwnProperty("messageId"))
                if (!$util.isString(message.messageId))
                    return "messageId: string expected";
            if (message.messageSeq != null && message.hasOwnProperty("messageSeq"))
                if (!$util.isInteger(message.messageSeq) && !(message.messageSeq && $util.isInteger(message.messageSeq.low) && $util.isInteger(message.messageSeq.high)))
                    return "messageSeq: integer|Long expected";
            if (message.cliMsgId != null && message.hasOwnProperty("cliMsgId"))
                if (!$util.isString(message.cliMsgId))
                    return "cliMsgId: string expected";
            if (message.chatId != null && message.hasOwnProperty("chatId"))
                if (!$util.isString(message.chatId))
                    return "chatId: string expected";
            if (message.createdAt != null && message.hasOwnProperty("createdAt"))
                if (!$util.isInteger(message.createdAt) && !(message.createdAt && $util.isInteger(message.createdAt.low) && $util.isInteger(message.createdAt.high)))
                    return "createdAt: integer|Long expected";
            return null;
        };

        /**
         * Creates a SendMessageV2Response message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof chat.SendMessageV2Response
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {chat.SendMessageV2Response} SendMessageV2Response
         */
        SendMessageV2Response.fromObject = function fromObject(object) {
            if (object instanceof $root.chat.SendMessageV2Response)
                return object;
            let message = new $root.chat.SendMessageV2Response();
            if (object.statusCode != null)
                message.statusCode = object.statusCode | 0;
            if (object.messageId != null)
                message.messageId = String(object.messageId);
            if (object.messageSeq != null)
                if ($util.Long)
                    (message.messageSeq = $util.Long.fromValue(object.messageSeq)).unsigned = false;
                else if (typeof object.messageSeq === "string")
                    message.messageSeq = parseInt(object.messageSeq, 10);
                else if (typeof object.messageSeq === "number")
                    message.messageSeq = object.messageSeq;
                else if (typeof object.messageSeq === "object")
                    message.messageSeq = new $util.LongBits(object.messageSeq.low >>> 0, object.messageSeq.high >>> 0).toNumber();
            if (object.cliMsgId != null)
                message.cliMsgId = String(object.cliMsgId);
            if (object.chatId != null)
                message.chatId = String(object.chatId);
            if (object.createdAt != null)
                if ($util.Long)
                    (message.createdAt = $util.Long.fromValue(object.createdAt)).unsigned = false;
                else if (typeof object.createdAt === "string")
                    message.createdAt = parseInt(object.createdAt, 10);
                else if (typeof object.createdAt === "number")
                    message.createdAt = object.createdAt;
                else if (typeof object.createdAt === "object")
                    message.createdAt = new $util.LongBits(object.createdAt.low >>> 0, object.createdAt.high >>> 0).toNumber();
            return message;
        };

        /**
         * Creates a plain object from a SendMessageV2Response message. Also converts values to other types if specified.
         * @function toObject
         * @memberof chat.SendMessageV2Response
         * @static
         * @param {chat.SendMessageV2Response} message SendMessageV2Response
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        SendMessageV2Response.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.statusCode = 0;
                object.messageId = "";
                if ($util.Long) {
                    let long = new $util.Long(0, 0, false);
                    object.messageSeq = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.messageSeq = options.longs === String ? "0" : 0;
                object.cliMsgId = "";
                object.chatId = "";
                if ($util.Long) {
                    let long = new $util.Long(0, 0, false);
                    object.createdAt = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.createdAt = options.longs === String ? "0" : 0;
            }
            if (message.statusCode != null && message.hasOwnProperty("statusCode"))
                object.statusCode = message.statusCode;
            if (message.messageId != null && message.hasOwnProperty("messageId"))
                object.messageId = message.messageId;
            if (message.messageSeq != null && message.hasOwnProperty("messageSeq"))
                if (typeof message.messageSeq === "number")
                    object.messageSeq = options.longs === String ? String(message.messageSeq) : message.messageSeq;
                else
                    object.messageSeq = options.longs === String ? $util.Long.prototype.toString.call(message.messageSeq) : options.longs === Number ? new $util.LongBits(message.messageSeq.low >>> 0, message.messageSeq.high >>> 0).toNumber() : message.messageSeq;
            if (message.cliMsgId != null && message.hasOwnProperty("cliMsgId"))
                object.cliMsgId = message.cliMsgId;
            if (message.chatId != null && message.hasOwnProperty("chatId"))
                object.chatId = message.chatId;
            if (message.createdAt != null && message.hasOwnProperty("createdAt"))
                if (typeof message.createdAt === "number")
                    object.createdAt = options.longs === String ? String(message.createdAt) : message.createdAt;
                else
                    object.createdAt = options.longs === String ? $util.Long.prototype.toString.call(message.createdAt) : options.longs === Number ? new $util.LongBits(message.createdAt.low >>> 0, message.createdAt.high >>> 0).toNumber() : message.createdAt;
            return object;
        };

        /**
         * Converts this SendMessageV2Response to JSON.
         * @function toJSON
         * @memberof chat.SendMessageV2Response
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        SendMessageV2Response.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for SendMessageV2Response
         * @function getTypeUrl
         * @memberof chat.SendMessageV2Response
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        SendMessageV2Response.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/chat.SendMessageV2Response";
        };

        return SendMessageV2Response;
    })();

    chat.PullMessageInfoListTestRequest = (function() {

        /**
         * Properties of a PullMessageInfoListTestRequest.
         * @memberof chat
         * @interface IPullMessageInfoListTestRequest
         * @property {Array.<string>|null} [messageIdList] PullMessageInfoListTestRequest messageIdList
         */

        /**
         * Constructs a new PullMessageInfoListTestRequest.
         * @memberof chat
         * @classdesc Represents a PullMessageInfoListTestRequest.
         * @implements IPullMessageInfoListTestRequest
         * @constructor
         * @param {chat.IPullMessageInfoListTestRequest=} [properties] Properties to set
         */
        function PullMessageInfoListTestRequest(properties) {
            this.messageIdList = [];
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * PullMessageInfoListTestRequest messageIdList.
         * @member {Array.<string>} messageIdList
         * @memberof chat.PullMessageInfoListTestRequest
         * @instance
         */
        PullMessageInfoListTestRequest.prototype.messageIdList = $util.emptyArray;

        /**
         * Creates a new PullMessageInfoListTestRequest instance using the specified properties.
         * @function create
         * @memberof chat.PullMessageInfoListTestRequest
         * @static
         * @param {chat.IPullMessageInfoListTestRequest=} [properties] Properties to set
         * @returns {chat.PullMessageInfoListTestRequest} PullMessageInfoListTestRequest instance
         */
        PullMessageInfoListTestRequest.create = function create(properties) {
            return new PullMessageInfoListTestRequest(properties);
        };

        /**
         * Encodes the specified PullMessageInfoListTestRequest message. Does not implicitly {@link chat.PullMessageInfoListTestRequest.verify|verify} messages.
         * @function encode
         * @memberof chat.PullMessageInfoListTestRequest
         * @static
         * @param {chat.IPullMessageInfoListTestRequest} message PullMessageInfoListTestRequest message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        PullMessageInfoListTestRequest.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.messageIdList != null && message.messageIdList.length)
                for (let i = 0; i < message.messageIdList.length; ++i)
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.messageIdList[i]);
            return writer;
        };

        /**
         * Encodes the specified PullMessageInfoListTestRequest message, length delimited. Does not implicitly {@link chat.PullMessageInfoListTestRequest.verify|verify} messages.
         * @function encodeDelimited
         * @memberof chat.PullMessageInfoListTestRequest
         * @static
         * @param {chat.IPullMessageInfoListTestRequest} message PullMessageInfoListTestRequest message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        PullMessageInfoListTestRequest.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a PullMessageInfoListTestRequest message from the specified reader or buffer.
         * @function decode
         * @memberof chat.PullMessageInfoListTestRequest
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {chat.PullMessageInfoListTestRequest} PullMessageInfoListTestRequest
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        PullMessageInfoListTestRequest.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.chat.PullMessageInfoListTestRequest();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1: {
                        if (!(message.messageIdList && message.messageIdList.length))
                            message.messageIdList = [];
                        message.messageIdList.push(reader.string());
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a PullMessageInfoListTestRequest message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof chat.PullMessageInfoListTestRequest
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {chat.PullMessageInfoListTestRequest} PullMessageInfoListTestRequest
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        PullMessageInfoListTestRequest.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a PullMessageInfoListTestRequest message.
         * @function verify
         * @memberof chat.PullMessageInfoListTestRequest
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        PullMessageInfoListTestRequest.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.messageIdList != null && message.hasOwnProperty("messageIdList")) {
                if (!Array.isArray(message.messageIdList))
                    return "messageIdList: array expected";
                for (let i = 0; i < message.messageIdList.length; ++i)
                    if (!$util.isString(message.messageIdList[i]))
                        return "messageIdList: string[] expected";
            }
            return null;
        };

        /**
         * Creates a PullMessageInfoListTestRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof chat.PullMessageInfoListTestRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {chat.PullMessageInfoListTestRequest} PullMessageInfoListTestRequest
         */
        PullMessageInfoListTestRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.chat.PullMessageInfoListTestRequest)
                return object;
            let message = new $root.chat.PullMessageInfoListTestRequest();
            if (object.messageIdList) {
                if (!Array.isArray(object.messageIdList))
                    throw TypeError(".chat.PullMessageInfoListTestRequest.messageIdList: array expected");
                message.messageIdList = [];
                for (let i = 0; i < object.messageIdList.length; ++i)
                    message.messageIdList[i] = String(object.messageIdList[i]);
            }
            return message;
        };

        /**
         * Creates a plain object from a PullMessageInfoListTestRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof chat.PullMessageInfoListTestRequest
         * @static
         * @param {chat.PullMessageInfoListTestRequest} message PullMessageInfoListTestRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        PullMessageInfoListTestRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.arrays || options.defaults)
                object.messageIdList = [];
            if (message.messageIdList && message.messageIdList.length) {
                object.messageIdList = [];
                for (let j = 0; j < message.messageIdList.length; ++j)
                    object.messageIdList[j] = message.messageIdList[j];
            }
            return object;
        };

        /**
         * Converts this PullMessageInfoListTestRequest to JSON.
         * @function toJSON
         * @memberof chat.PullMessageInfoListTestRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        PullMessageInfoListTestRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for PullMessageInfoListTestRequest
         * @function getTypeUrl
         * @memberof chat.PullMessageInfoListTestRequest
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        PullMessageInfoListTestRequest.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/chat.PullMessageInfoListTestRequest";
        };

        return PullMessageInfoListTestRequest;
    })();

    chat.PullMessageInfoListTestResponse = (function() {

        /**
         * Properties of a PullMessageInfoListTestResponse.
         * @memberof chat
         * @interface IPullMessageInfoListTestResponse
         * @property {string|null} [res] PullMessageInfoListTestResponse res
         */

        /**
         * Constructs a new PullMessageInfoListTestResponse.
         * @memberof chat
         * @classdesc Represents a PullMessageInfoListTestResponse.
         * @implements IPullMessageInfoListTestResponse
         * @constructor
         * @param {chat.IPullMessageInfoListTestResponse=} [properties] Properties to set
         */
        function PullMessageInfoListTestResponse(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * PullMessageInfoListTestResponse res.
         * @member {string} res
         * @memberof chat.PullMessageInfoListTestResponse
         * @instance
         */
        PullMessageInfoListTestResponse.prototype.res = "";

        /**
         * Creates a new PullMessageInfoListTestResponse instance using the specified properties.
         * @function create
         * @memberof chat.PullMessageInfoListTestResponse
         * @static
         * @param {chat.IPullMessageInfoListTestResponse=} [properties] Properties to set
         * @returns {chat.PullMessageInfoListTestResponse} PullMessageInfoListTestResponse instance
         */
        PullMessageInfoListTestResponse.create = function create(properties) {
            return new PullMessageInfoListTestResponse(properties);
        };

        /**
         * Encodes the specified PullMessageInfoListTestResponse message. Does not implicitly {@link chat.PullMessageInfoListTestResponse.verify|verify} messages.
         * @function encode
         * @memberof chat.PullMessageInfoListTestResponse
         * @static
         * @param {chat.IPullMessageInfoListTestResponse} message PullMessageInfoListTestResponse message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        PullMessageInfoListTestResponse.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.res != null && Object.hasOwnProperty.call(message, "res"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.res);
            return writer;
        };

        /**
         * Encodes the specified PullMessageInfoListTestResponse message, length delimited. Does not implicitly {@link chat.PullMessageInfoListTestResponse.verify|verify} messages.
         * @function encodeDelimited
         * @memberof chat.PullMessageInfoListTestResponse
         * @static
         * @param {chat.IPullMessageInfoListTestResponse} message PullMessageInfoListTestResponse message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        PullMessageInfoListTestResponse.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a PullMessageInfoListTestResponse message from the specified reader or buffer.
         * @function decode
         * @memberof chat.PullMessageInfoListTestResponse
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {chat.PullMessageInfoListTestResponse} PullMessageInfoListTestResponse
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        PullMessageInfoListTestResponse.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.chat.PullMessageInfoListTestResponse();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1: {
                        message.res = reader.string();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a PullMessageInfoListTestResponse message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof chat.PullMessageInfoListTestResponse
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {chat.PullMessageInfoListTestResponse} PullMessageInfoListTestResponse
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        PullMessageInfoListTestResponse.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a PullMessageInfoListTestResponse message.
         * @function verify
         * @memberof chat.PullMessageInfoListTestResponse
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        PullMessageInfoListTestResponse.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.res != null && message.hasOwnProperty("res"))
                if (!$util.isString(message.res))
                    return "res: string expected";
            return null;
        };

        /**
         * Creates a PullMessageInfoListTestResponse message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof chat.PullMessageInfoListTestResponse
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {chat.PullMessageInfoListTestResponse} PullMessageInfoListTestResponse
         */
        PullMessageInfoListTestResponse.fromObject = function fromObject(object) {
            if (object instanceof $root.chat.PullMessageInfoListTestResponse)
                return object;
            let message = new $root.chat.PullMessageInfoListTestResponse();
            if (object.res != null)
                message.res = String(object.res);
            return message;
        };

        /**
         * Creates a plain object from a PullMessageInfoListTestResponse message. Also converts values to other types if specified.
         * @function toObject
         * @memberof chat.PullMessageInfoListTestResponse
         * @static
         * @param {chat.PullMessageInfoListTestResponse} message PullMessageInfoListTestResponse
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        PullMessageInfoListTestResponse.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults)
                object.res = "";
            if (message.res != null && message.hasOwnProperty("res"))
                object.res = message.res;
            return object;
        };

        /**
         * Converts this PullMessageInfoListTestResponse to JSON.
         * @function toJSON
         * @memberof chat.PullMessageInfoListTestResponse
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        PullMessageInfoListTestResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for PullMessageInfoListTestResponse
         * @function getTypeUrl
         * @memberof chat.PullMessageInfoListTestResponse
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        PullMessageInfoListTestResponse.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/chat.PullMessageInfoListTestResponse";
        };

        return PullMessageInfoListTestResponse;
    })();

    chat.MediaCallNotice = (function() {

        /**
         * Properties of a MediaCallNotice.
         * @memberof chat
         * @interface IMediaCallNotice
         * @property {string|null} [roomId] MediaCallNotice roomId
         * @property {number|Long|null} [busy] MediaCallNotice busy
         * @property {string|null} [gid] MediaCallNotice gid
         */

        /**
         * Constructs a new MediaCallNotice.
         * @memberof chat
         * @classdesc Represents a MediaCallNotice.
         * @implements IMediaCallNotice
         * @constructor
         * @param {chat.IMediaCallNotice=} [properties] Properties to set
         */
        function MediaCallNotice(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * MediaCallNotice roomId.
         * @member {string} roomId
         * @memberof chat.MediaCallNotice
         * @instance
         */
        MediaCallNotice.prototype.roomId = "";

        /**
         * MediaCallNotice busy.
         * @member {number|Long} busy
         * @memberof chat.MediaCallNotice
         * @instance
         */
        MediaCallNotice.prototype.busy = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * MediaCallNotice gid.
         * @member {string} gid
         * @memberof chat.MediaCallNotice
         * @instance
         */
        MediaCallNotice.prototype.gid = "";

        /**
         * Creates a new MediaCallNotice instance using the specified properties.
         * @function create
         * @memberof chat.MediaCallNotice
         * @static
         * @param {chat.IMediaCallNotice=} [properties] Properties to set
         * @returns {chat.MediaCallNotice} MediaCallNotice instance
         */
        MediaCallNotice.create = function create(properties) {
            return new MediaCallNotice(properties);
        };

        /**
         * Encodes the specified MediaCallNotice message. Does not implicitly {@link chat.MediaCallNotice.verify|verify} messages.
         * @function encode
         * @memberof chat.MediaCallNotice
         * @static
         * @param {chat.IMediaCallNotice} message MediaCallNotice message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        MediaCallNotice.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.roomId != null && Object.hasOwnProperty.call(message, "roomId"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.roomId);
            if (message.busy != null && Object.hasOwnProperty.call(message, "busy"))
                writer.uint32(/* id 2, wireType 0 =*/16).int64(message.busy);
            if (message.gid != null && Object.hasOwnProperty.call(message, "gid"))
                writer.uint32(/* id 3, wireType 2 =*/26).string(message.gid);
            return writer;
        };

        /**
         * Encodes the specified MediaCallNotice message, length delimited. Does not implicitly {@link chat.MediaCallNotice.verify|verify} messages.
         * @function encodeDelimited
         * @memberof chat.MediaCallNotice
         * @static
         * @param {chat.IMediaCallNotice} message MediaCallNotice message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        MediaCallNotice.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a MediaCallNotice message from the specified reader or buffer.
         * @function decode
         * @memberof chat.MediaCallNotice
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {chat.MediaCallNotice} MediaCallNotice
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        MediaCallNotice.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.chat.MediaCallNotice();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1: {
                        message.roomId = reader.string();
                        break;
                    }
                case 2: {
                        message.busy = reader.int64();
                        break;
                    }
                case 3: {
                        message.gid = reader.string();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a MediaCallNotice message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof chat.MediaCallNotice
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {chat.MediaCallNotice} MediaCallNotice
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        MediaCallNotice.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a MediaCallNotice message.
         * @function verify
         * @memberof chat.MediaCallNotice
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        MediaCallNotice.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.roomId != null && message.hasOwnProperty("roomId"))
                if (!$util.isString(message.roomId))
                    return "roomId: string expected";
            if (message.busy != null && message.hasOwnProperty("busy"))
                if (!$util.isInteger(message.busy) && !(message.busy && $util.isInteger(message.busy.low) && $util.isInteger(message.busy.high)))
                    return "busy: integer|Long expected";
            if (message.gid != null && message.hasOwnProperty("gid"))
                if (!$util.isString(message.gid))
                    return "gid: string expected";
            return null;
        };

        /**
         * Creates a MediaCallNotice message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof chat.MediaCallNotice
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {chat.MediaCallNotice} MediaCallNotice
         */
        MediaCallNotice.fromObject = function fromObject(object) {
            if (object instanceof $root.chat.MediaCallNotice)
                return object;
            let message = new $root.chat.MediaCallNotice();
            if (object.roomId != null)
                message.roomId = String(object.roomId);
            if (object.busy != null)
                if ($util.Long)
                    (message.busy = $util.Long.fromValue(object.busy)).unsigned = false;
                else if (typeof object.busy === "string")
                    message.busy = parseInt(object.busy, 10);
                else if (typeof object.busy === "number")
                    message.busy = object.busy;
                else if (typeof object.busy === "object")
                    message.busy = new $util.LongBits(object.busy.low >>> 0, object.busy.high >>> 0).toNumber();
            if (object.gid != null)
                message.gid = String(object.gid);
            return message;
        };

        /**
         * Creates a plain object from a MediaCallNotice message. Also converts values to other types if specified.
         * @function toObject
         * @memberof chat.MediaCallNotice
         * @static
         * @param {chat.MediaCallNotice} message MediaCallNotice
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        MediaCallNotice.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.roomId = "";
                if ($util.Long) {
                    let long = new $util.Long(0, 0, false);
                    object.busy = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.busy = options.longs === String ? "0" : 0;
                object.gid = "";
            }
            if (message.roomId != null && message.hasOwnProperty("roomId"))
                object.roomId = message.roomId;
            if (message.busy != null && message.hasOwnProperty("busy"))
                if (typeof message.busy === "number")
                    object.busy = options.longs === String ? String(message.busy) : message.busy;
                else
                    object.busy = options.longs === String ? $util.Long.prototype.toString.call(message.busy) : options.longs === Number ? new $util.LongBits(message.busy.low >>> 0, message.busy.high >>> 0).toNumber() : message.busy;
            if (message.gid != null && message.hasOwnProperty("gid"))
                object.gid = message.gid;
            return object;
        };

        /**
         * Converts this MediaCallNotice to JSON.
         * @function toJSON
         * @memberof chat.MediaCallNotice
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        MediaCallNotice.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for MediaCallNotice
         * @function getTypeUrl
         * @memberof chat.MediaCallNotice
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        MediaCallNotice.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/chat.MediaCallNotice";
        };

        return MediaCallNotice;
    })();

    chat.MediaCallGroupJoinRequest = (function() {

        /**
         * Properties of a MediaCallGroupJoinRequest.
         * @memberof chat
         * @interface IMediaCallGroupJoinRequest
         * @property {string|null} [groupId] MediaCallGroupJoinRequest groupId
         */

        /**
         * Constructs a new MediaCallGroupJoinRequest.
         * @memberof chat
         * @classdesc Represents a MediaCallGroupJoinRequest.
         * @implements IMediaCallGroupJoinRequest
         * @constructor
         * @param {chat.IMediaCallGroupJoinRequest=} [properties] Properties to set
         */
        function MediaCallGroupJoinRequest(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * MediaCallGroupJoinRequest groupId.
         * @member {string} groupId
         * @memberof chat.MediaCallGroupJoinRequest
         * @instance
         */
        MediaCallGroupJoinRequest.prototype.groupId = "";

        /**
         * Creates a new MediaCallGroupJoinRequest instance using the specified properties.
         * @function create
         * @memberof chat.MediaCallGroupJoinRequest
         * @static
         * @param {chat.IMediaCallGroupJoinRequest=} [properties] Properties to set
         * @returns {chat.MediaCallGroupJoinRequest} MediaCallGroupJoinRequest instance
         */
        MediaCallGroupJoinRequest.create = function create(properties) {
            return new MediaCallGroupJoinRequest(properties);
        };

        /**
         * Encodes the specified MediaCallGroupJoinRequest message. Does not implicitly {@link chat.MediaCallGroupJoinRequest.verify|verify} messages.
         * @function encode
         * @memberof chat.MediaCallGroupJoinRequest
         * @static
         * @param {chat.IMediaCallGroupJoinRequest} message MediaCallGroupJoinRequest message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        MediaCallGroupJoinRequest.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.groupId != null && Object.hasOwnProperty.call(message, "groupId"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.groupId);
            return writer;
        };

        /**
         * Encodes the specified MediaCallGroupJoinRequest message, length delimited. Does not implicitly {@link chat.MediaCallGroupJoinRequest.verify|verify} messages.
         * @function encodeDelimited
         * @memberof chat.MediaCallGroupJoinRequest
         * @static
         * @param {chat.IMediaCallGroupJoinRequest} message MediaCallGroupJoinRequest message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        MediaCallGroupJoinRequest.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a MediaCallGroupJoinRequest message from the specified reader or buffer.
         * @function decode
         * @memberof chat.MediaCallGroupJoinRequest
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {chat.MediaCallGroupJoinRequest} MediaCallGroupJoinRequest
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        MediaCallGroupJoinRequest.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.chat.MediaCallGroupJoinRequest();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1: {
                        message.groupId = reader.string();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a MediaCallGroupJoinRequest message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof chat.MediaCallGroupJoinRequest
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {chat.MediaCallGroupJoinRequest} MediaCallGroupJoinRequest
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        MediaCallGroupJoinRequest.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a MediaCallGroupJoinRequest message.
         * @function verify
         * @memberof chat.MediaCallGroupJoinRequest
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        MediaCallGroupJoinRequest.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.groupId != null && message.hasOwnProperty("groupId"))
                if (!$util.isString(message.groupId))
                    return "groupId: string expected";
            return null;
        };

        /**
         * Creates a MediaCallGroupJoinRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof chat.MediaCallGroupJoinRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {chat.MediaCallGroupJoinRequest} MediaCallGroupJoinRequest
         */
        MediaCallGroupJoinRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.chat.MediaCallGroupJoinRequest)
                return object;
            let message = new $root.chat.MediaCallGroupJoinRequest();
            if (object.groupId != null)
                message.groupId = String(object.groupId);
            return message;
        };

        /**
         * Creates a plain object from a MediaCallGroupJoinRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof chat.MediaCallGroupJoinRequest
         * @static
         * @param {chat.MediaCallGroupJoinRequest} message MediaCallGroupJoinRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        MediaCallGroupJoinRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults)
                object.groupId = "";
            if (message.groupId != null && message.hasOwnProperty("groupId"))
                object.groupId = message.groupId;
            return object;
        };

        /**
         * Converts this MediaCallGroupJoinRequest to JSON.
         * @function toJSON
         * @memberof chat.MediaCallGroupJoinRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        MediaCallGroupJoinRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for MediaCallGroupJoinRequest
         * @function getTypeUrl
         * @memberof chat.MediaCallGroupJoinRequest
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        MediaCallGroupJoinRequest.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/chat.MediaCallGroupJoinRequest";
        };

        return MediaCallGroupJoinRequest;
    })();

    chat.MediaCallGroupJoinResponse = (function() {

        /**
         * Properties of a MediaCallGroupJoinResponse.
         * @memberof chat
         * @interface IMediaCallGroupJoinResponse
         * @property {string|null} [roomId] MediaCallGroupJoinResponse roomId
         * @property {string|null} [busy] MediaCallGroupJoinResponse busy
         * @property {string|null} [groupId] MediaCallGroupJoinResponse groupId
         * @property {string|null} [tGroupId] MediaCallGroupJoinResponse tGroupId
         * @property {string|null} [senderId] MediaCallGroupJoinResponse senderId
         */

        /**
         * Constructs a new MediaCallGroupJoinResponse.
         * @memberof chat
         * @classdesc Represents a MediaCallGroupJoinResponse.
         * @implements IMediaCallGroupJoinResponse
         * @constructor
         * @param {chat.IMediaCallGroupJoinResponse=} [properties] Properties to set
         */
        function MediaCallGroupJoinResponse(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * MediaCallGroupJoinResponse roomId.
         * @member {string} roomId
         * @memberof chat.MediaCallGroupJoinResponse
         * @instance
         */
        MediaCallGroupJoinResponse.prototype.roomId = "";

        /**
         * MediaCallGroupJoinResponse busy.
         * @member {string} busy
         * @memberof chat.MediaCallGroupJoinResponse
         * @instance
         */
        MediaCallGroupJoinResponse.prototype.busy = "";

        /**
         * MediaCallGroupJoinResponse groupId.
         * @member {string} groupId
         * @memberof chat.MediaCallGroupJoinResponse
         * @instance
         */
        MediaCallGroupJoinResponse.prototype.groupId = "";

        /**
         * MediaCallGroupJoinResponse tGroupId.
         * @member {string} tGroupId
         * @memberof chat.MediaCallGroupJoinResponse
         * @instance
         */
        MediaCallGroupJoinResponse.prototype.tGroupId = "";

        /**
         * MediaCallGroupJoinResponse senderId.
         * @member {string} senderId
         * @memberof chat.MediaCallGroupJoinResponse
         * @instance
         */
        MediaCallGroupJoinResponse.prototype.senderId = "";

        /**
         * Creates a new MediaCallGroupJoinResponse instance using the specified properties.
         * @function create
         * @memberof chat.MediaCallGroupJoinResponse
         * @static
         * @param {chat.IMediaCallGroupJoinResponse=} [properties] Properties to set
         * @returns {chat.MediaCallGroupJoinResponse} MediaCallGroupJoinResponse instance
         */
        MediaCallGroupJoinResponse.create = function create(properties) {
            return new MediaCallGroupJoinResponse(properties);
        };

        /**
         * Encodes the specified MediaCallGroupJoinResponse message. Does not implicitly {@link chat.MediaCallGroupJoinResponse.verify|verify} messages.
         * @function encode
         * @memberof chat.MediaCallGroupJoinResponse
         * @static
         * @param {chat.IMediaCallGroupJoinResponse} message MediaCallGroupJoinResponse message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        MediaCallGroupJoinResponse.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.roomId != null && Object.hasOwnProperty.call(message, "roomId"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.roomId);
            if (message.busy != null && Object.hasOwnProperty.call(message, "busy"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.busy);
            if (message.groupId != null && Object.hasOwnProperty.call(message, "groupId"))
                writer.uint32(/* id 3, wireType 2 =*/26).string(message.groupId);
            if (message.tGroupId != null && Object.hasOwnProperty.call(message, "tGroupId"))
                writer.uint32(/* id 4, wireType 2 =*/34).string(message.tGroupId);
            if (message.senderId != null && Object.hasOwnProperty.call(message, "senderId"))
                writer.uint32(/* id 5, wireType 2 =*/42).string(message.senderId);
            return writer;
        };

        /**
         * Encodes the specified MediaCallGroupJoinResponse message, length delimited. Does not implicitly {@link chat.MediaCallGroupJoinResponse.verify|verify} messages.
         * @function encodeDelimited
         * @memberof chat.MediaCallGroupJoinResponse
         * @static
         * @param {chat.IMediaCallGroupJoinResponse} message MediaCallGroupJoinResponse message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        MediaCallGroupJoinResponse.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a MediaCallGroupJoinResponse message from the specified reader or buffer.
         * @function decode
         * @memberof chat.MediaCallGroupJoinResponse
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {chat.MediaCallGroupJoinResponse} MediaCallGroupJoinResponse
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        MediaCallGroupJoinResponse.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.chat.MediaCallGroupJoinResponse();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1: {
                        message.roomId = reader.string();
                        break;
                    }
                case 2: {
                        message.busy = reader.string();
                        break;
                    }
                case 3: {
                        message.groupId = reader.string();
                        break;
                    }
                case 4: {
                        message.tGroupId = reader.string();
                        break;
                    }
                case 5: {
                        message.senderId = reader.string();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a MediaCallGroupJoinResponse message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof chat.MediaCallGroupJoinResponse
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {chat.MediaCallGroupJoinResponse} MediaCallGroupJoinResponse
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        MediaCallGroupJoinResponse.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a MediaCallGroupJoinResponse message.
         * @function verify
         * @memberof chat.MediaCallGroupJoinResponse
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        MediaCallGroupJoinResponse.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.roomId != null && message.hasOwnProperty("roomId"))
                if (!$util.isString(message.roomId))
                    return "roomId: string expected";
            if (message.busy != null && message.hasOwnProperty("busy"))
                if (!$util.isString(message.busy))
                    return "busy: string expected";
            if (message.groupId != null && message.hasOwnProperty("groupId"))
                if (!$util.isString(message.groupId))
                    return "groupId: string expected";
            if (message.tGroupId != null && message.hasOwnProperty("tGroupId"))
                if (!$util.isString(message.tGroupId))
                    return "tGroupId: string expected";
            if (message.senderId != null && message.hasOwnProperty("senderId"))
                if (!$util.isString(message.senderId))
                    return "senderId: string expected";
            return null;
        };

        /**
         * Creates a MediaCallGroupJoinResponse message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof chat.MediaCallGroupJoinResponse
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {chat.MediaCallGroupJoinResponse} MediaCallGroupJoinResponse
         */
        MediaCallGroupJoinResponse.fromObject = function fromObject(object) {
            if (object instanceof $root.chat.MediaCallGroupJoinResponse)
                return object;
            let message = new $root.chat.MediaCallGroupJoinResponse();
            if (object.roomId != null)
                message.roomId = String(object.roomId);
            if (object.busy != null)
                message.busy = String(object.busy);
            if (object.groupId != null)
                message.groupId = String(object.groupId);
            if (object.tGroupId != null)
                message.tGroupId = String(object.tGroupId);
            if (object.senderId != null)
                message.senderId = String(object.senderId);
            return message;
        };

        /**
         * Creates a plain object from a MediaCallGroupJoinResponse message. Also converts values to other types if specified.
         * @function toObject
         * @memberof chat.MediaCallGroupJoinResponse
         * @static
         * @param {chat.MediaCallGroupJoinResponse} message MediaCallGroupJoinResponse
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        MediaCallGroupJoinResponse.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.roomId = "";
                object.busy = "";
                object.groupId = "";
                object.tGroupId = "";
                object.senderId = "";
            }
            if (message.roomId != null && message.hasOwnProperty("roomId"))
                object.roomId = message.roomId;
            if (message.busy != null && message.hasOwnProperty("busy"))
                object.busy = message.busy;
            if (message.groupId != null && message.hasOwnProperty("groupId"))
                object.groupId = message.groupId;
            if (message.tGroupId != null && message.hasOwnProperty("tGroupId"))
                object.tGroupId = message.tGroupId;
            if (message.senderId != null && message.hasOwnProperty("senderId"))
                object.senderId = message.senderId;
            return object;
        };

        /**
         * Converts this MediaCallGroupJoinResponse to JSON.
         * @function toJSON
         * @memberof chat.MediaCallGroupJoinResponse
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        MediaCallGroupJoinResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for MediaCallGroupJoinResponse
         * @function getTypeUrl
         * @memberof chat.MediaCallGroupJoinResponse
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        MediaCallGroupJoinResponse.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/chat.MediaCallGroupJoinResponse";
        };

        return MediaCallGroupJoinResponse;
    })();

    chat.Chat = (function() {

        /**
         * Constructs a new Chat service.
         * @memberof chat
         * @classdesc Represents a Chat
         * @extends $protobuf.rpc.Service
         * @constructor
         * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
         * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
         * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
         */
        function Chat(rpcImpl, requestDelimited, responseDelimited) {
            $protobuf.rpc.Service.call(this, rpcImpl, requestDelimited, responseDelimited);
        }

        (Chat.prototype = Object.create($protobuf.rpc.Service.prototype)).constructor = Chat;

        /**
         * Creates new Chat service using the specified rpc implementation.
         * @function create
         * @memberof chat.Chat
         * @static
         * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
         * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
         * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
         * @returns {Chat} RPC service. Useful where requests and/or responses are streamed.
         */
        Chat.create = function create(rpcImpl, requestDelimited, responseDelimited) {
            return new this(rpcImpl, requestDelimited, responseDelimited);
        };

        /**
         * Callback as used by {@link chat.Chat#sendMessage}.
         * @memberof chat.Chat
         * @typedef SendMessageCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {chat.SendMessageResponse} [response] SendMessageResponse
         */

        /**
         * Calls SendMessage.
         * @function sendMessage
         * @memberof chat.Chat
         * @instance
         * @param {chat.ISendMessageRequest} request SendMessageRequest message or plain object
         * @param {chat.Chat.SendMessageCallback} callback Node-style callback called with the error, if any, and SendMessageResponse
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(Chat.prototype.sendMessage = function sendMessage(request, callback) {
            return this.rpcCall(sendMessage, $root.chat.SendMessageRequest, $root.chat.SendMessageResponse, request, callback);
        }, "name", { value: "SendMessage" });

        /**
         * Calls SendMessage.
         * @function sendMessage
         * @memberof chat.Chat
         * @instance
         * @param {chat.ISendMessageRequest} request SendMessageRequest message or plain object
         * @returns {Promise<chat.SendMessageResponse>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link chat.Chat#pullMessageIdList}.
         * @memberof chat.Chat
         * @typedef PullMessageIdListCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {chat.PullMessageIdListResponse} [response] PullMessageIdListResponse
         */

        /**
         * Calls PullMessageIdList.
         * @function pullMessageIdList
         * @memberof chat.Chat
         * @instance
         * @param {chat.IPullMessageIdListRequest} request PullMessageIdListRequest message or plain object
         * @param {chat.Chat.PullMessageIdListCallback} callback Node-style callback called with the error, if any, and PullMessageIdListResponse
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(Chat.prototype.pullMessageIdList = function pullMessageIdList(request, callback) {
            return this.rpcCall(pullMessageIdList, $root.chat.PullMessageIdListRequest, $root.chat.PullMessageIdListResponse, request, callback);
        }, "name", { value: "PullMessageIdList" });

        /**
         * Calls PullMessageIdList.
         * @function pullMessageIdList
         * @memberof chat.Chat
         * @instance
         * @param {chat.IPullMessageIdListRequest} request PullMessageIdListRequest message or plain object
         * @returns {Promise<chat.PullMessageIdListResponse>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link chat.Chat#pullMessageInfoList}.
         * @memberof chat.Chat
         * @typedef PullMessageInfoListCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {chat.PullMessageInfoListResponse} [response] PullMessageInfoListResponse
         */

        /**
         * Calls PullMessageInfoList.
         * @function pullMessageInfoList
         * @memberof chat.Chat
         * @instance
         * @param {chat.IPullMessageInfoListRequest} request PullMessageInfoListRequest message or plain object
         * @param {chat.Chat.PullMessageInfoListCallback} callback Node-style callback called with the error, if any, and PullMessageInfoListResponse
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(Chat.prototype.pullMessageInfoList = function pullMessageInfoList(request, callback) {
            return this.rpcCall(pullMessageInfoList, $root.chat.PullMessageInfoListRequest, $root.chat.PullMessageInfoListResponse, request, callback);
        }, "name", { value: "PullMessageInfoList" });

        /**
         * Calls PullMessageInfoList.
         * @function pullMessageInfoList
         * @memberof chat.Chat
         * @instance
         * @param {chat.IPullMessageInfoListRequest} request PullMessageInfoListRequest message or plain object
         * @returns {Promise<chat.PullMessageInfoListResponse>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link chat.Chat#messageArrivalReply}.
         * @memberof chat.Chat
         * @typedef MessageArrivalReplyCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {chat.MessageArrivalReplyResponse} [response] MessageArrivalReplyResponse
         */

        /**
         * Calls MessageArrivalReply.
         * @function messageArrivalReply
         * @memberof chat.Chat
         * @instance
         * @param {chat.IMessageArrivalReplyRequest} request MessageArrivalReplyRequest message or plain object
         * @param {chat.Chat.MessageArrivalReplyCallback} callback Node-style callback called with the error, if any, and MessageArrivalReplyResponse
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(Chat.prototype.messageArrivalReply = function messageArrivalReply(request, callback) {
            return this.rpcCall(messageArrivalReply, $root.chat.MessageArrivalReplyRequest, $root.chat.MessageArrivalReplyResponse, request, callback);
        }, "name", { value: "MessageArrivalReply" });

        /**
         * Calls MessageArrivalReply.
         * @function messageArrivalReply
         * @memberof chat.Chat
         * @instance
         * @param {chat.IMessageArrivalReplyRequest} request MessageArrivalReplyRequest message or plain object
         * @returns {Promise<chat.MessageArrivalReplyResponse>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link chat.Chat#readBurnMessageReply}.
         * @memberof chat.Chat
         * @typedef ReadBurnMessageReplyCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {chat.ReadBurnMessageReplyResponse} [response] ReadBurnMessageReplyResponse
         */

        /**
         * Calls ReadBurnMessageReply.
         * @function readBurnMessageReply
         * @memberof chat.Chat
         * @instance
         * @param {chat.IReadBurnMessageReplyRequest} request ReadBurnMessageReplyRequest message or plain object
         * @param {chat.Chat.ReadBurnMessageReplyCallback} callback Node-style callback called with the error, if any, and ReadBurnMessageReplyResponse
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(Chat.prototype.readBurnMessageReply = function readBurnMessageReply(request, callback) {
            return this.rpcCall(readBurnMessageReply, $root.chat.ReadBurnMessageReplyRequest, $root.chat.ReadBurnMessageReplyResponse, request, callback);
        }, "name", { value: "ReadBurnMessageReply" });

        /**
         * Calls ReadBurnMessageReply.
         * @function readBurnMessageReply
         * @memberof chat.Chat
         * @instance
         * @param {chat.IReadBurnMessageReplyRequest} request ReadBurnMessageReplyRequest message or plain object
         * @returns {Promise<chat.ReadBurnMessageReplyResponse>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link chat.Chat#getMediaCallToken}.
         * @memberof chat.Chat
         * @typedef GetMediaCallTokenCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {chat.GetMediaCallTokenResponse} [response] GetMediaCallTokenResponse
         */

        /**
         * Calls GetMediaCallToken.
         * @function getMediaCallToken
         * @memberof chat.Chat
         * @instance
         * @param {chat.IGetMediaCallTokenRequest} request GetMediaCallTokenRequest message or plain object
         * @param {chat.Chat.GetMediaCallTokenCallback} callback Node-style callback called with the error, if any, and GetMediaCallTokenResponse
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(Chat.prototype.getMediaCallToken = function getMediaCallToken(request, callback) {
            return this.rpcCall(getMediaCallToken, $root.chat.GetMediaCallTokenRequest, $root.chat.GetMediaCallTokenResponse, request, callback);
        }, "name", { value: "GetMediaCallToken" });

        /**
         * Calls GetMediaCallToken.
         * @function getMediaCallToken
         * @memberof chat.Chat
         * @instance
         * @param {chat.IGetMediaCallTokenRequest} request GetMediaCallTokenRequest message or plain object
         * @returns {Promise<chat.GetMediaCallTokenResponse>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link chat.Chat#mediaCallOperate}.
         * @memberof chat.Chat
         * @typedef MediaCallOperateCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {chat.MediaCallOperateResponse} [response] MediaCallOperateResponse
         */

        /**
         * Calls MediaCallOperate.
         * @function mediaCallOperate
         * @memberof chat.Chat
         * @instance
         * @param {chat.IMediaCallOperateRequest} request MediaCallOperateRequest message or plain object
         * @param {chat.Chat.MediaCallOperateCallback} callback Node-style callback called with the error, if any, and MediaCallOperateResponse
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(Chat.prototype.mediaCallOperate = function mediaCallOperate(request, callback) {
            return this.rpcCall(mediaCallOperate, $root.chat.MediaCallOperateRequest, $root.chat.MediaCallOperateResponse, request, callback);
        }, "name", { value: "MediaCallOperate" });

        /**
         * Calls MediaCallOperate.
         * @function mediaCallOperate
         * @memberof chat.Chat
         * @instance
         * @param {chat.IMediaCallOperateRequest} request MediaCallOperateRequest message or plain object
         * @returns {Promise<chat.MediaCallOperateResponse>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link chat.Chat#syncMediaCallInfo}.
         * @memberof chat.Chat
         * @typedef SyncMediaCallInfoCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {chat.SyncMediaCallInfoResponse} [response] SyncMediaCallInfoResponse
         */

        /**
         * Calls SyncMediaCallInfo.
         * @function syncMediaCallInfo
         * @memberof chat.Chat
         * @instance
         * @param {chat.ISyncMediaCallInfoRequest} request SyncMediaCallInfoRequest message or plain object
         * @param {chat.Chat.SyncMediaCallInfoCallback} callback Node-style callback called with the error, if any, and SyncMediaCallInfoResponse
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(Chat.prototype.syncMediaCallInfo = function syncMediaCallInfo(request, callback) {
            return this.rpcCall(syncMediaCallInfo, $root.chat.SyncMediaCallInfoRequest, $root.chat.SyncMediaCallInfoResponse, request, callback);
        }, "name", { value: "SyncMediaCallInfo" });

        /**
         * Calls SyncMediaCallInfo.
         * @function syncMediaCallInfo
         * @memberof chat.Chat
         * @instance
         * @param {chat.ISyncMediaCallInfoRequest} request SyncMediaCallInfoRequest message or plain object
         * @returns {Promise<chat.SyncMediaCallInfoResponse>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link chat.Chat#pullMessageInfoListTest}.
         * @memberof chat.Chat
         * @typedef PullMessageInfoListTestCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {chat.PullMessageInfoListTestResponse} [response] PullMessageInfoListTestResponse
         */

        /**
         * Calls PullMessageInfoListTest.
         * @function pullMessageInfoListTest
         * @memberof chat.Chat
         * @instance
         * @param {chat.IPullMessageInfoListTestRequest} request PullMessageInfoListTestRequest message or plain object
         * @param {chat.Chat.PullMessageInfoListTestCallback} callback Node-style callback called with the error, if any, and PullMessageInfoListTestResponse
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(Chat.prototype.pullMessageInfoListTest = function pullMessageInfoListTest(request, callback) {
            return this.rpcCall(pullMessageInfoListTest, $root.chat.PullMessageInfoListTestRequest, $root.chat.PullMessageInfoListTestResponse, request, callback);
        }, "name", { value: "PullMessageInfoListTest" });

        /**
         * Calls PullMessageInfoListTest.
         * @function pullMessageInfoListTest
         * @memberof chat.Chat
         * @instance
         * @param {chat.IPullMessageInfoListTestRequest} request PullMessageInfoListTestRequest message or plain object
         * @returns {Promise<chat.PullMessageInfoListTestResponse>} Promise
         * @variation 2
         */

        return Chat;
    })();

    return chat;
})();

export { $root as default };
